(function () {
	'use strict';

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	var jquery = createCommonjsModule(function (module) {
	/*!
	 * jQuery JavaScript Library v3.6.0
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright OpenJS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2021-03-02T17:08Z
	 */
	( function( global, factory ) {

		{

			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		}

	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : commonjsGlobal, function( window, noGlobal ) {

	var arr = [];

	var getProto = Object.getPrototypeOf;

	var slice = arr.slice;

	var flat = function( array ) {
		return arr.concat.apply( [], array );
	};


	var push = arr.push;

	var indexOf = arr.indexOf;

	var class2type = {};

	var toString = class2type.toString;

	var hasOwn = class2type.hasOwnProperty;

	var fnToString = hasOwn.toString;

	var ObjectFunctionString = fnToString.call( Object );

	var support = {};

	var isFunction = function isFunction( obj ) {

			// Support: Chrome <=57, Firefox <=52
			// In some browsers, typeof returns "function" for HTML <object> elements
			// (i.e., `typeof document.createElement( "object" ) === "function"`).
			// We don't want to classify *any* DOM node as a function.
			// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
			// Plus for old WebKit, typeof returns "function" for HTML collections
			// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
			return typeof obj === "function" && typeof obj.nodeType !== "number" &&
				typeof obj.item !== "function";
		};


	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};


	var document = window.document;



		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};

		function DOMEval( code, node, doc ) {
			doc = doc || document;

			var i, val,
				script = doc.createElement( "script" );

			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {

					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}


	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module



	var
		version = "3.6.0",

		// Define a local copy of jQuery
		jQuery = function( selector, context ) {

			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		};

	jQuery.fn = jQuery.prototype = {

		// The current version of jQuery being used
		jquery: version,

		constructor: jQuery,

		// The default length of a jQuery object is 0
		length: 0,

		toArray: function() {
			return slice.call( this );
		},

		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {

			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}

			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},

		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {

			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );

			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;

			// Return the newly-formed element set
			return ret;
		},

		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},

		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},

		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},

		first: function() {
			return this.eq( 0 );
		},

		last: function() {
			return this.eq( -1 );
		},

		even: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return ( i + 1 ) % 2;
			} ) );
		},

		odd: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return i % 2;
			} ) );
		},

		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},

		end: function() {
			return this.prevObject || this.constructor();
		},

		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};

	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;

		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;

			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}

		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}

		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}

		for ( ; i < length; i++ ) {

			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {

				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];

					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}

					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];

						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;

						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );

					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}

		// Return the modified object
		return target;
	};

	jQuery.extend( {

		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

		// Assume jQuery is ready without the ready module
		isReady: true,

		error: function( msg ) {
			throw new Error( msg );
		},

		noop: function() {},

		isPlainObject: function( obj ) {
			var proto, Ctor;

			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}

			proto = getProto( obj );

			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}

			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},

		isEmptyObject: function( obj ) {
			var name;

			for ( name in obj ) {
				return false;
			}
			return true;
		},

		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function( code, options, doc ) {
			DOMEval( code, { nonce: options && options.nonce }, doc );
		},

		each: function( obj, callback ) {
			var length, i = 0;

			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}

			return obj;
		},

		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];

			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
							[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}

			return ret;
		},

		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},

		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;

			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}

			first.length = i;

			return first;
		},

		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;

			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}

			return matches;
		},

		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];

			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );

					if ( value != null ) {
						ret.push( value );
					}
				}

			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );

					if ( value != null ) {
						ret.push( value );
					}
				}
			}

			// Flatten any nested arrays
			return flat( ret );
		},

		// A global GUID counter for objects
		guid: 1,

		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );

	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}

	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
		function( _i, name ) {
			class2type[ "[object " + name + "]" ] = name.toLowerCase();
		} );

	function isArrayLike( obj ) {

		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );

		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}

		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.6
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://js.foundation/
	 *
	 * Date: 2021-02-16
	 */
	( function( window ) {
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,

		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,

		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},

		// Instance methods
		hasOwn = ( {} ).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		pushNative = arr.push,
		push = arr.push,
		slice = arr.slice,

		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[ i ] === elem ) {
					return i;
				}
			}
			return -1;
		},

		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
			"ismap|loop|multiple|open|readonly|required|scoped",

		// Regular expressions

		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",

		// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
		identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +

			// "Attribute values must be CSS identifiers [capture 5]
			// or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
			whitespace + "*\\]",

		pseudos = ":(" + identifier + ")(?:\\((" +

			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

			// 3. anything else (capture 2)
			".*" +
			")\\)|)",

		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
			whitespace + "+$", "g" ),

		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
			"*" ),
		rdescend = new RegExp( whitespace + "|>" ),

		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),

		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace +
				"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
				"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},

		rhtml = /HTML$/i,
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,

		rnative = /^[^{]+\{\s*\[native \w/,

		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

		rsibling = /[+~]/,

		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
		funescape = function( escape, nonHex ) {
			var high = "0x" + escape.slice( 1 ) - 0x10000;

			return nonHex ?

				// Strip the backslash prefix from a non-hex escape sequence
				nonHex :

				// Replace a hexadecimal escape sequence with the encoded Unicode code point
				// Support: IE <=11+
				// For values outside the Basic Multilingual Plane (BMP), manually construct a
				// surrogate pair
				high < 0 ?
					String.fromCharCode( high + 0x10000 ) :
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},

		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {

				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}

				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" +
					ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}

			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},

		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},

		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
			},
			{ dir: "parentNode", next: "legend" }
		);

	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			( arr = slice.call( preferredDoc.childNodes ) ),
			preferredDoc.childNodes
		);

		// Support: Android<4.0
		// Detect silently failing push.apply
		// eslint-disable-next-line no-unused-expressions
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?

			// Leverage slice if possible
			function( target, els ) {
				pushNative.apply( target, slice.call( els ) );
			} :

			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;

				// Can't trust NodeList.length
				while ( ( target[ j++ ] = els[ i++ ] ) ) {}
				target.length = j - 1;
			}
		};
	}

	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,

			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;

		results = results || [];

		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

			return results;
		}

		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
			setDocument( context );
			context = context || document;

			if ( documentIsHTML ) {

				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

					// ID selector
					if ( ( m = match[ 1 ] ) ) {

						// Document context
						if ( nodeType === 9 ) {
							if ( ( elem = context.getElementById( m ) ) ) {

								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}

						// Element context
						} else {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && ( elem = newContext.getElementById( m ) ) &&
								contains( context, elem ) &&
								elem.id === m ) {

								results.push( elem );
								return results;
							}
						}

					// Type selector
					} else if ( match[ 2 ] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;

					// Class selector
					} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
						context.getElementsByClassName ) {

						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}

				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!nonnativeSelectorCache[ selector + " " ] &&
					( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

					// Support: IE 8 only
					// Exclude object elements
					( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

					newSelector = selector;
					newContext = context;

					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// The technique has to be used as well when a leading combinator is used
					// as such selectors are not recognized by querySelectorAll.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 &&
						( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {

						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;

						// We can use :scope instead of the ID hack if the browser
						// supports it & if we're not changing the context.
						if ( newContext !== context || !support.scope ) {

							// Capture the context ID, setting it first if necessary
							if ( ( nid = context.getAttribute( "id" ) ) ) {
								nid = nid.replace( rcssescape, fcssescape );
							} else {
								context.setAttribute( "id", ( nid = expando ) );
							}
						}

						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
								toSelector( groups[ i ] );
						}
						newSelector = groups.join( "," );
					}

					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}

		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}

	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];

		function cache( key, value ) {

			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {

				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return ( cache[ key + " " ] = value );
		}
		return cache;
	}

	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}

	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement( "fieldset" );

		try {
			return !!fn( el );
		} catch ( e ) {
			return false;
		} finally {

			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}

			// release memory in IE
			el = null;
		}
	}

	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split( "|" ),
			i = arr.length;

		while ( i-- ) {
			Expr.attrHandle[ arr[ i ] ] = handler;
		}
	}

	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;

		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}

		// Check if b follows a
		if ( cur ) {
			while ( ( cur = cur.nextSibling ) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}

		return a ? 1 : -1;
	}

	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}

	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return ( name === "input" || name === "button" ) && elem.type === type;
		};
	}

	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {

		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {

			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {

				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {

					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}

					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||

						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
				}

				return elem.disabled === disabled;

			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}

			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}

	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction( function( argument ) {
			argument = +argument;
			return markFunction( function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;

				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
						seed[ j ] = !( matches[ j ] = seed[ j ] );
					}
				}
			} );
		} );
	}

	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}

	// Expose support vars for convenience
	support = Sizzle.support = {};

	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;

		// Support: IE <=8
		// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
		// https://bugs.jquery.com/ticket/4833
		return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
	};

	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;

		// Return early if doc is invalid or already selected
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}

		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );

		// Support: IE 9 - 11+, Edge 12 - 18+
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( preferredDoc != document &&
			( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );

			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}

		// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
		// Safari 4 - 5 only, Opera <=11.6 - 12.x only
		// IE/Edge & older browsers don't support the :scope pseudo-class.
		// Support: Safari 6.0 only
		// Safari 6.0 supports :scope but it's an alias of :root there.
		support.scope = assert( function( el ) {
			docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
			return typeof el.querySelectorAll !== "undefined" &&
				!el.querySelectorAll( ":scope fieldset div" ).length;
		} );

		/* Attributes
		---------------------------------------------------------------------- */

		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert( function( el ) {
			el.className = "i";
			return !el.getAttribute( "className" );
		} );

		/* getElement(s)By*
		---------------------------------------------------------------------- */

		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert( function( el ) {
			el.appendChild( document.createComment( "" ) );
			return !el.getElementsByTagName( "*" ).length;
		} );

		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );

		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert( function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		} );

		// ID filter and find
		if ( support.getById ) {
			Expr.filter[ "ID" ] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute( "id" ) === attrId;
				};
			};
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter[ "ID" ] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode( "id" );
					return node && node.value === attrId;
				};
			};

			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );

					if ( elem ) {

						// Verify the id attribute
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}

						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( ( elem = elems[ i++ ] ) ) {
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}

					return [];
				}
			};
		}

		// Tag
		Expr.find[ "TAG" ] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );

				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :

			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,

					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );

				// Filter out possible comments
				if ( tag === "*" ) {
					while ( ( elem = results[ i++ ] ) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}

					return tmp;
				}
				return results;
			};

		// Class
		Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};

		/* QSA/matchesSelector
		---------------------------------------------------------------------- */

		// QSA and matchesSelector support

		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];

		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];

		if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert( function( el ) {

				var input;

				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";

				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}

				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll( "[selected]" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}

				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push( "~=" );
				}

				// Support: IE 11+, Edge 15 - 18+
				// IE 11/Edge don't find elements on a `[name='']` query in some cases.
				// Adding a temporary attribute to the document before the selection works
				// around the issue.
				// Interestingly, IE 10 & older don't seem to have the issue.
				input = document.createElement( "input" );
				input.setAttribute( "name", "" );
				el.appendChild( input );
				if ( !el.querySelectorAll( "[name='']" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
						whitespace + "*(?:''|\"\")" );
				}

				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll( ":checked" ).length ) {
					rbuggyQSA.push( ":checked" );
				}

				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push( ".#.+[+~]" );
				}

				// Support: Firefox <=3.6 - 5 only
				// Old Firefox doesn't throw on a badly-escaped identifier.
				el.querySelectorAll( "\\\f" );
				rbuggyQSA.push( "[\\r\\n\\f]" );
			} );

			assert( function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";

				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement( "input" );
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );

				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll( "[name=d]" ).length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}

				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}

				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}

				// Support: Opera 10 - 11 only
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll( "*,:x" );
				rbuggyQSA.push( ",.*:" );
			} );
		}

		if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector ) ) ) ) {

			assert( function( el ) {

				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );

				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			} );
		}

		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );

		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				) );
			} :
			function( a, b ) {
				if ( b ) {
					while ( ( b = b.parentNode ) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};

		/* Sorting
		---------------------------------------------------------------------- */

		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {

			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}

			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}

			// Calculate position if both inputs belong to the same document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :

				// Otherwise we know they are disconnected
				1;

			// Disconnected nodes
			if ( compare & 1 ||
				( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

				// Choose the first element that is related to our preferred document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( a == document || a.ownerDocument == preferredDoc &&
					contains( preferredDoc, a ) ) {
					return -1;
				}

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( b == document || b.ownerDocument == preferredDoc &&
					contains( preferredDoc, b ) ) {
					return 1;
				}

				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}

			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {

			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}

			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];

			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				return a == document ? -1 :
					b == document ? 1 :
					/* eslint-enable eqeqeq */
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;

			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}

			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( ( cur = cur.parentNode ) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( ( cur = cur.parentNode ) ) {
				bp.unshift( cur );
			}

			// Walk down the tree looking for a discrepancy
			while ( ap[ i ] === bp[ i ] ) {
				i++;
			}

			return i ?

				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[ i ], bp[ i ] ) :

				// Otherwise nodes in our document sort first
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				ap[ i ] == preferredDoc ? -1 :
				bp[ i ] == preferredDoc ? 1 :
				/* eslint-enable eqeqeq */
				0;
		};

		return document;
	};

	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};

	Sizzle.matchesSelector = function( elem, expr ) {
		setDocument( elem );

		if ( support.matchesSelector && documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

			try {
				var ret = matches.call( elem, expr );

				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||

					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch ( e ) {
				nonnativeSelectorCache( expr, true );
			}
		}

		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};

	Sizzle.contains = function( context, elem ) {

		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( context.ownerDocument || context ) != document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};

	Sizzle.attr = function( elem, name ) {

		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( elem.ownerDocument || elem ) != document ) {
			setDocument( elem );
		}

		var fn = Expr.attrHandle[ name.toLowerCase() ],

			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;

		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
	};

	Sizzle.escape = function( sel ) {
		return ( sel + "" ).replace( rcssescape, fcssescape );
	};

	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};

	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;

		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );

		if ( hasDuplicate ) {
			while ( ( elem = results[ i++ ] ) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}

		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;

		return results;
	};

	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;

		if ( !nodeType ) {

			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {

				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {

				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}

		// Do not include comment or processing instruction nodes

		return ret;
	};

	Expr = Sizzle.selectors = {

		// Can be adjusted by the user
		cacheLength: 50,

		createPseudo: markFunction,

		match: matchExpr,

		attrHandle: {},

		find: {},

		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},

		preFilter: {
			"ATTR": function( match ) {
				match[ 1 ] = match[ 1 ].replace( runescape, funescape );

				// Move the given value to match[3] whether quoted or unquoted
				match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
					match[ 5 ] || "" ).replace( runescape, funescape );

				if ( match[ 2 ] === "~=" ) {
					match[ 3 ] = " " + match[ 3 ] + " ";
				}

				return match.slice( 0, 4 );
			},

			"CHILD": function( match ) {

				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[ 1 ] = match[ 1 ].toLowerCase();

				if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

					// nth-* requires argument
					if ( !match[ 3 ] ) {
						Sizzle.error( match[ 0 ] );
					}

					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[ 4 ] = +( match[ 4 ] ?
						match[ 5 ] + ( match[ 6 ] || 1 ) :
						2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
					match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

					// other types prohibit arguments
				} else if ( match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}

				return match;
			},

			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[ 6 ] && match[ 2 ];

				if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
					return null;
				}

				// Accept quoted arguments as-is
				if ( match[ 3 ] ) {
					match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&

					// Get excess from tokenize (recursively)
					( excess = tokenize( unquoted, true ) ) &&

					// advance to the next closing parenthesis
					( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

					// excess is a negative index
					match[ 0 ] = match[ 0 ].slice( 0, excess );
					match[ 2 ] = unquoted.slice( 0, excess );
				}

				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},

		filter: {

			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() {
						return true;
					} :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},

			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];

				return pattern ||
					( pattern = new RegExp( "(^|" + whitespace +
						")" + className + "(" + whitespace + "|$)" ) ) && classCache(
							className, function( elem ) {
								return pattern.test(
									typeof elem.className === "string" && elem.className ||
									typeof elem.getAttribute !== "undefined" &&
										elem.getAttribute( "class" ) ||
									""
								);
					} );
			},

			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );

					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}

					result += "";

					/* eslint-disable max-len */

					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
					/* eslint-enable max-len */

				};
			},

			"CHILD": function( type, what, _argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";

				return first === 1 && last === 0 ?

					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :

					function( elem, _context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;

						if ( parent ) {

							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( ( node = node[ dir ] ) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {

											return false;
										}
									}

									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}

							start = [ forward ? parent.firstChild : parent.lastChild ];

							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {

								// Seek `elem` from a previously-cached index

								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || ( node[ expando ] = {} );

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];

								while ( ( node = ++nodeIndex && node && node[ dir ] ||

									// Fallback to seeking `elem` from the start
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}

							} else {

								// Use previously-cached element index if available
								if ( useCache ) {

									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || ( node[ expando ] = {} );

									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										( outerCache[ node.uniqueID ] = {} );

									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}

								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {

									// Use the same loop as above to seek `elem` from the start
									while ( ( node = ++nodeIndex && node && node[ dir ] ||
										( diff = nodeIndex = 0 ) || start.pop() ) ) {

										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {

											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] ||
													( node[ expando ] = {} );

												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													( outerCache[ node.uniqueID ] = {} );

												uniqueCache[ type ] = [ dirruns, diff ];
											}

											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}

							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},

			"PSEUDO": function( pseudo, argument ) {

				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );

				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}

				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction( function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[ i ] );
								seed[ idx ] = !( matches[ idx ] = matched[ i ] );
							}
						} ) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}

				return fn;
			}
		},

		pseudos: {

			// Potentially complex pseudos
			"not": markFunction( function( selector ) {

				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );

				return matcher[ expando ] ?
					markFunction( function( seed, matches, _context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;

						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( ( elem = unmatched[ i ] ) ) {
								seed[ i ] = !( matches[ i ] = elem );
							}
						}
					} ) :
					function( elem, _context, xml ) {
						input[ 0 ] = elem;
						matcher( input, null, xml, results );

						// Don't keep the element (issue #299)
						input[ 0 ] = null;
						return !results.pop();
					};
			} ),

			"has": markFunction( function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			} ),

			"contains": markFunction( function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
				};
			} ),

			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {

				// lang value must be a valid identifier
				if ( !ridentifier.test( lang || "" ) ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( ( elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
					return false;
				};
			} ),

			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},

			"root": function( elem ) {
				return elem === docElem;
			},

			"focus": function( elem ) {
				return elem === document.activeElement &&
					( !document.hasFocus || document.hasFocus() ) &&
					!!( elem.type || elem.href || ~elem.tabIndex );
			},

			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),

			"checked": function( elem ) {

				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return ( nodeName === "input" && !!elem.checked ) ||
					( nodeName === "option" && !!elem.selected );
			},

			"selected": function( elem ) {

				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					// eslint-disable-next-line no-unused-expressions
					elem.parentNode.selectedIndex;
				}

				return elem.selected === true;
			},

			// Contents
			"empty": function( elem ) {

				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},

			"parent": function( elem ) {
				return !Expr.pseudos[ "empty" ]( elem );
			},

			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},

			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},

			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},

			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&

					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( ( attr = elem.getAttribute( "type" ) ) == null ||
						attr.toLowerCase() === "text" );
			},

			// Position-in-collection
			"first": createPositionalPseudo( function() {
				return [ 0 ];
			} ),

			"last": createPositionalPseudo( function( _matchIndexes, length ) {
				return [ length - 1 ];
			} ),

			"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			} ),

			"even": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),

			"odd": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),

			"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ?
					argument + length :
					argument > length ?
						length :
						argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),

			"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} )
		}
	};

	Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}

	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();

	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];

		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}

		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;

		while ( soFar ) {

			// Comma and first run
			if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
				if ( match ) {

					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[ 0 ].length ) || soFar;
				}
				groups.push( ( tokens = [] ) );
			}

			matched = false;

			// Combinators
			if ( ( match = rcombinators.exec( soFar ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,

					// Cast descendant combinators to space
					type: match[ 0 ].replace( rtrim, " " )
				} );
				soFar = soFar.slice( matched.length );
			}

			// Filters
			for ( type in Expr.filter ) {
				if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
					( match = preFilters[ type ]( match ) ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,
						type: type,
						matches: match
					} );
					soFar = soFar.slice( matched.length );
				}
			}

			if ( !matched ) {
				break;
			}
		}

		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :

				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};

	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[ i ].value;
		}
		return selector;
	}

	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;

		return combinator.first ?

			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :

			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];

				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || ( elem[ expando ] = {} );

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] ||
								( outerCache[ elem.uniqueID ] = {} );

							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( ( oldCache = uniqueCache[ key ] ) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

								// Assign to newCache so results back-propagate to previous elements
								return ( newCache[ 2 ] = oldCache[ 2 ] );
							} else {

								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;

								// A match means we're done; a fail means we have to keep checking
								if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}

	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[ i ]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[ 0 ];
	}

	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[ i ], results );
		}
		return results;
	}

	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;

		for ( ; i < len; i++ ) {
			if ( ( elem = unmatched[ i ] ) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}

		return newUnmatched;
	}

	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction( function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,

				// Get initial elements from seed or context
				elems = seed || multipleContexts(
					selector || "*",
					context.nodeType ? [ context ] : context,
					[]
				),

				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,

				matcherOut = matcher ?

					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

						// ...intermediate processing is necessary
						[] :

						// ...otherwise use results directly
						results :
					matcherIn;

			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}

			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );

				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( ( elem = temp[ i ] ) ) {
						matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
					}
				}
			}

			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {

						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) ) {

								// Restore matcherIn since elem is not yet a final match
								temp.push( ( matcherIn[ i ] = elem ) );
							}
						}
						postFinder( null, ( matcherOut = [] ), temp, xml );
					}

					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) &&
							( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

							seed[ temp ] = !( results[ temp ] = elem );
						}
					}
				}

			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		} );
	}

	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[ 0 ].type ],
			implicitRelative = leadingRelative || Expr.relative[ " " ],
			i = leadingRelative ? 1 : 0,

			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					( checkContext = context ).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );

				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];

		for ( ; i < len; i++ ) {
			if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
				matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
			} else {
				matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {

					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[ j ].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(

						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens
							.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}

		return elementMatcher( matchers );
	}

	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,

					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
					len = elems.length;

				if ( outermost ) {

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					outermostContext = context == document || context || outermost;
				}

				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;

						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( !context && elem.ownerDocument != document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( ( matcher = elementMatchers[ j++ ] ) ) {
							if ( matcher( elem, context || document, xml ) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}

					// Track unmatched elements for set filters
					if ( bySet ) {

						// They will have gone through all possible matchers
						if ( ( elem = !matcher && elem ) ) {
							matchedCount--;
						}

						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}

				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;

				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( ( matcher = setMatchers[ j++ ] ) ) {
						matcher( unmatched, setMatched, context, xml );
					}

					if ( seed ) {

						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
									setMatched[ i ] = pop.call( results );
								}
							}
						}

						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}

					// Add matches to results
					push.apply( results, setMatched );

					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {

						Sizzle.uniqueSort( results );
					}
				}

				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}

				return unmatched;
			};

		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}

	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];

		if ( !cached ) {

			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[ i ] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}

			// Cache the compiled function
			cached = compilerCache(
				selector,
				matcherFromGroupMatchers( elementMatchers, setMatchers )
			);

			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};

	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( ( selector = compiled.selector || selector ) );

		results = results || [];

		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {

			// Reduce context if the leading compound selector is an ID
			tokens = match[ 0 ] = match[ 0 ].slice( 0 );
			if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

				context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
					.replace( runescape, funescape ), context ) || [] )[ 0 ];
				if ( !context ) {
					return results;

				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}

				selector = selector.slice( tokens.shift().value.length );
			}

			// Fetch a seed set for right-to-left matching
			i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[ i ];

				// Abort if we hit a combinator
				if ( Expr.relative[ ( type = token.type ) ] ) {
					break;
				}
				if ( ( find = Expr.find[ type ] ) ) {

					// Search, expanding context for leading sibling combinators
					if ( ( seed = find(
						token.matches[ 0 ].replace( runescape, funescape ),
						rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
							context
					) ) ) {

						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}

						break;
					}
				}
			}
		}

		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};

	// One-time assignments

	// Sort stability
	support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;

	// Initialize against the default document
	setDocument();

	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert( function( el ) {

		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
	} );

	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert( function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute( "href" ) === "#";
	} ) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		} );
	}

	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert( function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	} ) ) {
		addHandle( "value", function( elem, _name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		} );
	}

	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert( function( el ) {
		return el.getAttribute( "disabled" ) == null;
	} ) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
					( val = elem.getAttributeNode( name ) ) && val.specified ?
						val.value :
						null;
			}
		} );
	}

	return Sizzle;

	} )( window );



	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;

	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;




	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;

		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};


	var siblings = function( n, elem ) {
		var matched = [];

		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}

		return matched;
	};


	var rneedsContext = jQuery.expr.match.needsContext;



	function nodeName( elem, name ) {

		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

	}
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}

		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}

		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}

		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}

	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];

		if ( not ) {
			expr = ":not(" + expr + ")";
		}

		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}

		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};

	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;

			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}

			ret = this.pushStack( [] );

			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}

			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,

				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );


	// Initialize a jQuery object


	// A central reference to the root jQuery(document)
	var rootjQuery,

		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;

			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}

			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;

			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {

					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];

				} else {
					match = rquickExpr.exec( selector );
				}

				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {

					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;

						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );

						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {

								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );

								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}

						return this;

					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );

						if ( elem ) {

							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}

				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );

				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}

			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;

			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :

					// Execute immediately if ready is not present
					selector( jQuery );
			}

			return jQuery.makeArray( selector, this );
		};

	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;

	// Initialize central reference
	rootjQuery = jQuery( document );


	var rparentsprev = /^(?:parents|prev(?:Until|All))/,

		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};

	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;

			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},

		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );

			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :

							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {

							matched.push( cur );
							break;
						}
					}
				}
			}

			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},

		// Determine the position of an element within the set
		index: function( elem ) {

			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}

			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}

			// Locate the position of the desired element
			return indexOf.call( this,

				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},

		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},

		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );

	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}

	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, _i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, _i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, _i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( elem.contentDocument != null &&

				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto( elem.contentDocument ) ) {

				return elem.contentDocument;
			}

			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}

			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );

			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}

			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}

			if ( this.length > 1 ) {

				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}

				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}

			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}

	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {

		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );

		var // Flag to know if list is currently firing
			firing,

			// Last fire value for non-forgettable lists
			memory,

			// Flag to know if list was already fired
			fired,

			// Flag to prevent firing
			locked,

			// Actual callback list
			list = [],

			// Queue of execution data for repeatable lists
			queue = [],

			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,

			// Fire callbacks
			fire = function() {

				// Enforce single-firing
				locked = locked || options.once;

				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {

						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {

							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}

				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}

				firing = false;

				// Clean up if we're done firing for good
				if ( locked ) {

					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];

					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},

			// Actual Callbacks object
			self = {

				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {

						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}

						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {

									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );

						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},

				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );

							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},

				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},

				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},

				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},

				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},

				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},

				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},

				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};

		return self;
	};


	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}

	function adoptValue( value, resolve, reject, noValue ) {
		var method;

		try {

			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );

			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );

			// Other non-thenables
			} else {

				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}

		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {

			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}

	jQuery.extend( {

		Deferred: function( func ) {
			var tuples = [

					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},

					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;

						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( _i, tuple ) {

								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;

										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}

										returned = handler.apply( that, args );

										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}

										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&

											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;

										// Handle a returned thenable
										if ( isFunction( then ) ) {

											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);

											// Normal processors (resolve) also hook into progress
											} else {

												// ...and disregard older resolution values
												maxDepth++;

												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}

										// Handle all other returned values
										} else {

											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}

											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},

									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {

												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}

												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {

													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}

													deferred.rejectWith( that, args );
												}
											}
										};

								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {

									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}

						return jQuery.Deferred( function( newDefer ) {

							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);

							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);

							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},

					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};

			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];

				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;

				// Handle state
				if ( stateString ) {
					list.add(
						function() {

							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},

						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,

						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,

						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,

						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}

				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );

				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};

				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );

			// Make the deferred a promise
			promise.promise( deferred );

			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}

			// All done!
			return deferred;
		},

		// Deferred helper
		when: function( singleValue ) {
			var

				// count of uncompleted subordinates
				remaining = arguments.length,

				// count of unprocessed arguments
				i = remaining,

				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),

				// the primary Deferred
				primary = jQuery.Deferred(),

				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							primary.resolveWith( resolveContexts, resolveValues );
						}
					};
				};

			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
					!remaining );

				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( primary.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

					return primary.then();
				}
			}

			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
			}

			return primary.promise();
		}
	} );


	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

	jQuery.Deferred.exceptionHook = function( error, stack ) {

		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};




	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};




	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();

	jQuery.fn.ready = function( fn ) {

		readyList
			.then( fn )

			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );

		return this;
	};

	jQuery.extend( {

		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,

		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,

		// Handle when the DOM is ready
		ready: function( wait ) {

			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}

			// Remember that the DOM is ready
			jQuery.isReady = true;

			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}

			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );

	jQuery.ready.then = readyList.then;

	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}

	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );

	} else {

		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );

		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}




	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;

		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}

		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;

			if ( !isFunction( value ) ) {
				raw = true;
			}

			if ( bulk ) {

				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;

				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, _key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}

			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
							value :
							value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}

		if ( chainable ) {
			return elems;
		}

		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}

		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};


	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;

	// Used by camelCase as callback to replace()
	function fcamelCase( _all, letter ) {
		return letter.toUpperCase();
	}

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {

		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};




	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}

	Data.uid = 1;

	Data.prototype = {

		cache: function( owner ) {

			// Check if the owner object already has a cache
			var value = owner[ this.expando ];

			// If not, create one
			if ( !value ) {
				value = {};

				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {

					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;

					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}

			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );

			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;

			// Handle: [ owner, { properties } ] args
			} else {

				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :

				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {

			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {

				return this.get( owner, key );
			}

			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );

			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];

			if ( cache === undefined ) {
				return;
			}

			if ( key !== undefined ) {

				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {

					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );

					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}

				i = key.length;

				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}

			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();

	var dataUser = new Data();



	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;

	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}

		if ( data === "false" ) {
			return false;
		}

		if ( data === "null" ) {
			return null;
		}

		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}

		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}

		return data;
	}

	function dataAttr( elem, key, data ) {
		var name;

		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );

			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}

				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}

	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},

		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},

		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},

		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},

		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );

	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;

			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );

					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {

							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}

				return data;
			}

			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}

			return access( this, function( value ) {
				var data;

				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {

					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}

					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}

					// We tried really hard, but the data doesn't exist.
					return;
				}

				// Set the data...
				this.each( function() {

					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},

		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );


	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;

			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );

				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},

		dequeue: function( elem, type ) {
			type = type || "fx";

			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};

			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}

			if ( fn ) {

				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}

				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}

			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},

		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );

	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;

			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}

			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}

			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );

					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );

					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},

		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};

			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";

			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

	var documentElement = document.documentElement;



		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };

		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {

			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;

			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&

				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&

				jQuery.css( elem, "display" ) === "none";
		};



	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );

		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;

			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];

			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;

			while ( maxIterations-- ) {

				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;

			}

			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );

			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}

		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;

			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}


	var defaultDisplayMap = {};

	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];

		if ( display ) {
			return display;
		}

		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );

		temp.parentNode.removeChild( temp );

		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;

		return display;
	}

	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;

		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}

			display = elem.style.display;
			if ( show ) {

				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";

					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}

		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}

		return elements;
	}

	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}

			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );

	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );

		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );

		div.appendChild( input );

		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	} )();


	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {

		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

		_default: [ 0, "", "" ]
	};

	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;

	// Support: IE <=9 only
	if ( !support.option ) {
		wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
	}


	function getAll( context, tag ) {

		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;

		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );

		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );

		} else {
			ret = [];
		}

		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}

		return ret;
	}


	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;

		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}


	var rhtml = /<|&#?\w+;/;

	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;

		for ( ; i < l; i++ ) {
			elem = elems[ i ];

			if ( elem || elem === 0 ) {

				// Add nodes directly
				if ( toType( elem ) === "object" ) {

					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );

				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}

					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );

					// Remember the top-level container
					tmp = fragment.firstChild;

					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}

		// Remove wrapper from fragment
		fragment.textContent = "";

		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {

			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}

			attached = isAttached( elem );

			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );

			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}

			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}

		return fragment;
	}


	var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

	function returnTrue() {
		return true;
	}

	function returnFalse() {
		return false;
	}

	// Support: IE <=9 - 11+
	// focus() and blur() are asynchronous, except when they are no-op.
	// So expect focus to be synchronous when the element is already active,
	// and blur to be synchronous when the element is not already active.
	// (focus and blur are always synchronous in other supported browsers,
	// this just defines when we can count on it).
	function expectSync( elem, type ) {
		return ( elem === safeActiveElement() ) === ( type === "focus" );
	}

	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}

	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;

		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {

			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {

				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}

		if ( data == null && fn == null ) {

			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {

				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {

				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}

		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {

				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};

			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}

	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {

		global: {},

		add: function( elem, types, handler, data, selector ) {

			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );

			// Only attach events to objects that accept data
			if ( !acceptData( elem ) ) {
				return;
			}

			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}

			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}

			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}

			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = Object.create( null );
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {

					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}

			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}

				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};

				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;

				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};

				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );

				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;

					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}

				if ( special.add ) {
					special.add.call( elem, handleObj );

					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}

				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}

				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}

		},

		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {

			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}

			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}

				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];

					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );

						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}

				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

						jQuery.removeEvent( elem, type, elemData.handle );
					}

					delete events[ type ];
				}
			}

			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},

		dispatch: function( nativeEvent ) {

			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),

				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix( nativeEvent ),

				handlers = (
					dataPriv.get( this, "events" ) || Object.create( null )
				)[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};

			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;

			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}

			event.delegateTarget = this;

			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}

			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );

			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;

				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {

					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {

						event.handleObj = handleObj;
						event.data = handleObj.data;

						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );

						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}

			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}

			return event.result;
		},

		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;

			// Find delegate handlers
			if ( delegateCount &&

				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&

				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {

				for ( ; cur !== this; cur = cur.parentNode || this ) {

					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];

							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";

							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}

			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}

			return handlerQueue;
		},

		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,

				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
							return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
							return this.originalEvent[ name ];
						}
					},

				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},

		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},

		special: {
			load: {

				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {

				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {

					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;

					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {

						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", returnTrue );
					}

					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {

					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;

					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {

						leverageNative( el, "click" );
					}

					// Return non-false to allow normal event-path propagation
					return true;
				},

				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},

			beforeunload: {
				postDispatch: function( event ) {

					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};

	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, expectSync ) {

		// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
		if ( !expectSync ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}

		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var notAsync, result,
					saved = dataPriv.get( this, type );

				if ( ( event.isTrigger & 1 ) && this[ type ] ) {

					// Interrupt processing of the outer synthetic .trigger()ed event
					// Saved data should be false in such cases, but might be a leftover capture object
					// from an async native handler (gh-4350)
					if ( !saved.length ) {

						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );

						// Trigger the native event and capture its result
						// Support: IE <=9 - 11+
						// focus() and blur() are asynchronous
						notAsync = expectSync( this, type );
						this[ type ]();
						result = dataPriv.get( this, type );
						if ( saved !== result || notAsync ) {
							dataPriv.set( this, type, false );
						} else {
							result = {};
						}
						if ( saved !== result ) {

							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();

							// Support: Chrome 86+
							// In Chrome, if an element having a focusout handler is blurred by
							// clicking outside of it, it invokes the handler synchronously. If
							// that handler calls `.remove()` on the element, the data is cleared,
							// leaving `result` undefined. We need to guard against this.
							return result && result.value;
						}

					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering the
					// native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}

				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved.length ) {

					// ...and capture the result
					dataPriv.set( this, type, {
						value: jQuery.event.trigger(

							// Support: IE <=9 - 11+
							// Extend with the prototype to reset the above stopImmediatePropagation()
							jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
							saved.slice( 1 ),
							this
						)
					} );

					// Abort handling of the native event
					event.stopImmediatePropagation();
				}
			}
		} );
	}

	jQuery.removeEvent = function( elem, type, handle ) {

		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};

	jQuery.Event = function( src, props ) {

		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}

		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;

			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&

					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;

			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;

			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;

		// Event type
		} else {
			this.type = src;
		}

		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}

		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();

		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};

	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,

		preventDefault: function() {
			var e = this.originalEvent;

			this.isDefaultPrevented = returnTrue;

			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;

			this.isPropagationStopped = returnTrue;

			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;

			this.isImmediatePropagationStopped = returnTrue;

			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}

			this.stopPropagation();
		}
	};

	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
		which: true
	}, jQuery.event.addProp );

	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
		jQuery.event.special[ type ] = {

			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {

				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, expectSync );

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function() {

				// Force setup before trigger
				leverageNative( this, type );

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// Suppress native focus or blur as it's already being fired
			// in leverageNative.
			_default: function() {
				return true;
			},

			delegateType: delegateType
		};
	} );

	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,

			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;

				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );

	jQuery.fn.extend( {

		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {

				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {

				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {

				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );


	var

		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,

		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}

		return elem;
	}

	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}

		return elem;
	}

	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, udataOld, udataCur, events;

		if ( dest.nodeType !== 1 ) {
			return;
		}

		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.get( src );
			events = pdataOld.events;

			if ( events ) {
				dataPriv.remove( dest, "handle events" );

				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}

		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );

			dataUser.set( dest, udataCur );
		}
	}

	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();

		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;

		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}

	function domManip( collection, args, callback, ignored ) {

		// Flatten any nested arrays
		args = flat( args );

		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );

		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}

		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;

			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}

			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;

				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;

					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );

						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {

							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}

					callback.call( collection[ i ], node, i );
				}

				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;

					// Reenable scripts
					jQuery.map( scripts, restoreScript );

					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {

							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									}, doc );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}

		return collection;
	}

	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;

		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}

			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}

		return elem;
	}

	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html;
		},

		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );

			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {

				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}

			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );

					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}

			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}

			// Return the cloned set
			return clone;
		},

		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;

			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );

								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}

						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {

						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );

	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},

		remove: function( selector ) {
			return remove( this, selector );
		},

		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},

		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},

		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},

		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},

		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},

		empty: function() {
			var elem,
				i = 0;

			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {

					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );

					// Remove any remaining nodes
					elem.textContent = "";
				}
			}

			return this;
		},

		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},

		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;

				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}

				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

					value = jQuery.htmlPrefilter( value );

					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};

							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}

						elem = 0;

					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}

				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},

		replaceWith: function() {
			var ignored = [];

			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;

				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}

			// Force callback invocation
			}, ignored );
		}
	} );

	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;

			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );

				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}

			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

	var getStyles = function( elem ) {

			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;

			if ( !view || !view.opener ) {
				view = window;
			}

			return view.getComputedStyle( elem );
		};

	var swap = function( elem, options, callback ) {
		var ret, name,
			old = {};

		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}

		ret = callback.call( elem );

		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}

		return ret;
	};


	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



	( function() {

		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {

			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}

			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );

			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";

			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

			documentElement.removeChild( container );

			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}

		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}

		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableTrDimensionsVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );

		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}

		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";

		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			},

			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			//
			// Support: Firefox 70+
			// Only Firefox includes border widths
			// in computed dimensions. (gh-4529)
			reliableTrDimensions: function() {
				var table, tr, trChild, trStyle;
				if ( reliableTrDimensionsVal == null ) {
					table = document.createElement( "table" );
					tr = document.createElement( "tr" );
					trChild = document.createElement( "div" );

					table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
					tr.style.cssText = "border:1px solid";

					// Support: Chrome 86+
					// Height set through cssText does not get applied.
					// Computed height then comes back as 0.
					tr.style.height = "1px";
					trChild.style.height = "9px";

					// Support: Android 8 Chrome 86+
					// In our bodyBackground.html iframe,
					// display for all div elements is set to "inline",
					// which causes a problem only in Android 8 Chrome 86.
					// Ensuring the div is display: block
					// gets around this issue.
					trChild.style.display = "block";

					documentElement
						.appendChild( table )
						.appendChild( tr )
						.appendChild( trChild );

					trStyle = window.getComputedStyle( tr );
					reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
						parseInt( trStyle.borderTopWidth, 10 ) +
						parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

					documentElement.removeChild( table );
				}
				return reliableTrDimensionsVal;
			}
		} );
	} )();


	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,

			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;

		computed = computed || getStyles( elem );

		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];

			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}

			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;

				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;

				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}

		return ret !== undefined ?

			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}


	function addGetHookIf( conditionFn, hookFn ) {

		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {

					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}

				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}


	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};

	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {

		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;

		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}

	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];

		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}


	var

		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};

	function setPositiveNumber( _elem, value, subtract ) {

		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?

			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}

	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;

		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}

		for ( ; i < 4; i += 2 ) {

			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}

			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {

				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}

			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {

				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}

				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}

		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {

			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5

			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}

		return delta;
	}

	function getWidthOrHeight( elem, dimension, extra ) {

		// Start with computed style
		var styles = getStyles( elem ),

			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,

			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}


		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ( ( !support.boxSizingReliable() && isBorderBox ||

			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||

			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

			// Make sure the element is visible & connected
			elem.getClientRects().length ) {

			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}

		// Normalize "" and auto
		val = parseFloat( val ) || 0;

		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,

				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}

	jQuery.extend( {

		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {

						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},

		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"gridArea": true,
			"gridColumn": true,
			"gridColumnEnd": true,
			"gridColumnStart": true,
			"gridRow": true,
			"gridRowEnd": true,
			"gridRowStart": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},

		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},

		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {

			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}

			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;

			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}

			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;

				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );

					// Fixes bug #9237
					type = "number";
				}

				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}

				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}

				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}

				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {

					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}

			} else {

				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

					return ret;
				}

				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},

		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );

			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}

			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}

			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}

			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}

			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}

			return val;
		}
	} );

	jQuery.each( [ "height", "width" ], function( _i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {

					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
				}
			},

			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),

					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",

					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;

				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}

				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {

					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}

				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );

	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
				) + "px";
			}
		}
	);

	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},

					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];

				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}

				return expanded;
			}
		};

		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );

	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;

				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;

					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}

					return map;
				}

				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );


	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;

	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];

			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];

			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;

			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}

			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};

	Tween.prototype.init.prototype = Tween.prototype;

	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;

				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}

				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );

				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {

				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};

	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};

	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};

	jQuery.fx = Tween.prototype.init;

	// Back compat <1.8 extension point
	jQuery.fx.step = {};




	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;

	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}

			jQuery.fx.tick();
		}
	}

	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}

	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };

		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}

		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}

		return attrs;
	}

	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

				// We're done with this property
				return tween;
			}
		}
	}

	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );

		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;

			anim.always( function() {

				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}

		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {

					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;

					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}

		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}

		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {

			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {

					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}

			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {

					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}

		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}

		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {

			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}

				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}

				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}

				/* eslint-disable no-loop-func */

				anim.done( function() {

					/* eslint-enable no-loop-func */

					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}

			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}

	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;

		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}

			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}

			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];

				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}

	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {

				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;

				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}

				deferred.notifyWith( elem, [ animation, percent, remaining ] );

				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}

				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}

				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,

						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}

					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;

		propFilter( props, animation.opts.specialEasing );

		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}

		jQuery.map( props, createTween, animation );

		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}

		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );

		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);

		return animation;
	}

	jQuery.Animation = jQuery.extend( Animation, {

		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},

		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}

			var prop,
				index = 0,
				length = props.length;

			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},

		prefilters: [ defaultPrefilter ],

		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );

	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};

		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;

		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];

				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}

		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}

		// Queueing
		opt.old = opt.complete;

		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}

			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};

		return opt;
	};

	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {

			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {

					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );

					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};

			doAnimation.finish = doAnimation;

			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};

			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue ) {
				this.queue( type || "fx", [] );
			}

			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );

				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}

				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {

						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}

				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;

				// Enable finishing flag on private data
				data.finish = true;

				// Empty the queue first
				jQuery.queue( this, type, [] );

				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}

				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}

				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}

				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );

	jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );

	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );

	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;

		fxNow = Date.now();

		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];

			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}

		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};

	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};

	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}

		inProgress = true;
		schedule();
	};

	jQuery.fx.stop = function() {
		inProgress = null;
	};

	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,

		// Default speed
		_default: 400
	};


	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";

		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};


	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );

		input.type = "checkbox";

		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";

		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;

		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();


	var boolHook,
		attrHandle = jQuery.expr.attrHandle;

	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},

		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );

	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;

			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}

			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}

			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}

			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}

				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}

				elem.setAttribute( name, value + "" );
				return value;
			}

			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}

			ret = jQuery.find.attr( elem, name );

			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},

		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},

		removeAttr: function( elem, value ) {
			var name,
				i = 0,

				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );

			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );

	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {

				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};

	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;

		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();

			if ( !isXML ) {

				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );




	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;

	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},

		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );

	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;

			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}

			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}

			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}

				return ( elem[ name ] = value );
			}

			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}

			return elem[ name ];
		},

		propHooks: {
			tabIndex: {
				get: function( elem ) {

					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );

					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}

					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}

					return -1;
				}
			}
		},

		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );

	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {

				/* eslint no-unused-expressions: "off" */

				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {

				/* eslint no-unused-expressions: "off" */

				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;

					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}

	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );




		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}


	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}

	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}

	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;

			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}

			classes = classesToArray( value );

			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}

						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}

			return this;
		},

		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;

			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}

			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}

			classes = classesToArray( value );

			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );

					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {

							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}

						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}

			return this;
		},

		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );

			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}

			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}

			return this.each( function() {
				var className, i, self, classNames;

				if ( isValidValue ) {

					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );

					while ( ( className = classNames[ i++ ] ) ) {

						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}

				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {

						// Store className if set
						dataPriv.set( this, "__className__", className );
					}

					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
								"" :
								dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},

		hasClass: function( selector ) {
			var className, elem,
				i = 0;

			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
				}
			}

			return false;
		}
	} );




	var rreturn = /\r/g;

	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];

			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];

					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}

					ret = elem.value;

					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}

					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}

				return;
			}

			valueIsFunction = isFunction( value );

			return this.each( function( i ) {
				var val;

				if ( this.nodeType !== 1 ) {
					return;
				}

				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}

				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";

				} else if ( typeof val === "number" ) {
					val += "";

				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}

				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );

	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {

					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :

						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;

					if ( index < 0 ) {
						i = max;

					} else {
						i = one ? index : 0;
					}

					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];

						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&

								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {

							// Get the specific value for the option
							value = jQuery( option ).val();

							// We don't need an array for one selects
							if ( one ) {
								return value;
							}

							// Multi-Selects return an array
							values.push( value );
						}
					}

					return values;
				},

				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;

					while ( i-- ) {
						option = options[ i ];

						/* eslint-disable no-cond-assign */

						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}

						/* eslint-enable no-cond-assign */
					}

					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );

	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );




	// Return jQuery for attributes-only inclusion


	support.focusin = "onfocusin" in window;


	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};

	jQuery.extend( jQuery.event, {

		trigger: function( event, data, elem, onlyHandlers ) {

			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

			cur = lastElement = tmp = elem = elem || document;

			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}

			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}

			if ( type.indexOf( "." ) > -1 ) {

				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;

			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );

			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;

			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}

			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );

			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}

			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}

				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}

			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;

				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}

				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;

			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {

				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {

					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];

						if ( tmp ) {
							elem[ ontype ] = null;
						}

						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;

						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}

						elem[ type ]();

						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}

						jQuery.event.triggered = undefined;

						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}

			return event.result;
		},

		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);

			jQuery.event.trigger( e, null, elem );
		}

	} );

	jQuery.fn.extend( {

		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );


	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};

			jQuery.event.special[ fix ] = {
				setup: function() {

					// Handle: regular nodes (via `this.ownerDocument`), window
					// (via `this.document`) & document (via `this`).
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix );

					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix ) - 1;

					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );

					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;

	var nonce = { guid: Date.now() };

	var rquery = ( /\?/ );



	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, parserErrorElem;
		if ( !data || typeof data !== "string" ) {
			return null;
		}

		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {}

		parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
		if ( !xml || parserErrorElem ) {
			jQuery.error( "Invalid XML: " + (
				parserErrorElem ?
					jQuery.map( parserErrorElem.childNodes, function( el ) {
						return el.textContent;
					} ).join( "\n" ) :
					data
			) );
		}
		return xml;
	};


	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;

	function buildParams( prefix, obj, traditional, add ) {
		var name;

		if ( Array.isArray( obj ) ) {

			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {

					// Treat each array item as a scalar.
					add( prefix, v );

				} else {

					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );

		} else if ( !traditional && toType( obj ) === "object" ) {

			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}

		} else {

			// Serialize scalar item.
			add( prefix, obj );
		}
	}

	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {

				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;

				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};

		if ( a == null ) {
			return "";
		}

		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );

		} else {

			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}

		// Return the resulting serialization
		return s.join( "&" );
	};

	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {

				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} ).filter( function() {
				var type = this.type;

				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} ).map( function( _i, elem ) {
				var val = jQuery( this ).val();

				if ( val == null ) {
					return null;
				}

				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}

				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );


	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,

		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},

		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},

		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),

		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );

	originAnchor.href = location.href;

	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {

		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {

			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}

			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

			if ( isFunction( func ) ) {

				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {

					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}

	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

		var inspected = {},
			seekingTransport = ( structure === transports );

		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}

		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}

	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};

		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}

		return target;
	}

	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {

		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;

		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}

		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}

		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {

			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}

			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}

		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}

	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},

			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();

		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}

		current = dataTypes.shift();

		// Convert to each sequential dataType
		while ( current ) {

			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}

			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}

			prev = current;
			current = dataTypes.shift();

			if ( current ) {

				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {

					current = prev;

				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {

					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];

					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {

							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {

								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {

									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];

									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}

					// Apply converter (if not an equivalence)
					if ( conv !== true ) {

						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}

		return { state: "success", data: response };
	}

	jQuery.extend( {

		// Counter for holding the number of active queries
		active: 0,

		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},

		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",

			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/

			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},

			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},

			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},

			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {

				// Convert anything to text
				"* text": String,

				// Text to html (true = no transformation)
				"text html": true,

				// Evaluate text as a json expression
				"text json": JSON.parse,

				// Parse text as xml
				"text xml": jQuery.parseXML
			},

			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},

		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?

				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},

		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),

		// Main method
		ajax: function( url, options ) {

			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}

			// Force options to be an object
			options = options || {};

			var transport,

				// URL without anti-cache param
				cacheURL,

				// Response headers
				responseHeadersString,
				responseHeaders,

				// timeout handle
				timeoutTimer,

				// Url cleanup var
				urlAnchor,

				// Request state (becomes false upon send and true upon completion)
				completed,

				// To know if global events are to be dispatched
				fireGlobals,

				// Loop variable
				i,

				// uncached part of the url
				uncached,

				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),

				// Callbacks context
				callbackContext = s.context || s,

				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),

				// Status-dependent callbacks
				statusCode = s.statusCode || {},

				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},

				// Default abort message
				strAbort = "canceled",

				// Fake xhr
				jqXHR = {
					readyState: 0,

					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},

					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},

					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},

					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},

					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {

								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {

								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},

					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};

			// Attach deferreds
			deferred.promise( jqXHR );

			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );

			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;

			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );

				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;

					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {

					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}

			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}

			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}

			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;

			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}

			// Uppercase the type
			s.type = s.type.toUpperCase();

			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );

			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );

			// More options handling for requests with no content
			if ( !s.hasContent ) {

				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );

				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}

				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
						uncached;
				}

				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;

			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}

			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}

			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}

			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);

			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}

			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

				// Abort if not done already and return
				return jqXHR.abort();
			}

			// Aborting is no longer a cancellation
			strAbort = "abort";

			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );

			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;

				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}

				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}

				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}

				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {

					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}

					// Propagate others as results
					done( -1, e );
				}
			}

			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;

				// Ignore repeat invocations
				if ( completed ) {
					return;
				}

				completed = true;

				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}

				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;

				// Cache response headers
				responseHeadersString = headers || "";

				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;

				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;

				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}

				// Use a noop converter for missing script but not if jsonp
				if ( !isSuccess &&
					jQuery.inArray( "script", s.dataTypes ) > -1 &&
					jQuery.inArray( "json", s.dataTypes ) < 0 ) {
					s.converters[ "text script" ] = function() {};
				}

				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );

				// If successful, handle type chaining
				if ( isSuccess ) {

					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}

					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";

					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";

					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {

					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}

				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";

				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}

				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;

				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}

				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}

			return jqXHR;
		},

		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},

		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );

	jQuery.each( [ "get", "post" ], function( _i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {

			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}

			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );

	jQuery.ajaxPrefilter( function( s ) {
		var i;
		for ( i in s.headers ) {
			if ( i.toLowerCase() === "content-type" ) {
				s.contentType = s.headers[ i ] || "";
			}
		}
	} );


	jQuery._evalUrl = function( url, options, doc ) {
		return jQuery.ajax( {
			url: url,

			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,

			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options, doc );
			}
		} );
	};


	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;

			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}

				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}

				wrap.map( function() {
					var elem = this;

					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}

					return elem;
				} ).append( this );
			}

			return this;
		},

		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}

			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();

				if ( contents.length ) {
					contents.wrapAll( html );

				} else {
					self.append( html );
				}
			} );
		},

		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );

			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},

		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );


	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};




	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};

	var xhrSuccessStatus = {

			// File protocol always yields status code 0, assume 200
			0: 200,

			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();

	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;

	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;

		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();

					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);

					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}

					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}

					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}

					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}

					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;

								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {

									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(

											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,

										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};

					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {

							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {

								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}

					// Create the abort callback
					callback = callback( "abort" );

					try {

						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {

						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},

				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );




	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );

	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );

	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );

	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {

		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );

					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );




	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;

	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );

	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);

		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;

			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}

			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};

			// Force json dataType
			s.dataTypes[ 0 ] = "json";

			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};

			// Clean-up function (fires after converters)
			jqXHR.always( function() {

				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );

				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}

				// Save back as free
				if ( s[ callbackName ] ) {

					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;

					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}

				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}

				responseContainer = overwritten = undefined;
			} );

			// Delegate to script
			return "script";
		}
	} );




	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();


	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}

		var base, parsed, scripts;

		if ( !context ) {

			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );

				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}

		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];

		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}

		parsed = buildFragment( [ data ], context, scripts );

		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}

		return jQuery.merge( [], parsed.childNodes );
	};


	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );

		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}

		// If it's a function
		if ( isFunction( params ) ) {

			// We assume that it's the callback
			callback = params;
			params = undefined;

		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}

		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,

				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {

				// Save response for use in complete callback
				response = arguments;

				self.html( selector ?

					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

					// Otherwise use the full result
					responseText );

			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}

		return this;
	};




	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};




	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};

			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}

			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;

			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}

			if ( isFunction( options ) ) {

				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}

			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}

			if ( "using" in options ) {
				options.using.call( elem, props );

			} else {
				curElem.css( props );
			}
		}
	};

	jQuery.fn.extend( {

		// offset() relates an element's border box to the document origin
		offset: function( options ) {

			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}

			var rect, win,
				elem = this[ 0 ];

			if ( !elem ) {
				return;
			}

			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}

			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},

		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}

			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };

			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {

				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();

			} else {
				offset = this.offset();

				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {

					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}

			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},

		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;

				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}

				return offsetParent || documentElement;
			} );
		}
	} );

	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;

		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {

				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}

				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}

				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);

				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );

	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( _i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );

					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );


	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( {
			padding: "inner" + name,
			content: type,
			"": "outer" + name
		}, function( defaultExtra, funcName ) {

			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

				return access( this, function( elem, type, value ) {
					var doc;

					if ( isWindow( elem ) ) {

						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}

					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;

						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}

					return value === undefined ?

						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :

						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );


	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( _i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );




	jQuery.fn.extend( {

		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},

		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {

			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},

		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );

	jQuery.each(
		( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( _i, name ) {

			// Handle event binding
			jQuery.fn[ name ] = function( data, fn ) {
				return arguments.length > 0 ?
					this.on( name, null, data, fn ) :
					this.trigger( name );
			};
		}
	);




	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	};

	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;

	jQuery.now = Date.now;

	jQuery.isNumeric = function( obj ) {

		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&

			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};

	jQuery.trim = function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	};




	var

		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,

		// Map over the $ in case of overwrite
		_$ = window.$;

	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}

		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}

		return jQuery;
	};

	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( typeof noGlobal === "undefined" ) {
		window.jQuery = window.$ = jQuery;
	}




	return jQuery;
	} );
	});

	createCommonjsModule(function (module, exports) {
	(function(factory) {
	    {
	        module.exports = factory(jquery);
	    }

	}(function($) {
	    var Slick = window.Slick || {};

	    Slick = (function() {

	        var instanceUid = 0;

	        function Slick(element, settings) {

	            var _ = this, dataSettings;

	            _.defaults = {
	                accessibility: true,
	                adaptiveHeight: false,
	                appendArrows: $(element),
	                appendDots: $(element),
	                arrows: true,
	                asNavFor: null,
	                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
	                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
	                autoplay: false,
	                autoplaySpeed: 3000,
	                centerMode: false,
	                centerPadding: '50px',
	                cssEase: 'ease',
	                customPaging: function(slider, i) {
	                    return $('<button type="button" />').text(i + 1);
	                },
	                dots: false,
	                dotsClass: 'slick-dots',
	                draggable: true,
	                easing: 'linear',
	                edgeFriction: 0.35,
	                fade: false,
	                focusOnSelect: false,
	                focusOnChange: false,
	                infinite: true,
	                initialSlide: 0,
	                lazyLoad: 'ondemand',
	                mobileFirst: false,
	                pauseOnHover: true,
	                pauseOnFocus: true,
	                pauseOnDotsHover: false,
	                respondTo: 'window',
	                responsive: null,
	                rows: 1,
	                rtl: false,
	                slide: '',
	                slidesPerRow: 1,
	                slidesToShow: 1,
	                slidesToScroll: 1,
	                speed: 500,
	                swipe: true,
	                swipeToSlide: false,
	                touchMove: true,
	                touchThreshold: 5,
	                useCSS: true,
	                useTransform: true,
	                variableWidth: false,
	                vertical: false,
	                verticalSwiping: false,
	                waitForAnimate: true,
	                zIndex: 1000
	            };

	            _.initials = {
	                animating: false,
	                dragging: false,
	                autoPlayTimer: null,
	                currentDirection: 0,
	                currentLeft: null,
	                currentSlide: 0,
	                direction: 1,
	                $dots: null,
	                listWidth: null,
	                listHeight: null,
	                loadIndex: 0,
	                $nextArrow: null,
	                $prevArrow: null,
	                scrolling: false,
	                slideCount: null,
	                slideWidth: null,
	                $slideTrack: null,
	                $slides: null,
	                sliding: false,
	                slideOffset: 0,
	                swipeLeft: null,
	                swiping: false,
	                $list: null,
	                touchObject: {},
	                transformsEnabled: false,
	                unslicked: false
	            };

	            $.extend(_, _.initials);

	            _.activeBreakpoint = null;
	            _.animType = null;
	            _.animProp = null;
	            _.breakpoints = [];
	            _.breakpointSettings = [];
	            _.cssTransitions = false;
	            _.focussed = false;
	            _.interrupted = false;
	            _.hidden = 'hidden';
	            _.paused = true;
	            _.positionProp = null;
	            _.respondTo = null;
	            _.rowCount = 1;
	            _.shouldClick = true;
	            _.$slider = $(element);
	            _.$slidesCache = null;
	            _.transformType = null;
	            _.transitionType = null;
	            _.visibilityChange = 'visibilitychange';
	            _.windowWidth = 0;
	            _.windowTimer = null;

	            dataSettings = $(element).data('slick') || {};

	            _.options = $.extend({}, _.defaults, settings, dataSettings);

	            _.currentSlide = _.options.initialSlide;

	            _.originalSettings = _.options;

	            if (typeof document.mozHidden !== 'undefined') {
	                _.hidden = 'mozHidden';
	                _.visibilityChange = 'mozvisibilitychange';
	            } else if (typeof document.webkitHidden !== 'undefined') {
	                _.hidden = 'webkitHidden';
	                _.visibilityChange = 'webkitvisibilitychange';
	            }

	            _.autoPlay = $.proxy(_.autoPlay, _);
	            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
	            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
	            _.changeSlide = $.proxy(_.changeSlide, _);
	            _.clickHandler = $.proxy(_.clickHandler, _);
	            _.selectHandler = $.proxy(_.selectHandler, _);
	            _.setPosition = $.proxy(_.setPosition, _);
	            _.swipeHandler = $.proxy(_.swipeHandler, _);
	            _.dragHandler = $.proxy(_.dragHandler, _);
	            _.keyHandler = $.proxy(_.keyHandler, _);

	            _.instanceUid = instanceUid++;

	            // A simple way to check for HTML strings
	            // Strict HTML recognition (must start with <)
	            // Extracted from jQuery v1.11 source
	            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;


	            _.registerBreakpoints();
	            _.init(true);

	        }

	        return Slick;

	    }());

	    Slick.prototype.activateADA = function() {
	        var _ = this;

	        _.$slideTrack.find('.slick-active').attr({
	            'aria-hidden': 'false'
	        }).find('a, input, button, select').attr({
	            'tabindex': '0'
	        });

	    };

	    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {

	        var _ = this;

	        if (typeof(index) === 'boolean') {
	            addBefore = index;
	            index = null;
	        } else if (index < 0 || (index >= _.slideCount)) {
	            return false;
	        }

	        _.unload();

	        if (typeof(index) === 'number') {
	            if (index === 0 && _.$slides.length === 0) {
	                $(markup).appendTo(_.$slideTrack);
	            } else if (addBefore) {
	                $(markup).insertBefore(_.$slides.eq(index));
	            } else {
	                $(markup).insertAfter(_.$slides.eq(index));
	            }
	        } else {
	            if (addBefore === true) {
	                $(markup).prependTo(_.$slideTrack);
	            } else {
	                $(markup).appendTo(_.$slideTrack);
	            }
	        }

	        _.$slides = _.$slideTrack.children(this.options.slide);

	        _.$slideTrack.children(this.options.slide).detach();

	        _.$slideTrack.append(_.$slides);

	        _.$slides.each(function(index, element) {
	            $(element).attr('data-slick-index', index);
	        });

	        _.$slidesCache = _.$slides;

	        _.reinit();

	    };

	    Slick.prototype.animateHeight = function() {
	        var _ = this;
	        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
	            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
	            _.$list.animate({
	                height: targetHeight
	            }, _.options.speed);
	        }
	    };

	    Slick.prototype.animateSlide = function(targetLeft, callback) {

	        var animProps = {},
	            _ = this;

	        _.animateHeight();

	        if (_.options.rtl === true && _.options.vertical === false) {
	            targetLeft = -targetLeft;
	        }
	        if (_.transformsEnabled === false) {
	            if (_.options.vertical === false) {
	                _.$slideTrack.animate({
	                    left: targetLeft
	                }, _.options.speed, _.options.easing, callback);
	            } else {
	                _.$slideTrack.animate({
	                    top: targetLeft
	                }, _.options.speed, _.options.easing, callback);
	            }

	        } else {

	            if (_.cssTransitions === false) {
	                if (_.options.rtl === true) {
	                    _.currentLeft = -(_.currentLeft);
	                }
	                $({
	                    animStart: _.currentLeft
	                }).animate({
	                    animStart: targetLeft
	                }, {
	                    duration: _.options.speed,
	                    easing: _.options.easing,
	                    step: function(now) {
	                        now = Math.ceil(now);
	                        if (_.options.vertical === false) {
	                            animProps[_.animType] = 'translate(' +
	                                now + 'px, 0px)';
	                            _.$slideTrack.css(animProps);
	                        } else {
	                            animProps[_.animType] = 'translate(0px,' +
	                                now + 'px)';
	                            _.$slideTrack.css(animProps);
	                        }
	                    },
	                    complete: function() {
	                        if (callback) {
	                            callback.call();
	                        }
	                    }
	                });

	            } else {

	                _.applyTransition();
	                targetLeft = Math.ceil(targetLeft);

	                if (_.options.vertical === false) {
	                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
	                } else {
	                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
	                }
	                _.$slideTrack.css(animProps);

	                if (callback) {
	                    setTimeout(function() {

	                        _.disableTransition();

	                        callback.call();
	                    }, _.options.speed);
	                }

	            }

	        }

	    };

	    Slick.prototype.getNavTarget = function() {

	        var _ = this,
	            asNavFor = _.options.asNavFor;

	        if ( asNavFor && asNavFor !== null ) {
	            asNavFor = $(asNavFor).not(_.$slider);
	        }

	        return asNavFor;

	    };

	    Slick.prototype.asNavFor = function(index) {

	        var _ = this,
	            asNavFor = _.getNavTarget();

	        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
	            asNavFor.each(function() {
	                var target = $(this).slick('getSlick');
	                if(!target.unslicked) {
	                    target.slideHandler(index, true);
	                }
	            });
	        }

	    };

	    Slick.prototype.applyTransition = function(slide) {

	        var _ = this,
	            transition = {};

	        if (_.options.fade === false) {
	            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
	        } else {
	            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
	        }

	        if (_.options.fade === false) {
	            _.$slideTrack.css(transition);
	        } else {
	            _.$slides.eq(slide).css(transition);
	        }

	    };

	    Slick.prototype.autoPlay = function() {

	        var _ = this;

	        _.autoPlayClear();

	        if ( _.slideCount > _.options.slidesToShow ) {
	            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
	        }

	    };

	    Slick.prototype.autoPlayClear = function() {

	        var _ = this;

	        if (_.autoPlayTimer) {
	            clearInterval(_.autoPlayTimer);
	        }

	    };

	    Slick.prototype.autoPlayIterator = function() {

	        var _ = this,
	            slideTo = _.currentSlide + _.options.slidesToScroll;

	        if ( !_.paused && !_.interrupted && !_.focussed ) {

	            if ( _.options.infinite === false ) {

	                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
	                    _.direction = 0;
	                }

	                else if ( _.direction === 0 ) {

	                    slideTo = _.currentSlide - _.options.slidesToScroll;

	                    if ( _.currentSlide - 1 === 0 ) {
	                        _.direction = 1;
	                    }

	                }

	            }

	            _.slideHandler( slideTo );

	        }

	    };

	    Slick.prototype.buildArrows = function() {

	        var _ = this;

	        if (_.options.arrows === true ) {

	            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
	            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

	            if( _.slideCount > _.options.slidesToShow ) {

	                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
	                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

	                if (_.htmlExpr.test(_.options.prevArrow)) {
	                    _.$prevArrow.prependTo(_.options.appendArrows);
	                }

	                if (_.htmlExpr.test(_.options.nextArrow)) {
	                    _.$nextArrow.appendTo(_.options.appendArrows);
	                }

	                if (_.options.infinite !== true) {
	                    _.$prevArrow
	                        .addClass('slick-disabled')
	                        .attr('aria-disabled', 'true');
	                }

	            } else {

	                _.$prevArrow.add( _.$nextArrow )

	                    .addClass('slick-hidden')
	                    .attr({
	                        'aria-disabled': 'true',
	                        'tabindex': '-1'
	                    });

	            }

	        }

	    };

	    Slick.prototype.buildDots = function() {

	        var _ = this,
	            i, dot;

	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

	            _.$slider.addClass('slick-dotted');

	            dot = $('<ul />').addClass(_.options.dotsClass);

	            for (i = 0; i <= _.getDotCount(); i += 1) {
	                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
	            }

	            _.$dots = dot.appendTo(_.options.appendDots);

	            _.$dots.find('li').first().addClass('slick-active');

	        }

	    };

	    Slick.prototype.buildOut = function() {

	        var _ = this;

	        _.$slides =
	            _.$slider
	                .children( _.options.slide + ':not(.slick-cloned)')
	                .addClass('slick-slide');

	        _.slideCount = _.$slides.length;

	        _.$slides.each(function(index, element) {
	            $(element)
	                .attr('data-slick-index', index)
	                .data('originalStyling', $(element).attr('style') || '');
	        });

	        _.$slider.addClass('slick-slider');

	        _.$slideTrack = (_.slideCount === 0) ?
	            $('<div class="slick-track"/>').appendTo(_.$slider) :
	            _.$slides.wrapAll('<div class="slick-track"/>').parent();

	        _.$list = _.$slideTrack.wrap(
	            '<div class="slick-list"/>').parent();
	        _.$slideTrack.css('opacity', 0);

	        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
	            _.options.slidesToScroll = 1;
	        }

	        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

	        _.setupInfinite();

	        _.buildArrows();

	        _.buildDots();

	        _.updateDots();


	        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

	        if (_.options.draggable === true) {
	            _.$list.addClass('draggable');
	        }

	    };

	    Slick.prototype.buildRows = function() {

	        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;

	        newSlides = document.createDocumentFragment();
	        originalSlides = _.$slider.children();

	        if(_.options.rows > 0) {

	            slidesPerSection = _.options.slidesPerRow * _.options.rows;
	            numOfSlides = Math.ceil(
	                originalSlides.length / slidesPerSection
	            );

	            for(a = 0; a < numOfSlides; a++){
	                var slide = document.createElement('div');
	                for(b = 0; b < _.options.rows; b++) {
	                    var row = document.createElement('div');
	                    for(c = 0; c < _.options.slidesPerRow; c++) {
	                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
	                        if (originalSlides.get(target)) {
	                            row.appendChild(originalSlides.get(target));
	                        }
	                    }
	                    slide.appendChild(row);
	                }
	                newSlides.appendChild(slide);
	            }

	            _.$slider.empty().append(newSlides);
	            _.$slider.children().children().children()
	                .css({
	                    'width':(100 / _.options.slidesPerRow) + '%',
	                    'display': 'inline-block'
	                });

	        }

	    };

	    Slick.prototype.checkResponsive = function(initial, forceUpdate) {

	        var _ = this,
	            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
	        var sliderWidth = _.$slider.width();
	        var windowWidth = window.innerWidth || $(window).width();

	        if (_.respondTo === 'window') {
	            respondToWidth = windowWidth;
	        } else if (_.respondTo === 'slider') {
	            respondToWidth = sliderWidth;
	        } else if (_.respondTo === 'min') {
	            respondToWidth = Math.min(windowWidth, sliderWidth);
	        }

	        if ( _.options.responsive &&
	            _.options.responsive.length &&
	            _.options.responsive !== null) {

	            targetBreakpoint = null;

	            for (breakpoint in _.breakpoints) {
	                if (_.breakpoints.hasOwnProperty(breakpoint)) {
	                    if (_.originalSettings.mobileFirst === false) {
	                        if (respondToWidth < _.breakpoints[breakpoint]) {
	                            targetBreakpoint = _.breakpoints[breakpoint];
	                        }
	                    } else {
	                        if (respondToWidth > _.breakpoints[breakpoint]) {
	                            targetBreakpoint = _.breakpoints[breakpoint];
	                        }
	                    }
	                }
	            }

	            if (targetBreakpoint !== null) {
	                if (_.activeBreakpoint !== null) {
	                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
	                        _.activeBreakpoint =
	                            targetBreakpoint;
	                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
	                            _.unslick(targetBreakpoint);
	                        } else {
	                            _.options = $.extend({}, _.originalSettings,
	                                _.breakpointSettings[
	                                    targetBreakpoint]);
	                            if (initial === true) {
	                                _.currentSlide = _.options.initialSlide;
	                            }
	                            _.refresh(initial);
	                        }
	                        triggerBreakpoint = targetBreakpoint;
	                    }
	                } else {
	                    _.activeBreakpoint = targetBreakpoint;
	                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
	                        _.unslick(targetBreakpoint);
	                    } else {
	                        _.options = $.extend({}, _.originalSettings,
	                            _.breakpointSettings[
	                                targetBreakpoint]);
	                        if (initial === true) {
	                            _.currentSlide = _.options.initialSlide;
	                        }
	                        _.refresh(initial);
	                    }
	                    triggerBreakpoint = targetBreakpoint;
	                }
	            } else {
	                if (_.activeBreakpoint !== null) {
	                    _.activeBreakpoint = null;
	                    _.options = _.originalSettings;
	                    if (initial === true) {
	                        _.currentSlide = _.options.initialSlide;
	                    }
	                    _.refresh(initial);
	                    triggerBreakpoint = targetBreakpoint;
	                }
	            }

	            // only trigger breakpoints during an actual break. not on initialize.
	            if( !initial && triggerBreakpoint !== false ) {
	                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
	            }
	        }

	    };

	    Slick.prototype.changeSlide = function(event, dontAnimate) {

	        var _ = this,
	            $target = $(event.currentTarget),
	            indexOffset, slideOffset, unevenOffset;

	        // If target is a link, prevent default action.
	        if($target.is('a')) {
	            event.preventDefault();
	        }

	        // If target is not the <li> element (ie: a child), find the <li>.
	        if(!$target.is('li')) {
	            $target = $target.closest('li');
	        }

	        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
	        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

	        switch (event.data.message) {

	            case 'previous':
	                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
	                if (_.slideCount > _.options.slidesToShow) {
	                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
	                }
	                break;

	            case 'next':
	                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
	                if (_.slideCount > _.options.slidesToShow) {
	                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
	                }
	                break;

	            case 'index':
	                var index = event.data.index === 0 ? 0 :
	                    event.data.index || $target.index() * _.options.slidesToScroll;

	                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
	                $target.children().trigger('focus');
	                break;

	            default:
	                return;
	        }

	    };

	    Slick.prototype.checkNavigable = function(index) {

	        var _ = this,
	            navigables, prevNavigable;

	        navigables = _.getNavigableIndexes();
	        prevNavigable = 0;
	        if (index > navigables[navigables.length - 1]) {
	            index = navigables[navigables.length - 1];
	        } else {
	            for (var n in navigables) {
	                if (index < navigables[n]) {
	                    index = prevNavigable;
	                    break;
	                }
	                prevNavigable = navigables[n];
	            }
	        }

	        return index;
	    };

	    Slick.prototype.cleanUpEvents = function() {

	        var _ = this;

	        if (_.options.dots && _.$dots !== null) {

	            $('li', _.$dots)
	                .off('click.slick', _.changeSlide)
	                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
	                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));

	            if (_.options.accessibility === true) {
	                _.$dots.off('keydown.slick', _.keyHandler);
	            }
	        }

	        _.$slider.off('focus.slick blur.slick');

	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
	            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);

	            if (_.options.accessibility === true) {
	                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
	                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
	            }
	        }

	        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
	        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
	        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
	        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

	        _.$list.off('click.slick', _.clickHandler);

	        $(document).off(_.visibilityChange, _.visibility);

	        _.cleanUpSlideEvents();

	        if (_.options.accessibility === true) {
	            _.$list.off('keydown.slick', _.keyHandler);
	        }

	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
	        }

	        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

	        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

	        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

	        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);

	    };

	    Slick.prototype.cleanUpSlideEvents = function() {

	        var _ = this;

	        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
	        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));

	    };

	    Slick.prototype.cleanUpRows = function() {

	        var _ = this, originalSlides;

	        if(_.options.rows > 0) {
	            originalSlides = _.$slides.children().children();
	            originalSlides.removeAttr('style');
	            _.$slider.empty().append(originalSlides);
	        }

	    };

	    Slick.prototype.clickHandler = function(event) {

	        var _ = this;

	        if (_.shouldClick === false) {
	            event.stopImmediatePropagation();
	            event.stopPropagation();
	            event.preventDefault();
	        }

	    };

	    Slick.prototype.destroy = function(refresh) {

	        var _ = this;

	        _.autoPlayClear();

	        _.touchObject = {};

	        _.cleanUpEvents();

	        $('.slick-cloned', _.$slider).detach();

	        if (_.$dots) {
	            _.$dots.remove();
	        }

	        if ( _.$prevArrow && _.$prevArrow.length ) {

	            _.$prevArrow
	                .removeClass('slick-disabled slick-arrow slick-hidden')
	                .removeAttr('aria-hidden aria-disabled tabindex')
	                .css('display','');

	            if ( _.htmlExpr.test( _.options.prevArrow )) {
	                _.$prevArrow.remove();
	            }
	        }

	        if ( _.$nextArrow && _.$nextArrow.length ) {

	            _.$nextArrow
	                .removeClass('slick-disabled slick-arrow slick-hidden')
	                .removeAttr('aria-hidden aria-disabled tabindex')
	                .css('display','');

	            if ( _.htmlExpr.test( _.options.nextArrow )) {
	                _.$nextArrow.remove();
	            }
	        }


	        if (_.$slides) {

	            _.$slides
	                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
	                .removeAttr('aria-hidden')
	                .removeAttr('data-slick-index')
	                .each(function(){
	                    $(this).attr('style', $(this).data('originalStyling'));
	                });

	            _.$slideTrack.children(this.options.slide).detach();

	            _.$slideTrack.detach();

	            _.$list.detach();

	            _.$slider.append(_.$slides);
	        }

	        _.cleanUpRows();

	        _.$slider.removeClass('slick-slider');
	        _.$slider.removeClass('slick-initialized');
	        _.$slider.removeClass('slick-dotted');

	        _.unslicked = true;

	        if(!refresh) {
	            _.$slider.trigger('destroy', [_]);
	        }

	    };

	    Slick.prototype.disableTransition = function(slide) {

	        var _ = this,
	            transition = {};

	        transition[_.transitionType] = '';

	        if (_.options.fade === false) {
	            _.$slideTrack.css(transition);
	        } else {
	            _.$slides.eq(slide).css(transition);
	        }

	    };

	    Slick.prototype.fadeSlide = function(slideIndex, callback) {

	        var _ = this;

	        if (_.cssTransitions === false) {

	            _.$slides.eq(slideIndex).css({
	                zIndex: _.options.zIndex
	            });

	            _.$slides.eq(slideIndex).animate({
	                opacity: 1
	            }, _.options.speed, _.options.easing, callback);

	        } else {

	            _.applyTransition(slideIndex);

	            _.$slides.eq(slideIndex).css({
	                opacity: 1,
	                zIndex: _.options.zIndex
	            });

	            if (callback) {
	                setTimeout(function() {

	                    _.disableTransition(slideIndex);

	                    callback.call();
	                }, _.options.speed);
	            }

	        }

	    };

	    Slick.prototype.fadeSlideOut = function(slideIndex) {

	        var _ = this;

	        if (_.cssTransitions === false) {

	            _.$slides.eq(slideIndex).animate({
	                opacity: 0,
	                zIndex: _.options.zIndex - 2
	            }, _.options.speed, _.options.easing);

	        } else {

	            _.applyTransition(slideIndex);

	            _.$slides.eq(slideIndex).css({
	                opacity: 0,
	                zIndex: _.options.zIndex - 2
	            });

	        }

	    };

	    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {

	        var _ = this;

	        if (filter !== null) {

	            _.$slidesCache = _.$slides;

	            _.unload();

	            _.$slideTrack.children(this.options.slide).detach();

	            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

	            _.reinit();

	        }

	    };

	    Slick.prototype.focusHandler = function() {

	        var _ = this;

	        _.$slider
	            .off('focus.slick blur.slick')
	            .on('focus.slick blur.slick', '*', function(event) {

	            event.stopImmediatePropagation();
	            var $sf = $(this);

	            setTimeout(function() {

	                if( _.options.pauseOnFocus ) {
	                    _.focussed = $sf.is(':focus');
	                    _.autoPlay();
	                }

	            }, 0);

	        });
	    };

	    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {

	        var _ = this;
	        return _.currentSlide;

	    };

	    Slick.prototype.getDotCount = function() {

	        var _ = this;

	        var breakPoint = 0;
	        var counter = 0;
	        var pagerQty = 0;

	        if (_.options.infinite === true) {
	            if (_.slideCount <= _.options.slidesToShow) {
	                 ++pagerQty;
	            } else {
	                while (breakPoint < _.slideCount) {
	                    ++pagerQty;
	                    breakPoint = counter + _.options.slidesToScroll;
	                    counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	                }
	            }
	        } else if (_.options.centerMode === true) {
	            pagerQty = _.slideCount;
	        } else if(!_.options.asNavFor) {
	            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
	        }else {
	            while (breakPoint < _.slideCount) {
	                ++pagerQty;
	                breakPoint = counter + _.options.slidesToScroll;
	                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	            }
	        }

	        return pagerQty - 1;

	    };

	    Slick.prototype.getLeft = function(slideIndex) {

	        var _ = this,
	            targetLeft,
	            verticalHeight,
	            verticalOffset = 0,
	            targetSlide,
	            coef;

	        _.slideOffset = 0;
	        verticalHeight = _.$slides.first().outerHeight(true);

	        if (_.options.infinite === true) {
	            if (_.slideCount > _.options.slidesToShow) {
	                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
	                coef = -1;

	                if (_.options.vertical === true && _.options.centerMode === true) {
	                    if (_.options.slidesToShow === 2) {
	                        coef = -1.5;
	                    } else if (_.options.slidesToShow === 1) {
	                        coef = -2;
	                    }
	                }
	                verticalOffset = (verticalHeight * _.options.slidesToShow) * coef;
	            }
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
	                    if (slideIndex > _.slideCount) {
	                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
	                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
	                    } else {
	                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
	                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
	                    }
	                }
	            }
	        } else {
	            if (slideIndex + _.options.slidesToShow > _.slideCount) {
	                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
	                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
	            }
	        }

	        if (_.slideCount <= _.options.slidesToShow) {
	            _.slideOffset = 0;
	            verticalOffset = 0;
	        }

	        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
	            _.slideOffset = ((_.slideWidth * Math.floor(_.options.slidesToShow)) / 2) - ((_.slideWidth * _.slideCount) / 2);
	        } else if (_.options.centerMode === true && _.options.infinite === true) {
	            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
	        } else if (_.options.centerMode === true) {
	            _.slideOffset = 0;
	            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
	        }

	        if (_.options.vertical === false) {
	            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
	        } else {
	            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
	        }

	        if (_.options.variableWidth === true) {

	            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
	                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
	            } else {
	                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
	            }

	            if (_.options.rtl === true) {
	                if (targetSlide[0]) {
	                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
	                } else {
	                    targetLeft =  0;
	                }
	            } else {
	                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
	            }

	            if (_.options.centerMode === true) {
	                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
	                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
	                } else {
	                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
	                }

	                if (_.options.rtl === true) {
	                    if (targetSlide[0]) {
	                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
	                    } else {
	                        targetLeft =  0;
	                    }
	                } else {
	                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
	                }

	                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
	            }
	        }

	        return targetLeft;

	    };

	    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {

	        var _ = this;

	        return _.options[option];

	    };

	    Slick.prototype.getNavigableIndexes = function() {

	        var _ = this,
	            breakPoint = 0,
	            counter = 0,
	            indexes = [],
	            max;

	        if (_.options.infinite === false) {
	            max = _.slideCount;
	        } else {
	            breakPoint = _.options.slidesToScroll * -1;
	            counter = _.options.slidesToScroll * -1;
	            max = _.slideCount * 2;
	        }

	        while (breakPoint < max) {
	            indexes.push(breakPoint);
	            breakPoint = counter + _.options.slidesToScroll;
	            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	        }

	        return indexes;

	    };

	    Slick.prototype.getSlick = function() {

	        return this;

	    };

	    Slick.prototype.getSlideCount = function() {

	        var _ = this,
	            slidesTraversed, swipedSlide, centerOffset;

	        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

	        if (_.options.swipeToSlide === true) {
	            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
	                if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
	                    swipedSlide = slide;
	                    return false;
	                }
	            });

	            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

	            return slidesTraversed;

	        } else {
	            return _.options.slidesToScroll;
	        }

	    };

	    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {

	        var _ = this;

	        _.changeSlide({
	            data: {
	                message: 'index',
	                index: parseInt(slide)
	            }
	        }, dontAnimate);

	    };

	    Slick.prototype.init = function(creation) {

	        var _ = this;

	        if (!$(_.$slider).hasClass('slick-initialized')) {

	            $(_.$slider).addClass('slick-initialized');

	            _.buildRows();
	            _.buildOut();
	            _.setProps();
	            _.startLoad();
	            _.loadSlider();
	            _.initializeEvents();
	            _.updateArrows();
	            _.updateDots();
	            _.checkResponsive(true);
	            _.focusHandler();

	        }

	        if (creation) {
	            _.$slider.trigger('init', [_]);
	        }

	        if (_.options.accessibility === true) {
	            _.initADA();
	        }

	        if ( _.options.autoplay ) {

	            _.paused = false;
	            _.autoPlay();

	        }

	    };

	    Slick.prototype.initADA = function() {
	        var _ = this,
	                numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
	                tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
	                    return (val >= 0) && (val < _.slideCount);
	                });

	        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
	            'aria-hidden': 'true',
	            'tabindex': '-1'
	        }).find('a, input, button, select').attr({
	            'tabindex': '-1'
	        });

	        if (_.$dots !== null) {
	            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
	                var slideControlIndex = tabControlIndexes.indexOf(i);

	                $(this).attr({
	                    'role': 'tabpanel',
	                    'id': 'slick-slide' + _.instanceUid + i,
	                    'tabindex': -1
	                });

	                if (slideControlIndex !== -1) {
	                   var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex;
	                   if ($('#' + ariaButtonControl).length) {
	                     $(this).attr({
	                         'aria-describedby': ariaButtonControl
	                     });
	                   }
	                }
	            });

	            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
	                var mappedSlideIndex = tabControlIndexes[i];

	                $(this).attr({
	                    'role': 'presentation'
	                });

	                $(this).find('button').first().attr({
	                    'role': 'tab',
	                    'id': 'slick-slide-control' + _.instanceUid + i,
	                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
	                    'aria-label': (i + 1) + ' of ' + numDotGroups,
	                    'aria-selected': null,
	                    'tabindex': '-1'
	                });

	            }).eq(_.currentSlide).find('button').attr({
	                'aria-selected': 'true',
	                'tabindex': '0'
	            }).end();
	        }

	        for (var i=_.currentSlide, max=i+_.options.slidesToShow; i < max; i++) {
	          if (_.options.focusOnChange) {
	            _.$slides.eq(i).attr({'tabindex': '0'});
	          } else {
	            _.$slides.eq(i).removeAttr('tabindex');
	          }
	        }

	        _.activateADA();

	    };

	    Slick.prototype.initArrowEvents = function() {

	        var _ = this;

	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	            _.$prevArrow
	               .off('click.slick')
	               .on('click.slick', {
	                    message: 'previous'
	               }, _.changeSlide);
	            _.$nextArrow
	               .off('click.slick')
	               .on('click.slick', {
	                    message: 'next'
	               }, _.changeSlide);

	            if (_.options.accessibility === true) {
	                _.$prevArrow.on('keydown.slick', _.keyHandler);
	                _.$nextArrow.on('keydown.slick', _.keyHandler);
	            }
	        }

	    };

	    Slick.prototype.initDotEvents = function() {

	        var _ = this;

	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	            $('li', _.$dots).on('click.slick', {
	                message: 'index'
	            }, _.changeSlide);

	            if (_.options.accessibility === true) {
	                _.$dots.on('keydown.slick', _.keyHandler);
	            }
	        }

	        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {

	            $('li', _.$dots)
	                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
	                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));

	        }

	    };

	    Slick.prototype.initSlideEvents = function() {

	        var _ = this;

	        if ( _.options.pauseOnHover ) {

	            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
	            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));

	        }

	    };

	    Slick.prototype.initializeEvents = function() {

	        var _ = this;

	        _.initArrowEvents();

	        _.initDotEvents();
	        _.initSlideEvents();

	        _.$list.on('touchstart.slick mousedown.slick', {
	            action: 'start'
	        }, _.swipeHandler);
	        _.$list.on('touchmove.slick mousemove.slick', {
	            action: 'move'
	        }, _.swipeHandler);
	        _.$list.on('touchend.slick mouseup.slick', {
	            action: 'end'
	        }, _.swipeHandler);
	        _.$list.on('touchcancel.slick mouseleave.slick', {
	            action: 'end'
	        }, _.swipeHandler);

	        _.$list.on('click.slick', _.clickHandler);

	        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

	        if (_.options.accessibility === true) {
	            _.$list.on('keydown.slick', _.keyHandler);
	        }

	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
	        }

	        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

	        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

	        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

	        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
	        $(_.setPosition);

	    };

	    Slick.prototype.initUI = function() {

	        var _ = this;

	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

	            _.$prevArrow.show();
	            _.$nextArrow.show();

	        }

	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

	            _.$dots.show();

	        }

	    };

	    Slick.prototype.keyHandler = function(event) {

	        var _ = this;
	         //Dont slide if the cursor is inside the form fields and arrow keys are pressed
	        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
	            if (event.keyCode === 37 && _.options.accessibility === true) {
	                _.changeSlide({
	                    data: {
	                        message: _.options.rtl === true ? 'next' :  'previous'
	                    }
	                });
	            } else if (event.keyCode === 39 && _.options.accessibility === true) {
	                _.changeSlide({
	                    data: {
	                        message: _.options.rtl === true ? 'previous' : 'next'
	                    }
	                });
	            }
	        }

	    };

	    Slick.prototype.lazyLoad = function() {

	        var _ = this,
	            loadRange, cloneRange, rangeStart, rangeEnd;

	        function loadImages(imagesScope) {

	            $('img[data-lazy]', imagesScope).each(function() {

	                var image = $(this),
	                    imageSource = $(this).attr('data-lazy'),
	                    imageSrcSet = $(this).attr('data-srcset'),
	                    imageSizes  = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
	                    imageToLoad = document.createElement('img');

	                imageToLoad.onload = function() {

	                    image
	                        .animate({ opacity: 0 }, 100, function() {

	                            if (imageSrcSet) {
	                                image
	                                    .attr('srcset', imageSrcSet );

	                                if (imageSizes) {
	                                    image
	                                        .attr('sizes', imageSizes );
	                                }
	                            }

	                            image
	                                .attr('src', imageSource)
	                                .animate({ opacity: 1 }, 200, function() {
	                                    image
	                                        .removeAttr('data-lazy data-srcset data-sizes')
	                                        .removeClass('slick-loading');
	                                });
	                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
	                        });

	                };

	                imageToLoad.onerror = function() {

	                    image
	                        .removeAttr( 'data-lazy' )
	                        .removeClass( 'slick-loading' )
	                        .addClass( 'slick-lazyload-error' );

	                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

	                };

	                imageToLoad.src = imageSource;

	            });

	        }

	        if (_.options.centerMode === true) {
	            if (_.options.infinite === true) {
	                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
	                rangeEnd = rangeStart + _.options.slidesToShow + 2;
	            } else {
	                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
	                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
	            }
	        } else {
	            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
	            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
	            if (_.options.fade === true) {
	                if (rangeStart > 0) rangeStart--;
	                if (rangeEnd <= _.slideCount) rangeEnd++;
	            }
	        }

	        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);

	        if (_.options.lazyLoad === 'anticipated') {
	            var prevSlide = rangeStart - 1,
	                nextSlide = rangeEnd,
	                $slides = _.$slider.find('.slick-slide');

	            for (var i = 0; i < _.options.slidesToScroll; i++) {
	                if (prevSlide < 0) prevSlide = _.slideCount - 1;
	                loadRange = loadRange.add($slides.eq(prevSlide));
	                loadRange = loadRange.add($slides.eq(nextSlide));
	                prevSlide--;
	                nextSlide++;
	            }
	        }

	        loadImages(loadRange);

	        if (_.slideCount <= _.options.slidesToShow) {
	            cloneRange = _.$slider.find('.slick-slide');
	            loadImages(cloneRange);
	        } else
	        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
	            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
	            loadImages(cloneRange);
	        } else if (_.currentSlide === 0) {
	            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
	            loadImages(cloneRange);
	        }

	    };

	    Slick.prototype.loadSlider = function() {

	        var _ = this;

	        _.setPosition();

	        _.$slideTrack.css({
	            opacity: 1
	        });

	        _.$slider.removeClass('slick-loading');

	        _.initUI();

	        if (_.options.lazyLoad === 'progressive') {
	            _.progressiveLazyLoad();
	        }

	    };

	    Slick.prototype.next = Slick.prototype.slickNext = function() {

	        var _ = this;

	        _.changeSlide({
	            data: {
	                message: 'next'
	            }
	        });

	    };

	    Slick.prototype.orientationChange = function() {

	        var _ = this;

	        _.checkResponsive();
	        _.setPosition();

	    };

	    Slick.prototype.pause = Slick.prototype.slickPause = function() {

	        var _ = this;

	        _.autoPlayClear();
	        _.paused = true;

	    };

	    Slick.prototype.play = Slick.prototype.slickPlay = function() {

	        var _ = this;

	        _.autoPlay();
	        _.options.autoplay = true;
	        _.paused = false;
	        _.focussed = false;
	        _.interrupted = false;

	    };

	    Slick.prototype.postSlide = function(index) {

	        var _ = this;

	        if( !_.unslicked ) {

	            _.$slider.trigger('afterChange', [_, index]);

	            _.animating = false;

	            if (_.slideCount > _.options.slidesToShow) {
	                _.setPosition();
	            }

	            _.swipeLeft = null;

	            if ( _.options.autoplay ) {
	                _.autoPlay();
	            }

	            if (_.options.accessibility === true) {
	                _.initADA();

	                if (_.options.focusOnChange) {
	                    var $currentSlide = $(_.$slides.get(_.currentSlide));
	                    $currentSlide.attr('tabindex', 0).focus();
	                }
	            }

	        }

	    };

	    Slick.prototype.prev = Slick.prototype.slickPrev = function() {

	        var _ = this;

	        _.changeSlide({
	            data: {
	                message: 'previous'
	            }
	        });

	    };

	    Slick.prototype.preventDefault = function(event) {

	        event.preventDefault();

	    };

	    Slick.prototype.progressiveLazyLoad = function( tryCount ) {

	        tryCount = tryCount || 1;

	        var _ = this,
	            $imgsToLoad = $( 'img[data-lazy]', _.$slider ),
	            image,
	            imageSource,
	            imageSrcSet,
	            imageSizes,
	            imageToLoad;

	        if ( $imgsToLoad.length ) {

	            image = $imgsToLoad.first();
	            imageSource = image.attr('data-lazy');
	            imageSrcSet = image.attr('data-srcset');
	            imageSizes  = image.attr('data-sizes') || _.$slider.attr('data-sizes');
	            imageToLoad = document.createElement('img');

	            imageToLoad.onload = function() {

	                if (imageSrcSet) {
	                    image
	                        .attr('srcset', imageSrcSet );

	                    if (imageSizes) {
	                        image
	                            .attr('sizes', imageSizes );
	                    }
	                }

	                image
	                    .attr( 'src', imageSource )
	                    .removeAttr('data-lazy data-srcset data-sizes')
	                    .removeClass('slick-loading');

	                if ( _.options.adaptiveHeight === true ) {
	                    _.setPosition();
	                }

	                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
	                _.progressiveLazyLoad();

	            };

	            imageToLoad.onerror = function() {

	                if ( tryCount < 3 ) {

	                    /**
	                     * try to load the image 3 times,
	                     * leave a slight delay so we don't get
	                     * servers blocking the request.
	                     */
	                    setTimeout( function() {
	                        _.progressiveLazyLoad( tryCount + 1 );
	                    }, 500 );

	                } else {

	                    image
	                        .removeAttr( 'data-lazy' )
	                        .removeClass( 'slick-loading' )
	                        .addClass( 'slick-lazyload-error' );

	                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

	                    _.progressiveLazyLoad();

	                }

	            };

	            imageToLoad.src = imageSource;

	        } else {

	            _.$slider.trigger('allImagesLoaded', [ _ ]);

	        }

	    };

	    Slick.prototype.refresh = function( initializing ) {

	        var _ = this, currentSlide, lastVisibleIndex;

	        lastVisibleIndex = _.slideCount - _.options.slidesToShow;

	        // in non-infinite sliders, we don't want to go past the
	        // last visible index.
	        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
	            _.currentSlide = lastVisibleIndex;
	        }

	        // if less slides than to show, go to start.
	        if ( _.slideCount <= _.options.slidesToShow ) {
	            _.currentSlide = 0;

	        }

	        currentSlide = _.currentSlide;

	        _.destroy(true);

	        $.extend(_, _.initials, { currentSlide: currentSlide });

	        _.init();

	        if( !initializing ) {

	            _.changeSlide({
	                data: {
	                    message: 'index',
	                    index: currentSlide
	                }
	            }, false);

	        }

	    };

	    Slick.prototype.registerBreakpoints = function() {

	        var _ = this, breakpoint, currentBreakpoint, l,
	            responsiveSettings = _.options.responsive || null;

	        if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {

	            _.respondTo = _.options.respondTo || 'window';

	            for ( breakpoint in responsiveSettings ) {

	                l = _.breakpoints.length-1;

	                if (responsiveSettings.hasOwnProperty(breakpoint)) {
	                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

	                    // loop through the breakpoints and cut out any existing
	                    // ones with the same breakpoint number, we don't want dupes.
	                    while( l >= 0 ) {
	                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
	                            _.breakpoints.splice(l,1);
	                        }
	                        l--;
	                    }

	                    _.breakpoints.push(currentBreakpoint);
	                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;

	                }

	            }

	            _.breakpoints.sort(function(a, b) {
	                return ( _.options.mobileFirst ) ? a-b : b-a;
	            });

	        }

	    };

	    Slick.prototype.reinit = function() {

	        var _ = this;

	        _.$slides =
	            _.$slideTrack
	                .children(_.options.slide)
	                .addClass('slick-slide');

	        _.slideCount = _.$slides.length;

	        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
	            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
	        }

	        if (_.slideCount <= _.options.slidesToShow) {
	            _.currentSlide = 0;
	        }

	        _.registerBreakpoints();

	        _.setProps();
	        _.setupInfinite();
	        _.buildArrows();
	        _.updateArrows();
	        _.initArrowEvents();
	        _.buildDots();
	        _.updateDots();
	        _.initDotEvents();
	        _.cleanUpSlideEvents();
	        _.initSlideEvents();

	        _.checkResponsive(false, true);

	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
	        }

	        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

	        _.setPosition();
	        _.focusHandler();

	        _.paused = !_.options.autoplay;
	        _.autoPlay();

	        _.$slider.trigger('reInit', [_]);

	    };

	    Slick.prototype.resize = function() {

	        var _ = this;

	        if ($(window).width() !== _.windowWidth) {
	            clearTimeout(_.windowDelay);
	            _.windowDelay = window.setTimeout(function() {
	                _.windowWidth = $(window).width();
	                _.checkResponsive();
	                if( !_.unslicked ) { _.setPosition(); }
	            }, 50);
	        }
	    };

	    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {

	        var _ = this;

	        if (typeof(index) === 'boolean') {
	            removeBefore = index;
	            index = removeBefore === true ? 0 : _.slideCount - 1;
	        } else {
	            index = removeBefore === true ? --index : index;
	        }

	        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
	            return false;
	        }

	        _.unload();

	        if (removeAll === true) {
	            _.$slideTrack.children().remove();
	        } else {
	            _.$slideTrack.children(this.options.slide).eq(index).remove();
	        }

	        _.$slides = _.$slideTrack.children(this.options.slide);

	        _.$slideTrack.children(this.options.slide).detach();

	        _.$slideTrack.append(_.$slides);

	        _.$slidesCache = _.$slides;

	        _.reinit();

	    };

	    Slick.prototype.setCSS = function(position) {

	        var _ = this,
	            positionProps = {},
	            x, y;

	        if (_.options.rtl === true) {
	            position = -position;
	        }
	        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
	        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

	        positionProps[_.positionProp] = position;

	        if (_.transformsEnabled === false) {
	            _.$slideTrack.css(positionProps);
	        } else {
	            positionProps = {};
	            if (_.cssTransitions === false) {
	                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
	                _.$slideTrack.css(positionProps);
	            } else {
	                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
	                _.$slideTrack.css(positionProps);
	            }
	        }

	    };

	    Slick.prototype.setDimensions = function() {

	        var _ = this;

	        if (_.options.vertical === false) {
	            if (_.options.centerMode === true) {
	                _.$list.css({
	                    padding: ('0px ' + _.options.centerPadding)
	                });
	            }
	        } else {
	            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
	            if (_.options.centerMode === true) {
	                _.$list.css({
	                    padding: (_.options.centerPadding + ' 0px')
	                });
	            }
	        }

	        _.listWidth = _.$list.width();
	        _.listHeight = _.$list.height();


	        if (_.options.vertical === false && _.options.variableWidth === false) {
	            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
	            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));

	        } else if (_.options.variableWidth === true) {
	            _.$slideTrack.width(5000 * _.slideCount);
	        } else {
	            _.slideWidth = Math.ceil(_.listWidth);
	            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
	        }

	        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
	        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);

	    };

	    Slick.prototype.setFade = function() {

	        var _ = this,
	            targetLeft;

	        _.$slides.each(function(index, element) {
	            targetLeft = (_.slideWidth * index) * -1;
	            if (_.options.rtl === true) {
	                $(element).css({
	                    position: 'relative',
	                    right: targetLeft,
	                    top: 0,
	                    zIndex: _.options.zIndex - 2,
	                    opacity: 0
	                });
	            } else {
	                $(element).css({
	                    position: 'relative',
	                    left: targetLeft,
	                    top: 0,
	                    zIndex: _.options.zIndex - 2,
	                    opacity: 0
	                });
	            }
	        });

	        _.$slides.eq(_.currentSlide).css({
	            zIndex: _.options.zIndex - 1,
	            opacity: 1
	        });

	    };

	    Slick.prototype.setHeight = function() {

	        var _ = this;

	        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
	            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
	            _.$list.css('height', targetHeight);
	        }

	    };

	    Slick.prototype.setOption =
	    Slick.prototype.slickSetOption = function() {

	        /**
	         * accepts arguments in format of:
	         *
	         *  - for changing a single option's value:
	         *     .slick("setOption", option, value, refresh )
	         *
	         *  - for changing a set of responsive options:
	         *     .slick("setOption", 'responsive', [{}, ...], refresh )
	         *
	         *  - for updating multiple values at once (not responsive)
	         *     .slick("setOption", { 'option': value, ... }, refresh )
	         */

	        var _ = this, l, item, option, value, refresh = false, type;

	        if( $.type( arguments[0] ) === 'object' ) {

	            option =  arguments[0];
	            refresh = arguments[1];
	            type = 'multiple';

	        } else if ( $.type( arguments[0] ) === 'string' ) {

	            option =  arguments[0];
	            value = arguments[1];
	            refresh = arguments[2];

	            if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {

	                type = 'responsive';

	            } else if ( typeof arguments[1] !== 'undefined' ) {

	                type = 'single';

	            }

	        }

	        if ( type === 'single' ) {

	            _.options[option] = value;


	        } else if ( type === 'multiple' ) {

	            $.each( option , function( opt, val ) {

	                _.options[opt] = val;

	            });


	        } else if ( type === 'responsive' ) {

	            for ( item in value ) {

	                if( $.type( _.options.responsive ) !== 'array' ) {

	                    _.options.responsive = [ value[item] ];

	                } else {

	                    l = _.options.responsive.length-1;

	                    // loop through the responsive object and splice out duplicates.
	                    while( l >= 0 ) {

	                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {

	                            _.options.responsive.splice(l,1);

	                        }

	                        l--;

	                    }

	                    _.options.responsive.push( value[item] );

	                }

	            }

	        }

	        if ( refresh ) {

	            _.unload();
	            _.reinit();

	        }

	    };

	    Slick.prototype.setPosition = function() {

	        var _ = this;

	        _.setDimensions();

	        _.setHeight();

	        if (_.options.fade === false) {
	            _.setCSS(_.getLeft(_.currentSlide));
	        } else {
	            _.setFade();
	        }

	        _.$slider.trigger('setPosition', [_]);

	    };

	    Slick.prototype.setProps = function() {

	        var _ = this,
	            bodyStyle = document.body.style;

	        _.positionProp = _.options.vertical === true ? 'top' : 'left';

	        if (_.positionProp === 'top') {
	            _.$slider.addClass('slick-vertical');
	        } else {
	            _.$slider.removeClass('slick-vertical');
	        }

	        if (bodyStyle.WebkitTransition !== undefined ||
	            bodyStyle.MozTransition !== undefined ||
	            bodyStyle.msTransition !== undefined) {
	            if (_.options.useCSS === true) {
	                _.cssTransitions = true;
	            }
	        }

	        if ( _.options.fade ) {
	            if ( typeof _.options.zIndex === 'number' ) {
	                if( _.options.zIndex < 3 ) {
	                    _.options.zIndex = 3;
	                }
	            } else {
	                _.options.zIndex = _.defaults.zIndex;
	            }
	        }

	        if (bodyStyle.OTransform !== undefined) {
	            _.animType = 'OTransform';
	            _.transformType = '-o-transform';
	            _.transitionType = 'OTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.MozTransform !== undefined) {
	            _.animType = 'MozTransform';
	            _.transformType = '-moz-transform';
	            _.transitionType = 'MozTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.webkitTransform !== undefined) {
	            _.animType = 'webkitTransform';
	            _.transformType = '-webkit-transform';
	            _.transitionType = 'webkitTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.msTransform !== undefined) {
	            _.animType = 'msTransform';
	            _.transformType = '-ms-transform';
	            _.transitionType = 'msTransition';
	            if (bodyStyle.msTransform === undefined) _.animType = false;
	        }
	        if (bodyStyle.transform !== undefined && _.animType !== false) {
	            _.animType = 'transform';
	            _.transformType = 'transform';
	            _.transitionType = 'transition';
	        }
	        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
	    };


	    Slick.prototype.setSlideClasses = function(index) {

	        var _ = this,
	            centerOffset, allSlides, indexOffset, remainder;

	        allSlides = _.$slider
	            .find('.slick-slide')
	            .removeClass('slick-active slick-center slick-current')
	            .attr('aria-hidden', 'true');

	        _.$slides
	            .eq(index)
	            .addClass('slick-current');

	        if (_.options.centerMode === true) {

	            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;

	            centerOffset = Math.floor(_.options.slidesToShow / 2);

	            if (_.options.infinite === true) {

	                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {
	                    _.$slides
	                        .slice(index - centerOffset + evenCoef, index + centerOffset + 1)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');

	                } else {

	                    indexOffset = _.options.slidesToShow + index;
	                    allSlides
	                        .slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');

	                }

	                if (index === 0) {

	                    allSlides
	                        .eq(allSlides.length - 1 - _.options.slidesToShow)
	                        .addClass('slick-center');

	                } else if (index === _.slideCount - 1) {

	                    allSlides
	                        .eq(_.options.slidesToShow)
	                        .addClass('slick-center');

	                }

	            }

	            _.$slides
	                .eq(index)
	                .addClass('slick-center');

	        } else {

	            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {

	                _.$slides
	                    .slice(index, index + _.options.slidesToShow)
	                    .addClass('slick-active')
	                    .attr('aria-hidden', 'false');

	            } else if (allSlides.length <= _.options.slidesToShow) {

	                allSlides
	                    .addClass('slick-active')
	                    .attr('aria-hidden', 'false');

	            } else {

	                remainder = _.slideCount % _.options.slidesToShow;
	                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

	                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {

	                    allSlides
	                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');

	                } else {

	                    allSlides
	                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');

	                }

	            }

	        }

	        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
	            _.lazyLoad();
	        }
	    };

	    Slick.prototype.setupInfinite = function() {

	        var _ = this,
	            i, slideIndex, infiniteCount;

	        if (_.options.fade === true) {
	            _.options.centerMode = false;
	        }

	        if (_.options.infinite === true && _.options.fade === false) {

	            slideIndex = null;

	            if (_.slideCount > _.options.slidesToShow) {

	                if (_.options.centerMode === true) {
	                    infiniteCount = _.options.slidesToShow + 1;
	                } else {
	                    infiniteCount = _.options.slidesToShow;
	                }

	                for (i = _.slideCount; i > (_.slideCount -
	                        infiniteCount); i -= 1) {
	                    slideIndex = i - 1;
	                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
	                        .attr('data-slick-index', slideIndex - _.slideCount)
	                        .prependTo(_.$slideTrack).addClass('slick-cloned');
	                }
	                for (i = 0; i < infiniteCount  + _.slideCount; i += 1) {
	                    slideIndex = i;
	                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
	                        .attr('data-slick-index', slideIndex + _.slideCount)
	                        .appendTo(_.$slideTrack).addClass('slick-cloned');
	                }
	                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
	                    $(this).attr('id', '');
	                });

	            }

	        }

	    };

	    Slick.prototype.interrupt = function( toggle ) {

	        var _ = this;

	        if( !toggle ) {
	            _.autoPlay();
	        }
	        _.interrupted = toggle;

	    };

	    Slick.prototype.selectHandler = function(event) {

	        var _ = this;

	        var targetElement =
	            $(event.target).is('.slick-slide') ?
	                $(event.target) :
	                $(event.target).parents('.slick-slide');

	        var index = parseInt(targetElement.attr('data-slick-index'));

	        if (!index) index = 0;

	        if (_.slideCount <= _.options.slidesToShow) {

	            _.slideHandler(index, false, true);
	            return;

	        }

	        _.slideHandler(index);

	    };

	    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {

	        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
	            _ = this, navTarget;

	        sync = sync || false;

	        if (_.animating === true && _.options.waitForAnimate === true) {
	            return;
	        }

	        if (_.options.fade === true && _.currentSlide === index) {
	            return;
	        }

	        if (sync === false) {
	            _.asNavFor(index);
	        }

	        targetSlide = index;
	        targetLeft = _.getLeft(targetSlide);
	        slideLeft = _.getLeft(_.currentSlide);

	        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

	        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
	            if (_.options.fade === false) {
	                targetSlide = _.currentSlide;
	                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
	                    _.animateSlide(slideLeft, function() {
	                        _.postSlide(targetSlide);
	                    });
	                } else {
	                    _.postSlide(targetSlide);
	                }
	            }
	            return;
	        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
	            if (_.options.fade === false) {
	                targetSlide = _.currentSlide;
	                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
	                    _.animateSlide(slideLeft, function() {
	                        _.postSlide(targetSlide);
	                    });
	                } else {
	                    _.postSlide(targetSlide);
	                }
	            }
	            return;
	        }

	        if ( _.options.autoplay ) {
	            clearInterval(_.autoPlayTimer);
	        }

	        if (targetSlide < 0) {
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
	            } else {
	                animSlide = _.slideCount + targetSlide;
	            }
	        } else if (targetSlide >= _.slideCount) {
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                animSlide = 0;
	            } else {
	                animSlide = targetSlide - _.slideCount;
	            }
	        } else {
	            animSlide = targetSlide;
	        }

	        _.animating = true;

	        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

	        oldSlide = _.currentSlide;
	        _.currentSlide = animSlide;

	        _.setSlideClasses(_.currentSlide);

	        if ( _.options.asNavFor ) {

	            navTarget = _.getNavTarget();
	            navTarget = navTarget.slick('getSlick');

	            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
	                navTarget.setSlideClasses(_.currentSlide);
	            }

	        }

	        _.updateDots();
	        _.updateArrows();

	        if (_.options.fade === true) {
	            if (dontAnimate !== true) {

	                _.fadeSlideOut(oldSlide);

	                _.fadeSlide(animSlide, function() {
	                    _.postSlide(animSlide);
	                });

	            } else {
	                _.postSlide(animSlide);
	            }
	            _.animateHeight();
	            return;
	        }

	        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
	            _.animateSlide(targetLeft, function() {
	                _.postSlide(animSlide);
	            });
	        } else {
	            _.postSlide(animSlide);
	        }

	    };

	    Slick.prototype.startLoad = function() {

	        var _ = this;

	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

	            _.$prevArrow.hide();
	            _.$nextArrow.hide();

	        }

	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

	            _.$dots.hide();

	        }

	        _.$slider.addClass('slick-loading');

	    };

	    Slick.prototype.swipeDirection = function() {

	        var xDist, yDist, r, swipeAngle, _ = this;

	        xDist = _.touchObject.startX - _.touchObject.curX;
	        yDist = _.touchObject.startY - _.touchObject.curY;
	        r = Math.atan2(yDist, xDist);

	        swipeAngle = Math.round(r * 180 / Math.PI);
	        if (swipeAngle < 0) {
	            swipeAngle = 360 - Math.abs(swipeAngle);
	        }

	        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
	            return (_.options.rtl === false ? 'left' : 'right');
	        }
	        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
	            return (_.options.rtl === false ? 'left' : 'right');
	        }
	        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
	            return (_.options.rtl === false ? 'right' : 'left');
	        }
	        if (_.options.verticalSwiping === true) {
	            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
	                return 'down';
	            } else {
	                return 'up';
	            }
	        }

	        return 'vertical';

	    };

	    Slick.prototype.swipeEnd = function(event) {

	        var _ = this,
	            slideCount,
	            direction;

	        _.dragging = false;
	        _.swiping = false;

	        if (_.scrolling) {
	            _.scrolling = false;
	            return false;
	        }

	        _.interrupted = false;
	        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;

	        if ( _.touchObject.curX === undefined ) {
	            return false;
	        }

	        if ( _.touchObject.edgeHit === true ) {
	            _.$slider.trigger('edge', [_, _.swipeDirection() ]);
	        }

	        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {

	            direction = _.swipeDirection();

	            switch ( direction ) {

	                case 'left':
	                case 'down':

	                    slideCount =
	                        _.options.swipeToSlide ?
	                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
	                            _.currentSlide + _.getSlideCount();

	                    _.currentDirection = 0;

	                    break;

	                case 'right':
	                case 'up':

	                    slideCount =
	                        _.options.swipeToSlide ?
	                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
	                            _.currentSlide - _.getSlideCount();

	                    _.currentDirection = 1;

	                    break;


	            }

	            if( direction != 'vertical' ) {

	                _.slideHandler( slideCount );
	                _.touchObject = {};
	                _.$slider.trigger('swipe', [_, direction ]);

	            }

	        } else {

	            if ( _.touchObject.startX !== _.touchObject.curX ) {

	                _.slideHandler( _.currentSlide );
	                _.touchObject = {};

	            }

	        }

	    };

	    Slick.prototype.swipeHandler = function(event) {

	        var _ = this;

	        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
	            return;
	        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
	            return;
	        }

	        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
	            event.originalEvent.touches.length : 1;

	        _.touchObject.minSwipe = _.listWidth / _.options
	            .touchThreshold;

	        if (_.options.verticalSwiping === true) {
	            _.touchObject.minSwipe = _.listHeight / _.options
	                .touchThreshold;
	        }

	        switch (event.data.action) {

	            case 'start':
	                _.swipeStart(event);
	                break;

	            case 'move':
	                _.swipeMove(event);
	                break;

	            case 'end':
	                _.swipeEnd(event);
	                break;

	        }

	    };

	    Slick.prototype.swipeMove = function(event) {

	        var _ = this,
	            curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;

	        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

	        if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
	            return false;
	        }

	        curLeft = _.getLeft(_.currentSlide);

	        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
	        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

	        _.touchObject.swipeLength = Math.round(Math.sqrt(
	            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

	        verticalSwipeLength = Math.round(Math.sqrt(
	            Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));

	        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
	            _.scrolling = true;
	            return false;
	        }

	        if (_.options.verticalSwiping === true) {
	            _.touchObject.swipeLength = verticalSwipeLength;
	        }

	        swipeDirection = _.swipeDirection();

	        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
	            _.swiping = true;
	            event.preventDefault();
	        }

	        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
	        if (_.options.verticalSwiping === true) {
	            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
	        }


	        swipeLength = _.touchObject.swipeLength;

	        _.touchObject.edgeHit = false;

	        if (_.options.infinite === false) {
	            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
	                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
	                _.touchObject.edgeHit = true;
	            }
	        }

	        if (_.options.vertical === false) {
	            _.swipeLeft = curLeft + swipeLength * positionOffset;
	        } else {
	            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
	        }
	        if (_.options.verticalSwiping === true) {
	            _.swipeLeft = curLeft + swipeLength * positionOffset;
	        }

	        if (_.options.fade === true || _.options.touchMove === false) {
	            return false;
	        }

	        if (_.animating === true) {
	            _.swipeLeft = null;
	            return false;
	        }

	        _.setCSS(_.swipeLeft);

	    };

	    Slick.prototype.swipeStart = function(event) {

	        var _ = this,
	            touches;

	        _.interrupted = true;

	        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
	            _.touchObject = {};
	            return false;
	        }

	        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
	            touches = event.originalEvent.touches[0];
	        }

	        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
	        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

	        _.dragging = true;

	    };

	    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {

	        var _ = this;

	        if (_.$slidesCache !== null) {

	            _.unload();

	            _.$slideTrack.children(this.options.slide).detach();

	            _.$slidesCache.appendTo(_.$slideTrack);

	            _.reinit();

	        }

	    };

	    Slick.prototype.unload = function() {

	        var _ = this;

	        $('.slick-cloned', _.$slider).remove();

	        if (_.$dots) {
	            _.$dots.remove();
	        }

	        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
	            _.$prevArrow.remove();
	        }

	        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
	            _.$nextArrow.remove();
	        }

	        _.$slides
	            .removeClass('slick-slide slick-active slick-visible slick-current')
	            .attr('aria-hidden', 'true')
	            .css('width', '');

	    };

	    Slick.prototype.unslick = function(fromBreakpoint) {

	        var _ = this;
	        _.$slider.trigger('unslick', [_, fromBreakpoint]);
	        _.destroy();

	    };

	    Slick.prototype.updateArrows = function() {

	        var _ = this;

	        Math.floor(_.options.slidesToShow / 2);

	        if ( _.options.arrows === true &&
	            _.slideCount > _.options.slidesToShow &&
	            !_.options.infinite ) {

	            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

	            if (_.currentSlide === 0) {

	                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

	            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

	                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

	            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

	                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

	            }

	        }

	    };

	    Slick.prototype.updateDots = function() {

	        var _ = this;

	        if (_.$dots !== null) {

	            _.$dots
	                .find('li')
	                    .removeClass('slick-active')
	                    .end();

	            _.$dots
	                .find('li')
	                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
	                .addClass('slick-active');

	        }

	    };

	    Slick.prototype.visibility = function() {

	        var _ = this;

	        if ( _.options.autoplay ) {

	            if ( document[_.hidden] ) {

	                _.interrupted = true;

	            } else {

	                _.interrupted = false;

	            }

	        }

	    };

	    $.fn.slick = function() {
	        var _ = this,
	            opt = arguments[0],
	            args = Array.prototype.slice.call(arguments, 1),
	            l = _.length,
	            i,
	            ret;
	        for (i = 0; i < l; i++) {
	            if (typeof opt == 'object' || typeof opt == 'undefined')
	                _[i].slick = new Slick(_[i], opt);
	            else
	                ret = _[i].slick[opt].apply(_[i].slick, args);
	            if (typeof ret != 'undefined') return ret;
	        }
	        return _;
	    };

	}));
	});

	window.jQuery = window.$ = jquery;

}());

(function () {
  'use strict';

  var n,l,u,t,r,o,f,c={},s=[],a=/acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;function h(n,l){for(var u in l)n[u]=l[u];return n}function v(n){var l=n.parentNode;l&&l.removeChild(n);}function y(l,u,i){var t,r,o,f={};for(o in u)"key"==o?t=u[o]:"ref"==o?r=u[o]:f[o]=u[o];if(arguments.length>2&&(f.children=arguments.length>3?n.call(arguments,2):i),"function"==typeof l&&null!=l.defaultProps)for(o in l.defaultProps)void 0===f[o]&&(f[o]=l.defaultProps[o]);return p(l,f,t,r,null)}function p(n,i,t,r,o){var f={type:n,props:i,key:t,ref:r,__k:null,__:null,__b:0,__e:null,__d:void 0,__c:null,__h:null,constructor:void 0,__v:null==o?++u:o};return null==o&&null!=l.vnode&&l.vnode(f),f}function d(){return {current:null}}function _(n){return n.children}function k(n,l){this.props=n,this.context=l;}function b(n,l){if(null==l)return n.__?b(n.__,n.__.__k.indexOf(n)+1):null;for(var u;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e)return u.__e;return "function"==typeof n.type?b(n):null}function g(n){var l,u;if(null!=(n=n.__)&&null!=n.__c){for(n.__e=n.__c.base=null,l=0;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e){n.__e=n.__c.base=u.__e;break}return g(n)}}function m(n){(!n.__d&&(n.__d=!0)&&t.push(n)&&!w.__r++||r!==l.debounceRendering)&&((r=l.debounceRendering)||o)(w);}function w(){var n,l,u,i,r,o,e,c;for(t.sort(f);n=t.shift();)n.__d&&(l=t.length,i=void 0,r=void 0,e=(o=(u=n).__v).__e,(c=u.__P)&&(i=[],(r=h({},o)).__v=o.__v+1,L(c,o,r,u.__n,void 0!==c.ownerSVGElement,null!=o.__h?[e]:null,i,null==e?b(o):e,o.__h),M(i,o),o.__e!=e&&g(o)),t.length>l&&t.sort(f));w.__r=0;}function x(n,l,u,i,t,r,o,f,e,a){var h,v,y,d,k,g,m,w=i&&i.__k||s,x=w.length;for(u.__k=[],h=0;h<l.length;h++)if(null!=(d=u.__k[h]=null==(d=l[h])||"boolean"==typeof d||"function"==typeof d?null:"string"==typeof d||"number"==typeof d||"bigint"==typeof d?p(null,d,null,null,d):Array.isArray(d)?p(_,{children:d},null,null,null):d.__b>0?p(d.type,d.props,d.key,d.ref?d.ref:null,d.__v):d)){if(d.__=u,d.__b=u.__b+1,null===(y=w[h])||y&&d.key==y.key&&d.type===y.type)w[h]=void 0;else for(v=0;v<x;v++){if((y=w[v])&&d.key==y.key&&d.type===y.type){w[v]=void 0;break}y=null;}L(n,d,y=y||c,t,r,o,f,e,a),k=d.__e,(v=d.ref)&&y.ref!=v&&(m||(m=[]),y.ref&&m.push(y.ref,null,d),m.push(v,d.__c||k,d)),null!=k?(null==g&&(g=k),"function"==typeof d.type&&d.__k===y.__k?d.__d=e=A$1(d,e,n):e=C(n,d,y,w,k,e),"function"==typeof u.type&&(u.__d=e)):e&&y.__e==e&&e.parentNode!=n&&(e=b(y));}for(u.__e=g,h=x;h--;)null!=w[h]&&("function"==typeof u.type&&null!=w[h].__e&&w[h].__e==u.__d&&(u.__d=$$1(i).nextSibling),S(w[h],w[h]));if(m)for(h=0;h<m.length;h++)O(m[h],m[++h],m[++h]);}function A$1(n,l,u){for(var i,t=n.__k,r=0;t&&r<t.length;r++)(i=t[r])&&(i.__=n,l="function"==typeof i.type?A$1(i,l,u):C(u,i,i,t,i.__e,l));return l}function C(n,l,u,i,t,r){var o,f,e;if(void 0!==l.__d)o=l.__d,l.__d=void 0;else if(null==u||t!=r||null==t.parentNode)n:if(null==r||r.parentNode!==n)n.appendChild(t),o=null;else {for(f=r,e=0;(f=f.nextSibling)&&e<i.length;e+=1)if(f==t)break n;n.insertBefore(t,r),o=r;}return void 0!==o?o:t.nextSibling}function $$1(n){var l,u,i;if(null==n.type||"string"==typeof n.type)return n.__e;if(n.__k)for(l=n.__k.length-1;l>=0;l--)if((u=n.__k[l])&&(i=$$1(u)))return i;return null}function H(n,l,u,i,t){var r;for(r in u)"children"===r||"key"===r||r in l||T(n,r,null,u[r],i);for(r in l)t&&"function"!=typeof l[r]||"children"===r||"key"===r||"value"===r||"checked"===r||u[r]===l[r]||T(n,r,l[r],u[r],i);}function I(n,l,u){"-"===l[0]?n.setProperty(l,null==u?"":u):n[l]=null==u?"":"number"!=typeof u||a.test(l)?u:u+"px";}function T(n,l,u,i,t){var r;n:if("style"===l)if("string"==typeof u)n.style.cssText=u;else {if("string"==typeof i&&(n.style.cssText=i=""),i)for(l in i)u&&l in u||I(n.style,l,"");if(u)for(l in u)i&&u[l]===i[l]||I(n.style,l,u[l]);}else if("o"===l[0]&&"n"===l[1])r=l!==(l=l.replace(/Capture$/,"")),l=l.toLowerCase()in n?l.toLowerCase().slice(2):l.slice(2),n.l||(n.l={}),n.l[l+r]=u,u?i||n.addEventListener(l,r?z:j,r):n.removeEventListener(l,r?z:j,r);else if("dangerouslySetInnerHTML"!==l){if(t)l=l.replace(/xlink(H|:h)/,"h").replace(/sName$/,"s");else if("width"!==l&&"height"!==l&&"href"!==l&&"list"!==l&&"form"!==l&&"tabIndex"!==l&&"download"!==l&&l in n)try{n[l]=null==u?"":u;break n}catch(n){}"function"==typeof u||(null==u||!1===u&&-1==l.indexOf("-")?n.removeAttribute(l):n.setAttribute(l,u));}}function j(n){return this.l[n.type+!1](l.event?l.event(n):n)}function z(n){return this.l[n.type+!0](l.event?l.event(n):n)}function L(n,u,i,t,r,o,f,e,c){var s,a,v,y,p,d,b,g,m,w,A,P,C,$,H,I=u.type;if(void 0!==u.constructor)return null;null!=i.__h&&(c=i.__h,e=u.__e=i.__e,u.__h=null,o=[e]),(s=l.__b)&&s(u);try{n:if("function"==typeof I){if(g=u.props,m=(s=I.contextType)&&t[s.__c],w=s?m?m.props.value:s.__:t,i.__c?b=(a=u.__c=i.__c).__=a.__E:("prototype"in I&&I.prototype.render?u.__c=a=new I(g,w):(u.__c=a=new k(g,w),a.constructor=I,a.render=q),m&&m.sub(a),a.props=g,a.state||(a.state={}),a.context=w,a.__n=t,v=a.__d=!0,a.__h=[],a._sb=[]),null==a.__s&&(a.__s=a.state),null!=I.getDerivedStateFromProps&&(a.__s==a.state&&(a.__s=h({},a.__s)),h(a.__s,I.getDerivedStateFromProps(g,a.__s))),y=a.props,p=a.state,a.__v=u,v)null==I.getDerivedStateFromProps&&null!=a.componentWillMount&&a.componentWillMount(),null!=a.componentDidMount&&a.__h.push(a.componentDidMount);else {if(null==I.getDerivedStateFromProps&&g!==y&&null!=a.componentWillReceiveProps&&a.componentWillReceiveProps(g,w),!a.__e&&null!=a.shouldComponentUpdate&&!1===a.shouldComponentUpdate(g,a.__s,w)||u.__v===i.__v){for(u.__v!==i.__v&&(a.props=g,a.state=a.__s,a.__d=!1),a.__e=!1,u.__e=i.__e,u.__k=i.__k,u.__k.forEach(function(n){n&&(n.__=u);}),A=0;A<a._sb.length;A++)a.__h.push(a._sb[A]);a._sb=[],a.__h.length&&f.push(a);break n}null!=a.componentWillUpdate&&a.componentWillUpdate(g,a.__s,w),null!=a.componentDidUpdate&&a.__h.push(function(){a.componentDidUpdate(y,p,d);});}if(a.context=w,a.props=g,a.__P=n,P=l.__r,C=0,"prototype"in I&&I.prototype.render){for(a.state=a.__s,a.__d=!1,P&&P(u),s=a.render(a.props,a.state,a.context),$=0;$<a._sb.length;$++)a.__h.push(a._sb[$]);a._sb=[];}else do{a.__d=!1,P&&P(u),s=a.render(a.props,a.state,a.context),a.state=a.__s;}while(a.__d&&++C<25);a.state=a.__s,null!=a.getChildContext&&(t=h(h({},t),a.getChildContext())),v||null==a.getSnapshotBeforeUpdate||(d=a.getSnapshotBeforeUpdate(y,p)),H=null!=s&&s.type===_&&null==s.key?s.props.children:s,x(n,Array.isArray(H)?H:[H],u,i,t,r,o,f,e,c),a.base=u.__e,u.__h=null,a.__h.length&&f.push(a),b&&(a.__E=a.__=null),a.__e=!1;}else null==o&&u.__v===i.__v?(u.__k=i.__k,u.__e=i.__e):u.__e=N(i.__e,u,i,t,r,o,f,c);(s=l.diffed)&&s(u);}catch(n){u.__v=null,(c||null!=o)&&(u.__e=e,u.__h=!!c,o[o.indexOf(e)]=null),l.__e(n,u,i);}}function M(n,u){l.__c&&l.__c(u,n),n.some(function(u){try{n=u.__h,u.__h=[],n.some(function(n){n.call(u);});}catch(n){l.__e(n,u.__v);}});}function N(l,u,i,t,r,o,f,e){var s,a,h,y=i.props,p=u.props,d=u.type,_=0;if("svg"===d&&(r=!0),null!=o)for(;_<o.length;_++)if((s=o[_])&&"setAttribute"in s==!!d&&(d?s.localName===d:3===s.nodeType)){l=s,o[_]=null;break}if(null==l){if(null===d)return document.createTextNode(p);l=r?document.createElementNS("http://www.w3.org/2000/svg",d):document.createElement(d,p.is&&p),o=null,e=!1;}if(null===d)y===p||e&&l.data===p||(l.data=p);else {if(o=o&&n.call(l.childNodes),a=(y=i.props||c).dangerouslySetInnerHTML,h=p.dangerouslySetInnerHTML,!e){if(null!=o)for(y={},_=0;_<l.attributes.length;_++)y[l.attributes[_].name]=l.attributes[_].value;(h||a)&&(h&&(a&&h.__html==a.__html||h.__html===l.innerHTML)||(l.innerHTML=h&&h.__html||""));}if(H(l,p,y,r,e),h)u.__k=[];else if(_=u.props.children,x(l,Array.isArray(_)?_:[_],u,i,t,r&&"foreignObject"!==d,o,f,o?o[0]:i.__k&&b(i,0),e),null!=o)for(_=o.length;_--;)null!=o[_]&&v(o[_]);e||("value"in p&&void 0!==(_=p.value)&&(_!==l.value||"progress"===d&&!_||"option"===d&&_!==y.value)&&T(l,"value",_,y.value,!1),"checked"in p&&void 0!==(_=p.checked)&&_!==l.checked&&T(l,"checked",_,y.checked,!1));}return l}function O(n,u,i){try{"function"==typeof n?n(u):n.current=u;}catch(n){l.__e(n,i);}}function S(n,u,i){var t,r;if(l.unmount&&l.unmount(n),(t=n.ref)&&(t.current&&t.current!==n.__e||O(t,null,u)),null!=(t=n.__c)){if(t.componentWillUnmount)try{t.componentWillUnmount();}catch(n){l.__e(n,u);}t.base=t.__P=null,n.__c=void 0;}if(t=n.__k)for(r=0;r<t.length;r++)t[r]&&S(t[r],u,i||"function"!=typeof n.type);i||null==n.__e||v(n.__e),n.__=n.__e=n.__d=void 0;}function q(n,l,u){return this.constructor(n,u)}function B(u,i,t){var r,o,f;l.__&&l.__(u,i),o=(r="function"==typeof t)?null:t&&t.__k||i.__k,f=[],L(i,u=(!r&&t||i).__k=y(_,null,[u]),o||c,c,void 0!==i.ownerSVGElement,!r&&t?[t]:o?null:i.firstChild?n.call(i.childNodes):null,f,!r&&t?t:o?o.__e:i.firstChild,r),M(f,u);}n=s.slice,l={__e:function(n,l,u,i){for(var t,r,o;l=l.__;)if((t=l.__c)&&!t.__)try{if((r=t.constructor)&&null!=r.getDerivedStateFromError&&(t.setState(r.getDerivedStateFromError(n)),o=t.__d),null!=t.componentDidCatch&&(t.componentDidCatch(n,i||{}),o=t.__d),o)return t.__E=t}catch(l){n=l;}throw n}},u=0,k.prototype.setState=function(n,l){var u;u=null!=this.__s&&this.__s!==this.state?this.__s:this.__s=h({},this.state),"function"==typeof n&&(n=n(h({},u),this.props)),n&&h(u,n),null!=n&&this.__v&&(l&&this._sb.push(l),m(this));},k.prototype.forceUpdate=function(n){this.__v&&(this.__e=!0,n&&this.__h.push(n),m(this));},k.prototype.render=_,t=[],o="function"==typeof Promise?Promise.prototype.then.bind(Promise.resolve()):setTimeout,f=function(n,l){return n.__v.__b-l.__v.__b},w.__r=0;

  const Div = (attrs = {}, html = "") => {
    const {
      ...valores
    } = attrs;
    return y("div", valores, html);
  };
  const Img = (attrs = {}) => {
    const {
      ...valores
    } = attrs;
    return y("img", valores);
  };
  const Li = (attrs = {}, html = "") => {
    const {
      ...valores
    } = attrs;
    return y("li", valores, html);
  };
  const A = (attrs = {}, html = "") => {
    const {
      ...valores
    } = attrs;
    return y("a", valores, html);
  };
  const P = (attrs = {}, html = "") => {
    const {
      ...valores
    } = attrs;
    return y("p", valores, html);
  };
  const Ul = (attrs = {}, html = "") => {
    const {
      ...valores
    } = attrs;
    return y("ul", valores, html);
  };
  const Hr = (attrs = {}) => {
    const {
      ...valores
    } = attrs;
    return y("hr", valores);
  };

  function Tamaños(urls) {
    const métodos = {};
    ["sm", "md", "lg", "xl"].forEach(tamaño => {
      const url = urls[tamaño];
      métodos[tamaño] = {
        get: () => {
          return url;
        }
      };
    });
    Object.defineProperties(this, métodos);
  }
  new Tamaños({
    sm: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/logo-rodin-header.png?v=15619386453047641044",
    md: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/logo-rodin-header.png?v=15619386453047641044"
  });
  new Tamaños({
    sm: "https://cdn.shopify.com/s/files/1/1577/8469/files/lupa_c5303124-c3b7-493c-baf7-b2da1f085433.png?v=1614718687",
    md: "https://cdn.shopify.com/s/files/1/1577/8469/files/lupa.png?v=1613591910"
  });
  new Tamaños({
    sm: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/carrito-header.png?v=13558517324228180857",
    md: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/carrito-header.png?v=13558517324228180857"
  });
  new Tamaños({
    sm: "https://cdn.shopify.com/s/files/1/1577/8469/files/valoraciones.png?v=1614718687",
    md: "https://cdn.shopify.com/s/files/1/1577/8469/files/corazon.png?v=1613591910"
  });
  new Tamaños({
    sm: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/account-header.png?v=10938938484457976803",
    md: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/account-header.png?v=10938938484457976803"
  });
  const informacion = {};
  informacion["espana"] = new Tamaños({
    sm: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/espana.png?v=3081048002528828263",
    md: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/espana.png?v=3081048002528828263"
  });
  informacion["mexico"] = new Tamaños({
    sm: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/mexico.png?v=7208548786240976508",
    md: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/mexico.png?v=7208548786240976508"
  });
  informacion["flecha"] = new Tamaños({
    sm: "https://cdn.shopify.com/s/files/1/1577/8469/files/flecha.png?v=1613598064",
    md: "https://cdn.shopify.com/s/files/1/1577/8469/files/flecha.png?v=1613598064"
  });
  informacion["flecha-gris"] = new Tamaños({
    sm: "https://cdn.shopify.com/s/files/1/1577/8469/files/flecha-dropdown-sm.png?v=1614978235",
    md: "https://cdn.shopify.com/s/files/1/1577/8469/files/flecha-dropdown-sm.png?v=1614978235"
  });
  new Tamaños({
    sm: "https://cdn.shopify.com/s/files/1/1577/8469/files/img-tmp-categorias-home.png?v=1613081215",
    md: "https://cdn.shopify.com/s/files/1/1577/8469/files/img-tmp-categorias-home.png?v=1613081215"
  });
  const botones = {};
  botones["flecha-izquierda-carrusel-blanca"] = new Tamaños({
    sm: "https://cdn.shopify.com/s/files/1/1577/8469/files/flecha-izquierda-blanco.png?v=1613005003",
    md: "https://cdn.shopify.com/s/files/1/1577/8469/files/flecha-izquierda-blanco.png?v=1613005003"
  });
  botones["flecha-derecha-carrusel-blanca"] = new Tamaños({
    sm: "https://cdn.shopify.com/s/files/1/1577/8469/files/flecha-derecha-blanco.png?v=1613005003",
    md: "https://cdn.shopify.com/s/files/1/1577/8469/files/flecha-derecha-blanco.png?v=1613005003"
  });
  botones["flecha-abajo"] = new Tamaños({
    sm: "https://cdn.shopify.com/s/files/1/1577/8469/files/flecha-dropdown-sm.png?v=1614978235",
    md: "https://cdn.shopify.com/s/files/1/1577/8469/files/flecha-dropdown-sm.png?v=1614978235"
  });
  botones["flecha-izquierda-carrusel"] = new Tamaños({
    sm: "https://cdn.shopify.com/s/files/1/1577/8469/files/flecha-izquierda-gris_2x_881ecccd-848c-49f9-b883-6e392a5979a8.png?v=1613504051",
    md: "https://cdn.shopify.com/s/files/1/1577/8469/files/flecha-izquierda-gris_2x_881ecccd-848c-49f9-b883-6e392a5979a8.png?v=1613504051"
  });
  botones["flecha-derecha-carrusel"] = new Tamaños({
    sm: "https://cdn.shopify.com/s/files/1/1577/8469/files/flecha-derecha-gris_2x_3d820b5a-27b8-4027-b866-bd6a09b65639.png?v=1613504051",
    md: "https://cdn.shopify.com/s/files/1/1577/8469/files/flecha-derecha-gris_2x_3d820b5a-27b8-4027-b866-bd6a09b65639.png?v=1613504051"
  });
  botones["flecha-izquierda-carrusel-sm"] = new Tamaños({
    sm: "https://cdn.shopify.com/s/files/1/1577/8469/files/flecha_1.png?v=1614959861",
    md: "https://cdn.shopify.com/s/files/1/1577/8469/files/flecha_1.png?v=1614959861"
  });
  botones["flecha-derecha-carrusel-sm"] = new Tamaños({
    sm: "https://cdn.shopify.com/s/files/1/1577/8469/files/flecha-derecha.png?v=1614959928",
    md: "https://cdn.shopify.com/s/files/1/1577/8469/files/flecha-derecha.png?v=1614959928"
  });
  const footer = {};
  footer["redesSociales"] = {};
  footer["pagos"] = {};
  footer["redesSociales"]["facebook"] = new Tamaños({
    sm: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/facebook-footer.png?v=6506230802411161973",
    md: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/facebook-footer.png?v=6506230802411161973"
  });
  footer["redesSociales"]["instagram"] = new Tamaños({
    sm: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/instagram-footer.png?v=11816706845168829404",
    md: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/instagram-footer.png?v=11816706845168829404"
  });
  footer["redesSociales"]["tiktok"] = new Tamaños({
    sm: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/tiktok-footer.png?v=11320807369068520105",
    md: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/tiktok-footer.png?v=11320807369068520105"
  });
  footer["redesSociales"]["youtube"] = new Tamaños({
    sm: "//cdn.shopify.com/s/files/1/0533/1157/0100/files/youtube.png?v=1674081417",
    md: "//cdn.shopify.com/s/files/1/0533/1157/0100/files/youtube.png?v=1674081417"
  });
  footer["redesSociales"]["mail"] = new Tamaños({
    sm: "https://cdn.shopify.com/s/files/1/1577/8469/files/icono_gmail.png?v=1614012078",
    md: "https://cdn.shopify.com/s/files/1/1577/8469/files/icono_gmail.png?v=1614012078"
  });
  footer["redesSociales"]["pagina"] = new Tamaños({
    sm: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/security-footer.png?v=13991086805054421076",
    md: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/security-footer.png?v=13991086805054421076"
  });
  footer["pagos"]["american"] = new Tamaños({
    sm: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/americanexpress-footer.png?v=3075629420847363510",
    md: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/americanexpress-footer.png?v=3075629420847363510"
  });
  footer["pagos"]["visa"] = new Tamaños({
    sm: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/visa-footer.png?v=14714454753011092008",
    md: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/visa-footer.png?v=14714454753011092008"
  });
  footer["pagos"]["master"] = new Tamaños({
    sm: "https://cdn.shopify.com/s/files/1/1577/8469/t/4/assets/mastercard-footer.png?v=1417373840797963594",
    md: "cdn.shopify.com/s/files/1/1577/8469/t/4/assets/mastercard-footer.png?v=1417373840797963594"
  });
  footer["pagos"]["paypal"] = new Tamaños({
    sm: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/paypal-footer.png?v=12221114887059900561",
    md: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/paypal-footer.png?v=12221114887059900561"
  });
  footer["pagos"]["mercado"] = new Tamaños({
    sm: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/mercadopago-footer.png?v=3139533758014580078",
    md: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/mercadopago-footer.png?v=3139533758014580078"
  });
  footer["pagos"]["banco"] = new Tamaños({
    sm: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/banco-footer.png?v=49196159333720060",
    md: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/banco-footer.png?v=49196159333720060"
  });
  footer["pagos"]["dinero"] = new Tamaños({
    sm: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/dinero-footer.png?v=1815499937992720177",
    md: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/dinero-footer.png?v=1815499937992720177"
  });

  class Info extends k {
    constructor() {
      super();
      this.informacion = [{
        href: "/pages/contacto",
        texto: "Ayuda y Contacto"
      }, {
        href: "/pages/envios-y-devoluciones",
        texto: "Envíos y devoluciones"
      }, {
        href: "tel:877019210",
        texto: "+34 877 01 92 10"
      }, {
        href: "/pages/faq",
        texto: "FAQ's"
      }, {
        href: "/blogs",
        texto: "Blog"
      }];
    }
    enlaces() {
      let li = this.informacion.map(enlace => {
        return Li({}, A({
          href: enlace.href,
          title: enlace.href
        }, enlace.texto));
      });
      return li;
    }
    componentDidMount() {
      $(document).ready(function () {
        $(".dropdown-l").click(function () {
          if ($(".dropdown-content-l").css("display") == "block") {
            $(".dropdown-content-l").css("display", "none");
            $(".flecha-l").css("transform", "rotate(0deg)");
          } else {
            $(".dropdown-content-l").css("display", "block");
            $(".flecha-l").css("transform", "rotate(180deg)");
          }
        });
        $(".dropdown-l").hover(function () {
          $(".flecha-l").css("transform", "rotate(180deg)");
          $(".dropdown-content-l").css("display", "block");
        }, function () {
          $(".dropdown-content-l").css("display", "none");
          $(".flecha-l").css("transform", "rotate(0)");
        });
      });
    }
    render() {
      return y("div", {
        class: "informacion"
      }, y("div", {
        class: "info-cabeza-l"
      }, y("ul", null, y("li", null, y("div", {
        class: "dropdown-l"
      }, y("div", {
        onClick: () => {
          window.location.href = "https://rodin.es";
        },
        class: "pais-seleccionado-l"
      }, y("img", {
        src: informacion["espana"].sm,
        alt: "espana",
        title: "espana"
      }), y("span", null, "ESP"), y("img", {
        class: "flecha-l",
        src: informacion["flecha"].sm,
        alt: "flecha",
        title: "flecha"
      })), y("div", {
        class: "dropdown-content-l"
      }, y("div", {
        onClick: () => {
          window.location.href = "https://rodin.mx";
        },
        class: "paises-l"
      }, y("img", {
        src: informacion["mexico"].sm,
        alt: "mexico",
        title: "mexico"
      }), y("span", null, "MEX"))))), this.enlaces())));
    }
  }

  class InfoMovil extends k {
    constructor() {
      super();
      this.informacion = [{
        href: "/pages/contacto",
        texto: "Ayuda y Contacto"
      }, {
        href: "/pages/envios-y-devoluciones",
        texto: "Envíos y devoluciones"
      }, {
        href: "tel:877019210",
        texto: "+34 877 01 92 10"
      }, {
        href: "/pages/faq",
        texto: "FAQ's"
      }, {
        href: "/blogs",
        texto: "Blog"
      }];
    }
    enlaces() {
      let li = this.informacion.map(enlace => {
        return Li({}, A({
          href: enlace.href,
          title: enlace.href
        }, enlace.texto));
      });
      return li;
    }
    componentDidMount() {
      $(document).ready(function () {
        $(".carrusel-info").slick({
          autoplay: true,
          autoplaySpeed: 10000,
          speed: 500,
          dots: false,
          infinite: true,
          slidesToShow: 1,
          centerMode: false,
          variableWidth: true,
          arrows: false
        });
        $(".dropdown").click(function (e) {
          let posicion = $(this).offset().left;
          if ($(".dropdown-content").css("display") == "block") {
            $(".dropdown-content").css("display", "none");
            $(".dropdown-content").css("left", posicion);
            $(".flecha").css("transform", "rotate(0deg)");
          } else {
            $(".dropdown-content").css("display", "block");
            $(".dropdown-content").css("left", posicion);
            $(".flecha").css("transform", "rotate(180deg)");
          }
        });
      });
    }
    render() {
      return y("div", {
        class: "informacion"
      }, y("div", {
        class: "info-cabeza"
      }, y("ul", {
        class: "carrusel-info"
      }, y("li", {
        class: "drop-cont"
      }, y("div", {
        class: "dropdown"
      }, y("div", {
        class: "pais-seleccionado"
      }, y("img", {
        src: informacion["espana"].sm,
        alt: "espana",
        title: "espana"
      }), y("span", null, "ESP"), y("img", {
        class: "flecha",
        src: informacion["flecha-gris"].sm,
        alt: "flecha-gris",
        title: "flecha-gris"
      })))), this.enlaces()), y("div", {
        class: "dropdown-content"
      }, y("div", {
        onClick: () => {
          window.location.href = "https://rodin.mx";
        },
        class: "paises"
      }, y("img", {
        src: informacion["mexico"].sm,
        alt: "mexico",
        title: "mexico"
      }), y("span", null, "MEX")))));
    }
  }

  class BuscadorMovil extends k {
    constructor() {
      super();
      this.els = {
        buscadorMovil: d()
      };
    }
    componentDidMount() {
      this.els.buscadorMovil = $(this.els.buscadorMovil.current);
      const self = this;
      const doc = $(document);
      const input = this.els.buscadorMovil.find("input");
      const img = this.els.buscadorMovil.find("img.buscar-img");
      const onEnter = e => {
        if (e.which == 13) {
          const value = input.val().trim();
          window.location = `/search?q=${value}`;
        }
      };
      const onClick = e => {
        const value = input.val().trim();
        window.location = `/search?q=${value}`;
      };
      $(".móvil .lupa").click(function () {
        if (self.els.buscadorMovil.css("display") == "none") {
          self.els.buscadorMovil.slideDown();
          doc.on("keypress", onEnter);
          img.on("click", onClick);
        } else {
          self.els.buscadorMovil.slideUp();
          doc.off("keypress", onEnter);
          img.off("click", onClick);
        }
      });
    }
    render() {
      return y("div", {
        class: "buscador-movil",
        ref: this.els.buscadorMovil
      }, y("div", {
        class: "contenedor-buscador"
      }, y("input", {
        type: "text",
        placeholder: "Buscar..."
      }), y("img", {
        class: "buscar-img",
        src: "https://cdn.shopify.com/s/files/1/1577/8469/files/lupa_c5303124-c3b7-493c-baf7-b2da1f085433.png?v=1614718687",
        alt: "buscar",
        title: "buscar"
      })));
    }
  }

  class Opciones extends k {
    constructor(props) {
      super();
      this.navegacion = [{
        titulo: "Compra por productos",
        categoria: "0"
      }, {
        titulo: "Compra por marcas",
        href: "/pages/marcas",
        categoria: "1"
      }, {
        titulo: "Top Ventas",
        href: "/collections/top-ventas",
        categoria: "2"
      },
      // { titulo: "Navidad", href: "/collections/navidad", categoria: "3" },
      {
        titulo: "Ofertas",
        href: "/collections/ofertas",
        categoria: "3"
      }, {
        titulo: "Blog",
        href: "/blog",
        categoria: "4"
      }];
      this.eventos = props.eventos;
      this.btns = d();
    }
    botones({
      lista
    }) {
      let boton = ({
        titulo,
        href,
        categoria
      }) => {
        if (href) {
          return y("a", {
            href: href,
            title: href
          }, y("button", {
            class: `boton-opciones boton-opciones-${categoria}`,
            categoria: categoria
          }, titulo));
        }
        return y("button", {
          class: `boton-opciones boton-opciones-${categoria}`,
          categoria: categoria
        }, titulo);
      };
      return lista.map(data => {
        return boton(data);
      });
    }
    componentDidMount() {
      this.btns = $(this.btns.current).find("button");
      // this.btns.on('click',(e)=>{
      //     let boton = $(e.target);
      //     if(boton[0].attributes[2].value == 0) {
      //         this.eventos.notify('abrirMenu', boton);
      //     }
      // });

      $(".boton-opciones-0").on("click", e => {
        let boton = $(e.target);
        if (boton[0].attributes[1].value == 0) {
          this.eventos.notify("abrirMenu", boton);
        }
      });
      $(".boton-opciones-0").on("click", e => {
        let boton = $(e.target);
        let indice = boton[0].attributes[1].value;
        $.each(this.btns, function (ind, elem) {
          if (ind == indice) {
            $(elem).addClass("activo");
          } else {
            $(elem).removeClass("activo");
          }
        });
      });
    }
    render() {
      return y("div", {
        ref: this.btns,
        class: "opciones-menu"
      }, this.botones({
        lista: this.navegacion
      }));
    }
  }

  const TarjetaProducto = ({
    imágenes,
    título,
    precio,
    handle,
    css,
    precioComparativo
  }) => {
    return y("div", {
      class: `TarjetaProducto ${css ? css : ""}`
    }, y("a", {
      href: `/products/${handle}`,
      title: `/products/${handle}`
    }, y("div", null, y("img", {
      class: "TarjetaProducto__Imagen",
      src: imágenes[0],
      alt: título,
      title: título
    }), y("h2", {
      class: "TarjetaProducto__Titulo"
    }, título)), y("div", null, y("span", {
      class: "TarjetaProducto__Precio"
    }, "Desde: ", precio, "\u20AC"), y("span", {
      class: "TarjetaProducto__PrecioComparativo"
    }, precioComparativo ? `${precioComparativo}€` : precioComparativo), y("div", {
      class: "TarjetaProducto__Botones"
    }, y("button", {
      class: "TarjetaProducto__Boton TarjetaProducto__Boton--Comprar"
    }, "Comprar")))));
  };

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var chroma = createCommonjsModule(function (module, exports) {
  /**
   * chroma.js - JavaScript library for color conversions
   *
   * Copyright (c) 2011-2019, Gregor Aisch
   * All rights reserved.
   *
   * Redistribution and use in source and binary forms, with or without
   * modification, are permitted provided that the following conditions are met:
   *
   * 1. Redistributions of source code must retain the above copyright notice, this
   * list of conditions and the following disclaimer.
   *
   * 2. Redistributions in binary form must reproduce the above copyright notice,
   * this list of conditions and the following disclaimer in the documentation
   * and/or other materials provided with the distribution.
   *
   * 3. The name Gregor Aisch may not be used to endorse or promote products
   * derived from this software without specific prior written permission.
   *
   * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
   * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
   * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
   * DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
   * INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
   * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
   * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
   * OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
   * EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   *
   * -------------------------------------------------------
   *
   * chroma.js includes colors from colorbrewer2.org, which are released under
   * the following license:
   *
   * Copyright (c) 2002 Cynthia Brewer, Mark Harrower,
   * and The Pennsylvania State University.
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   * http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing,
   * software distributed under the License is distributed on an
   * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND,
   * either express or implied. See the License for the specific
   * language governing permissions and limitations under the License.
   *
   * ------------------------------------------------------
   *
   * Named colors are taken from X11 Color Names.
   * http://www.w3.org/TR/css3-color/#svg-color
   *
   * @preserve
   */

  (function (global, factory) {
      module.exports = factory() ;
  }(commonjsGlobal, (function () {
      var limit = function (x, min, max) {
          if ( min === void 0 ) min=0;
          if ( max === void 0 ) max=1;

          return x < min ? min : x > max ? max : x;
      };

      var clip_rgb = function (rgb) {
          rgb._clipped = false;
          rgb._unclipped = rgb.slice(0);
          for (var i=0; i<=3; i++) {
              if (i < 3) {
                  if (rgb[i] < 0 || rgb[i] > 255) { rgb._clipped = true; }
                  rgb[i] = limit(rgb[i], 0, 255);
              } else if (i === 3) {
                  rgb[i] = limit(rgb[i], 0, 1);
              }
          }
          return rgb;
      };

      // ported from jQuery's $.type
      var classToType = {};
      for (var i = 0, list = ['Boolean', 'Number', 'String', 'Function', 'Array', 'Date', 'RegExp', 'Undefined', 'Null']; i < list.length; i += 1) {
          var name = list[i];

          classToType[("[object " + name + "]")] = name.toLowerCase();
      }
      var type = function(obj) {
          return classToType[Object.prototype.toString.call(obj)] || "object";
      };

      var unpack = function (args, keyOrder) {
          if ( keyOrder === void 0 ) keyOrder=null;

      	// if called with more than 3 arguments, we return the arguments
          if (args.length >= 3) { return Array.prototype.slice.call(args); }
          // with less than 3 args we check if first arg is object
          // and use the keyOrder string to extract and sort properties
      	if (type(args[0]) == 'object' && keyOrder) {
      		return keyOrder.split('')
      			.filter(function (k) { return args[0][k] !== undefined; })
      			.map(function (k) { return args[0][k]; });
      	}
      	// otherwise we just return the first argument
      	// (which we suppose is an array of args)
          return args[0];
      };

      var last = function (args) {
          if (args.length < 2) { return null; }
          var l = args.length-1;
          if (type(args[l]) == 'string') { return args[l].toLowerCase(); }
          return null;
      };

      var PI = Math.PI;

      var utils = {
      	clip_rgb: clip_rgb,
      	limit: limit,
      	type: type,
      	unpack: unpack,
      	last: last,
      	PI: PI,
      	TWOPI: PI*2,
      	PITHIRD: PI/3,
      	DEG2RAD: PI / 180,
      	RAD2DEG: 180 / PI
      };

      var input = {
      	format: {},
      	autodetect: []
      };

      var last$1 = utils.last;
      var clip_rgb$1 = utils.clip_rgb;
      var type$1 = utils.type;


      var Color = function Color() {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          var me = this;
          if (type$1(args[0]) === 'object' &&
              args[0].constructor &&
              args[0].constructor === this.constructor) {
              // the argument is already a Color instance
              return args[0];
          }

          // last argument could be the mode
          var mode = last$1(args);
          var autodetect = false;

          if (!mode) {
              autodetect = true;
              if (!input.sorted) {
                  input.autodetect = input.autodetect.sort(function (a,b) { return b.p - a.p; });
                  input.sorted = true;
              }
              // auto-detect format
              for (var i = 0, list = input.autodetect; i < list.length; i += 1) {
                  var chk = list[i];

                  mode = chk.test.apply(chk, args);
                  if (mode) { break; }
              }
          }

          if (input.format[mode]) {
              var rgb = input.format[mode].apply(null, autodetect ? args : args.slice(0,-1));
              me._rgb = clip_rgb$1(rgb);
          } else {
              throw new Error('unknown format: '+args);
          }

          // add alpha channel
          if (me._rgb.length === 3) { me._rgb.push(1); }
      };

      Color.prototype.toString = function toString () {
          if (type$1(this.hex) == 'function') { return this.hex(); }
          return ("[" + (this._rgb.join(',')) + "]");
      };

      var Color_1 = Color;

      var chroma = function () {
      	var args = [], len = arguments.length;
      	while ( len-- ) args[ len ] = arguments[ len ];

      	return new (Function.prototype.bind.apply( chroma.Color, [ null ].concat( args) ));
      };

      chroma.Color = Color_1;
      chroma.version = '2.1.2';

      var chroma_1 = chroma;

      var unpack$1 = utils.unpack;
      var max = Math.max;

      var rgb2cmyk = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          var ref = unpack$1(args, 'rgb');
          var r = ref[0];
          var g = ref[1];
          var b = ref[2];
          r = r / 255;
          g = g / 255;
          b = b / 255;
          var k = 1 - max(r,max(g,b));
          var f = k < 1 ? 1 / (1-k) : 0;
          var c = (1-r-k) * f;
          var m = (1-g-k) * f;
          var y = (1-b-k) * f;
          return [c,m,y,k];
      };

      var rgb2cmyk_1 = rgb2cmyk;

      var unpack$2 = utils.unpack;

      var cmyk2rgb = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          args = unpack$2(args, 'cmyk');
          var c = args[0];
          var m = args[1];
          var y = args[2];
          var k = args[3];
          var alpha = args.length > 4 ? args[4] : 1;
          if (k === 1) { return [0,0,0,alpha]; }
          return [
              c >= 1 ? 0 : 255 * (1-c) * (1-k), // r
              m >= 1 ? 0 : 255 * (1-m) * (1-k), // g
              y >= 1 ? 0 : 255 * (1-y) * (1-k), // b
              alpha
          ];
      };

      var cmyk2rgb_1 = cmyk2rgb;

      var unpack$3 = utils.unpack;
      var type$2 = utils.type;



      Color_1.prototype.cmyk = function() {
          return rgb2cmyk_1(this._rgb);
      };

      chroma_1.cmyk = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['cmyk']) ));
      };

      input.format.cmyk = cmyk2rgb_1;

      input.autodetect.push({
          p: 2,
          test: function () {
              var args = [], len = arguments.length;
              while ( len-- ) args[ len ] = arguments[ len ];

              args = unpack$3(args, 'cmyk');
              if (type$2(args) === 'array' && args.length === 4) {
                  return 'cmyk';
              }
          }
      });

      var unpack$4 = utils.unpack;
      var last$2 = utils.last;
      var rnd = function (a) { return Math.round(a*100)/100; };

      /*
       * supported arguments:
       * - hsl2css(h,s,l)
       * - hsl2css(h,s,l,a)
       * - hsl2css([h,s,l], mode)
       * - hsl2css([h,s,l,a], mode)
       * - hsl2css({h,s,l,a}, mode)
       */
      var hsl2css = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          var hsla = unpack$4(args, 'hsla');
          var mode = last$2(args) || 'lsa';
          hsla[0] = rnd(hsla[0] || 0);
          hsla[1] = rnd(hsla[1]*100) + '%';
          hsla[2] = rnd(hsla[2]*100) + '%';
          if (mode === 'hsla' || (hsla.length > 3 && hsla[3]<1)) {
              hsla[3] = hsla.length > 3 ? hsla[3] : 1;
              mode = 'hsla';
          } else {
              hsla.length = 3;
          }
          return (mode + "(" + (hsla.join(',')) + ")");
      };

      var hsl2css_1 = hsl2css;

      var unpack$5 = utils.unpack;

      /*
       * supported arguments:
       * - rgb2hsl(r,g,b)
       * - rgb2hsl(r,g,b,a)
       * - rgb2hsl([r,g,b])
       * - rgb2hsl([r,g,b,a])
       * - rgb2hsl({r,g,b,a})
       */
      var rgb2hsl = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          args = unpack$5(args, 'rgba');
          var r = args[0];
          var g = args[1];
          var b = args[2];

          r /= 255;
          g /= 255;
          b /= 255;

          var min = Math.min(r, g, b);
          var max = Math.max(r, g, b);

          var l = (max + min) / 2;
          var s, h;

          if (max === min){
              s = 0;
              h = Number.NaN;
          } else {
              s = l < 0.5 ? (max - min) / (max + min) : (max - min) / (2 - max - min);
          }

          if (r == max) { h = (g - b) / (max - min); }
          else if (g == max) { h = 2 + (b - r) / (max - min); }
          else if (b == max) { h = 4 + (r - g) / (max - min); }

          h *= 60;
          if (h < 0) { h += 360; }
          if (args.length>3 && args[3]!==undefined) { return [h,s,l,args[3]]; }
          return [h,s,l];
      };

      var rgb2hsl_1 = rgb2hsl;

      var unpack$6 = utils.unpack;
      var last$3 = utils.last;


      var round = Math.round;

      /*
       * supported arguments:
       * - rgb2css(r,g,b)
       * - rgb2css(r,g,b,a)
       * - rgb2css([r,g,b], mode)
       * - rgb2css([r,g,b,a], mode)
       * - rgb2css({r,g,b,a}, mode)
       */
      var rgb2css = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          var rgba = unpack$6(args, 'rgba');
          var mode = last$3(args) || 'rgb';
          if (mode.substr(0,3) == 'hsl') {
              return hsl2css_1(rgb2hsl_1(rgba), mode);
          }
          rgba[0] = round(rgba[0]);
          rgba[1] = round(rgba[1]);
          rgba[2] = round(rgba[2]);
          if (mode === 'rgba' || (rgba.length > 3 && rgba[3]<1)) {
              rgba[3] = rgba.length > 3 ? rgba[3] : 1;
              mode = 'rgba';
          }
          return (mode + "(" + (rgba.slice(0,mode==='rgb'?3:4).join(',')) + ")");
      };

      var rgb2css_1 = rgb2css;

      var unpack$7 = utils.unpack;
      var round$1 = Math.round;

      var hsl2rgb = function () {
          var assign;

          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];
          args = unpack$7(args, 'hsl');
          var h = args[0];
          var s = args[1];
          var l = args[2];
          var r,g,b;
          if (s === 0) {
              r = g = b = l*255;
          } else {
              var t3 = [0,0,0];
              var c = [0,0,0];
              var t2 = l < 0.5 ? l * (1+s) : l+s-l*s;
              var t1 = 2 * l - t2;
              var h_ = h / 360;
              t3[0] = h_ + 1/3;
              t3[1] = h_;
              t3[2] = h_ - 1/3;
              for (var i=0; i<3; i++) {
                  if (t3[i] < 0) { t3[i] += 1; }
                  if (t3[i] > 1) { t3[i] -= 1; }
                  if (6 * t3[i] < 1)
                      { c[i] = t1 + (t2 - t1) * 6 * t3[i]; }
                  else if (2 * t3[i] < 1)
                      { c[i] = t2; }
                  else if (3 * t3[i] < 2)
                      { c[i] = t1 + (t2 - t1) * ((2 / 3) - t3[i]) * 6; }
                  else
                      { c[i] = t1; }
              }
              (assign = [round$1(c[0]*255),round$1(c[1]*255),round$1(c[2]*255)], r = assign[0], g = assign[1], b = assign[2]);
          }
          if (args.length > 3) {
              // keep alpha channel
              return [r,g,b,args[3]];
          }
          return [r,g,b,1];
      };

      var hsl2rgb_1 = hsl2rgb;

      var RE_RGB = /^rgb\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*\)$/;
      var RE_RGBA = /^rgba\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*,\s*([01]|[01]?\.\d+)\)$/;
      var RE_RGB_PCT = /^rgb\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
      var RE_RGBA_PCT = /^rgba\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
      var RE_HSL = /^hsl\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
      var RE_HSLA = /^hsla\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;

      var round$2 = Math.round;

      var css2rgb = function (css) {
          css = css.toLowerCase().trim();
          var m;

          if (input.format.named) {
              try {
                  return input.format.named(css);
              } catch (e) {
                  // eslint-disable-next-line
              }
          }

          // rgb(250,20,0)
          if ((m = css.match(RE_RGB))) {
              var rgb = m.slice(1,4);
              for (var i=0; i<3; i++) {
                  rgb[i] = +rgb[i];
              }
              rgb[3] = 1;  // default alpha
              return rgb;
          }

          // rgba(250,20,0,0.4)
          if ((m = css.match(RE_RGBA))) {
              var rgb$1 = m.slice(1,5);
              for (var i$1=0; i$1<4; i$1++) {
                  rgb$1[i$1] = +rgb$1[i$1];
              }
              return rgb$1;
          }

          // rgb(100%,0%,0%)
          if ((m = css.match(RE_RGB_PCT))) {
              var rgb$2 = m.slice(1,4);
              for (var i$2=0; i$2<3; i$2++) {
                  rgb$2[i$2] = round$2(rgb$2[i$2] * 2.55);
              }
              rgb$2[3] = 1;  // default alpha
              return rgb$2;
          }

          // rgba(100%,0%,0%,0.4)
          if ((m = css.match(RE_RGBA_PCT))) {
              var rgb$3 = m.slice(1,5);
              for (var i$3=0; i$3<3; i$3++) {
                  rgb$3[i$3] = round$2(rgb$3[i$3] * 2.55);
              }
              rgb$3[3] = +rgb$3[3];
              return rgb$3;
          }

          // hsl(0,100%,50%)
          if ((m = css.match(RE_HSL))) {
              var hsl = m.slice(1,4);
              hsl[1] *= 0.01;
              hsl[2] *= 0.01;
              var rgb$4 = hsl2rgb_1(hsl);
              rgb$4[3] = 1;
              return rgb$4;
          }

          // hsla(0,100%,50%,0.5)
          if ((m = css.match(RE_HSLA))) {
              var hsl$1 = m.slice(1,4);
              hsl$1[1] *= 0.01;
              hsl$1[2] *= 0.01;
              var rgb$5 = hsl2rgb_1(hsl$1);
              rgb$5[3] = +m[4];  // default alpha = 1
              return rgb$5;
          }
      };

      css2rgb.test = function (s) {
          return RE_RGB.test(s) ||
              RE_RGBA.test(s) ||
              RE_RGB_PCT.test(s) ||
              RE_RGBA_PCT.test(s) ||
              RE_HSL.test(s) ||
              RE_HSLA.test(s);
      };

      var css2rgb_1 = css2rgb;

      var type$3 = utils.type;




      Color_1.prototype.css = function(mode) {
          return rgb2css_1(this._rgb, mode);
      };

      chroma_1.css = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['css']) ));
      };

      input.format.css = css2rgb_1;

      input.autodetect.push({
          p: 5,
          test: function (h) {
              var rest = [], len = arguments.length - 1;
              while ( len-- > 0 ) rest[ len ] = arguments[ len + 1 ];

              if (!rest.length && type$3(h) === 'string' && css2rgb_1.test(h)) {
                  return 'css';
              }
          }
      });

      var unpack$8 = utils.unpack;

      input.format.gl = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          var rgb = unpack$8(args, 'rgba');
          rgb[0] *= 255;
          rgb[1] *= 255;
          rgb[2] *= 255;
          return rgb;
      };

      chroma_1.gl = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['gl']) ));
      };

      Color_1.prototype.gl = function() {
          var rgb = this._rgb;
          return [rgb[0]/255, rgb[1]/255, rgb[2]/255, rgb[3]];
      };

      var unpack$9 = utils.unpack;

      var rgb2hcg = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          var ref = unpack$9(args, 'rgb');
          var r = ref[0];
          var g = ref[1];
          var b = ref[2];
          var min = Math.min(r, g, b);
          var max = Math.max(r, g, b);
          var delta = max - min;
          var c = delta * 100 / 255;
          var _g = min / (255 - delta) * 100;
          var h;
          if (delta === 0) {
              h = Number.NaN;
          } else {
              if (r === max) { h = (g - b) / delta; }
              if (g === max) { h = 2+(b - r) / delta; }
              if (b === max) { h = 4+(r - g) / delta; }
              h *= 60;
              if (h < 0) { h += 360; }
          }
          return [h, c, _g];
      };

      var rgb2hcg_1 = rgb2hcg;

      var unpack$a = utils.unpack;
      var floor = Math.floor;

      /*
       * this is basically just HSV with some minor tweaks
       *
       * hue.. [0..360]
       * chroma .. [0..1]
       * grayness .. [0..1]
       */

      var hcg2rgb = function () {
          var assign, assign$1, assign$2, assign$3, assign$4, assign$5;

          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];
          args = unpack$a(args, 'hcg');
          var h = args[0];
          var c = args[1];
          var _g = args[2];
          var r,g,b;
          _g = _g * 255;
          var _c = c * 255;
          if (c === 0) {
              r = g = b = _g;
          } else {
              if (h === 360) { h = 0; }
              if (h > 360) { h -= 360; }
              if (h < 0) { h += 360; }
              h /= 60;
              var i = floor(h);
              var f = h - i;
              var p = _g * (1 - c);
              var q = p + _c * (1 - f);
              var t = p + _c * f;
              var v = p + _c;
              switch (i) {
                  case 0: (assign = [v, t, p], r = assign[0], g = assign[1], b = assign[2]); break
                  case 1: (assign$1 = [q, v, p], r = assign$1[0], g = assign$1[1], b = assign$1[2]); break
                  case 2: (assign$2 = [p, v, t], r = assign$2[0], g = assign$2[1], b = assign$2[2]); break
                  case 3: (assign$3 = [p, q, v], r = assign$3[0], g = assign$3[1], b = assign$3[2]); break
                  case 4: (assign$4 = [t, p, v], r = assign$4[0], g = assign$4[1], b = assign$4[2]); break
                  case 5: (assign$5 = [v, p, q], r = assign$5[0], g = assign$5[1], b = assign$5[2]); break
              }
          }
          return [r, g, b, args.length > 3 ? args[3] : 1];
      };

      var hcg2rgb_1 = hcg2rgb;

      var unpack$b = utils.unpack;
      var type$4 = utils.type;






      Color_1.prototype.hcg = function() {
          return rgb2hcg_1(this._rgb);
      };

      chroma_1.hcg = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hcg']) ));
      };

      input.format.hcg = hcg2rgb_1;

      input.autodetect.push({
          p: 1,
          test: function () {
              var args = [], len = arguments.length;
              while ( len-- ) args[ len ] = arguments[ len ];

              args = unpack$b(args, 'hcg');
              if (type$4(args) === 'array' && args.length === 3) {
                  return 'hcg';
              }
          }
      });

      var unpack$c = utils.unpack;
      var last$4 = utils.last;
      var round$3 = Math.round;

      var rgb2hex = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          var ref = unpack$c(args, 'rgba');
          var r = ref[0];
          var g = ref[1];
          var b = ref[2];
          var a = ref[3];
          var mode = last$4(args) || 'auto';
          if (a === undefined) { a = 1; }
          if (mode === 'auto') {
              mode = a < 1 ? 'rgba' : 'rgb';
          }
          r = round$3(r);
          g = round$3(g);
          b = round$3(b);
          var u = r << 16 | g << 8 | b;
          var str = "000000" + u.toString(16); //#.toUpperCase();
          str = str.substr(str.length - 6);
          var hxa = '0' + round$3(a * 255).toString(16);
          hxa = hxa.substr(hxa.length - 2);
          switch (mode.toLowerCase()) {
              case 'rgba': return ("#" + str + hxa);
              case 'argb': return ("#" + hxa + str);
              default: return ("#" + str);
          }
      };

      var rgb2hex_1 = rgb2hex;

      var RE_HEX = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
      var RE_HEXA = /^#?([A-Fa-f0-9]{8}|[A-Fa-f0-9]{4})$/;

      var hex2rgb = function (hex) {
          if (hex.match(RE_HEX)) {
              // remove optional leading #
              if (hex.length === 4 || hex.length === 7) {
                  hex = hex.substr(1);
              }
              // expand short-notation to full six-digit
              if (hex.length === 3) {
                  hex = hex.split('');
                  hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
              }
              var u = parseInt(hex, 16);
              var r = u >> 16;
              var g = u >> 8 & 0xFF;
              var b = u & 0xFF;
              return [r,g,b,1];
          }

          // match rgba hex format, eg #FF000077
          if (hex.match(RE_HEXA)) {
              if (hex.length === 5 || hex.length === 9) {
                  // remove optional leading #
                  hex = hex.substr(1);
              }
              // expand short-notation to full eight-digit
              if (hex.length === 4) {
                  hex = hex.split('');
                  hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2]+hex[3]+hex[3];
              }
              var u$1 = parseInt(hex, 16);
              var r$1 = u$1 >> 24 & 0xFF;
              var g$1 = u$1 >> 16 & 0xFF;
              var b$1 = u$1 >> 8 & 0xFF;
              var a = Math.round((u$1 & 0xFF) / 0xFF * 100) / 100;
              return [r$1,g$1,b$1,a];
          }

          // we used to check for css colors here
          // if _input.css? and rgb = _input.css hex
          //     return rgb

          throw new Error(("unknown hex color: " + hex));
      };

      var hex2rgb_1 = hex2rgb;

      var type$5 = utils.type;




      Color_1.prototype.hex = function(mode) {
          return rgb2hex_1(this._rgb, mode);
      };

      chroma_1.hex = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hex']) ));
      };

      input.format.hex = hex2rgb_1;
      input.autodetect.push({
          p: 4,
          test: function (h) {
              var rest = [], len = arguments.length - 1;
              while ( len-- > 0 ) rest[ len ] = arguments[ len + 1 ];

              if (!rest.length && type$5(h) === 'string' && [3,4,5,6,7,8,9].indexOf(h.length) >= 0) {
                  return 'hex';
              }
          }
      });

      var unpack$d = utils.unpack;
      var TWOPI = utils.TWOPI;
      var min = Math.min;
      var sqrt = Math.sqrt;
      var acos = Math.acos;

      var rgb2hsi = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          /*
          borrowed from here:
          http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/rgb2hsi.cpp
          */
          var ref = unpack$d(args, 'rgb');
          var r = ref[0];
          var g = ref[1];
          var b = ref[2];
          r /= 255;
          g /= 255;
          b /= 255;
          var h;
          var min_ = min(r,g,b);
          var i = (r+g+b) / 3;
          var s = i > 0 ? 1 - min_/i : 0;
          if (s === 0) {
              h = NaN;
          } else {
              h = ((r-g)+(r-b)) / 2;
              h /= sqrt((r-g)*(r-g) + (r-b)*(g-b));
              h = acos(h);
              if (b > g) {
                  h = TWOPI - h;
              }
              h /= TWOPI;
          }
          return [h*360,s,i];
      };

      var rgb2hsi_1 = rgb2hsi;

      var unpack$e = utils.unpack;
      var limit$1 = utils.limit;
      var TWOPI$1 = utils.TWOPI;
      var PITHIRD = utils.PITHIRD;
      var cos = Math.cos;

      /*
       * hue [0..360]
       * saturation [0..1]
       * intensity [0..1]
       */
      var hsi2rgb = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          /*
          borrowed from here:
          http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/hsi2rgb.cpp
          */
          args = unpack$e(args, 'hsi');
          var h = args[0];
          var s = args[1];
          var i = args[2];
          var r,g,b;

          if (isNaN(h)) { h = 0; }
          if (isNaN(s)) { s = 0; }
          // normalize hue
          if (h > 360) { h -= 360; }
          if (h < 0) { h += 360; }
          h /= 360;
          if (h < 1/3) {
              b = (1-s)/3;
              r = (1+s*cos(TWOPI$1*h)/cos(PITHIRD-TWOPI$1*h))/3;
              g = 1 - (b+r);
          } else if (h < 2/3) {
              h -= 1/3;
              r = (1-s)/3;
              g = (1+s*cos(TWOPI$1*h)/cos(PITHIRD-TWOPI$1*h))/3;
              b = 1 - (r+g);
          } else {
              h -= 2/3;
              g = (1-s)/3;
              b = (1+s*cos(TWOPI$1*h)/cos(PITHIRD-TWOPI$1*h))/3;
              r = 1 - (g+b);
          }
          r = limit$1(i*r*3);
          g = limit$1(i*g*3);
          b = limit$1(i*b*3);
          return [r*255, g*255, b*255, args.length > 3 ? args[3] : 1];
      };

      var hsi2rgb_1 = hsi2rgb;

      var unpack$f = utils.unpack;
      var type$6 = utils.type;






      Color_1.prototype.hsi = function() {
          return rgb2hsi_1(this._rgb);
      };

      chroma_1.hsi = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hsi']) ));
      };

      input.format.hsi = hsi2rgb_1;

      input.autodetect.push({
          p: 2,
          test: function () {
              var args = [], len = arguments.length;
              while ( len-- ) args[ len ] = arguments[ len ];

              args = unpack$f(args, 'hsi');
              if (type$6(args) === 'array' && args.length === 3) {
                  return 'hsi';
              }
          }
      });

      var unpack$g = utils.unpack;
      var type$7 = utils.type;






      Color_1.prototype.hsl = function() {
          return rgb2hsl_1(this._rgb);
      };

      chroma_1.hsl = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hsl']) ));
      };

      input.format.hsl = hsl2rgb_1;

      input.autodetect.push({
          p: 2,
          test: function () {
              var args = [], len = arguments.length;
              while ( len-- ) args[ len ] = arguments[ len ];

              args = unpack$g(args, 'hsl');
              if (type$7(args) === 'array' && args.length === 3) {
                  return 'hsl';
              }
          }
      });

      var unpack$h = utils.unpack;
      var min$1 = Math.min;
      var max$1 = Math.max;

      /*
       * supported arguments:
       * - rgb2hsv(r,g,b)
       * - rgb2hsv([r,g,b])
       * - rgb2hsv({r,g,b})
       */
      var rgb2hsl$1 = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          args = unpack$h(args, 'rgb');
          var r = args[0];
          var g = args[1];
          var b = args[2];
          var min_ = min$1(r, g, b);
          var max_ = max$1(r, g, b);
          var delta = max_ - min_;
          var h,s,v;
          v = max_ / 255.0;
          if (max_ === 0) {
              h = Number.NaN;
              s = 0;
          } else {
              s = delta / max_;
              if (r === max_) { h = (g - b) / delta; }
              if (g === max_) { h = 2+(b - r) / delta; }
              if (b === max_) { h = 4+(r - g) / delta; }
              h *= 60;
              if (h < 0) { h += 360; }
          }
          return [h, s, v]
      };

      var rgb2hsv = rgb2hsl$1;

      var unpack$i = utils.unpack;
      var floor$1 = Math.floor;

      var hsv2rgb = function () {
          var assign, assign$1, assign$2, assign$3, assign$4, assign$5;

          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];
          args = unpack$i(args, 'hsv');
          var h = args[0];
          var s = args[1];
          var v = args[2];
          var r,g,b;
          v *= 255;
          if (s === 0) {
              r = g = b = v;
          } else {
              if (h === 360) { h = 0; }
              if (h > 360) { h -= 360; }
              if (h < 0) { h += 360; }
              h /= 60;

              var i = floor$1(h);
              var f = h - i;
              var p = v * (1 - s);
              var q = v * (1 - s * f);
              var t = v * (1 - s * (1 - f));

              switch (i) {
                  case 0: (assign = [v, t, p], r = assign[0], g = assign[1], b = assign[2]); break
                  case 1: (assign$1 = [q, v, p], r = assign$1[0], g = assign$1[1], b = assign$1[2]); break
                  case 2: (assign$2 = [p, v, t], r = assign$2[0], g = assign$2[1], b = assign$2[2]); break
                  case 3: (assign$3 = [p, q, v], r = assign$3[0], g = assign$3[1], b = assign$3[2]); break
                  case 4: (assign$4 = [t, p, v], r = assign$4[0], g = assign$4[1], b = assign$4[2]); break
                  case 5: (assign$5 = [v, p, q], r = assign$5[0], g = assign$5[1], b = assign$5[2]); break
              }
          }
          return [r,g,b,args.length > 3?args[3]:1];
      };

      var hsv2rgb_1 = hsv2rgb;

      var unpack$j = utils.unpack;
      var type$8 = utils.type;






      Color_1.prototype.hsv = function() {
          return rgb2hsv(this._rgb);
      };

      chroma_1.hsv = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hsv']) ));
      };

      input.format.hsv = hsv2rgb_1;

      input.autodetect.push({
          p: 2,
          test: function () {
              var args = [], len = arguments.length;
              while ( len-- ) args[ len ] = arguments[ len ];

              args = unpack$j(args, 'hsv');
              if (type$8(args) === 'array' && args.length === 3) {
                  return 'hsv';
              }
          }
      });

      var labConstants = {
          // Corresponds roughly to RGB brighter/darker
          Kn: 18,

          // D65 standard referent
          Xn: 0.950470,
          Yn: 1,
          Zn: 1.088830,

          t0: 0.137931034,  // 4 / 29
          t1: 0.206896552,  // 6 / 29
          t2: 0.12841855,   // 3 * t1 * t1
          t3: 0.008856452,  // t1 * t1 * t1
      };

      var unpack$k = utils.unpack;
      var pow = Math.pow;

      var rgb2lab = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          var ref = unpack$k(args, 'rgb');
          var r = ref[0];
          var g = ref[1];
          var b = ref[2];
          var ref$1 = rgb2xyz(r,g,b);
          var x = ref$1[0];
          var y = ref$1[1];
          var z = ref$1[2];
          var l = 116 * y - 16;
          return [l < 0 ? 0 : l, 500 * (x - y), 200 * (y - z)];
      };

      var rgb_xyz = function (r) {
          if ((r /= 255) <= 0.04045) { return r / 12.92; }
          return pow((r + 0.055) / 1.055, 2.4);
      };

      var xyz_lab = function (t) {
          if (t > labConstants.t3) { return pow(t, 1 / 3); }
          return t / labConstants.t2 + labConstants.t0;
      };

      var rgb2xyz = function (r,g,b) {
          r = rgb_xyz(r);
          g = rgb_xyz(g);
          b = rgb_xyz(b);
          var x = xyz_lab((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / labConstants.Xn);
          var y = xyz_lab((0.2126729 * r + 0.7151522 * g + 0.0721750 * b) / labConstants.Yn);
          var z = xyz_lab((0.0193339 * r + 0.1191920 * g + 0.9503041 * b) / labConstants.Zn);
          return [x,y,z];
      };

      var rgb2lab_1 = rgb2lab;

      var unpack$l = utils.unpack;
      var pow$1 = Math.pow;

      /*
       * L* [0..100]
       * a [-100..100]
       * b [-100..100]
       */
      var lab2rgb = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          args = unpack$l(args, 'lab');
          var l = args[0];
          var a = args[1];
          var b = args[2];
          var x,y,z, r,g,b_;

          y = (l + 16) / 116;
          x = isNaN(a) ? y : y + a / 500;
          z = isNaN(b) ? y : y - b / 200;

          y = labConstants.Yn * lab_xyz(y);
          x = labConstants.Xn * lab_xyz(x);
          z = labConstants.Zn * lab_xyz(z);

          r = xyz_rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z);  // D65 -> sRGB
          g = xyz_rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z);
          b_ = xyz_rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z);

          return [r,g,b_,args.length > 3 ? args[3] : 1];
      };

      var xyz_rgb = function (r) {
          return 255 * (r <= 0.00304 ? 12.92 * r : 1.055 * pow$1(r, 1 / 2.4) - 0.055)
      };

      var lab_xyz = function (t) {
          return t > labConstants.t1 ? t * t * t : labConstants.t2 * (t - labConstants.t0)
      };

      var lab2rgb_1 = lab2rgb;

      var unpack$m = utils.unpack;
      var type$9 = utils.type;






      Color_1.prototype.lab = function() {
          return rgb2lab_1(this._rgb);
      };

      chroma_1.lab = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['lab']) ));
      };

      input.format.lab = lab2rgb_1;

      input.autodetect.push({
          p: 2,
          test: function () {
              var args = [], len = arguments.length;
              while ( len-- ) args[ len ] = arguments[ len ];

              args = unpack$m(args, 'lab');
              if (type$9(args) === 'array' && args.length === 3) {
                  return 'lab';
              }
          }
      });

      var unpack$n = utils.unpack;
      var RAD2DEG = utils.RAD2DEG;
      var sqrt$1 = Math.sqrt;
      var atan2 = Math.atan2;
      var round$4 = Math.round;

      var lab2lch = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          var ref = unpack$n(args, 'lab');
          var l = ref[0];
          var a = ref[1];
          var b = ref[2];
          var c = sqrt$1(a * a + b * b);
          var h = (atan2(b, a) * RAD2DEG + 360) % 360;
          if (round$4(c*10000) === 0) { h = Number.NaN; }
          return [l, c, h];
      };

      var lab2lch_1 = lab2lch;

      var unpack$o = utils.unpack;



      var rgb2lch = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          var ref = unpack$o(args, 'rgb');
          var r = ref[0];
          var g = ref[1];
          var b = ref[2];
          var ref$1 = rgb2lab_1(r,g,b);
          var l = ref$1[0];
          var a = ref$1[1];
          var b_ = ref$1[2];
          return lab2lch_1(l,a,b_);
      };

      var rgb2lch_1 = rgb2lch;

      var unpack$p = utils.unpack;
      var DEG2RAD = utils.DEG2RAD;
      var sin = Math.sin;
      var cos$1 = Math.cos;

      var lch2lab = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          /*
          Convert from a qualitative parameter h and a quantitative parameter l to a 24-bit pixel.
          These formulas were invented by David Dalrymple to obtain maximum contrast without going
          out of gamut if the parameters are in the range 0-1.

          A saturation multiplier was added by Gregor Aisch
          */
          var ref = unpack$p(args, 'lch');
          var l = ref[0];
          var c = ref[1];
          var h = ref[2];
          if (isNaN(h)) { h = 0; }
          h = h * DEG2RAD;
          return [l, cos$1(h) * c, sin(h) * c]
      };

      var lch2lab_1 = lch2lab;

      var unpack$q = utils.unpack;



      var lch2rgb = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          args = unpack$q(args, 'lch');
          var l = args[0];
          var c = args[1];
          var h = args[2];
          var ref = lch2lab_1 (l,c,h);
          var L = ref[0];
          var a = ref[1];
          var b_ = ref[2];
          var ref$1 = lab2rgb_1 (L,a,b_);
          var r = ref$1[0];
          var g = ref$1[1];
          var b = ref$1[2];
          return [r, g, b, args.length > 3 ? args[3] : 1];
      };

      var lch2rgb_1 = lch2rgb;

      var unpack$r = utils.unpack;


      var hcl2rgb = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          var hcl = unpack$r(args, 'hcl').reverse();
          return lch2rgb_1.apply(void 0, hcl);
      };

      var hcl2rgb_1 = hcl2rgb;

      var unpack$s = utils.unpack;
      var type$a = utils.type;






      Color_1.prototype.lch = function() { return rgb2lch_1(this._rgb); };
      Color_1.prototype.hcl = function() { return rgb2lch_1(this._rgb).reverse(); };

      chroma_1.lch = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['lch']) ));
      };
      chroma_1.hcl = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hcl']) ));
      };

      input.format.lch = lch2rgb_1;
      input.format.hcl = hcl2rgb_1;

      ['lch','hcl'].forEach(function (m) { return input.autodetect.push({
          p: 2,
          test: function () {
              var args = [], len = arguments.length;
              while ( len-- ) args[ len ] = arguments[ len ];

              args = unpack$s(args, m);
              if (type$a(args) === 'array' && args.length === 3) {
                  return m;
              }
          }
      }); });

      /**
      	X11 color names

      	http://www.w3.org/TR/css3-color/#svg-color
      */

      var w3cx11 = {
          aliceblue: '#f0f8ff',
          antiquewhite: '#faebd7',
          aqua: '#00ffff',
          aquamarine: '#7fffd4',
          azure: '#f0ffff',
          beige: '#f5f5dc',
          bisque: '#ffe4c4',
          black: '#000000',
          blanchedalmond: '#ffebcd',
          blue: '#0000ff',
          blueviolet: '#8a2be2',
          brown: '#a52a2a',
          burlywood: '#deb887',
          cadetblue: '#5f9ea0',
          chartreuse: '#7fff00',
          chocolate: '#d2691e',
          coral: '#ff7f50',
          cornflower: '#6495ed',
          cornflowerblue: '#6495ed',
          cornsilk: '#fff8dc',
          crimson: '#dc143c',
          cyan: '#00ffff',
          darkblue: '#00008b',
          darkcyan: '#008b8b',
          darkgoldenrod: '#b8860b',
          darkgray: '#a9a9a9',
          darkgreen: '#006400',
          darkgrey: '#a9a9a9',
          darkkhaki: '#bdb76b',
          darkmagenta: '#8b008b',
          darkolivegreen: '#556b2f',
          darkorange: '#ff8c00',
          darkorchid: '#9932cc',
          darkred: '#8b0000',
          darksalmon: '#e9967a',
          darkseagreen: '#8fbc8f',
          darkslateblue: '#483d8b',
          darkslategray: '#2f4f4f',
          darkslategrey: '#2f4f4f',
          darkturquoise: '#00ced1',
          darkviolet: '#9400d3',
          deeppink: '#ff1493',
          deepskyblue: '#00bfff',
          dimgray: '#696969',
          dimgrey: '#696969',
          dodgerblue: '#1e90ff',
          firebrick: '#b22222',
          floralwhite: '#fffaf0',
          forestgreen: '#228b22',
          fuchsia: '#ff00ff',
          gainsboro: '#dcdcdc',
          ghostwhite: '#f8f8ff',
          gold: '#ffd700',
          goldenrod: '#daa520',
          gray: '#808080',
          green: '#008000',
          greenyellow: '#adff2f',
          grey: '#808080',
          honeydew: '#f0fff0',
          hotpink: '#ff69b4',
          indianred: '#cd5c5c',
          indigo: '#4b0082',
          ivory: '#fffff0',
          khaki: '#f0e68c',
          laserlemon: '#ffff54',
          lavender: '#e6e6fa',
          lavenderblush: '#fff0f5',
          lawngreen: '#7cfc00',
          lemonchiffon: '#fffacd',
          lightblue: '#add8e6',
          lightcoral: '#f08080',
          lightcyan: '#e0ffff',
          lightgoldenrod: '#fafad2',
          lightgoldenrodyellow: '#fafad2',
          lightgray: '#d3d3d3',
          lightgreen: '#90ee90',
          lightgrey: '#d3d3d3',
          lightpink: '#ffb6c1',
          lightsalmon: '#ffa07a',
          lightseagreen: '#20b2aa',
          lightskyblue: '#87cefa',
          lightslategray: '#778899',
          lightslategrey: '#778899',
          lightsteelblue: '#b0c4de',
          lightyellow: '#ffffe0',
          lime: '#00ff00',
          limegreen: '#32cd32',
          linen: '#faf0e6',
          magenta: '#ff00ff',
          maroon: '#800000',
          maroon2: '#7f0000',
          maroon3: '#b03060',
          mediumaquamarine: '#66cdaa',
          mediumblue: '#0000cd',
          mediumorchid: '#ba55d3',
          mediumpurple: '#9370db',
          mediumseagreen: '#3cb371',
          mediumslateblue: '#7b68ee',
          mediumspringgreen: '#00fa9a',
          mediumturquoise: '#48d1cc',
          mediumvioletred: '#c71585',
          midnightblue: '#191970',
          mintcream: '#f5fffa',
          mistyrose: '#ffe4e1',
          moccasin: '#ffe4b5',
          navajowhite: '#ffdead',
          navy: '#000080',
          oldlace: '#fdf5e6',
          olive: '#808000',
          olivedrab: '#6b8e23',
          orange: '#ffa500',
          orangered: '#ff4500',
          orchid: '#da70d6',
          palegoldenrod: '#eee8aa',
          palegreen: '#98fb98',
          paleturquoise: '#afeeee',
          palevioletred: '#db7093',
          papayawhip: '#ffefd5',
          peachpuff: '#ffdab9',
          peru: '#cd853f',
          pink: '#ffc0cb',
          plum: '#dda0dd',
          powderblue: '#b0e0e6',
          purple: '#800080',
          purple2: '#7f007f',
          purple3: '#a020f0',
          rebeccapurple: '#663399',
          red: '#ff0000',
          rosybrown: '#bc8f8f',
          royalblue: '#4169e1',
          saddlebrown: '#8b4513',
          salmon: '#fa8072',
          sandybrown: '#f4a460',
          seagreen: '#2e8b57',
          seashell: '#fff5ee',
          sienna: '#a0522d',
          silver: '#c0c0c0',
          skyblue: '#87ceeb',
          slateblue: '#6a5acd',
          slategray: '#708090',
          slategrey: '#708090',
          snow: '#fffafa',
          springgreen: '#00ff7f',
          steelblue: '#4682b4',
          tan: '#d2b48c',
          teal: '#008080',
          thistle: '#d8bfd8',
          tomato: '#ff6347',
          turquoise: '#40e0d0',
          violet: '#ee82ee',
          wheat: '#f5deb3',
          white: '#ffffff',
          whitesmoke: '#f5f5f5',
          yellow: '#ffff00',
          yellowgreen: '#9acd32'
      };

      var w3cx11_1 = w3cx11;

      var type$b = utils.type;





      Color_1.prototype.name = function() {
          var hex = rgb2hex_1(this._rgb, 'rgb');
          for (var i = 0, list = Object.keys(w3cx11_1); i < list.length; i += 1) {
              var n = list[i];

              if (w3cx11_1[n] === hex) { return n.toLowerCase(); }
          }
          return hex;
      };

      input.format.named = function (name) {
          name = name.toLowerCase();
          if (w3cx11_1[name]) { return hex2rgb_1(w3cx11_1[name]); }
          throw new Error('unknown color name: '+name);
      };

      input.autodetect.push({
          p: 5,
          test: function (h) {
              var rest = [], len = arguments.length - 1;
              while ( len-- > 0 ) rest[ len ] = arguments[ len + 1 ];

              if (!rest.length && type$b(h) === 'string' && w3cx11_1[h.toLowerCase()]) {
                  return 'named';
              }
          }
      });

      var unpack$t = utils.unpack;

      var rgb2num = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          var ref = unpack$t(args, 'rgb');
          var r = ref[0];
          var g = ref[1];
          var b = ref[2];
          return (r << 16) + (g << 8) + b;
      };

      var rgb2num_1 = rgb2num;

      var type$c = utils.type;

      var num2rgb = function (num) {
          if (type$c(num) == "number" && num >= 0 && num <= 0xFFFFFF) {
              var r = num >> 16;
              var g = (num >> 8) & 0xFF;
              var b = num & 0xFF;
              return [r,g,b,1];
          }
          throw new Error("unknown num color: "+num);
      };

      var num2rgb_1 = num2rgb;

      var type$d = utils.type;



      Color_1.prototype.num = function() {
          return rgb2num_1(this._rgb);
      };

      chroma_1.num = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['num']) ));
      };

      input.format.num = num2rgb_1;

      input.autodetect.push({
          p: 5,
          test: function () {
              var args = [], len = arguments.length;
              while ( len-- ) args[ len ] = arguments[ len ];

              if (args.length === 1 && type$d(args[0]) === 'number' && args[0] >= 0 && args[0] <= 0xFFFFFF) {
                  return 'num';
              }
          }
      });

      var unpack$u = utils.unpack;
      var type$e = utils.type;
      var round$5 = Math.round;

      Color_1.prototype.rgb = function(rnd) {
          if ( rnd === void 0 ) rnd=true;

          if (rnd === false) { return this._rgb.slice(0,3); }
          return this._rgb.slice(0,3).map(round$5);
      };

      Color_1.prototype.rgba = function(rnd) {
          if ( rnd === void 0 ) rnd=true;

          return this._rgb.slice(0,4).map(function (v,i) {
              return i<3 ? (rnd === false ? v : round$5(v)) : v;
          });
      };

      chroma_1.rgb = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['rgb']) ));
      };

      input.format.rgb = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          var rgba = unpack$u(args, 'rgba');
          if (rgba[3] === undefined) { rgba[3] = 1; }
          return rgba;
      };

      input.autodetect.push({
          p: 3,
          test: function () {
              var args = [], len = arguments.length;
              while ( len-- ) args[ len ] = arguments[ len ];

              args = unpack$u(args, 'rgba');
              if (type$e(args) === 'array' && (args.length === 3 ||
                  args.length === 4 && type$e(args[3]) == 'number' && args[3] >= 0 && args[3] <= 1)) {
                  return 'rgb';
              }
          }
      });

      /*
       * Based on implementation by Neil Bartlett
       * https://github.com/neilbartlett/color-temperature
       */

      var log = Math.log;

      var temperature2rgb = function (kelvin) {
          var temp = kelvin / 100;
          var r,g,b;
          if (temp < 66) {
              r = 255;
              g = -155.25485562709179 - 0.44596950469579133 * (g = temp-2) + 104.49216199393888 * log(g);
              b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp-10) + 115.67994401066147 * log(b);
          } else {
              r = 351.97690566805693 + 0.114206453784165 * (r = temp-55) - 40.25366309332127 * log(r);
              g = 325.4494125711974 + 0.07943456536662342 * (g = temp-50) - 28.0852963507957 * log(g);
              b = 255;
          }
          return [r,g,b,1];
      };

      var temperature2rgb_1 = temperature2rgb;

      /*
       * Based on implementation by Neil Bartlett
       * https://github.com/neilbartlett/color-temperature
       **/


      var unpack$v = utils.unpack;
      var round$6 = Math.round;

      var rgb2temperature = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          var rgb = unpack$v(args, 'rgb');
          var r = rgb[0], b = rgb[2];
          var minTemp = 1000;
          var maxTemp = 40000;
          var eps = 0.4;
          var temp;
          while (maxTemp - minTemp > eps) {
              temp = (maxTemp + minTemp) * 0.5;
              var rgb$1 = temperature2rgb_1(temp);
              if ((rgb$1[2] / rgb$1[0]) >= (b / r)) {
                  maxTemp = temp;
              } else {
                  minTemp = temp;
              }
          }
          return round$6(temp);
      };

      var rgb2temperature_1 = rgb2temperature;

      Color_1.prototype.temp =
      Color_1.prototype.kelvin =
      Color_1.prototype.temperature = function() {
          return rgb2temperature_1(this._rgb);
      };

      chroma_1.temp =
      chroma_1.kelvin =
      chroma_1.temperature = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['temp']) ));
      };

      input.format.temp =
      input.format.kelvin =
      input.format.temperature = temperature2rgb_1;

      var type$f = utils.type;

      Color_1.prototype.alpha = function(a, mutate) {
          if ( mutate === void 0 ) mutate=false;

          if (a !== undefined && type$f(a) === 'number') {
              if (mutate) {
                  this._rgb[3] = a;
                  return this;
              }
              return new Color_1([this._rgb[0], this._rgb[1], this._rgb[2], a], 'rgb');
          }
          return this._rgb[3];
      };

      Color_1.prototype.clipped = function() {
          return this._rgb._clipped || false;
      };

      Color_1.prototype.darken = function(amount) {
      	if ( amount === void 0 ) amount=1;

      	var me = this;
      	var lab = me.lab();
      	lab[0] -= labConstants.Kn * amount;
      	return new Color_1(lab, 'lab').alpha(me.alpha(), true);
      };

      Color_1.prototype.brighten = function(amount) {
      	if ( amount === void 0 ) amount=1;

      	return this.darken(-amount);
      };

      Color_1.prototype.darker = Color_1.prototype.darken;
      Color_1.prototype.brighter = Color_1.prototype.brighten;

      Color_1.prototype.get = function(mc) {
          var ref = mc.split('.');
          var mode = ref[0];
          var channel = ref[1];
          var src = this[mode]();
          if (channel) {
              var i = mode.indexOf(channel);
              if (i > -1) { return src[i]; }
              throw new Error(("unknown channel " + channel + " in mode " + mode));
          } else {
              return src;
          }
      };

      var type$g = utils.type;
      var pow$2 = Math.pow;

      var EPS = 1e-7;
      var MAX_ITER = 20;

      Color_1.prototype.luminance = function(lum) {
          if (lum !== undefined && type$g(lum) === 'number') {
              if (lum === 0) {
                  // return pure black
                  return new Color_1([0,0,0,this._rgb[3]], 'rgb');
              }
              if (lum === 1) {
                  // return pure white
                  return new Color_1([255,255,255,this._rgb[3]], 'rgb');
              }
              // compute new color using...
              var cur_lum = this.luminance();
              var mode = 'rgb';
              var max_iter = MAX_ITER;

              var test = function (low, high) {
                  var mid = low.interpolate(high, 0.5, mode);
                  var lm = mid.luminance();
                  if (Math.abs(lum - lm) < EPS || !max_iter--) {
                      // close enough
                      return mid;
                  }
                  return lm > lum ? test(low, mid) : test(mid, high);
              };

              var rgb = (cur_lum > lum ? test(new Color_1([0,0,0]), this) : test(this, new Color_1([255,255,255]))).rgb();
              return new Color_1(rgb.concat( [this._rgb[3]]));
          }
          return rgb2luminance.apply(void 0, (this._rgb).slice(0,3));
      };


      var rgb2luminance = function (r,g,b) {
          // relative luminance
          // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
          r = luminance_x(r);
          g = luminance_x(g);
          b = luminance_x(b);
          return 0.2126 * r + 0.7152 * g + 0.0722 * b;
      };

      var luminance_x = function (x) {
          x /= 255;
          return x <= 0.03928 ? x/12.92 : pow$2((x+0.055)/1.055, 2.4);
      };

      var interpolator = {};

      var type$h = utils.type;


      var mix = function (col1, col2, f) {
          if ( f === void 0 ) f=0.5;
          var rest = [], len = arguments.length - 3;
          while ( len-- > 0 ) rest[ len ] = arguments[ len + 3 ];

          var mode = rest[0] || 'lrgb';
          if (!interpolator[mode] && !rest.length) {
              // fall back to the first supported mode
              mode = Object.keys(interpolator)[0];
          }
          if (!interpolator[mode]) {
              throw new Error(("interpolation mode " + mode + " is not defined"));
          }
          if (type$h(col1) !== 'object') { col1 = new Color_1(col1); }
          if (type$h(col2) !== 'object') { col2 = new Color_1(col2); }
          return interpolator[mode](col1, col2, f)
              .alpha(col1.alpha() + f * (col2.alpha() - col1.alpha()));
      };

      Color_1.prototype.mix =
      Color_1.prototype.interpolate = function(col2, f) {
      	if ( f === void 0 ) f=0.5;
      	var rest = [], len = arguments.length - 2;
      	while ( len-- > 0 ) rest[ len ] = arguments[ len + 2 ];

      	return mix.apply(void 0, [ this, col2, f ].concat( rest ));
      };

      Color_1.prototype.premultiply = function(mutate) {
      	if ( mutate === void 0 ) mutate=false;

      	var rgb = this._rgb;
      	var a = rgb[3];
      	if (mutate) {
      		this._rgb = [rgb[0]*a, rgb[1]*a, rgb[2]*a, a];
      		return this;
      	} else {
      		return new Color_1([rgb[0]*a, rgb[1]*a, rgb[2]*a, a], 'rgb');
      	}
      };

      Color_1.prototype.saturate = function(amount) {
      	if ( amount === void 0 ) amount=1;

      	var me = this;
      	var lch = me.lch();
      	lch[1] += labConstants.Kn * amount;
      	if (lch[1] < 0) { lch[1] = 0; }
      	return new Color_1(lch, 'lch').alpha(me.alpha(), true);
      };

      Color_1.prototype.desaturate = function(amount) {
      	if ( amount === void 0 ) amount=1;

      	return this.saturate(-amount);
      };

      var type$i = utils.type;

      Color_1.prototype.set = function(mc, value, mutate) {
          if ( mutate === void 0 ) mutate=false;

          var ref = mc.split('.');
          var mode = ref[0];
          var channel = ref[1];
          var src = this[mode]();
          if (channel) {
              var i = mode.indexOf(channel);
              if (i > -1) {
                  if (type$i(value) == 'string') {
                      switch(value.charAt(0)) {
                          case '+': src[i] += +value; break;
                          case '-': src[i] += +value; break;
                          case '*': src[i] *= +(value.substr(1)); break;
                          case '/': src[i] /= +(value.substr(1)); break;
                          default: src[i] = +value;
                      }
                  } else if (type$i(value) === 'number') {
                      src[i] = value;
                  } else {
                      throw new Error("unsupported value for Color.set");
                  }
                  var out = new Color_1(src, mode);
                  if (mutate) {
                      this._rgb = out._rgb;
                      return this;
                  }
                  return out;
              }
              throw new Error(("unknown channel " + channel + " in mode " + mode));
          } else {
              return src;
          }
      };

      var rgb$1 = function (col1, col2, f) {
          var xyz0 = col1._rgb;
          var xyz1 = col2._rgb;
          return new Color_1(
              xyz0[0] + f * (xyz1[0]-xyz0[0]),
              xyz0[1] + f * (xyz1[1]-xyz0[1]),
              xyz0[2] + f * (xyz1[2]-xyz0[2]),
              'rgb'
          )
      };

      // register interpolator
      interpolator.rgb = rgb$1;

      var sqrt$2 = Math.sqrt;
      var pow$3 = Math.pow;

      var lrgb = function (col1, col2, f) {
          var ref = col1._rgb;
          var x1 = ref[0];
          var y1 = ref[1];
          var z1 = ref[2];
          var ref$1 = col2._rgb;
          var x2 = ref$1[0];
          var y2 = ref$1[1];
          var z2 = ref$1[2];
          return new Color_1(
              sqrt$2(pow$3(x1,2) * (1-f) + pow$3(x2,2) * f),
              sqrt$2(pow$3(y1,2) * (1-f) + pow$3(y2,2) * f),
              sqrt$2(pow$3(z1,2) * (1-f) + pow$3(z2,2) * f),
              'rgb'
          )
      };

      // register interpolator
      interpolator.lrgb = lrgb;

      var lab$1 = function (col1, col2, f) {
          var xyz0 = col1.lab();
          var xyz1 = col2.lab();
          return new Color_1(
              xyz0[0] + f * (xyz1[0]-xyz0[0]),
              xyz0[1] + f * (xyz1[1]-xyz0[1]),
              xyz0[2] + f * (xyz1[2]-xyz0[2]),
              'lab'
          )
      };

      // register interpolator
      interpolator.lab = lab$1;

      var _hsx = function (col1, col2, f, m) {
          var assign, assign$1;

          var xyz0, xyz1;
          if (m === 'hsl') {
              xyz0 = col1.hsl();
              xyz1 = col2.hsl();
          } else if (m === 'hsv') {
              xyz0 = col1.hsv();
              xyz1 = col2.hsv();
          } else if (m === 'hcg') {
              xyz0 = col1.hcg();
              xyz1 = col2.hcg();
          } else if (m === 'hsi') {
              xyz0 = col1.hsi();
              xyz1 = col2.hsi();
          } else if (m === 'lch' || m === 'hcl') {
              m = 'hcl';
              xyz0 = col1.hcl();
              xyz1 = col2.hcl();
          }

          var hue0, hue1, sat0, sat1, lbv0, lbv1;
          if (m.substr(0, 1) === 'h') {
              (assign = xyz0, hue0 = assign[0], sat0 = assign[1], lbv0 = assign[2]);
              (assign$1 = xyz1, hue1 = assign$1[0], sat1 = assign$1[1], lbv1 = assign$1[2]);
          }

          var sat, hue, lbv, dh;

          if (!isNaN(hue0) && !isNaN(hue1)) {
              // both colors have hue
              if (hue1 > hue0 && hue1 - hue0 > 180) {
                  dh = hue1-(hue0+360);
              } else if (hue1 < hue0 && hue0 - hue1 > 180) {
                  dh = hue1+360-hue0;
              } else {
                  dh = hue1 - hue0;
              }
              hue = hue0 + f * dh;
          } else if (!isNaN(hue0)) {
              hue = hue0;
              if ((lbv1 == 1 || lbv1 == 0) && m != 'hsv') { sat = sat0; }
          } else if (!isNaN(hue1)) {
              hue = hue1;
              if ((lbv0 == 1 || lbv0 == 0) && m != 'hsv') { sat = sat1; }
          } else {
              hue = Number.NaN;
          }

          if (sat === undefined) { sat = sat0 + f * (sat1 - sat0); }
          lbv = lbv0 + f * (lbv1-lbv0);
          return new Color_1([hue, sat, lbv], m);
      };

      var lch$1 = function (col1, col2, f) {
      	return _hsx(col1, col2, f, 'lch');
      };

      // register interpolator
      interpolator.lch = lch$1;
      interpolator.hcl = lch$1;

      var num$1 = function (col1, col2, f) {
          var c1 = col1.num();
          var c2 = col2.num();
          return new Color_1(c1 + f * (c2-c1), 'num')
      };

      // register interpolator
      interpolator.num = num$1;

      var hcg$1 = function (col1, col2, f) {
      	return _hsx(col1, col2, f, 'hcg');
      };

      // register interpolator
      interpolator.hcg = hcg$1;

      var hsi$1 = function (col1, col2, f) {
      	return _hsx(col1, col2, f, 'hsi');
      };

      // register interpolator
      interpolator.hsi = hsi$1;

      var hsl$1 = function (col1, col2, f) {
      	return _hsx(col1, col2, f, 'hsl');
      };

      // register interpolator
      interpolator.hsl = hsl$1;

      var hsv$1 = function (col1, col2, f) {
      	return _hsx(col1, col2, f, 'hsv');
      };

      // register interpolator
      interpolator.hsv = hsv$1;

      var clip_rgb$2 = utils.clip_rgb;
      var pow$4 = Math.pow;
      var sqrt$3 = Math.sqrt;
      var PI$1 = Math.PI;
      var cos$2 = Math.cos;
      var sin$1 = Math.sin;
      var atan2$1 = Math.atan2;

      var average = function (colors, mode, weights) {
          if ( mode === void 0 ) mode='lrgb';
          if ( weights === void 0 ) weights=null;

          var l = colors.length;
          if (!weights) { weights = Array.from(new Array(l)).map(function () { return 1; }); }
          // normalize weights
          var k = l / weights.reduce(function(a, b) { return a + b; });
          weights.forEach(function (w,i) { weights[i] *= k; });
          // convert colors to Color objects
          colors = colors.map(function (c) { return new Color_1(c); });
          if (mode === 'lrgb') {
              return _average_lrgb(colors, weights)
          }
          var first = colors.shift();
          var xyz = first.get(mode);
          var cnt = [];
          var dx = 0;
          var dy = 0;
          // initial color
          for (var i=0; i<xyz.length; i++) {
              xyz[i] = (xyz[i] || 0) * weights[0];
              cnt.push(isNaN(xyz[i]) ? 0 : weights[0]);
              if (mode.charAt(i) === 'h' && !isNaN(xyz[i])) {
                  var A = xyz[i] / 180 * PI$1;
                  dx += cos$2(A) * weights[0];
                  dy += sin$1(A) * weights[0];
              }
          }

          var alpha = first.alpha() * weights[0];
          colors.forEach(function (c,ci) {
              var xyz2 = c.get(mode);
              alpha += c.alpha() * weights[ci+1];
              for (var i=0; i<xyz.length; i++) {
                  if (!isNaN(xyz2[i])) {
                      cnt[i] += weights[ci+1];
                      if (mode.charAt(i) === 'h') {
                          var A = xyz2[i] / 180 * PI$1;
                          dx += cos$2(A) * weights[ci+1];
                          dy += sin$1(A) * weights[ci+1];
                      } else {
                          xyz[i] += xyz2[i] * weights[ci+1];
                      }
                  }
              }
          });

          for (var i$1=0; i$1<xyz.length; i$1++) {
              if (mode.charAt(i$1) === 'h') {
                  var A$1 = atan2$1(dy / cnt[i$1], dx / cnt[i$1]) / PI$1 * 180;
                  while (A$1 < 0) { A$1 += 360; }
                  while (A$1 >= 360) { A$1 -= 360; }
                  xyz[i$1] = A$1;
              } else {
                  xyz[i$1] = xyz[i$1]/cnt[i$1];
              }
          }
          alpha /= l;
          return (new Color_1(xyz, mode)).alpha(alpha > 0.99999 ? 1 : alpha, true);
      };


      var _average_lrgb = function (colors, weights) {
          var l = colors.length;
          var xyz = [0,0,0,0];
          for (var i=0; i < colors.length; i++) {
              var col = colors[i];
              var f = weights[i] / l;
              var rgb = col._rgb;
              xyz[0] += pow$4(rgb[0],2) * f;
              xyz[1] += pow$4(rgb[1],2) * f;
              xyz[2] += pow$4(rgb[2],2) * f;
              xyz[3] += rgb[3] * f;
          }
          xyz[0] = sqrt$3(xyz[0]);
          xyz[1] = sqrt$3(xyz[1]);
          xyz[2] = sqrt$3(xyz[2]);
          if (xyz[3] > 0.9999999) { xyz[3] = 1; }
          return new Color_1(clip_rgb$2(xyz));
      };

      // minimal multi-purpose interface

      // @requires utils color analyze


      var type$j = utils.type;

      var pow$5 = Math.pow;

      var scale = function(colors) {

          // constructor
          var _mode = 'rgb';
          var _nacol = chroma_1('#ccc');
          var _spread = 0;
          // const _fixed = false;
          var _domain = [0, 1];
          var _pos = [];
          var _padding = [0,0];
          var _classes = false;
          var _colors = [];
          var _out = false;
          var _min = 0;
          var _max = 1;
          var _correctLightness = false;
          var _colorCache = {};
          var _useCache = true;
          var _gamma = 1;

          // private methods

          var setColors = function(colors) {
              colors = colors || ['#fff', '#000'];
              if (colors && type$j(colors) === 'string' && chroma_1.brewer &&
                  chroma_1.brewer[colors.toLowerCase()]) {
                  colors = chroma_1.brewer[colors.toLowerCase()];
              }
              if (type$j(colors) === 'array') {
                  // handle single color
                  if (colors.length === 1) {
                      colors = [colors[0], colors[0]];
                  }
                  // make a copy of the colors
                  colors = colors.slice(0);
                  // convert to chroma classes
                  for (var c=0; c<colors.length; c++) {
                      colors[c] = chroma_1(colors[c]);
                  }
                  // auto-fill color position
                  _pos.length = 0;
                  for (var c$1=0; c$1<colors.length; c$1++) {
                      _pos.push(c$1/(colors.length-1));
                  }
              }
              resetCache();
              return _colors = colors;
          };

          var getClass = function(value) {
              if (_classes != null) {
                  var n = _classes.length-1;
                  var i = 0;
                  while (i < n && value >= _classes[i]) {
                      i++;
                  }
                  return i-1;
              }
              return 0;
          };

          var tMapLightness = function (t) { return t; };
          var tMapDomain = function (t) { return t; };

          // const classifyValue = function(value) {
          //     let val = value;
          //     if (_classes.length > 2) {
          //         const n = _classes.length-1;
          //         const i = getClass(value);
          //         const minc = _classes[0] + ((_classes[1]-_classes[0]) * (0 + (_spread * 0.5)));  // center of 1st class
          //         const maxc = _classes[n-1] + ((_classes[n]-_classes[n-1]) * (1 - (_spread * 0.5)));  // center of last class
          //         val = _min + ((((_classes[i] + ((_classes[i+1] - _classes[i]) * 0.5)) - minc) / (maxc-minc)) * (_max - _min));
          //     }
          //     return val;
          // };

          var getColor = function(val, bypassMap) {
              var col, t;
              if (bypassMap == null) { bypassMap = false; }
              if (isNaN(val) || (val === null)) { return _nacol; }
              if (!bypassMap) {
                  if (_classes && (_classes.length > 2)) {
                      // find the class
                      var c = getClass(val);
                      t = c / (_classes.length-2);
                  } else if (_max !== _min) {
                      // just interpolate between min/max
                      t = (val - _min) / (_max - _min);
                  } else {
                      t = 1;
                  }
              } else {
                  t = val;
              }

              // domain map
              t = tMapDomain(t);

              if (!bypassMap) {
                  t = tMapLightness(t);  // lightness correction
              }

              if (_gamma !== 1) { t = pow$5(t, _gamma); }

              t = _padding[0] + (t * (1 - _padding[0] - _padding[1]));

              t = Math.min(1, Math.max(0, t));

              var k = Math.floor(t * 10000);

              if (_useCache && _colorCache[k]) {
                  col = _colorCache[k];
              } else {
                  if (type$j(_colors) === 'array') {
                      //for i in [0.._pos.length-1]
                      for (var i=0; i<_pos.length; i++) {
                          var p = _pos[i];
                          if (t <= p) {
                              col = _colors[i];
                              break;
                          }
                          if ((t >= p) && (i === (_pos.length-1))) {
                              col = _colors[i];
                              break;
                          }
                          if (t > p && t < _pos[i+1]) {
                              t = (t-p)/(_pos[i+1]-p);
                              col = chroma_1.interpolate(_colors[i], _colors[i+1], t, _mode);
                              break;
                          }
                      }
                  } else if (type$j(_colors) === 'function') {
                      col = _colors(t);
                  }
                  if (_useCache) { _colorCache[k] = col; }
              }
              return col;
          };

          var resetCache = function () { return _colorCache = {}; };

          setColors(colors);

          // public interface

          var f = function(v) {
              var c = chroma_1(getColor(v));
              if (_out && c[_out]) { return c[_out](); } else { return c; }
          };

          f.classes = function(classes) {
              if (classes != null) {
                  if (type$j(classes) === 'array') {
                      _classes = classes;
                      _domain = [classes[0], classes[classes.length-1]];
                  } else {
                      var d = chroma_1.analyze(_domain);
                      if (classes === 0) {
                          _classes = [d.min, d.max];
                      } else {
                          _classes = chroma_1.limits(d, 'e', classes);
                      }
                  }
                  return f;
              }
              return _classes;
          };


          f.domain = function(domain) {
              if (!arguments.length) {
                  return _domain;
              }
              _min = domain[0];
              _max = domain[domain.length-1];
              _pos = [];
              var k = _colors.length;
              if ((domain.length === k) && (_min !== _max)) {
                  // update positions
                  for (var i = 0, list = Array.from(domain); i < list.length; i += 1) {
                      var d = list[i];

                    _pos.push((d-_min) / (_max-_min));
                  }
              } else {
                  for (var c=0; c<k; c++) {
                      _pos.push(c/(k-1));
                  }
                  if (domain.length > 2) {
                      // set domain map
                      var tOut = domain.map(function (d,i) { return i/(domain.length-1); });
                      var tBreaks = domain.map(function (d) { return (d - _min) / (_max - _min); });
                      if (!tBreaks.every(function (val, i) { return tOut[i] === val; })) {
                          tMapDomain = function (t) {
                              if (t <= 0 || t >= 1) { return t; }
                              var i = 0;
                              while (t >= tBreaks[i+1]) { i++; }
                              var f = (t - tBreaks[i]) / (tBreaks[i+1] - tBreaks[i]);
                              var out = tOut[i] + f * (tOut[i+1] - tOut[i]);
                              return out;
                          };
                      }

                  }
              }
              _domain = [_min, _max];
              return f;
          };

          f.mode = function(_m) {
              if (!arguments.length) {
                  return _mode;
              }
              _mode = _m;
              resetCache();
              return f;
          };

          f.range = function(colors, _pos) {
              setColors(colors);
              return f;
          };

          f.out = function(_o) {
              _out = _o;
              return f;
          };

          f.spread = function(val) {
              if (!arguments.length) {
                  return _spread;
              }
              _spread = val;
              return f;
          };

          f.correctLightness = function(v) {
              if (v == null) { v = true; }
              _correctLightness = v;
              resetCache();
              if (_correctLightness) {
                  tMapLightness = function(t) {
                      var L0 = getColor(0, true).lab()[0];
                      var L1 = getColor(1, true).lab()[0];
                      var pol = L0 > L1;
                      var L_actual = getColor(t, true).lab()[0];
                      var L_ideal = L0 + ((L1 - L0) * t);
                      var L_diff = L_actual - L_ideal;
                      var t0 = 0;
                      var t1 = 1;
                      var max_iter = 20;
                      while ((Math.abs(L_diff) > 1e-2) && (max_iter-- > 0)) {
                          (function() {
                              if (pol) { L_diff *= -1; }
                              if (L_diff < 0) {
                                  t0 = t;
                                  t += (t1 - t) * 0.5;
                              } else {
                                  t1 = t;
                                  t += (t0 - t) * 0.5;
                              }
                              L_actual = getColor(t, true).lab()[0];
                              return L_diff = L_actual - L_ideal;
                          })();
                      }
                      return t;
                  };
              } else {
                  tMapLightness = function (t) { return t; };
              }
              return f;
          };

          f.padding = function(p) {
              if (p != null) {
                  if (type$j(p) === 'number') {
                      p = [p,p];
                  }
                  _padding = p;
                  return f;
              } else {
                  return _padding;
              }
          };

          f.colors = function(numColors, out) {
              // If no arguments are given, return the original colors that were provided
              if (arguments.length < 2) { out = 'hex'; }
              var result = [];

              if (arguments.length === 0) {
                  result = _colors.slice(0);

              } else if (numColors === 1) {
                  result = [f(0.5)];

              } else if (numColors > 1) {
                  var dm = _domain[0];
                  var dd = _domain[1] - dm;
                  result = __range__(0, numColors, false).map(function (i) { return f( dm + ((i/(numColors-1)) * dd) ); });

              } else { // returns all colors based on the defined classes
                  colors = [];
                  var samples = [];
                  if (_classes && (_classes.length > 2)) {
                      for (var i = 1, end = _classes.length, asc = 1 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
                          samples.push((_classes[i-1]+_classes[i])*0.5);
                      }
                  } else {
                      samples = _domain;
                  }
                  result = samples.map(function (v) { return f(v); });
              }

              if (chroma_1[out]) {
                  result = result.map(function (c) { return c[out](); });
              }
              return result;
          };

          f.cache = function(c) {
              if (c != null) {
                  _useCache = c;
                  return f;
              } else {
                  return _useCache;
              }
          };

          f.gamma = function(g) {
              if (g != null) {
                  _gamma = g;
                  return f;
              } else {
                  return _gamma;
              }
          };

          f.nodata = function(d) {
              if (d != null) {
                  _nacol = chroma_1(d);
                  return f;
              } else {
                  return _nacol;
              }
          };

          return f;
      };

      function __range__(left, right, inclusive) {
        var range = [];
        var ascending = left < right;
        var end = !inclusive ? right : ascending ? right + 1 : right - 1;
        for (var i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
          range.push(i);
        }
        return range;
      }

      //
      // interpolates between a set of colors uzing a bezier spline
      //

      // @requires utils lab




      var bezier = function(colors) {
          var assign, assign$1, assign$2;

          var I, lab0, lab1, lab2;
          colors = colors.map(function (c) { return new Color_1(c); });
          if (colors.length === 2) {
              // linear interpolation
              (assign = colors.map(function (c) { return c.lab(); }), lab0 = assign[0], lab1 = assign[1]);
              I = function(t) {
                  var lab = ([0, 1, 2].map(function (i) { return lab0[i] + (t * (lab1[i] - lab0[i])); }));
                  return new Color_1(lab, 'lab');
              };
          } else if (colors.length === 3) {
              // quadratic bezier interpolation
              (assign$1 = colors.map(function (c) { return c.lab(); }), lab0 = assign$1[0], lab1 = assign$1[1], lab2 = assign$1[2]);
              I = function(t) {
                  var lab = ([0, 1, 2].map(function (i) { return ((1-t)*(1-t) * lab0[i]) + (2 * (1-t) * t * lab1[i]) + (t * t * lab2[i]); }));
                  return new Color_1(lab, 'lab');
              };
          } else if (colors.length === 4) {
              // cubic bezier interpolation
              var lab3;
              (assign$2 = colors.map(function (c) { return c.lab(); }), lab0 = assign$2[0], lab1 = assign$2[1], lab2 = assign$2[2], lab3 = assign$2[3]);
              I = function(t) {
                  var lab = ([0, 1, 2].map(function (i) { return ((1-t)*(1-t)*(1-t) * lab0[i]) + (3 * (1-t) * (1-t) * t * lab1[i]) + (3 * (1-t) * t * t * lab2[i]) + (t*t*t * lab3[i]); }));
                  return new Color_1(lab, 'lab');
              };
          } else if (colors.length === 5) {
              var I0 = bezier(colors.slice(0, 3));
              var I1 = bezier(colors.slice(2, 5));
              I = function(t) {
                  if (t < 0.5) {
                      return I0(t*2);
                  } else {
                      return I1((t-0.5)*2);
                  }
              };
          }
          return I;
      };

      var bezier_1 = function (colors) {
          var f = bezier(colors);
          f.scale = function () { return scale(f); };
          return f;
      };

      /*
       * interpolates between a set of colors uzing a bezier spline
       * blend mode formulas taken from http://www.venture-ware.com/kevin/coding/lets-learn-math-photoshop-blend-modes/
       */




      var blend = function (bottom, top, mode) {
          if (!blend[mode]) {
              throw new Error('unknown blend mode ' + mode);
          }
          return blend[mode](bottom, top);
      };

      var blend_f = function (f) { return function (bottom,top) {
              var c0 = chroma_1(top).rgb();
              var c1 = chroma_1(bottom).rgb();
              return chroma_1.rgb(f(c0, c1));
          }; };

      var each = function (f) { return function (c0, c1) {
              var out = [];
              out[0] = f(c0[0], c1[0]);
              out[1] = f(c0[1], c1[1]);
              out[2] = f(c0[2], c1[2]);
              return out;
          }; };

      var normal = function (a) { return a; };
      var multiply = function (a,b) { return a * b / 255; };
      var darken$1 = function (a,b) { return a > b ? b : a; };
      var lighten = function (a,b) { return a > b ? a : b; };
      var screen = function (a,b) { return 255 * (1 - (1-a/255) * (1-b/255)); };
      var overlay = function (a,b) { return b < 128 ? 2 * a * b / 255 : 255 * (1 - 2 * (1 - a / 255 ) * ( 1 - b / 255 )); };
      var burn = function (a,b) { return 255 * (1 - (1 - b / 255) / (a/255)); };
      var dodge = function (a,b) {
          if (a === 255) { return 255; }
          a = 255 * (b / 255) / (1 - a / 255);
          return a > 255 ? 255 : a
      };

      // # add = (a,b) ->
      // #     if (a + b > 255) then 255 else a + b

      blend.normal = blend_f(each(normal));
      blend.multiply = blend_f(each(multiply));
      blend.screen = blend_f(each(screen));
      blend.overlay = blend_f(each(overlay));
      blend.darken = blend_f(each(darken$1));
      blend.lighten = blend_f(each(lighten));
      blend.dodge = blend_f(each(dodge));
      blend.burn = blend_f(each(burn));
      // blend.add = blend_f(each(add));

      var blend_1 = blend;

      // cubehelix interpolation
      // based on D.A. Green "A colour scheme for the display of astronomical intensity images"
      // http://astron-soc.in/bulletin/11June/289392011.pdf

      var type$k = utils.type;
      var clip_rgb$3 = utils.clip_rgb;
      var TWOPI$2 = utils.TWOPI;
      var pow$6 = Math.pow;
      var sin$2 = Math.sin;
      var cos$3 = Math.cos;


      var cubehelix = function(start, rotations, hue, gamma, lightness) {
          if ( start === void 0 ) start=300;
          if ( rotations === void 0 ) rotations=-1.5;
          if ( hue === void 0 ) hue=1;
          if ( gamma === void 0 ) gamma=1;
          if ( lightness === void 0 ) lightness=[0,1];

          var dh = 0, dl;
          if (type$k(lightness) === 'array') {
              dl = lightness[1] - lightness[0];
          } else {
              dl = 0;
              lightness = [lightness, lightness];
          }

          var f = function(fract) {
              var a = TWOPI$2 * (((start+120)/360) + (rotations * fract));
              var l = pow$6(lightness[0] + (dl * fract), gamma);
              var h = dh !== 0 ? hue[0] + (fract * dh) : hue;
              var amp = (h * l * (1-l)) / 2;
              var cos_a = cos$3(a);
              var sin_a = sin$2(a);
              var r = l + (amp * ((-0.14861 * cos_a) + (1.78277* sin_a)));
              var g = l + (amp * ((-0.29227 * cos_a) - (0.90649* sin_a)));
              var b = l + (amp * (+1.97294 * cos_a));
              return chroma_1(clip_rgb$3([r*255,g*255,b*255,1]));
          };

          f.start = function(s) {
              if ((s == null)) { return start; }
              start = s;
              return f;
          };

          f.rotations = function(r) {
              if ((r == null)) { return rotations; }
              rotations = r;
              return f;
          };

          f.gamma = function(g) {
              if ((g == null)) { return gamma; }
              gamma = g;
              return f;
          };

          f.hue = function(h) {
              if ((h == null)) { return hue; }
              hue = h;
              if (type$k(hue) === 'array') {
                  dh = hue[1] - hue[0];
                  if (dh === 0) { hue = hue[1]; }
              } else {
                  dh = 0;
              }
              return f;
          };

          f.lightness = function(h) {
              if ((h == null)) { return lightness; }
              if (type$k(h) === 'array') {
                  lightness = h;
                  dl = h[1] - h[0];
              } else {
                  lightness = [h,h];
                  dl = 0;
              }
              return f;
          };

          f.scale = function () { return chroma_1.scale(f); };

          f.hue(hue);

          return f;
      };

      var digits = '0123456789abcdef';

      var floor$2 = Math.floor;
      var random = Math.random;

      var random_1 = function () {
          var code = '#';
          for (var i=0; i<6; i++) {
              code += digits.charAt(floor$2(random() * 16));
          }
          return new Color_1(code, 'hex');
      };

      var log$1 = Math.log;
      var pow$7 = Math.pow;
      var floor$3 = Math.floor;
      var abs = Math.abs;


      var analyze = function (data, key) {
          if ( key === void 0 ) key=null;

          var r = {
              min: Number.MAX_VALUE,
              max: Number.MAX_VALUE*-1,
              sum: 0,
              values: [],
              count: 0
          };
          if (type(data) === 'object') {
              data = Object.values(data);
          }
          data.forEach(function (val) {
              if (key && type(val) === 'object') { val = val[key]; }
              if (val !== undefined && val !== null && !isNaN(val)) {
                  r.values.push(val);
                  r.sum += val;
                  if (val < r.min) { r.min = val; }
                  if (val > r.max) { r.max = val; }
                  r.count += 1;
              }
          });

          r.domain = [r.min, r.max];

          r.limits = function (mode, num) { return limits(r, mode, num); };

          return r;
      };


      var limits = function (data, mode, num) {
          if ( mode === void 0 ) mode='equal';
          if ( num === void 0 ) num=7;

          if (type(data) == 'array') {
              data = analyze(data);
          }
          var min = data.min;
          var max = data.max;
          var values = data.values.sort(function (a,b) { return a-b; });

          if (num === 1) { return [min,max]; }

          var limits = [];

          if (mode.substr(0,1) === 'c') { // continuous
              limits.push(min);
              limits.push(max);
          }

          if (mode.substr(0,1) === 'e') { // equal interval
              limits.push(min);
              for (var i=1; i<num; i++) {
                  limits.push(min+((i/num)*(max-min)));
              }
              limits.push(max);
          }

          else if (mode.substr(0,1) === 'l') { // log scale
              if (min <= 0) {
                  throw new Error('Logarithmic scales are only possible for values > 0');
              }
              var min_log = Math.LOG10E * log$1(min);
              var max_log = Math.LOG10E * log$1(max);
              limits.push(min);
              for (var i$1=1; i$1<num; i$1++) {
                  limits.push(pow$7(10, min_log + ((i$1/num) * (max_log - min_log))));
              }
              limits.push(max);
          }

          else if (mode.substr(0,1) === 'q') { // quantile scale
              limits.push(min);
              for (var i$2=1; i$2<num; i$2++) {
                  var p = ((values.length-1) * i$2)/num;
                  var pb = floor$3(p);
                  if (pb === p) {
                      limits.push(values[pb]);
                  } else { // p > pb
                      var pr = p - pb;
                      limits.push((values[pb]*(1-pr)) + (values[pb+1]*pr));
                  }
              }
              limits.push(max);

          }

          else if (mode.substr(0,1) === 'k') { // k-means clustering
              /*
              implementation based on
              http://code.google.com/p/figue/source/browse/trunk/figue.js#336
              simplified for 1-d input values
              */
              var cluster;
              var n = values.length;
              var assignments = new Array(n);
              var clusterSizes = new Array(num);
              var repeat = true;
              var nb_iters = 0;
              var centroids = null;

              // get seed values
              centroids = [];
              centroids.push(min);
              for (var i$3=1; i$3<num; i$3++) {
                  centroids.push(min + ((i$3/num) * (max-min)));
              }
              centroids.push(max);

              while (repeat) {
                  // assignment step
                  for (var j=0; j<num; j++) {
                      clusterSizes[j] = 0;
                  }
                  for (var i$4=0; i$4<n; i$4++) {
                      var value = values[i$4];
                      var mindist = Number.MAX_VALUE;
                      var best = (void 0);
                      for (var j$1=0; j$1<num; j$1++) {
                          var dist = abs(centroids[j$1]-value);
                          if (dist < mindist) {
                              mindist = dist;
                              best = j$1;
                          }
                          clusterSizes[best]++;
                          assignments[i$4] = best;
                      }
                  }

                  // update centroids step
                  var newCentroids = new Array(num);
                  for (var j$2=0; j$2<num; j$2++) {
                      newCentroids[j$2] = null;
                  }
                  for (var i$5=0; i$5<n; i$5++) {
                      cluster = assignments[i$5];
                      if (newCentroids[cluster] === null) {
                          newCentroids[cluster] = values[i$5];
                      } else {
                          newCentroids[cluster] += values[i$5];
                      }
                  }
                  for (var j$3=0; j$3<num; j$3++) {
                      newCentroids[j$3] *= 1/clusterSizes[j$3];
                  }

                  // check convergence
                  repeat = false;
                  for (var j$4=0; j$4<num; j$4++) {
                      if (newCentroids[j$4] !== centroids[j$4]) {
                          repeat = true;
                          break;
                      }
                  }

                  centroids = newCentroids;
                  nb_iters++;

                  if (nb_iters > 200) {
                      repeat = false;
                  }
              }

              // finished k-means clustering
              // the next part is borrowed from gabrielflor.it
              var kClusters = {};
              for (var j$5=0; j$5<num; j$5++) {
                  kClusters[j$5] = [];
              }
              for (var i$6=0; i$6<n; i$6++) {
                  cluster = assignments[i$6];
                  kClusters[cluster].push(values[i$6]);
              }
              var tmpKMeansBreaks = [];
              for (var j$6=0; j$6<num; j$6++) {
                  tmpKMeansBreaks.push(kClusters[j$6][0]);
                  tmpKMeansBreaks.push(kClusters[j$6][kClusters[j$6].length-1]);
              }
              tmpKMeansBreaks = tmpKMeansBreaks.sort(function (a,b){ return a-b; });
              limits.push(tmpKMeansBreaks[0]);
              for (var i$7=1; i$7 < tmpKMeansBreaks.length; i$7+= 2) {
                  var v = tmpKMeansBreaks[i$7];
                  if (!isNaN(v) && (limits.indexOf(v) === -1)) {
                      limits.push(v);
                  }
              }
          }
          return limits;
      };

      var analyze_1 = {analyze: analyze, limits: limits};

      var contrast = function (a, b) {
          // WCAG contrast ratio
          // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
          a = new Color_1(a);
          b = new Color_1(b);
          var l1 = a.luminance();
          var l2 = b.luminance();
          return l1 > l2 ? (l1 + 0.05) / (l2 + 0.05) : (l2 + 0.05) / (l1 + 0.05);
      };

      var sqrt$4 = Math.sqrt;
      var atan2$2 = Math.atan2;
      var abs$1 = Math.abs;
      var cos$4 = Math.cos;
      var PI$2 = Math.PI;

      var deltaE = function(a, b, L, C) {
          if ( L === void 0 ) L=1;
          if ( C === void 0 ) C=1;

          // Delta E (CMC)
          // see http://www.brucelindbloom.com/index.html?Eqn_DeltaE_CMC.html
          a = new Color_1(a);
          b = new Color_1(b);
          var ref = Array.from(a.lab());
          var L1 = ref[0];
          var a1 = ref[1];
          var b1 = ref[2];
          var ref$1 = Array.from(b.lab());
          var L2 = ref$1[0];
          var a2 = ref$1[1];
          var b2 = ref$1[2];
          var c1 = sqrt$4((a1 * a1) + (b1 * b1));
          var c2 = sqrt$4((a2 * a2) + (b2 * b2));
          var sl = L1 < 16.0 ? 0.511 : (0.040975 * L1) / (1.0 + (0.01765 * L1));
          var sc = ((0.0638 * c1) / (1.0 + (0.0131 * c1))) + 0.638;
          var h1 = c1 < 0.000001 ? 0.0 : (atan2$2(b1, a1) * 180.0) / PI$2;
          while (h1 < 0) { h1 += 360; }
          while (h1 >= 360) { h1 -= 360; }
          var t = (h1 >= 164.0) && (h1 <= 345.0) ? (0.56 + abs$1(0.2 * cos$4((PI$2 * (h1 + 168.0)) / 180.0))) : (0.36 + abs$1(0.4 * cos$4((PI$2 * (h1 + 35.0)) / 180.0)));
          var c4 = c1 * c1 * c1 * c1;
          var f = sqrt$4(c4 / (c4 + 1900.0));
          var sh = sc * (((f * t) + 1.0) - f);
          var delL = L1 - L2;
          var delC = c1 - c2;
          var delA = a1 - a2;
          var delB = b1 - b2;
          var dH2 = ((delA * delA) + (delB * delB)) - (delC * delC);
          var v1 = delL / (L * sl);
          var v2 = delC / (C * sc);
          var v3 = sh;
          return sqrt$4((v1 * v1) + (v2 * v2) + (dH2 / (v3 * v3)));
      };

      // simple Euclidean distance
      var distance = function(a, b, mode) {
          if ( mode === void 0 ) mode='lab';

          // Delta E (CIE 1976)
          // see http://www.brucelindbloom.com/index.html?Equations.html
          a = new Color_1(a);
          b = new Color_1(b);
          var l1 = a.get(mode);
          var l2 = b.get(mode);
          var sum_sq = 0;
          for (var i in l1) {
              var d = (l1[i] || 0) - (l2[i] || 0);
              sum_sq += d*d;
          }
          return Math.sqrt(sum_sq);
      };

      var valid = function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          try {
              new (Function.prototype.bind.apply( Color_1, [ null ].concat( args) ));
              return true;
          } catch (e) {
              return false;
          }
      };

      // some pre-defined color scales:




      var scales = {
      	cool: function cool() { return scale([chroma_1.hsl(180,1,.9), chroma_1.hsl(250,.7,.4)]) },
      	hot: function hot() { return scale(['#000','#f00','#ff0','#fff']).mode('rgb') }
      };

      /**
          ColorBrewer colors for chroma.js

          Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and The
          Pennsylvania State University.

          Licensed under the Apache License, Version 2.0 (the "License");
          you may not use this file except in compliance with the License.
          You may obtain a copy of the License at
          http://www.apache.org/licenses/LICENSE-2.0

          Unless required by applicable law or agreed to in writing, software distributed
          under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
          CONDITIONS OF ANY KIND, either express or implied. See the License for the
          specific language governing permissions and limitations under the License.
      */

      var colorbrewer = {
          // sequential
          OrRd: ['#fff7ec', '#fee8c8', '#fdd49e', '#fdbb84', '#fc8d59', '#ef6548', '#d7301f', '#b30000', '#7f0000'],
          PuBu: ['#fff7fb', '#ece7f2', '#d0d1e6', '#a6bddb', '#74a9cf', '#3690c0', '#0570b0', '#045a8d', '#023858'],
          BuPu: ['#f7fcfd', '#e0ecf4', '#bfd3e6', '#9ebcda', '#8c96c6', '#8c6bb1', '#88419d', '#810f7c', '#4d004b'],
          Oranges: ['#fff5eb', '#fee6ce', '#fdd0a2', '#fdae6b', '#fd8d3c', '#f16913', '#d94801', '#a63603', '#7f2704'],
          BuGn: ['#f7fcfd', '#e5f5f9', '#ccece6', '#99d8c9', '#66c2a4', '#41ae76', '#238b45', '#006d2c', '#00441b'],
          YlOrBr: ['#ffffe5', '#fff7bc', '#fee391', '#fec44f', '#fe9929', '#ec7014', '#cc4c02', '#993404', '#662506'],
          YlGn: ['#ffffe5', '#f7fcb9', '#d9f0a3', '#addd8e', '#78c679', '#41ab5d', '#238443', '#006837', '#004529'],
          Reds: ['#fff5f0', '#fee0d2', '#fcbba1', '#fc9272', '#fb6a4a', '#ef3b2c', '#cb181d', '#a50f15', '#67000d'],
          RdPu: ['#fff7f3', '#fde0dd', '#fcc5c0', '#fa9fb5', '#f768a1', '#dd3497', '#ae017e', '#7a0177', '#49006a'],
          Greens: ['#f7fcf5', '#e5f5e0', '#c7e9c0', '#a1d99b', '#74c476', '#41ab5d', '#238b45', '#006d2c', '#00441b'],
          YlGnBu: ['#ffffd9', '#edf8b1', '#c7e9b4', '#7fcdbb', '#41b6c4', '#1d91c0', '#225ea8', '#253494', '#081d58'],
          Purples: ['#fcfbfd', '#efedf5', '#dadaeb', '#bcbddc', '#9e9ac8', '#807dba', '#6a51a3', '#54278f', '#3f007d'],
          GnBu: ['#f7fcf0', '#e0f3db', '#ccebc5', '#a8ddb5', '#7bccc4', '#4eb3d3', '#2b8cbe', '#0868ac', '#084081'],
          Greys: ['#ffffff', '#f0f0f0', '#d9d9d9', '#bdbdbd', '#969696', '#737373', '#525252', '#252525', '#000000'],
          YlOrRd: ['#ffffcc', '#ffeda0', '#fed976', '#feb24c', '#fd8d3c', '#fc4e2a', '#e31a1c', '#bd0026', '#800026'],
          PuRd: ['#f7f4f9', '#e7e1ef', '#d4b9da', '#c994c7', '#df65b0', '#e7298a', '#ce1256', '#980043', '#67001f'],
          Blues: ['#f7fbff', '#deebf7', '#c6dbef', '#9ecae1', '#6baed6', '#4292c6', '#2171b5', '#08519c', '#08306b'],
          PuBuGn: ['#fff7fb', '#ece2f0', '#d0d1e6', '#a6bddb', '#67a9cf', '#3690c0', '#02818a', '#016c59', '#014636'],
          Viridis: ['#440154', '#482777', '#3f4a8a', '#31678e', '#26838f', '#1f9d8a', '#6cce5a', '#b6de2b', '#fee825'],

          // diverging

          Spectral: ['#9e0142', '#d53e4f', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#e6f598', '#abdda4', '#66c2a5', '#3288bd', '#5e4fa2'],
          RdYlGn: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#d9ef8b', '#a6d96a', '#66bd63', '#1a9850', '#006837'],
          RdBu: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#f7f7f7', '#d1e5f0', '#92c5de', '#4393c3', '#2166ac', '#053061'],
          PiYG: ['#8e0152', '#c51b7d', '#de77ae', '#f1b6da', '#fde0ef', '#f7f7f7', '#e6f5d0', '#b8e186', '#7fbc41', '#4d9221', '#276419'],
          PRGn: ['#40004b', '#762a83', '#9970ab', '#c2a5cf', '#e7d4e8', '#f7f7f7', '#d9f0d3', '#a6dba0', '#5aae61', '#1b7837', '#00441b'],
          RdYlBu: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee090', '#ffffbf', '#e0f3f8', '#abd9e9', '#74add1', '#4575b4', '#313695'],
          BrBG: ['#543005', '#8c510a', '#bf812d', '#dfc27d', '#f6e8c3', '#f5f5f5', '#c7eae5', '#80cdc1', '#35978f', '#01665e', '#003c30'],
          RdGy: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#ffffff', '#e0e0e0', '#bababa', '#878787', '#4d4d4d', '#1a1a1a'],
          PuOr: ['#7f3b08', '#b35806', '#e08214', '#fdb863', '#fee0b6', '#f7f7f7', '#d8daeb', '#b2abd2', '#8073ac', '#542788', '#2d004b'],

          // qualitative

          Set2: ['#66c2a5', '#fc8d62', '#8da0cb', '#e78ac3', '#a6d854', '#ffd92f', '#e5c494', '#b3b3b3'],
          Accent: ['#7fc97f', '#beaed4', '#fdc086', '#ffff99', '#386cb0', '#f0027f', '#bf5b17', '#666666'],
          Set1: ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00', '#ffff33', '#a65628', '#f781bf', '#999999'],
          Set3: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5', '#d9d9d9', '#bc80bd', '#ccebc5', '#ffed6f'],
          Dark2: ['#1b9e77', '#d95f02', '#7570b3', '#e7298a', '#66a61e', '#e6ab02', '#a6761d', '#666666'],
          Paired: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f', '#ff7f00', '#cab2d6', '#6a3d9a', '#ffff99', '#b15928'],
          Pastel2: ['#b3e2cd', '#fdcdac', '#cbd5e8', '#f4cae4', '#e6f5c9', '#fff2ae', '#f1e2cc', '#cccccc'],
          Pastel1: ['#fbb4ae', '#b3cde3', '#ccebc5', '#decbe4', '#fed9a6', '#ffffcc', '#e5d8bd', '#fddaec', '#f2f2f2'],
      };

      // add lowercase aliases for case-insensitive matches
      for (var i$1 = 0, list$1 = Object.keys(colorbrewer); i$1 < list$1.length; i$1 += 1) {
          var key = list$1[i$1];

          colorbrewer[key.toLowerCase()] = colorbrewer[key];
      }

      var colorbrewer_1 = colorbrewer;

      // feel free to comment out anything to rollup
      // a smaller chroma.js built

      // io --> convert colors















      // operators --> modify existing Colors










      // interpolators










      // generators -- > create new colors
      chroma_1.average = average;
      chroma_1.bezier = bezier_1;
      chroma_1.blend = blend_1;
      chroma_1.cubehelix = cubehelix;
      chroma_1.mix = chroma_1.interpolate = mix;
      chroma_1.random = random_1;
      chroma_1.scale = scale;

      // other utility methods
      chroma_1.analyze = analyze_1.analyze;
      chroma_1.contrast = contrast;
      chroma_1.deltaE = deltaE;
      chroma_1.distance = distance;
      chroma_1.limits = analyze_1.limits;
      chroma_1.valid = valid;

      // scale
      chroma_1.scales = scales;

      // colors
      chroma_1.colors = w3cx11_1;
      chroma_1.brewer = colorbrewer_1;

      var chroma_js = chroma_1;

      return chroma_js;

  })));
  });

  const RangoDeMatizes = {
    '0-20': 'rojo',
    '20-40': 'naranja',
    '40-60': 'amarillo',
    '70-160': 'verde',
    '160-220': 'cyan',
    '220-240': 'azul',
    '240-360': 'magenta'
  };
  const OrdenDeMatiz = ['amarillo', 'naranja', 'rojo', 'magenta', 'azul', 'cyan', 'verde', 'café', 'gris', 'metálico', 'negro', 'blanco'];
  function ordenarPorLuminosidad({
    l: l1
  }, {
    l: l2
  }) {
    return l2 - l1;
  }
  function limites({
    h,
    s,
    l
  }) {
    let i = 0,
      min = undefined,
      max = undefined;
    if (isNaN(h)) {
      return {
        h,
        s,
        l,
        min,
        max
      };
    }
    h = Math.floor(h);
    while ((h - i) % 10) {
      i++;
    }
    min = h - i;
    i = 0;
    while ((h + i) % 10) {
      i++;
    }
    max = h + (i ? i : 20);
    return {
      h,
      s,
      l,
      min,
      max
    };
  }
  function obtenerMatizPorRango({
    h,
    s,
    l,
    min,
    max
  }) {
    if (!min && !max) {
      return 'blanco';
    }
    const findMatiz = Object.keys(RangoDeMatizes).map(s => {
      return s.split('-').map(v => {
        return Number(v);
      });
    });
    const i = findMatiz.findIndex(([min1, max1]) => {
      return min >= min1 && min <= max1;
    });
    let matiz = RangoDeMatizes[findMatiz[i].join('-')];
    if (s) {
      if (s <= 0.2) {
        matiz = 'gris';
      } else if (l <= 0.099) {
        matiz = 'negro';
      } else if (matiz == 'naranja' || matiz == 'rojo') {
        if (h >= 20) {
          matiz = s <= 0.5 || l >= 0.68 && s >= 0.5 || s >= 0.5 && l < 0.45 ? 'café' : matiz;
        }
      }
    }
    return matiz;
  }
  function segmentarPorMatiz(colección, datosDeColor) {
    const {
      h,
      s,
      l
    } = colorEnHSL(datosDeColor.color);
    const matiz = datosDeColor.efecto == 'metálico' ? 'metálico' : obtenerMatizPorRango(limites({
      h,
      s,
      l
    }));
    if (!colección[matiz]) {
      colección[matiz] = [];
    }
    colección[matiz].push({
      h,
      s,
      l,
      datosDeColor
    });
    return colección;
  }
  function segmentarPorMatizMetal(colección, {
    h,
    s,
    l,
    datosDeColor
  }) {
    const matiz = obtenerMatizPorRango(limites({
      h,
      s,
      l
    }));
    if (!colección[matiz]) {
      colección[matiz] = [];
    }
    colección[matiz].push({
      h,
      s,
      l,
      datosDeColor
    });
    return colección;
  }
  function Ordenar(colores) {
    return OrdenDeMatiz.reduce((orden, matiz) => {
      if (matiz == 'metálico' && colores[matiz]) {
        return orden.concat(Ordenar(colores[matiz].reduce(segmentarPorMatizMetal, {})));
      }
      return colores[matiz] ? orden.concat(colores[matiz].sort(ordenarPorLuminosidad)) : orden;
    }, []);
  }
  function ordenarColores(colores) {
    const ordenar = Object.values(colores).reduce((a, c) => {
      a.push(c[0]);
      return a;
    }, []);
    return Ordenar(ordenar.reduce(segmentarPorMatiz, {})).map(data => {
      return colores[data.datosDeColor.color];
    });
  }
  function colorEnHSL(color) {
    let h, s, l;
    [h, s, l] = chroma(color).hsl();
    return {
      h,
      s,
      l
    };
  }

  function Observer(events) {
    const Events = {};
    let ID = 0;
    this.event = {
      create: event => {
        Events[event] = [];
      },
      delete: event => {
        delete Events[event];
      },
      keys: () => {
        return Object.keys(Events);
      },
      get: event => {
        return Events[event].map(e => {
          return e.id;
        });
      },
      exist: event => {
        return this.event.keys().indexOf(event) != -1;
      }
    };
    this.notify = (event, update) => {
      Events[event].forEach(sub => {
        sub.notify.apply(null, update == undefined ? [] : update);
      });
    };
    this.register = (event, subscriber) => {
      ID++;
      Events[event].push({
        id: ID,
        notify: subscriber
      });
      return ID;
    };
    this.empty = () => {
      Object.keys(Events).forEach(event => {
        Events[event] = [];
      });
    };
    this.unregister = (event, id) => {
      Events[event] = Events[event].reduce((a, c) => {
        if (c.id !== id) {
          a.push(c);
        }
        return a;
      }, []);
    };
    if (events) {
      events.forEach(this.event.create);
    }
  }
  function limpiarTitulo(titulo) {
    return titulo.toLowerCase().split(" ").reduce((titulo, palabra) => {
      if (palabra != "") {
        if (palabra.toLowerCase() == "acrilico") {
          palabra = "acrílico";
        }
        if (palabra.toLowerCase() == "decoracion") {
          palabra = "decoración";
        }
        palabra = `${palabra[0].toUpperCase()}${palabra.substr(1)}`;
        titulo.length ? titulo = `${titulo} ${palabra}` : titulo = palabra;
      }
      return titulo;
    }, "");
  }
  function CortarTítulo(título) {
    título = título.replace("-", "");
    título = título.length >= 20 ? título.substr(0, 22) : título;
    return `${limpiarTitulo(título)}...`;
  }
  function formatoPrecio(precio) {
    precio = String(precio).split(".");
    if (precio[0].length > 3) {
      let resultado = [];
      let agregarComma = 3;
      const cantidad = precio[0].length - 1;
      for (let i = cantidad; i >= 0; i--) {
        const número = precio[0][i];
        agregarComma--;
        resultado.unshift(número);
        if (!agregarComma && i) {
          resultado.unshift(",");
          agregarComma = 3;
        }
      }
      precio[0] = resultado.join("");
    }
    if (precio[1] && precio[1].length == 1) {
      if (!Boolean(Number(precio[1]))) {
        precio[1] = "00";
      }
    } else if (!precio[1]) {
      precio[1] = "00";
    }
    return `${precio[0]}.${precio[1]}`;
  }

   var Data = {
    "DIBUJO / ILUSTRACIÓN / LETTERING": {
      ROTULADORES: [{
        handle: "dibujo-ilustracion-lettering-rotuladores-rotulador-base-alcohol",
        colección: "ROTULADORES BASE ALCOHOL"
      }, {
        handle: "dibujo-ilustracion-lettering-rotuladores-set-de-rotuladores-base-alcohol",
        colección: "SETS ROTULADORES BASE ALCOHOL"
      }, {
        handle: "dibujo-ilustracion-lettering-rotuladores-rotuladores-calibrados",
        colección: "ROTULADORES CALIBRADOS"
      }, {
        handle: "dibujo-ilustracion-lettering-rotuladores-set-rotuladores-calibrados",
        colección: "SETS ROTULADORES CALIBRADOS"
      }, {
        handle: "dibujo-ilustracion-lettering-rotuladores-rotuladores-pintura-acrilica",
        colección: "ROTULADORES PINTURA ACRÍLICA"
      }, {
        handle: "dibujo-ilustracion-lettering-rotuladores-set-rotuladores-pintura-acrilica",
        colección: "SETS ROTULADORES PINTURA ACRÍLICA"
      }, {
        handle: "dibujo-ilustracion-lettering-rotuladores-rotuladores-acuarelables",
        colección: "ROTULADORES ACUARELA"
      }, {
        handle: "dibujo-ilustracion-lettering-rotuladores-set-rotuladores-acuarelables",
        colección: "SETS ROTULADORES ACUARELA"
      }, {
        handle: "",
        colección: "ROTULADORES TINTA CROMADA"
      },{
        handle: "",
        colección: "ROTULADORES PERMANENTES"
      },{
        handle: "",
        colección: "ROTULADORES CALIGRAFÍA"
      },{
        handle: "dibujo-ilustracion-lettering-rotuladores-rotuladores-tinta-gel",
        colección: "ROTULADORES TINTA GEL"
      },{
        handle: "dibujo-ilustracion-lettering-rotuladores-set-rotuladores-tinta-gel",
        colección: "SETS ROTULADORES DE GEL"
      },{
        handle: "dibujo-ilustracion-lettering-rotuladores-rotuladores-metalizados",
        colección: "ROTULADORES METALIZADOS"
      },{
        handle: "dibujo-ilustracion-lettering-rotuladores-puntas-de-recambio",
        colección: "PUNTAS DE RECAMBIO"
      },{
        handle: "dibujo-ilustracion-lettering-rotuladores-fundas-y-estuches",
        colección: "FUNDAS Y ESTUCHES"
      },{
        handle: "dibujo-ilustracion-lettering-rotuladores-rotuladores-recargable",
        colección: "ROTULADORES RECARGABLES"
      }],
			"LÁPICES Y BARRAS": [{
        handle: "dibujo-ilustracion-lettering-lapices-y-barras-grafito",
        colección: "GRAFITO"
      },{
        handle: "dibujo-ilustracion-lettering-lapices-y-barras-grafito-acuareable",
        colección: "GRAFITO ACUAREABLE"
      },{
        handle: "dibujo-ilustracion-lettering-lapices-y-barras-carbon-y-carboncillo",
        colección: "CARBÓN Y CARBONCILLO"
      },{
        handle: "dibujo-ilustracion-lettering-lapices-y-barras-lapices-color",
        colección: "LÁPICES COLOR"
      },{
        handle: "dibujo-ilustracion-lettering-lapices-y-barras-lapices-color-1",
        colección: "LÁPICES COLOR ACUAREABLE"
      },{
        handle: "dibujo-ilustracion-lettering-lapices-y-barras-tinta-acuareable",
        colección: "TINTA ACUAREABLE"
      },{
        handle: "dibujo-ilustracion-lettering-lapices-y-barras-pasteles",
        colección: "PASTELES"
      },{
        handle: "dibujo-ilustracion-lettering-lapices-y-barras-portaminas",
        colección: "PORTAMINAS"
      },{
        handle: "dibujo-ilustracion-lettering-lapices-y-barras-sets-lapices-de-grafito",
        colección: "SETS LÁPICES GRAFITO"
      },{
        handle: "dibujo-ilustracion-lettering-lapices-y-barras-sets-lapices-color",
        colección: "SETS LÁPICES COLOR"
      },{
        handle: "dibujo-ilustracion-lettering-lapices-y-barras-sets-lapices-acuareable",
        colección: "SETS LÁPICES ACUAREABLE"
      },{
        handle: "dibujo-ilustracion-lettering-lapices-y-barras-sets-carboncillo",
        colección: "SETS CARBONCILLO"
      },{
        handle: "dibujo-ilustracion-lettering-lapices-y-barras-sets-pasteles",
        colección: "SETS PASTELES"
      },{
        handle: "dibujo-ilustracion-lettering-lapices-y-barras-lapiz-para-efectos",
        colección: "LÁPIZ PARA EFECTOS"
      }],
      TINTAS: [{
        handle: "dibujo-ilustracion-lettering-tintas-tinta-para-caligrafia",
        colección: "TINTA PARA CALIGRAFÍA"
      },{
        handle: "dibujo-ilustracion-lettering-tintas-tinta-permanente",
        colección: "TINTA PERMANENTE"
      },{
        handle: "dibujo-ilustracion-lettering-tintas-tinta-para-dibujo",
        colección: "TINTA PARA DIBUJO"
      },{
        handle: "dibujo-ilustracion-lettering-tintas-tinta-china",
        colección: "TINTA CHINA"
      },{
        handle: "dibujo-ilustracion-lettering-tintas-tinta-para-cuero",
        colección: "TINTA PARA CUERO"
      },{
        handle: "dibujo-ilustracion-lettering-tintas-tinta-metalizada",
        colección: "TINTA METALIZADA"
      }],
      ACCESORIOS: [{
        handle: "dibujo-ilustracion-lettering-accesorios-gomas-electricas",
        colección: "GOMAS ELÉCTRICAS"
      },{
        handle: "dibujo-ilustracion-lettering-accesorios-set-de-gomas",
        colección: "GOMAS"
      },{
        handle: "dibujo-ilustracion-lettering-accesorios-difumino",
        colección: "DIFUMINO"
      },{
        handle: "dibujo-ilustracion-lettering-accesorios-trazadores",
        colección: "TRAZADORES"
      },{
        handle: "dibujo-ilustracion-lettering-accesorios-alargadores",
        colección: "ALARGADORES"
      },{
        handle: "dibujo-ilustracion-lettering-accesorios-estuche-de-lapices",
        colección: "ESTUCHES"
      },{
        handle: "dibujo-ilustracion-lettering-accesorios-sacapuntas",
        colección: "SACAPUNTAS"
      },{
        handle: "dibujo-ilustracion-lettering-accesorios-minas-portaminas",
        colección: "MINAS PORTAMINAS"
      },{
        handle: "dibujo-ilustracion-lettering-accesorios-puntas-y-cabezales",
        colección: "PUNTAS Y CABEZALES"
      },{
        handle: "dibujo-ilustracion-lettering-accesorios-difusores",
        colección: "DIFUSORES"
      }]
    },
    PINTURA: {
      ACUARELA: [{
        handle: "pintura-acuarela-acuarela-de-estudio",
        colección: "ACUARELA DE ESTUDIO"
      },{
        handle: "pintura-acuarela-acuarela-profesional",
        colección: "ACUARELA PROFESIONAL"
      },{
        handle: "pintura-acuarela-acuarela-godetes",
        colección: "ACUARELA GODETES"
      },{
        handle: "pintura-acuarela-acuarela-liquida",
        colección: "ACUARELA LÍQUIDA"
      },{
        handle: "pintura-acuarela-sets-acuarela",
        colección: "SETS ACUARELA"
      },{
        handle: "pintura-acuarela-carta-de-color",
        colección: "CARTA DE COLOR"
      }],
      ACRÍLICA: [{
      handle: "pintura-acrilica-acrilica-de-estudio",
        colección: "ACRÍLICA DE ESTUDIO"
      },{
        handle: "pintura-acrilica-acrilica-profesional",
        colección: "ACRÍLICA PROFESIONAL"
      },{
        handle: "pintura-acrilica-acrilica-fluida",
        colección: "ACRÍLICA FLUIDA"
      },{
        handle: "pintura-acrilica-sets-tinta-acrilica",
        colección: "TINTA ACRÍLICA"
      },{
        handle: "pintura-acrilica-sets-pintura",
        colección: "SETS PINTURA"
      },{
        handle: "pintura-acrilica-sets-tinta-acrilica",
        colección: "SETS TINTA ACRÍLICA"
      },{
        handle: "pintura-acrilica-acrilica-para-cuero",
        colección: "ACRÍLICA PARA CUERO"
      },{
        handle: "pintura-acrilica-sets-acrilica-para-cuero",
        colección: "SETS ACRÍLICA PARA CUERO"
      }],
      ÓLEO: [{
        handle: "pintura-oleo-oleo-de-estudio",
        colección: "ÓLEO DE ESTUDIO"
      },{
        handle: "pintura-oleo-oleo-profesional",
        colección: "ÓLEO PROFESIONAL"
      },{
        handle: "pintura-oleo-sets-oleo",
        colección: "SETS ÓLEO"
      }],
			"PINTURA EN AEROSOL": [{
        handle: "pintura-pintura-en-aerosol-acrilica-en-spray",
        colección: "ACRÍLICA EN SPRAY"
      },{
        handle: "pintura-pintura-en-aerosol-acrilica-efecto-metalizado",
        colección: "ACRILICA EFECTO METALIZADO"
      },{
        handle: "pintura-pintura-en-aerosol-imprimacion",
        colección: "IMPRIMACIÓN"
      },{
        handle: "pintura-pintura-en-aerosol-caps-boquillas",
        colección: "CAPS/BOQUILLAS"
      }],
      AUXILIARES: [{
        handle: "pintura-auxiliares-medium-acrilico",
        colección: "MEDIUM ACRÍLICO"
      },{
        handle: "pintura-auxiliares-medium-acuarela",
        colección: "MEDIUM ACUARELA"
      },{
        handle: "pintura-auxiliares-medium-oleo",
        colección: "MEDIUM ÓLEO"
      },{
        handle: "pintura-auxiliares-medium-acrilico-cuero",
        colección: "MEDIUM ACRÍLICO CUERO"
      },{
        handle: "pintura-auxiliares-imprimacion",
        colección: "IMPRIMACIÓN"
      },{
        handle: "pintura-auxiliares-enmascarador",
        colección: "ENMASCARADOR"
      }],
      ACABADOS: [{
        handle: "pintura-acabados-barniz",
        colección: "BARNIZ"
      },{
        handle: "pintura-acabados-barniz-para-cuero",
        colección: "BARNIZ PARA CUERO"
      },{
        handle: "pintura-acabados-barniz-en-aerosol",
        colección: "BARNIZ EN AEROSOL"
      },{
        handle: "pintura-acabados-fijadores-en-aerosol",
        colección: "FIJADORES EN AEROSOL"
      }],
      GOUACHE: [{
        handle: "arte-gouache-set-gouache-profesional",
        colección: "GOUACHE"
      },{
        handle: "arte-gouache-set-gouache-profesional",
        colección: "SETS DE COUACHE"
      }],
      "TEXTIL": [{
        handle: "custom-pintura-serigrafia",
        colección: "SERIGRAFÍA"
      },{
        handle: "custom-pintura-pintura-textil",
        colección: "PINTURA TEXTIL"
      },{
        handle: "pintura-textil-pintura-textil-spray",
        colección: "PINTURA TEXTIL SPRAY"
      }],
    },
    "PINCELES Y ACCESORIOS": {
      PINCELES: [{
        handle: "pinceles-y-accesorios-pinceles-pinceles-acuarela",
        colección: "PINCELES ACUARELA"
      },{
        handle: "pinceles-y-accesorios-pinceles-pinceles-oleo",
        colección: "PINCELES ÓLEO"
      },{
        handle: "pinceles-y-accesorios-pinceles-pinceles-acrilica",
        colección: "PINCELES ACRÍLICA"
      },{
        handle: "pinceles-y-accesorios-pinceles-pinceles-mix-media",
        colección: "PINCELES MIX MEDIA"
      },{
        handle: "pinceles-y-accesorios-pinceles-sets-de-pinceles",
        colección: "SETS DE PINCELES"
      },{
        handle: "pinceles-y-accesorios-pinceles-pinceles-con-deposito",
        colección: "PINCELES CON DEPÓSITO"
      }],
      "PALETINAS Y BROCHAS": [{
        handle: "pinceles-y-accesorios-paletinas",
        colección: "TODAS LAS PALETINAS Y BROCHAS"
      }],
      ESPÁTULAS: [{
        handle: "pinceles-y-accesorios-espatulas",
        colección: "TODOS LAS ESPÁTULAS"
      }],
      ESPONJAS: [{
        handle: "pinceles-y-accesorios-esponjas",
        colección: "TODAS LAS ESPONJAS"
      }],
      ACCESORIOS: [{
        handle: "pinceles-y-accesorios-accesorios-paletas",
        colección: "PALETAS"
      },{
        handle: "pinceles-y-accesorios-accesorios-limpia-pinceles",
        colección: "LIMPIA PINCELES"
      },{
        handle: "pinceles-y-accesorios-accesorios-bandejas",
        colección: "BANDEJAS"
      },{
        handle: "pinceles-y-accesorios-accesorios-esponjas",
        colección: "ESPONJAS"
      },{
        handle: "pinceles-y-accesorios-accesorios-caballetes",
        colección: "CABALLETES"
      },{
        handle: "pinceles-y-accesorios-accesorios-difusores",
        colección: "DIFUSORES"
      }]
    },
		"PAPEL Y SOPORTES": {
      "BLOC PAPEL ACUARELA": [{
        handle: "papel-y-soportes-bloc-papel-acuarela",
        colección: "VER TODO"
      }],
      "BLOC PAPEL DIBUJO": [{
        handle: "papel-y-soportes-bloc-papel-dibujo",
        colección: "VER TODO"
      }],
			"BLOC PAPEL MIX MEDIA": [{
        handle: "papel-y-soportes-bloc-papel-mix-media",
        colección: "VER TODO"
      }],
			"PAPEL YUPO": [{
        handle: "papel-y-soportes-papel-yupo",
        colección: "VER TODO"
      }],
			"SKETCHBOOK": [{
        handle: "papel-y-soportes-sketchbook",
        colección: "VER TODO"
      }],
			"BLOC PAPEL ROTULADORES": [{
        handle: "papel-y-soportes-bloc-para-rotuladores",
        colección: "VER TODO"
      }],
			"PAPEL ARTESANO": [{
        handle: "papel-y-soportes-papel-artesano",
        colección: "VER TODO"
      }],
			"BASTIDORES CON TELA": [{
        handle: "papel-y-soportes-bastidores-con-tela",
        colección: "VER TODO"
      }],
			"PAPEL TRANSFERENCIAS": [{
        handle: "papel-y-soportes-papel-transferencias",
        colección: "VER TODO"
      }],
			"PAPEL FOTOGÁFICO": [{
        handle: "papel-y-soportes-papel-transferencias",
        colección: "VER TODO"
      }],
			"TABLILLA ENTELADA": [{
        handle: "papel-y-soportes-tablilla-entelada",
        colección: "VER TODO"
      }],
    },
		"MANUALIDADES": {
      "PAPEL": [{
        handle: "manualidades-papel",
        colección: "VER TODO"
      }],
       "MASILLAS Y PASTAS DE MODELAR": [{
        handle: "manualidades-masillas-y-pastas-de-modelar",
        colección: "VER TODO"
      }],
      "ORO Y PLATA": [{
        handle: "manualidades-oro-y-plata",
        colección: "VER TODO"
      }],
			"PALILLOS": [{
        handle: "manualidades-palillos",
        colección: "VER TODO"
      }],
			"FIJADORES": [{
        handle: "manualidades-fijadores",
        colección: "VER TODO"
      }],
			"TEXTURAS GEL": [{
        handle: "manualidades-texturas-gel",
        colección: "VER TODO"
      }],
			"ESPONJAS": [{
        handle: "manualidades-esponjas",
        colección: "VER TODO"
      }],
			"CINTA ADHESIVA": [{
        handle: "manualidades-cinta-adhesiva",
        colección: "VER TODO"
      }],
			"PINTURA": [{
        handle: "manualidades-pintura-serigrafia",
        colección: "SERIGRAFIA"
      },{
        handle: "manualidades-pintura-pintura-porcelana-y-cristal",
        colección: "PINTURA PORCELANA Y CRISTAL"
      },{
        handle: "manualidades-pintura-marmoleado",
        colección: "MARMOLEADO"
      }],
      	"ROTULADORES": [{
        handle: "custom-rotuladores-rotulador-textil",
        colección: "ROTULADORES TEXTIL"
      },{
        handle: "custom-rotuladores-rotulador-porcelana-y-cristal",
        colección: "ROTULADOR PORCELANA Y CRISTAL"
      }], 
    },
    "CUSTOM": {
      "PINTURA": [{
        handle: "custom-pintura-pintura-para-cuero",
        colección: "PINTURA PARA CUERO"
      },{
        handle: "custom-pintura-mediums-y-aditivos",
        colección: "MEDIUMS Y ADITIVOS"
      },{
        handle: "custom-pintura-pintura-para-cuero",
        colección: "TINTA PARA CUERO"
      },{
        handle: "custom-pintura-serigrafia",
        colección: "SERIGRAFIA"
      },{
        handle: "custom-pintura-pintura-textil",
        colección: "PINTURA TEXTIL"
       },{
        handle: "custom-pintura-barnices",
        colección: "BARNICES"
      }],
      "ROTULADORES": [{
        handle: "custom-rotuladores-rotulador-textil",
        colección: "ROTULADOR TEXTIL"
       },{
        handle: "dibujo-ilustracion-lettering-rotuladores-rotuladores-pintura-acrilica",
        colección: "ROTULADOR ACRÍLICO"
      },{
        handle: "custom-rotuladores-rotulador-porcelana-y-cristal",
        colección: "ROTULADOR PORCELANA Y CRISTAL"
      }],
      PURPURINA: [{
        handle: "custom-purpurina",
        colección: "VER TODO"
      }],
			ADHESIVOS: [{
        handle: "custom-adhesivos",
        colección: "VER TODO"
      }],
			"LIMPIEZA CUERO": [{
        handle: "custom-limpieza-cuero",
        colección: "VER TODO"
      }],
			"LIMPIEZA ZAPATILLAS": [{
        handle: "custom-limpieza-zapatillas",
        colección: "VER TODO"
      }],
			"PINCELES": [{
        handle: "custom-pinceles",
        colección: "VER TODO"
      }],
			"CINTA ADHESIVA": [{
        handle: "custom-cinta-adhesiva",
        colección: "VER TODO"
      }]
    },
	"TABLETAS Y PANTALLAS": {
      "TABLETAS GRÁFICAS": [{
        handle: "tabletas-y-pantallas-tabletas-graficas",
        colección: "VER TODO"
      }],
			"PANTALLAS GRÁFICAS": [{
        handle: "tabletas-y-pantallas-pantallas-graficas",
        colección: "VER TODO"
      }],
    },
    "INFANTIL": {
      "PINTURA": [{
        handle: "infantil-pintura-pintura-infantil",
        colección: "PINTURA INFANTIL"
        },{
        handle: "infantil-pintura-pintura-dedos",
        colección: "PINTURA DEDOS"
        },{
        handle: "infantil-pintura-pintura-para-ventanas",
        colección: "PINTURA PARA VENTANAS"
        },{
        handle: "infantil-pintura-pintura-textil-infantil",
        colección: "PINTURA TEXTIL INFANTIL"
      }],
	"ROTULADORES": [{
        handle: "infantil-rotuladores-rotulador-textil-kids",
        colección: "ROTULADOR TEXTIL KIDS"
    },{
      handle: "infantil-rotuladores-rotulador-porcelana-y-cristal-kids",
        colección: "ROTULADOR PORCELANA Y CRISTAL KIDS"
      }],
    "JUEGOS CREATIVOS": [{
        handle: "infantil-juegos-creativos-puzzles",
        colección: "PUZZLES"
      },{
      handle: "infantil-juegos-creativos-decoracion",
        colección: "DECORACIÓN"
      }],
    }
  };

  class Contenido extends k {
    constructor(props) {
      super();
      this.eventos = props.eventos;
      this.raíz = d();
      this.categorías = [];
      this.colecciones = [];
      this.actual = 0;
      for (let categoría in Data) {
        let colecciones = Data[categoría];
        categoría = limpiarTitulo(categoría);
        this.categorías.push(categoría);
        const índice = this.colecciones.push([]) - 1;
        for (let colección in colecciones) {
          const handles = colecciones[colección];
          colección = limpiarTitulo(colección);
          this.colecciones[índice].push({
            categoría,
            colección,
            handles
          });
        }
        this.colecciones[índice] = this.colecciones[índice].map(this.coleccionesHtml);
      }
      this.state = {
        colección: this.colecciones[this.actual]
      };
      this.categorías = this.categorías.map(this.categoríaHtml.bind(this));
    }
    coleccionesHtml({
      handles,
      colección,
      categoría
    }) {
      handles = handles.length >= 5 ? handles.map(h => h).splice(1, 5) : handles;
      handles = handles.map(({
        handle,
        colección
      }) => {
        return y("li", null, y("a", {
          href: `/collections/${handle}`,
          title: `/collections/${handle}`
        }, colección));
      });
      return y("div", {
        class: "categorias-opciones"
      }, y("a", {
        href: `/collections?categoría=${categoría}`,
        title: `/collections?categoría=${categoría}`
      }, y("p", {
        class: "titulo"
      }, limpiarTitulo(colección))), y("ul", null, handles, y("li", null, y("a", {
        class: "activo",
        href: `/collections?categoría=${categoría.replace("&", "%26")}`,
        title: `/collections?categoría=${categoría.replace("&", "%26")}`
      }, "Ver m\xE1s..."))));
    }
    categoríaHtml(categoría, índice) {
      const actualizarColecciones = () => {
        this.actual = índice;
        this.setState({
          colección: this.colecciones[índice]
        });
      };
      return y("div", {
        onClick: actualizarColecciones,
        class: "boton-categorias"
      }, y("button", null, categoría), y("span", null, ">"));
    }
    componentDidMount() {
      const self = this;
      this.raíz = $(this.raíz.current);
      this.eventos.register("abrirMenu", function (boton) {
        self.raíz.toggleClass("open");
      });
    }
    render() {
      return y("div", {
        ref: this.raíz,
        class: "opciones-contenido"
      }, y("div", {
        class: "categorias"
      }, y("p", {
        class: "titulo-categorias"
      }, "Categorias"), this.categorías), y("div", {
        class: "categorias-contenido"
      }, this.state.colección));
    }
  }

  class Menu extends k {
    constructor() {
      super();
      this.elementos = {
        'raiz': d(),
        'opciones': undefined,
        'contenido': undefined
      };
      this.eventos = new Observer(['abrirMenu']);
      this.raiz = d();
    }
    componentDidMount() {
      let raiz = $(this.raiz.current);
      this.eventos.register('abrirMenu', function () {
        raiz.children('opciones').find('button').css({
          'color': 'red'
        });
      });
    }
    render() {
      return y("div", {
        ref: this.raiz,
        class: "menu-principal"
      }, y(Opciones, {
        eventos: this.eventos
      }), y(Contenido, {
        eventos: this.eventos
      }));
    }
  }

  class MenuMovil extends k {
    componentDidMount() {
      $("#btn-menú").click(function () {
        $("#btn-menú").toggleClass("equis");
        if ($("#menu-movil").css("display") == "none") {
          $("#menu-movil").slideDown();
          $("body").css("overflow", "hidden");
        } else {
          $("#menu-movil").slideUp();
          $("body").css("overflow", "scroll");
        }
      });
      $("button.accion").click(function () {
        let contenido = $(this).parent().children(".contenido");
        let signo = $(this).children(".signo");
        if (contenido.css("display") == "none") {
          contenido.slideDown();
          signo.html("-");
        } else {
          contenido.slideUp();
          signo.html("+");
        }
      });
    }
    render() {
      return y("div", {
        class: "menu-movil",
        id: "menu-movil"
      }, y("div", {
        class: "por-productos"
      }, y("button", {
        class: "accion"
      }, y("p", {
        class: "titulo"
      }, "Comprar por productos"), y("span", {
        class: "signo"
      }, "+")), y("div", {
        class: "separador"
      }), y("ul", {
        class: "contenido",
        id: "contenido"
      }, y("li", null, y("a", {
        href: "/collections?categor\xEDa=Dibujo%20/%20Ilustraci\xF3n%20/%20Lettering",
        title: "/collections?categor\xEDa=Dibujo%20/%20Ilustraci\xF3n%20/%20Lettering"
      }, "Dibujo / Ilustraci\xF3n / Lettering")), y("li", null, y("a", {
        href: "/collections?categor\xEDa=Pintura",
        title: "/collections?categor\xEDa=Pintura"
      }, "Pintura")), y("li", null, y("a", {
        href: "/collections?categor\xEDa=Pinceles",
        title: "/collections?categor\xEDa=Pinceles"
      }, "Pinceles")), y("li", null, y("a", {
        href: "/collections?categor\xEDa=Tableta%20/%20Pantalla%20Gr\xE1fica",
        title: "/collections?categor\xEDa=Tableta%20/%20Pantalla%20Gr\xE1fica"
      }, "Tableta / Pantalla Gr\xE1fica")))), y("div", {
        class: "marcas"
      }, y("a", {
        class: "enlace",
        href: "/pages/marcas",
        title: "/pages/marcas"
      }, y("p", {
        class: "titulo"
      }, "Comprar por marcas")), y("div", {
        class: "separador"
      })), y("div", {
        class: "top-ventas"
      }, y("a", {
        class: "enlace",
        href: "/collections/top-ventas",
        title: "/collections/top-ventas"
      }, y("p", {
        class: "titulo"
      }, "Top ventas")), y("div", {
        class: "separador"
      })), y("div", {
        class: "ofertas"
      }, y("a", {
        class: "enlace",
        href: "/collections/ofertas",
        title: "/collections/ofertas"
      }, y("p", {
        class: "titulo"
      }, "Ofertas")), y("div", {
        class: "separador"
      })), y("div", {
        class: "blog"
      }, y("a", {
        class: "enlace",
        href: "/blog",
        title: "/blog"
      }, y("p", {
        class: "titulo"
      }, "Blog"))));
    }
  }

  var index_unoptimized_umd = createCommonjsModule(function (module, exports) {
  /*
  @license
  The MIT License (MIT)

  Copyright (c) 2016 Shopify Inc.

  Permission is hereby granted, free of charge, to any person obtaining a
  copy of this software and associated documentation files (the
  "Software"), to deal in the Software without restriction, including
  without limitation the rights to use, copy, modify, merge, publish,
  distribute, sublicense, and/or sell copies of the Software, and to
  permit persons to whom the Software is furnished to do so, subject to
  the following conditions:

  The above copyright notice and this permission notice shall be included
  in all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
  OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
  IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
  CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
  TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
  SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

  */

  (function (global, factory) {
  	module.exports = factory() ;
  }(commonjsGlobal, (function () {
  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };











  var classCallCheck$1 = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };

  var createClass$1 = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();









  var inherits$1 = function (subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  };











  var possibleConstructorReturn$1 = function (self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  };

  /*
  The MIT License (MIT)
  Copyright (c) 2016 Shopify Inc.

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all
  copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
  IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
  DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
  OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
  OR OTHER DEALINGS IN THE SOFTWARE.


  */
  function join() {
    for (var _len = arguments.length, fields = Array(_len), _key = 0; _key < _len; _key++) {
      fields[_key] = arguments[_key];
    }

    return fields.join(' ');
  }

  function isObject(value) {
    return Boolean(value) && Object.prototype.toString.call(value.valueOf()) === '[object Object]';
  }

  function deepFreezeCopyExcept(predicate, structure) {
    if (predicate(structure)) {
      return structure;
    } else if (isObject(structure)) {
      return Object.freeze(Object.keys(structure).reduce(function (copy, key) {
        copy[key] = deepFreezeCopyExcept(predicate, structure[key]);

        return copy;
      }, {}));
    } else if (Array.isArray(structure)) {
      return Object.freeze(structure.map(function (item) {
        return deepFreezeCopyExcept(predicate, item);
      }));
    } else {
      return structure;
    }
  }

  function schemaForType(typeBundle, typeName) {
    var typeSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var type = typeBundle.types[typeName];

    if (type) {
      return type;
    } else if (typeSchema && typeSchema.kind === 'INTERFACE') {
      return typeSchema;
    }

    throw new Error('No type of ' + typeName + ' found in schema');
  }

  var classCallCheck = function classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };

  var createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var inherits = function inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  };

  var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
  };

  var slicedToArray = function () {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = undefined;

      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);

          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }

      return _arr;
    }

    return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  }();

  var toConsumableArray = function toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }return arr2;
    } else {
      return Array.from(arr);
    }
  };

  var VariableDefinition = function () {

    /**
     * This constructor should not be invoked directly.
     * Use the factory function {@link Client#variable} to create a VariableDefinition.
     *
     * @param {String} name The name of the variable.
     * @param {String} type The GraphQL type of the variable.
     * @param {*} [defaultValue] The default value of the variable.
     */
    function VariableDefinition(name, type, defaultValue) {
      classCallCheck(this, VariableDefinition);

      this.name = name;
      this.type = type;
      this.defaultValue = defaultValue;
      Object.freeze(this);
    }

    /**
     * Returns the GraphQL query string for the variable as an input value (e.g. `$variableName`).
     *
     * @return {String} The GraphQL query string for the variable as an input value.
     */

    createClass(VariableDefinition, [{
      key: 'toInputValueString',
      value: function toInputValueString() {
        return '$' + this.name;
      }

      /**
       * Returns the GraphQL query string for the variable (e.g. `$variableName:VariableType = defaultValue`).
       *
       * @return {String} The GraphQL query string for the variable.
       */

    }, {
      key: 'toString',
      value: function toString() {
        var defaultValueString = this.defaultValue ? ' = ' + formatInputValue(this.defaultValue) : '';

        return '$' + this.name + ':' + this.type + defaultValueString;
      }
    }]);
    return VariableDefinition;
  }();

  function isVariable(value) {
    return VariableDefinition.prototype.isPrototypeOf(value);
  }

  function variable(name, type, defaultValue) {
    return new VariableDefinition(name, type, defaultValue);
  }

  var Enum = function () {

    /**
     * This constructor should not be invoked directly.
     * Use the factory function {@link Client#enum} to create an Enum.
     *
     * @param {String} key The key of the enum.
     */
    function Enum(key) {
      classCallCheck(this, Enum);

      this.key = key;
    }

    /**
     * Returns the GraphQL query string for the enum (e.g. `enumKey`).
     *
     * @return {String} The GraphQL query string for the enum.
     */

    createClass(Enum, [{
      key: "toString",
      value: function toString() {
        return this.key;
      }
    }, {
      key: "valueOf",
      value: function valueOf() {
        return this.key.valueOf();
      }
    }]);
    return Enum;
  }();

  var enumFunction = function enumFunction(key) {
    return new Enum(key);
  };

  var Scalar = function () {
    function Scalar(value) {
      classCallCheck(this, Scalar);

      this.value = value;
    }

    createClass(Scalar, [{
      key: "toString",
      value: function toString() {
        return this.value.toString();
      }
    }, {
      key: "valueOf",
      value: function valueOf() {
        return this.value.valueOf();
      }
    }, {
      key: "unwrapped",
      get: function get$$1() {
        return this.value;
      }
    }]);
    return Scalar;
  }();

  function formatInputValue(value) {
    if (VariableDefinition.prototype.isPrototypeOf(value)) {
      return value.toInputValueString();
    } else if (Enum.prototype.isPrototypeOf(value)) {
      return String(value);
    } else if (Scalar.prototype.isPrototypeOf(value)) {
      return JSON.stringify(value.valueOf());
    } else if (Array.isArray(value)) {
      return '[' + join.apply(undefined, toConsumableArray(value.map(formatInputValue))) + ']';
    } else if (isObject(value)) {
      return formatObject(value, '{', '}');
    } else {
      return JSON.stringify(value);
    }
  }

  function formatObject(value) {
    var openChar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var closeChar = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    var argPairs = Object.keys(value).map(function (key) {
      return key + ': ' + formatInputValue(value[key]);
    });

    return '' + openChar + join.apply(undefined, toConsumableArray(argPairs)) + closeChar;
  }

  function formatArgs(args) {
    if (!Object.keys(args).length) {
      return '';
    }

    return ' (' + formatObject(args) + ')';
  }

  function formatDirectives(directives) {
    if (!Object.keys(directives).length) {
      return '';
    }

    var directiveStrings = Object.keys(directives).map(function (key) {
      var directiveArgs = directives[key];
      var arg = directiveArgs && Object.keys(directiveArgs).length ? '(' + formatObject(directiveArgs) + ')' : '';

      return '@' + key + arg;
    });

    return ' ' + join.apply(undefined, toConsumableArray(directiveStrings));
  }

  // eslint-disable-next-line no-empty-function
  var noop = function noop() {};

  var Profiler = {
    trackTypeDependency: noop,
    trackFieldDependency: noop
  };

  var trackTypeDependency = Profiler.trackTypeDependency;
  var trackFieldDependency = Profiler.trackFieldDependency;

  function parseFieldCreationArgs(creationArgs) {
    var callback = noop;
    var options = {};
    var selectionSet = null;

    if (creationArgs.length === 2) {
      if (typeof creationArgs[1] === 'function') {
        var _creationArgs = slicedToArray(creationArgs, 2);

        options = _creationArgs[0];
        callback = _creationArgs[1];
      } else {
        var _creationArgs2 = slicedToArray(creationArgs, 2);

        options = _creationArgs2[0];
        selectionSet = _creationArgs2[1];
      }
    } else if (creationArgs.length === 1) {
      // SelectionSet is defined before this function is called since it's
      // called by SelectionSet
      // eslint-disable-next-line no-use-before-define
      if (SelectionSet.prototype.isPrototypeOf(creationArgs[0])) {
        selectionSet = creationArgs[0];
      } else if (typeof creationArgs[0] === 'function') {
        callback = creationArgs[0];
      } else {
        options = creationArgs[0];
      }
    }

    return { options: options, selectionSet: selectionSet, callback: callback };
  }

  var emptyArgs = Object.freeze({});
  var emptyDirectives = Object.freeze({});

  var Field = function () {

    /**
     * This constructor should not be invoked directly.
     * Fields are added to a selection by {@link SelectionSetBuilder#add}, {@link SelectionSetBuilder#addConnection}
     * and {@link SelectionSetBuilder#addInlineFragmentOn}.
     *
     * @param {String} name The name of the field.
     * @param {Object} [options] An options object containing:
     *   @param {Object} [options.args] Arguments for the field.
     *   @param {String} [options.alias] An alias for the field.
     *   @param {Object} [options.directives] Directives for the field.
     * @param {SelectionSet} selectionSet The selection set on the field.
     */
    function Field(name, options, selectionSet) {
      classCallCheck(this, Field);

      this.name = name;
      this.alias = options.alias || null;
      this.responseKey = this.alias || this.name;
      this.args = options.args ? deepFreezeCopyExcept(isVariable, options.args) : emptyArgs;
      this.directives = options.directives ? deepFreezeCopyExcept(isVariable, options.directives) : emptyDirectives;
      this.selectionSet = selectionSet;
      Object.freeze(this);
    }

    /**
     * Returns the GraphQL query string for the Field (e.g. `catAlias: cat(size: 'small') { name }` or `name`).
     *
     * @return {String} The GraphQL query string for the Field.
     */

    createClass(Field, [{
      key: 'toString',
      value: function toString() {
        var aliasPrefix = this.alias ? this.alias + ': ' : '';

        return '' + aliasPrefix + this.name + formatArgs(this.args) + formatDirectives(this.directives) + this.selectionSet;
      }
    }]);
    return Field;
  }();

  // This is an interface that defines a usage, and simplifies type checking
  var Spread = function Spread() {
    classCallCheck(this, Spread);
  };

  var InlineFragment = function (_Spread) {
    inherits(InlineFragment, _Spread);

    /**
     * This constructor should not be invoked directly.
     * Use the factory function {@link SelectionSetBuilder#addInlineFragmentOn} to create an InlineFragment.
     *
     * @param {String} typeName The type of the fragment.
     * @param {SelectionSet} selectionSet The selection set on the fragment.
     */
    function InlineFragment(typeName, selectionSet) {
      classCallCheck(this, InlineFragment);

      var _this = possibleConstructorReturn(this, (InlineFragment.__proto__ || Object.getPrototypeOf(InlineFragment)).call(this));

      _this.typeName = typeName;
      _this.selectionSet = selectionSet;
      Object.freeze(_this);
      return _this;
    }

    /**
     * Returns the GraphQL query string for the InlineFragment (e.g. `... on Cat { name }`).
     *
     * @return {String} The GraphQL query string for the InlineFragment.
     */

    createClass(InlineFragment, [{
      key: 'toString',
      value: function toString() {
        return '... on ' + this.typeName + this.selectionSet;
      }
    }]);
    return InlineFragment;
  }(Spread);

  var FragmentSpread = function (_Spread2) {
    inherits(FragmentSpread, _Spread2);

    /**
     * This constructor should not be invoked directly.
     * Use the factory function {@link Document#defineFragment} to create a FragmentSpread.
     *
     * @param {FragmentDefinition} fragmentDefinition The corresponding fragment definition.
     */
    function FragmentSpread(fragmentDefinition) {
      classCallCheck(this, FragmentSpread);

      var _this2 = possibleConstructorReturn(this, (FragmentSpread.__proto__ || Object.getPrototypeOf(FragmentSpread)).call(this));

      _this2.name = fragmentDefinition.name;
      _this2.selectionSet = fragmentDefinition.selectionSet;
      Object.freeze(_this2);
      return _this2;
    }

    /**
     * Returns the GraphQL query string for the FragmentSpread (e.g. `...catName`).
     *
     * @return {String} The GraphQL query string for the FragmentSpread.
     */

    createClass(FragmentSpread, [{
      key: 'toString',
      value: function toString() {
        return '...' + this.name;
      }
    }, {
      key: 'toDefinition',
      value: function toDefinition() {
        // eslint-disable-next-line no-use-before-define
        return new FragmentDefinition(this.name, this.selectionSet.typeSchema.name, this.selectionSet);
      }
    }]);
    return FragmentSpread;
  }(Spread);

  var FragmentDefinition = function () {

    /**
     * This constructor should not be invoked directly.
     * Use the factory function {@link Document#defineFragment} to create a FragmentDefinition on a {@link Document}.
     *
     * @param {String} name The name of the fragment definition.
     * @param {String} typeName The type of the fragment.
     */
    function FragmentDefinition(name, typeName, selectionSet) {
      classCallCheck(this, FragmentDefinition);

      this.name = name;
      this.typeName = typeName;
      this.selectionSet = selectionSet;
      this.spread = new FragmentSpread(this);
      Object.freeze(this);
    }

    /**
     * Returns the GraphQL query string for the FragmentDefinition (e.g. `fragment catName on Cat { name }`).
     *
     * @return {String} The GraphQL query string for the FragmentDefinition.
     */

    createClass(FragmentDefinition, [{
      key: 'toString',
      value: function toString() {
        return 'fragment ' + this.name + ' on ' + this.typeName + ' ' + this.selectionSet;
      }
    }]);
    return FragmentDefinition;
  }();

  function selectionsHaveIdField(selections) {
    return selections.some(function (fieldOrFragment) {
      if (Field.prototype.isPrototypeOf(fieldOrFragment)) {
        return fieldOrFragment.name === 'id';
      } else if (Spread.prototype.isPrototypeOf(fieldOrFragment) && fieldOrFragment.selectionSet.typeSchema.implementsNode) {
        return selectionsHaveIdField(fieldOrFragment.selectionSet.selections);
      }

      return false;
    });
  }

  function selectionsHaveTypenameField(selections) {
    return selections.some(function (fieldOrFragment) {
      if (Field.prototype.isPrototypeOf(fieldOrFragment)) {
        return fieldOrFragment.name === '__typename';
      } else if (Spread.prototype.isPrototypeOf(fieldOrFragment) && fieldOrFragment.selectionSet.typeSchema.implementsNode) {
        return selectionsHaveTypenameField(fieldOrFragment.selectionSet.selections);
      }

      return false;
    });
  }

  function indexSelectionsByResponseKey(selections) {
    function assignOrPush(obj, key, value) {
      if (Array.isArray(obj[key])) {
        obj[key].push(value);
      } else {
        obj[key] = [value];
      }
    }
    var unfrozenObject = selections.reduce(function (acc, selection) {
      if (selection.responseKey) {
        assignOrPush(acc, selection.responseKey, selection);
      } else {
        var responseKeys = Object.keys(selection.selectionSet.selectionsByResponseKey);

        responseKeys.forEach(function (responseKey) {
          assignOrPush(acc, responseKey, selection);
        });
      }

      return acc;
    }, {});

    Object.keys(unfrozenObject).forEach(function (key) {
      Object.freeze(unfrozenObject[key]);
    });

    return Object.freeze(unfrozenObject);
  }

  /**
   * Class that specifies the full selection of data to query.
   */

  var SelectionSet = function () {

    /**
     * This constructor should not be invoked directly. SelectionSets are created when building queries/mutations.
     *
     * @param {Object} typeBundle A set of ES6 modules generated by {@link https://github.com/Shopify/graphql-js-schema|graphql-js-schema}.
     * @param {(Object|String)} type The type of the current selection.
     * @param {Function} builderFunction Callback function used to build the SelectionSet.
     *   The callback takes a {@link SelectionSetBuilder} as its argument.
     */
    function SelectionSet(typeBundle, type, builderFunction) {
      classCallCheck(this, SelectionSet);

      if (typeof type === 'string') {
        this.typeSchema = schemaForType(typeBundle, type);
      } else {
        this.typeSchema = type;
      }

      trackTypeDependency(this.typeSchema.name);

      this.typeBundle = typeBundle;
      this.selections = [];
      if (builderFunction) {
        // eslint-disable-next-line no-use-before-define
        builderFunction(new SelectionSetBuilder(this.typeBundle, this.typeSchema, this.selections));
      }

      if (this.typeSchema.implementsNode || this.typeSchema.name === 'Node') {
        if (!selectionsHaveIdField(this.selections)) {
          this.selections.unshift(new Field('id', {}, new SelectionSet(typeBundle, 'ID')));
        }
      }

      if (this.typeSchema.kind === 'INTERFACE') {
        if (!selectionsHaveTypenameField(this.selections)) {
          this.selections.unshift(new Field('__typename', {}, new SelectionSet(typeBundle, 'String')));
        }
      }

      this.selectionsByResponseKey = indexSelectionsByResponseKey(this.selections);
      Object.freeze(this.selections);
      Object.freeze(this);
    }

    /**
     * Returns the GraphQL query string for the SelectionSet (e.g. `{ cat { name } }`).
     *
     * @return {String} The GraphQL query string for the SelectionSet.
     */

    createClass(SelectionSet, [{
      key: 'toString',
      value: function toString() {
        if (this.typeSchema.kind === 'SCALAR' || this.typeSchema.kind === 'ENUM') {
          return '';
        } else {
          return ' { ' + join(this.selections) + ' }';
        }
      }
    }]);
    return SelectionSet;
  }();

  var SelectionSetBuilder = function () {

    /**
     * This constructor should not be invoked directly. SelectionSetBuilders are created when building queries/mutations.
     *
     * @param {Object} typeBundle A set of ES6 modules generated by {@link https://github.com/Shopify/graphql-js-schema|graphql-js-schema}.
     * @param {Object} typeSchema The schema object for the type of the current selection.
     * @param {Field[]} selections The fields on the current selection.
     */
    function SelectionSetBuilder(typeBundle, typeSchema, selections) {
      classCallCheck(this, SelectionSetBuilder);

      this.typeBundle = typeBundle;
      this.typeSchema = typeSchema;
      this.selections = selections;
    }

    createClass(SelectionSetBuilder, [{
      key: 'hasSelectionWithResponseKey',
      value: function hasSelectionWithResponseKey(responseKey) {
        return this.selections.some(function (field) {
          return field.responseKey === responseKey;
        });
      }

      /**
       * Adds a field to be queried on the current selection.
       *
       * @example
       * client.query((root) => {
       *   root.add('cat', {args: {id: '123456'}, alias: 'meow'}, (cat) => {
       *     cat.add('name');
       *   });
       * });
       *
       * @param {SelectionSet|String} selectionOrFieldName The selection or name of the field to add.
       * @param {Object} [options] Options on the query including:
       *   @param {Object} [options.args] Arguments on the query (e.g. `{id: '123456'}`).
       *   @param {String} [options.alias] Alias for the field being added.
       * @param {Function|SelectionSet} [callbackOrSelectionSet] Either a callback which will be used to create a new {@link SelectionSet}, or an existing {@link SelectionSet}.
       */

    }, {
      key: 'add',
      value: function add(selectionOrFieldName) {
        var selection = void 0;

        if (Object.prototype.toString.call(selectionOrFieldName) === '[object String]') {
          trackFieldDependency(this.typeSchema.name, selectionOrFieldName);

          for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            rest[_key - 1] = arguments[_key];
          }

          selection = this.field.apply(this, [selectionOrFieldName].concat(rest));
        } else {
          if (Field.prototype.isPrototypeOf(selectionOrFieldName)) {
            trackFieldDependency(this.typeSchema.name, selectionOrFieldName.name);
          }

          selection = selectionOrFieldName;
        }

        if (selection.responseKey && this.hasSelectionWithResponseKey(selection.responseKey)) {
          throw new Error('The field name or alias \'' + selection.responseKey + '\' has already been added.');
        }
        this.selections.push(selection);
      }
    }, {
      key: 'field',
      value: function field(name) {
        for (var _len2 = arguments.length, creationArgs = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          creationArgs[_key2 - 1] = arguments[_key2];
        }

        var parsedArgs = parseFieldCreationArgs(creationArgs);
        var options = parsedArgs.options,
            callback = parsedArgs.callback;
        var selectionSet = parsedArgs.selectionSet;

        if (!selectionSet) {
          if (!this.typeSchema.fieldBaseTypes[name]) {
            throw new Error('No field of name "' + name + '" found on type "' + this.typeSchema.name + '" in schema');
          }

          var fieldBaseType = schemaForType(this.typeBundle, this.typeSchema.fieldBaseTypes[name]);

          selectionSet = new SelectionSet(this.typeBundle, fieldBaseType, callback);
        }

        return new Field(name, options, selectionSet);
      }

      /**
       * Creates an inline fragment.
       *
       * @access private
       * @param {String} typeName The type  the inline fragment.
       * @param {Function|SelectionSet}  [callbackOrSelectionSet] Either a callback which will be used to create a new {@link SelectionSet}, or an existing {@link SelectionSet}.
       * @return {InlineFragment} An inline fragment.
       */

    }, {
      key: 'inlineFragmentOn',
      value: function inlineFragmentOn(typeName) {
        var builderFunctionOrSelectionSet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

        var selectionSet = void 0;

        if (SelectionSet.prototype.isPrototypeOf(builderFunctionOrSelectionSet)) {
          selectionSet = builderFunctionOrSelectionSet;
        } else {
          selectionSet = new SelectionSet(this.typeBundle, schemaForType(this.typeBundle, typeName), builderFunctionOrSelectionSet);
        }

        return new InlineFragment(typeName, selectionSet);
      }

      /**
       * Adds a field to be queried on the current selection.
       *
       * @access private
       * @param {String}    name The name of the field to add to the query.
       * @param {Object} [options] Options on the query including:
       *   @param {Object} [options.args] Arguments on the query (e.g. `{id: '123456'}`).
       *   @param {String} [options.alias] Alias for the field being added.
       * @param {Function}  [callback] Callback which will be used to create a new {@link SelectionSet} for the field added.
       */

    }, {
      key: 'addField',
      value: function addField(name) {
        for (var _len3 = arguments.length, creationArgs = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          creationArgs[_key3 - 1] = arguments[_key3];
        }

        this.add.apply(this, [name].concat(creationArgs));
      }

      /**
       * Adds a connection to be queried on the current selection.
       * This adds all the fields necessary for pagination.
       *
       * @example
       * client.query((root) => {
       *   root.add('cat', (cat) => {
       *     cat.addConnection('friends', {args: {first: 10}, alias: 'coolCats'}, (friends) => {
       *       friends.add('name');
       *     });
       *   });
       * });
       *
       * @param {String}    name The name of the connection to add to the query.
       * @param {Object} [options] Options on the query including:
       *   @param {Object} [options.args] Arguments on the query (e.g. `{first: 10}`).
       *   @param {String} [options.alias] Alias for the field being added.
       * @param {Function|SelectionSet}  [callbackOrSelectionSet] Either a callback which will be used to create a new {@link SelectionSet}, or an existing {@link SelectionSet}.
       */

    }, {
      key: 'addConnection',
      value: function addConnection(name) {
        for (var _len4 = arguments.length, creationArgs = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          creationArgs[_key4 - 1] = arguments[_key4];
        }

        var _parseFieldCreationAr = parseFieldCreationArgs(creationArgs),
            options = _parseFieldCreationAr.options,
            callback = _parseFieldCreationAr.callback,
            selectionSet = _parseFieldCreationAr.selectionSet;

        this.add(name, options, function (connection) {
          connection.add('pageInfo', {}, function (pageInfo) {
            pageInfo.add('hasNextPage');
            pageInfo.add('hasPreviousPage');
          });
          connection.add('edges', {}, function (edges) {
            edges.add('cursor');
            edges.addField('node', {}, selectionSet || callback); // This is bad. Don't do this
          });
        });
      }

      /**
       * Adds an inline fragment on the current selection.
       *
       * @example
       * client.query((root) => {
       *   root.add('animal', (animal) => {
       *     animal.addInlineFragmentOn('cat', (cat) => {
       *       cat.add('name');
       *     });
       *   });
       * });
       *
       * @param {String} typeName The name of the type of the inline fragment.
       * @param {Function|SelectionSet}  [callbackOrSelectionSet] Either a callback which will be used to create a new {@link SelectionSet}, or an existing {@link SelectionSet}.
       */

    }, {
      key: 'addInlineFragmentOn',
      value: function addInlineFragmentOn(typeName) {
        var fieldTypeCb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

        this.add(this.inlineFragmentOn(typeName, fieldTypeCb));
      }

      /**
       * Adds a fragment spread on the current selection.
       *
       * @example
       * client.query((root) => {
       *   root.addFragment(catFragmentSpread);
       * });
       *
       * @param {FragmentSpread} fragmentSpread The fragment spread to add.
       */

    }, {
      key: 'addFragment',
      value: function addFragment(fragmentSpread) {
        this.add(fragmentSpread);
      }
    }]);
    return SelectionSetBuilder;
  }();

  function parseArgs(args) {
    var name = void 0;
    var variables = void 0;
    var selectionSetCallback = void 0;

    if (args.length === 3) {
      var _args = slicedToArray(args, 3);

      name = _args[0];
      variables = _args[1];
      selectionSetCallback = _args[2];
    } else if (args.length === 2) {
      if (Object.prototype.toString.call(args[0]) === '[object String]') {
        name = args[0];
        variables = null;
      } else if (Array.isArray(args[0])) {
        variables = args[0];
        name = null;
      }

      selectionSetCallback = args[1];
    } else {
      selectionSetCallback = args[0];
      name = null;
    }

    return { name: name, variables: variables, selectionSetCallback: selectionSetCallback };
  }

  var VariableDefinitions = function () {
    function VariableDefinitions(variableDefinitions) {
      classCallCheck(this, VariableDefinitions);

      this.variableDefinitions = variableDefinitions ? [].concat(toConsumableArray(variableDefinitions)) : [];
      Object.freeze(this.variableDefinitions);
      Object.freeze(this);
    }

    createClass(VariableDefinitions, [{
      key: 'toString',
      value: function toString() {
        if (this.variableDefinitions.length === 0) {
          return '';
        }

        return ' (' + join(this.variableDefinitions) + ') ';
      }
    }]);
    return VariableDefinitions;
  }();

  /**
   * Base class for {@link Query} and {@link Mutation}.
   * @abstract
   */

  var Operation = function () {

    /**
     * This constructor should not be invoked. The subclasses {@link Query} and {@link Mutation} should be used instead.
     */
    function Operation(typeBundle, operationType) {
      classCallCheck(this, Operation);

      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      var _parseArgs = parseArgs(args),
          name = _parseArgs.name,
          variables = _parseArgs.variables,
          selectionSetCallback = _parseArgs.selectionSetCallback;

      this.typeBundle = typeBundle;
      this.name = name;
      this.variableDefinitions = new VariableDefinitions(variables);
      this.operationType = operationType;
      if (operationType === 'query') {
        this.selectionSet = new SelectionSet(typeBundle, typeBundle.queryType, selectionSetCallback);
        this.typeSchema = schemaForType(typeBundle, typeBundle.queryType);
      } else {
        this.selectionSet = new SelectionSet(typeBundle, typeBundle.mutationType, selectionSetCallback);
        this.typeSchema = schemaForType(typeBundle, typeBundle.mutationType);
      }
      Object.freeze(this);
    }

    /**
     * Whether the operation is anonymous (i.e. has no name).
     */

    createClass(Operation, [{
      key: 'toString',

      /**
       * Returns the GraphQL query or mutation string (e.g. `query myQuery { cat { name } }`).
       *
       * @return {String} The GraphQL query or mutation string.
       */
      value: function toString() {
        var nameString = this.name ? ' ' + this.name : '';

        return '' + this.operationType + nameString + this.variableDefinitions + this.selectionSet;
      }
    }, {
      key: 'isAnonymous',
      get: function get$$1() {
        return !this.name;
      }
    }]);
    return Operation;
  }();

  /**
   * GraphQL Query class.
   * @extends Operation
   */

  var Query = function (_Operation) {
    inherits(Query, _Operation);

    /**
     * This constructor should not be invoked directly.
     * Use the factory functions {@link Client#query} or {@link Document#addQuery} to create a Query.
     *
     * @param {Object} typeBundle A set of ES6 modules generated by {@link https://github.com/Shopify/graphql-js-schema|graphql-js-schema}.
     * @param {String} [name] A name for the query.
     * @param {Object[]} [variables] A list of variables in the query. See {@link Client#variable}.
     * @param {Function} selectionSetCallback The query builder callback.
     *   A {@link SelectionSet} is created using this callback.
     */
    function Query(typeBundle) {
      var _ref;

      classCallCheck(this, Query);

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return possibleConstructorReturn(this, (_ref = Query.__proto__ || Object.getPrototypeOf(Query)).call.apply(_ref, [this, typeBundle, 'query'].concat(args)));
    }

    return Query;
  }(Operation);

  /**
   * GraphQL Mutation class.
   * @extends Operation
   */

  var Mutation = function (_Operation) {
    inherits(Mutation, _Operation);

    /**
     * This constructor should not be invoked directly.
     * Use the factory functions {@link Client#mutation} or {@link Document#addMutation} to create a Mutation.
     *
     * @param {Object} typeBundle A set of ES6 modules generated by {@link https://github.com/Shopify/graphql-js-schema|graphql-js-schema}.
     * @param {String} [name] A name for the mutation.
     * @param {Object[]} [variables] A list of variables in the mutation. See {@link Client#variable}.
     * @param {Function} selectionSetCallback The mutation builder callback.
     *   A {@link SelectionSet} is created using this callback.
     */
    function Mutation(typeBundle) {
      var _ref;

      classCallCheck(this, Mutation);

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return possibleConstructorReturn(this, (_ref = Mutation.__proto__ || Object.getPrototypeOf(Mutation)).call.apply(_ref, [this, typeBundle, 'mutation'].concat(args)));
    }

    return Mutation;
  }(Operation);

  function isAnonymous(operation) {
    return operation.isAnonymous;
  }

  function hasAnonymousOperations(operations) {
    return operations.some(isAnonymous);
  }

  function hasDuplicateOperationNames(operations) {
    var names = operations.map(function (operation) {
      return operation.name;
    });

    return names.reduce(function (hasDuplicates, name, index) {
      return hasDuplicates || names.indexOf(name) !== index;
    }, false);
  }

  function extractOperation(typeBundle, operationType) {
    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    if (Operation.prototype.isPrototypeOf(args[0])) {
      return args[0];
    }

    if (operationType === 'query') {
      return new (Function.prototype.bind.apply(Query, [null].concat([typeBundle], args)))();
    } else {
      return new (Function.prototype.bind.apply(Mutation, [null].concat([typeBundle], args)))();
    }
  }

  function isInvalidOperationCombination(operations) {
    if (operations.length === 1) {
      return false;
    }

    return hasAnonymousOperations(operations) || hasDuplicateOperationNames(operations);
  }

  function fragmentNameIsNotUnique(existingDefinitions, name) {
    return existingDefinitions.some(function (definition) {
      return definition.name === name;
    });
  }

  var Document = function () {

    /**
     * This constructor should not be invoked directly.
     * Use the factory function {@link Client#document} to create a Document.
     * @param {Object} typeBundle A set of ES6 modules generated by {@link https://github.com/Shopify/graphql-js-schema|graphql-js-schema}.
     */
    function Document(typeBundle) {
      classCallCheck(this, Document);

      this.typeBundle = typeBundle;
      this.definitions = [];
    }

    /**
     * Returns the GraphQL query string for the Document (e.g. `query queryOne { ... } query queryTwo { ... }`).
     *
     * @return {String} The GraphQL query string for the Document.
     */

    createClass(Document, [{
      key: 'toString',
      value: function toString() {
        return join(this.definitions);
      }

      /**
       * Adds an operation to the Document.
       *
       * @private
       * @param {String} operationType The type of the operation. Either 'query' or 'mutation'.
       * @param {(Operation|String)} [query|queryName] Either an instance of an operation
       *   object, or the name of an operation. Both are optional.
       * @param {Object[]} [variables] A list of variables in the operation. See {@link Client#variable}.
       * @param {Function} [callback] The query builder callback. If an operation
       *   instance is passed, this callback will be ignored.
       *   A {@link SelectionSet} is created using this callback.
        */

    }, {
      key: 'addOperation',
      value: function addOperation(operationType) {
        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        var operation = extractOperation.apply(undefined, [this.typeBundle, operationType].concat(args));

        if (isInvalidOperationCombination(this.operations.concat(operation))) {
          throw new Error('All operations must be uniquely named on a multi-operation document');
        }

        this.definitions.push(operation);
      }

      /**
       * Adds a query to the Document.
       *
       * @example
       * document.addQuery('myQuery', (root) => {
       *   root.add('cat', (cat) => {
       *    cat.add('name');
       *   });
       * });
       *
       * @param {(Query|String)} [query|queryName] Either an instance of a query
       *   object, or the name of a query. Both are optional.
       * @param {Object[]} [variables] A list of variables in the query. See {@link Client#variable}.
       * @param {Function} [callback] The query builder callback. If a query
       *   instance is passed, this callback will be ignored.
       *   A {@link SelectionSet} is created using this callback.
       */

    }, {
      key: 'addQuery',
      value: function addQuery() {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        this.addOperation.apply(this, ['query'].concat(args));
      }

      /**
       * Adds a mutation to the Document.
       *
       * @example
       * const input = client.variable('input', 'CatCreateInput!');
       *
       * document.addMutation('myMutation', [input], (root) => {
       *   root.add('catCreate', {args: {input}}, (catCreate) => {
       *     catCreate.add('cat', (cat) => {
       *       cat.add('name');
       *     });
       *   });
       * });
       *
       * @param {(Mutation|String)} [mutation|mutationName] Either an instance of a mutation
       *   object, or the name of a mutation. Both are optional.
       * @param {Object[]} [variables] A list of variables in the mutation. See {@link Client#variable}.
       * @param {Function} [callback] The mutation builder callback. If a mutation
       *   instance is passed, this callback will be ignored.
       *   A {@link SelectionSet} is created using this callback.
       */

    }, {
      key: 'addMutation',
      value: function addMutation() {
        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }

        this.addOperation.apply(this, ['mutation'].concat(args));
      }

      /**
       * Defines a fragment on the Document.
       *
       * @param {String} name The name of the fragment.
       * @param {String} onType The type the fragment is on.
       * @param {Function} [builderFunction] The query builder callback.
       *   A {@link SelectionSet} is created using this callback.
       * @return {FragmentSpread} A {@link FragmentSpread} to be used with {@link SelectionSetBuilder#addFragment}.
       */

    }, {
      key: 'defineFragment',
      value: function defineFragment(name, onType, builderFunction) {
        if (fragmentNameIsNotUnique(this.fragmentDefinitions, name)) {
          throw new Error('All fragments must be uniquely named on a multi-fragment document');
        }

        var selectionSet = new SelectionSet(this.typeBundle, onType, builderFunction);
        var fragment = new FragmentDefinition(name, onType, selectionSet);

        this.definitions.push(fragment);

        return fragment.spread;
      }

      /**
       * All operations ({@link Query} and {@link Mutation}) on the Document.
       */

    }, {
      key: 'operations',
      get: function get$$1() {
        return this.definitions.filter(function (definition) {
          return Operation.prototype.isPrototypeOf(definition);
        });
      }

      /**
       * All {@link FragmentDefinition}s on the Document.
       */

    }, {
      key: 'fragmentDefinitions',
      get: function get$$1() {
        return this.definitions.filter(function (definition) {
          return FragmentDefinition.prototype.isPrototypeOf(definition);
        });
      }
    }]);
    return Document;
  }();

  /**
   * The base class used when deserializing response data.
   * Provides rich features, like functions to generate queries to refetch a node or fetch the next page.
   *
   * @class
   */
  var GraphModel =

  /**
   * @param {Object} attrs Attributes on the GraphModel.
   */
  function GraphModel(attrs) {
    var _this = this;

    classCallCheck(this, GraphModel);

    Object.defineProperty(this, 'attrs', { value: attrs, enumerable: false });

    Object.keys(this.attrs).filter(function (key) {
      return !(key in _this);
    }).forEach(function (key) {
      var descriptor = void 0;

      if (attrs[key] === null) {
        descriptor = {
          enumerable: true,
          get: function get$$1() {
            return null;
          }
        };
      } else {
        descriptor = {
          enumerable: true,
          get: function get$$1() {
            return this.attrs[key].valueOf();
          }
        };
      }
      Object.defineProperty(_this, key, descriptor);
    });
  };

  /**
   * A registry of classes used to deserialize the response data. Uses {@link GraphModel} by default.
   */

  var ClassRegistry = function () {
    function ClassRegistry() {
      classCallCheck(this, ClassRegistry);

      this.classStore = {};
    }

    /**
     * Registers a class for a GraphQL type in the registry.
     *
     * @param {Class} constructor The constructor of the class.
     * @param {String} type The GraphQL type of the object to deserialize into the class.
     */

    createClass(ClassRegistry, [{
      key: 'registerClassForType',
      value: function registerClassForType(constructor, type) {
        this.classStore[type] = constructor;
      }

      /**
       * Unregisters a class for a GraphQL type in the registry.
       *
       * @param {String} type The GraphQL type to unregister.
       */

    }, {
      key: 'unregisterClassForType',
      value: function unregisterClassForType(type) {
        delete this.classStore[type];
      }

      /**
       * Returns the class for the given GraphQL type.
       *
       * @param {String} type The GraphQL type to look up.
       * @return {Class|GraphModel} The class for the given GraphQL type. Defaults to {@link GraphModel} if no class is registered for the GraphQL type.
       */

    }, {
      key: 'classForType',
      value: function classForType(type) {
        return this.classStore[type] || GraphModel;
      }
    }]);
    return ClassRegistry;
  }();

  function isValue(arg) {
    return Object.prototype.toString.call(arg) !== '[object Null]' && Object.prototype.toString.call(arg) !== '[object Undefined]';
  }

  function isNodeContext(context) {
    return context.selection.selectionSet.typeSchema.implementsNode;
  }

  function isConnection(context) {
    return context.selection.selectionSet.typeSchema.name.endsWith('Connection');
  }

  function nearestNode(context) {
    if (context == null) {
      return null;
    } else if (isNodeContext(context)) {
      return context;
    } else {
      return nearestNode(context.parent);
    }
  }

  function contextsFromRoot(context) {
    if (context.parent) {
      return contextsFromRoot(context.parent).concat(context);
    } else {
      return [context];
    }
  }

  function contextsFromNearestNode(context) {
    if (context.selection.selectionSet.typeSchema.implementsNode) {
      return [context];
    } else {
      return contextsFromNearestNode(context.parent).concat(context);
    }
  }

  function initializeDocumentAndVars(currentContext, contextChain) {
    var lastInChain = contextChain[contextChain.length - 1];
    var first = lastInChain.selection.args.first;
    var variableDefinitions = Object.keys(lastInChain.selection.args).filter(function (key) {
      return isVariable(lastInChain.selection.args[key]);
    }).map(function (key) {
      return lastInChain.selection.args[key];
    });

    var firstVar = variableDefinitions.find(function (definition) {
      return definition.name === 'first';
    });

    if (!firstVar) {
      if (isVariable(first)) {
        firstVar = first;
      } else {
        firstVar = variable('first', 'Int', first);
        variableDefinitions.push(firstVar);
      }
    }

    var document = new Document(currentContext.selection.selectionSet.typeBundle);

    return [document, variableDefinitions, firstVar];
  }

  function addNextFieldTo(currentSelection, contextChain, path, cursor) {
    // There are always at least two. When we start, it's the root context, and the first set
    var nextContext = contextChain.shift();

    path.push(nextContext.selection.responseKey);

    if (contextChain.length) {
      currentSelection.add(nextContext.selection.name, { alias: nextContext.selection.alias, args: nextContext.selection.args }, function (newSelection) {
        addNextFieldTo(newSelection, contextChain, path, cursor);
      });
    } else {
      var edgesField = nextContext.selection.selectionSet.selections.find(function (field) {
        return field.name === 'edges';
      });
      var nodeField = edgesField.selectionSet.selections.find(function (field) {
        return field.name === 'node';
      });
      var first = void 0;

      if (isVariable(nextContext.selection.args.first)) {
        first = nextContext.selection.args.first;
      } else {
        first = variable('first', 'Int', nextContext.selection.args.first);
      }

      var options = {
        alias: nextContext.selection.alias,
        args: Object.assign({}, nextContext.selection.args, { after: cursor, first: first })
      };

      currentSelection.addConnection(nextContext.selection.name, options, nodeField.selectionSet);
    }
  }

  function collectFragments(selections) {
    return selections.reduce(function (fragmentDefinitions, field) {
      if (FragmentSpread.prototype.isPrototypeOf(field)) {
        fragmentDefinitions.push(field.toDefinition());
      }

      fragmentDefinitions.push.apply(fragmentDefinitions, toConsumableArray(collectFragments(field.selectionSet.selections)));

      return fragmentDefinitions;
    }, []);
  }

  function nextPageQueryAndPath(context, cursor) {
    var nearestNodeContext = nearestNode(context);

    if (nearestNodeContext) {
      return function () {
        var _document$definitions;

        var path = [];
        var nodeType = nearestNodeContext.selection.selectionSet.typeSchema;
        var nodeId = nearestNodeContext.responseData.id;
        var contextChain = contextsFromNearestNode(context);

        var _initializeDocumentAn = initializeDocumentAndVars(context, contextChain),
            _initializeDocumentAn2 = slicedToArray(_initializeDocumentAn, 2),
            document = _initializeDocumentAn2[0],
            variableDefinitions = _initializeDocumentAn2[1];

        document.addQuery(variableDefinitions, function (root) {
          path.push('node');
          root.add('node', { args: { id: nodeId } }, function (node) {
            node.addInlineFragmentOn(nodeType.name, function (fragment) {
              addNextFieldTo(fragment, contextChain.slice(1), path, cursor);
            });
          });
        });

        var fragments = collectFragments(document.operations[0].selectionSet.selections);

        (_document$definitions = document.definitions).unshift.apply(_document$definitions, toConsumableArray(fragments));

        return [document, path];
      };
    } else {
      return function () {
        var _document$definitions2;

        var path = [];
        var contextChain = contextsFromRoot(context);

        var _initializeDocumentAn3 = initializeDocumentAndVars(context, contextChain),
            _initializeDocumentAn4 = slicedToArray(_initializeDocumentAn3, 2),
            document = _initializeDocumentAn4[0],
            variableDefinitions = _initializeDocumentAn4[1];

        document.addQuery(variableDefinitions, function (root) {
          addNextFieldTo(root, contextChain.slice(1), path, cursor);
        });

        var fragments = collectFragments(document.operations[0].selectionSet.selections);

        (_document$definitions2 = document.definitions).unshift.apply(_document$definitions2, toConsumableArray(fragments));

        return [document, path];
      };
    }
  }

  function hasNextPage$1(connection, edge) {
    if (edge !== connection.edges[connection.edges.length - 1]) {
      return new Scalar(true);
    }

    return connection.pageInfo.hasNextPage;
  }

  function hasPreviousPage(connection, edge) {
    if (edge !== connection.edges[0]) {
      return new Scalar(true);
    }

    return connection.pageInfo.hasPreviousPage;
  }

  function transformConnections(variableValues) {
    return function (context, value) {
      if (isConnection(context)) {
        if (!(value.pageInfo && value.pageInfo.hasOwnProperty('hasNextPage') && value.pageInfo.hasOwnProperty('hasPreviousPage'))) {
          throw new Error('Connections must include the selections "pageInfo { hasNextPage, hasPreviousPage }".');
        }

        return value.edges.map(function (edge) {
          return Object.assign(edge.node, {
            nextPageQueryAndPath: nextPageQueryAndPath(context, edge.cursor),
            hasNextPage: hasNextPage$1(value, edge),
            hasPreviousPage: hasPreviousPage(value, edge),
            variableValues: variableValues
          });
        });
      } else {
        return value;
      }
    };
  }

  /* eslint-disable no-warning-comments */
  var DecodingContext = function () {
    function DecodingContext(selection, responseData) {
      var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      classCallCheck(this, DecodingContext);

      this.selection = selection;
      this.responseData = responseData;
      this.parent = parent;
      Object.freeze(this);
    }

    createClass(DecodingContext, [{
      key: 'contextForObjectProperty',
      value: function contextForObjectProperty(responseKey) {
        var nestedSelections = this.selection.selectionSet.selectionsByResponseKey[responseKey];
        var nextSelection = nestedSelections && nestedSelections[0];
        var nextContext = void 0;

        // fragment spreads operate inside the current context, so we recurse to get the proper
        // selection set, but retain the current response context
        if (Spread.prototype.isPrototypeOf(nextSelection)) {
          nextContext = new DecodingContext(nextSelection, this.responseData, this.parent);
        } else {
          nextContext = new DecodingContext(nextSelection, this.responseData[responseKey], this);
        }

        if (!nextSelection) {
          throw new Error('Unexpected response key "' + responseKey + '", not found in selection set: ' + this.selection.selectionSet);
        }

        if (Field.prototype.isPrototypeOf(nextSelection)) {
          return nextContext;
        } else {
          return nextContext.contextForObjectProperty(responseKey);
        }
      }
    }, {
      key: 'contextForArrayItem',
      value: function contextForArrayItem(item) {
        return new DecodingContext(this.selection, item, this.parent);
      }
    }]);
    return DecodingContext;
  }();

  function decodeArrayItems(context, transformers) {
    return context.responseData.map(function (item) {
      return decodeContext(context.contextForArrayItem(item), transformers);
    });
  }

  function decodeObjectValues(context, transformers) {
    return Object.keys(context.responseData).reduce(function (acc, responseKey) {
      acc[responseKey] = decodeContext(context.contextForObjectProperty(responseKey), transformers);

      return acc;
    }, {});
  }

  function runTransformers(transformers, context, value) {
    return transformers.reduce(function (acc, transformer) {
      return transformer(context, acc);
    }, value);
  }

  function decodeContext(context, transformers) {
    var value = context.responseData;

    if (Array.isArray(value)) {
      value = decodeArrayItems(context, transformers);
    } else if (isObject(value)) {
      value = decodeObjectValues(context, transformers);
    }

    return runTransformers(transformers, context, value);
  }

  function generateRefetchQueries(context, value) {
    if (isValue(value) && isNodeContext(context)) {
      value.refetchQuery = function () {
        return new Query(context.selection.selectionSet.typeBundle, function (root) {
          root.add('node', { args: { id: context.responseData.id } }, function (node) {
            node.addInlineFragmentOn(context.selection.selectionSet.typeSchema.name, context.selection.selectionSet);
          });
        });
      };
    }

    return value;
  }

  function transformPojosToClassesWithRegistry(classRegistry) {
    return function transformPojosToClasses(context, value) {
      if (isObject(value)) {
        var Klass = classRegistry.classForType(context.selection.selectionSet.typeSchema.name);

        return new Klass(value);
      } else {
        return value;
      }
    };
  }

  function transformScalars(context, value) {
    if (isValue(value)) {
      if (context.selection.selectionSet.typeSchema.kind === 'SCALAR') {
        return new Scalar(value);
      } else if (context.selection.selectionSet.typeSchema.kind === 'ENUM') {
        return new Enum(value);
      }
    }

    return value;
  }

  function recordTypeInformation(context, value) {
    var _context$selection$se = context.selection.selectionSet,
        typeBundle = _context$selection$se.typeBundle,
        typeSchema = _context$selection$se.typeSchema;

    if (isValue(value)) {
      if (value.__typename) {
        value.type = schemaForType(typeBundle, value.__typename, typeSchema);
      } else {
        value.type = typeSchema;
      }
    }

    return value;
  }

  function defaultTransformers(_ref) {
    var _ref$classRegistry = _ref.classRegistry,
        classRegistry = _ref$classRegistry === undefined ? new ClassRegistry() : _ref$classRegistry,
        variableValues = _ref.variableValues;

    return [transformScalars, generateRefetchQueries, transformConnections(variableValues), recordTypeInformation, transformPojosToClassesWithRegistry(classRegistry)];
  }

  /**
   * A function used to decode the response data.
   *
   * @function decode
   * @param {SelectionSet} selection The selection set used to query the response data.
   * @param {Object} responseData The response data returned.
   * @param {Object} [options] Options to use when decoding including:
   *   @param {ClassRegistry} [options.classRegistry] A class registry to use when deserializing the data into classes.
   * @return {GraphModel} The decoded response data.
   */
  function decode(selection, responseData) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var transformers = options.transformers || defaultTransformers(options);
    var context = new DecodingContext(selection, responseData);

    return decodeContext(context, transformers);
  }

  function httpFetcher(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return function fetcher(graphQLParams, headers) {
      return fetch(url, _extends({
        body: JSON.stringify(graphQLParams),
        method: 'POST',
        mode: 'cors'
      }, options, {
        headers: _extends({
          'Content-Type': 'application/json',
          Accept: 'application/json'
        }, options.headers, headers)
      })).then(function (response) {
        var contentType = response.headers.get('content-type');

        if (contentType.indexOf('application/json') > -1) {
          return response.json();
        }

        return response.text().then(function (text) {
          return { text: text };
        });
      });
    };
  }

  function hasNextPage(paginatedModels) {
    return paginatedModels && paginatedModels.length && paginatedModels[paginatedModels.length - 1].hasNextPage;
  }

  /**
   * The Client class used to create and send GraphQL documents, fragments, queries and mutations.
   */

  var Client$2 = function () {

    /**
     * @param {Object} typeBundle A set of ES6 modules generated by {@link https://github.com/Shopify/graphql-js-schema|graphql-js-schema}.
     * @param {Object} options An options object. Must include either `url` and optional `fetcherOptions` OR a `fetcher` function.
     *   @param {(String|Function)} options.url|fetcher Either the URL of the GraphQL API endpoint, or a custom fetcher function for further customization.
     *   @param {Object} [options.fetcherOptions] Additional options to use with `fetch`, like headers. Do not specify this argument if `fetcher` is specified.
     *   @param {ClassRegistry} [options.registry=new ClassRegistry()] A {@link ClassRegistry} used to decode the response data.
     */
    function Client(typeBundle, _ref) {
      var url = _ref.url,
          fetcherOptions = _ref.fetcherOptions,
          fetcher = _ref.fetcher,
          _ref$registry = _ref.registry,
          registry = _ref$registry === undefined ? new ClassRegistry() : _ref$registry;
      classCallCheck(this, Client);

      this.typeBundle = typeBundle;
      this.classRegistry = registry;

      if (url && fetcher) {
        throw new Error('Arguments not supported: supply either `url` and optional `fetcherOptions` OR use a `fetcher` function for further customization.');
      }

      if (url) {
        this.fetcher = httpFetcher(url, fetcherOptions);
      } else if (fetcher) {
        if (fetcherOptions) {
          throw new Error('Arguments not supported: when specifying your own `fetcher`, set options through it and not with `fetcherOptions`');
        }

        this.fetcher = fetcher;
      } else {
        throw new Error('Invalid arguments: one of `url` or `fetcher` is needed.');
      }
    }

    /**
     * Creates a GraphQL document.
     *
     * @example
     * const document = client.document();
     *
     * @return {Document} A GraphQL document.
     */

    createClass(Client, [{
      key: 'document',
      value: function document() {
        return new Document(this.typeBundle);
      }

      /**
       * Creates a GraphQL query.
       *
       * @example
       * const query = client.query('myQuery', (root) => {
       *   root.add('cat', (cat) => {
       *    cat.add('name');
       *   });
       * });
       *
       * @param {String} [name] A name for the query.
       * @param {VariableDefinition[]} [variables] A list of variables in the query. See {@link Client#variable}.
       * @param {Function} selectionSetCallback The query builder callback.
       *   A {@link SelectionSet} is created using this callback.
       * @return {Query} A GraphQL query.
       */

    }, {
      key: 'query',
      value: function query() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return new (Function.prototype.bind.apply(Query, [null].concat([this.typeBundle], args)))();
      }

      /**
       * Creates a GraphQL mutation.
       *
       * @example
       * const input = client.variable('input', 'CatCreateInput!');
       *
       * const mutation = client.mutation('myMutation', [input], (root) => {
       *   root.add('catCreate', {args: {input}}, (catCreate) => {
       *     catCreate.add('cat', (cat) => {
       *       cat.add('name');
       *     });
       *   });
       * });
       *
       * @param {String} [name] A name for the mutation.
       * @param {VariableDefinition[]} [variables] A list of variables in the mutation. See {@link Client#variable}.
       * @param {Function} selectionSetCallback The mutation builder callback.
       *   A {@link SelectionSet} is created using this callback.
       * @return {Mutation} A GraphQL mutation.
       */

    }, {
      key: 'mutation',
      value: function mutation() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return new (Function.prototype.bind.apply(Mutation, [null].concat([this.typeBundle], args)))();
      }

      /**
       * Sends a GraphQL operation (query or mutation) or a document.
       *
       * @example
       * client.send(query, {id: '12345'}).then((result) => {
       *   // Do something with the returned result
       *   console.log(result);
       * });
       *
       * @param {(Query|Mutation|Document|Function)} request The operation or document to send. If represented
       * as a function, it must return `Query`, `Mutation`, or `Document` and recieve the client as the only param.
       * @param {Object} [variableValues] The values for variables in the operation or document.
       * @param {Object} [otherProperties] Other properties to send with the query. For example, a custom operation name.
       * @param {Object} [headers] Additional headers to be applied on a request by request basis.
       * @return {Promise.<Object>} A promise resolving to an object containing the response data.
       */

    }, {
      key: 'send',
      value: function send(request) {
        var variableValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        var _this = this;

        var otherProperties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

        var operationOrDocument = void 0;

        if (Function.prototype.isPrototypeOf(request)) {
          operationOrDocument = request(this);
        } else {
          operationOrDocument = request;
        }

        var graphQLParams = { query: operationOrDocument.toString() };

        if (variableValues) {
          graphQLParams.variables = variableValues;
        }

        Object.assign(graphQLParams, otherProperties);

        var operation = void 0;

        if (Operation.prototype.isPrototypeOf(operationOrDocument)) {
          operation = operationOrDocument;
        } else {
          var document = operationOrDocument;

          if (document.operations.length === 1) {
            operation = document.operations[0];
          } else if (otherProperties.operationName) {
            operation = document.operations.find(function (documentOperation) {
              return documentOperation.name === otherProperties.operationName;
            });
          } else {
            throw new Error('\n          A document must contain exactly one operation, or an operationName\n          must be specified. Example:\n\n            client.send(document, null, {operationName: \'myFancyQuery\'});\n        ');
          }
        }

        return this.fetcher(graphQLParams, headers).then(function (response) {
          if (response.data) {
            response.model = decode(operation, response.data, {
              classRegistry: _this.classRegistry,
              variableValues: variableValues
            });
          }

          return response;
        });
      }

      /**
       * Fetches the next page of a paginated node or array of nodes.
       *
       * @example
       * client.fetchNextPage(node, {first: 10}).then((result) => {
       *   // Do something with the next page
       *   console.log(result);
       * });
       *
       * @param {(GraphModel|GraphModel[])} nodeOrNodes The node or list of nodes on which to fetch the next page.
       * @param {Object} [options] Options object containing:
       *   @param {Integer} [options.first] The number of nodes to query on the next page. Defaults to the page size of the previous query.
       * @return {Promise.<GraphModel[]>} A promise resolving with the next page of {@link GraphModel}s.
       */

    }, {
      key: 'fetchNextPage',
      value: function fetchNextPage(nodeOrNodes, options) {
        var node = void 0;

        if (Array.isArray(nodeOrNodes)) {
          node = nodeOrNodes[nodeOrNodes.length - 1];
        } else {
          node = nodeOrNodes;
        }

        var _node$nextPageQueryAn = node.nextPageQueryAndPath(),
            _node$nextPageQueryAn2 = slicedToArray(_node$nextPageQueryAn, 2),
            query = _node$nextPageQueryAn2[0],
            path = _node$nextPageQueryAn2[1];

        var variableValues = void 0;

        if (node.variableValues || options) {
          variableValues = Object.assign({}, node.variableValues, options);
        }

        return this.send(query, variableValues).then(function (response) {
          response.model = path.reduce(function (object, key) {
            return object[key];
          }, response.model);

          return response;
        });
      }

      /**
       * Fetches all subsequent pages of a paginated array of nodes.
       *
       * @example
       * client.fetchAllPages(nodes, {pageSize: 20}).then((result) => {
       *   // Do something with all the models
       *   console.log(result);
       * });
       *
       * @param {GraphModel[]} paginatedModels The list of nodes on which to fetch all pages.
       * @param {Object} options Options object containing:
       *   @param {Integer} options.pageSize The number of nodes to query on each page.
       * @return {Promise.<GraphModel[]>} A promise resolving with all pages of {@link GraphModel}s, including the original list.
       */

    }, {
      key: 'fetchAllPages',
      value: function fetchAllPages(paginatedModels, _ref2) {
        var _this2 = this;

        var pageSize = _ref2.pageSize;

        if (hasNextPage(paginatedModels)) {
          return this.fetchNextPage(paginatedModels, { first: pageSize }).then(function (_ref3) {
            var model = _ref3.model;

            var pages = paginatedModels.concat(model);

            return _this2.fetchAllPages(pages, { pageSize: pageSize });
          });
        }

        return Promise.resolve(paginatedModels);
      }

      /**
       * Refetches a {@link GraphModel} whose type implements `Node`.
       *
       * @example
       * client.refetch(node).then((result) => {
       *   // Do something with the refetched node
       *   console.log(result);
       * });
       *
       * @param {GraphModel} nodeType A {@link GraphModel} whose type implements `Node`.
       * @return {Promise.<GraphModel>} The refetched {@link GraphModel}.
       */

    }, {
      key: 'refetch',
      value: function refetch(nodeType) {
        if (!nodeType) {
          throw new Error('\'client#refetch\' must be called with a non-null instance of a Node.');
        } else if (!nodeType.type.implementsNode) {
          throw new Error('\'client#refetch\' must be called with a type that implements Node. Received ' + nodeType.type.name + '.');
        }

        return this.send(nodeType.refetchQuery()).then(function (_ref4) {
          var model = _ref4.model;
          return model.node;
        });
      }

      /**
       * Creates a variable to be used in a {@link Query} or {@link Mutation}.
       *
       * @example
       * const idVariable = client.variable('id', 'ID!', '12345');
       *
       * @param {String} name The name of the variable.
       * @param {String} type The GraphQL type of the variable.
       * @param {*} [defaultValue] The default value of the variable.
       * @return {VariableDefinition} A variable object that can be used in a {@link Query} or {@link Mutation}.
       */

    }, {
      key: 'variable',
      value: function variable$$1(name, type, defaultValue) {
        return variable(name, type, defaultValue);
      }

      /**
       * Creates an enum to be used in a {@link Query} or {@link Mutation}.
       *
       * @example
       * const titleEnum = client.enum('TITLE');
       *
       * @param {String} key The key of the enum.
       * @return {Enum} An enum object that can be used in a {@link Query} or {@link Mutation}.
       */

    }, {
      key: 'enum',
      value: function _enum(key) {
        return enumFunction(key);
      }
    }]);
    return Client;
  }();

  /**
   * The class used to configure the JS Buy SDK Client.
   * @class
   */
  var Config = function () {
    createClass$1(Config, [{
      key: 'requiredProperties',


      /**
       * Properties that must be set on initializations
       * @attribute requiredProperties
       * @default ['storefrontAccessToken', 'domain']
       * @type Array
       * @private
       */
      get: function get$$1() {
        return ['storefrontAccessToken', 'domain'];
      }

      /**
       * Deprecated properties that map directly to required properties
       * @attribute deprecatedProperties
       * @default {'accessToken': 'storefrontAccessToken', 'apiKey': 'storefrontAccessToken'}
       * @type Object
       * @private
       */

    }, {
      key: 'deprecatedProperties',
      get: function get$$1() {
        return {
          accessToken: 'storefrontAccessToken',
          apiKey: 'storefrontAccessToken'
        };
      }

      /**
       * @constructs Config
       * @param {Object} attrs An object specifying the configuration. Requires the following properties:
       *   @param {String} attrs.storefrontAccessToken The {@link https://help.shopify.com/api/reference/storefront_access_token|Storefront access token} for the shop.
       *   @param {String} attrs.domain The `myshopify` domain for the shop (e.g. `graphql.myshopify.com`).
       */

    }]);

    function Config(attrs) {
      var _this = this;

      classCallCheck$1(this, Config);

      Object.keys(this.deprecatedProperties).forEach(function (key) {
        if (!attrs.hasOwnProperty(key)) {
          return;
        }
        // eslint-disable-next-line no-console
        console.warn('[ShopifyBuy] Config property ' + key + ' is deprecated as of v1.0, please use ' + _this.deprecatedProperties[key] + ' instead.');
        attrs[_this.deprecatedProperties[key]] = attrs[key];
      });

      this.requiredProperties.forEach(function (key) {
        if (attrs.hasOwnProperty(key)) {
          _this[key] = attrs[key];
        } else {
          throw new Error('new Config() requires the option \'' + key + '\'');
        }
      });

      if (attrs.hasOwnProperty('apiVersion')) {
        this.apiVersion = attrs.apiVersion;
      } else {
        this.apiVersion = '2023-04';
      }

      if (attrs.hasOwnProperty('source')) {
        this.source = attrs.source;
      }

      if (attrs.hasOwnProperty('language')) {
        this.language = attrs.language;
      }
    }

    return Config;
  }();

  var Resource = function Resource(client) {
    classCallCheck$1(this, Resource);

    this.graphQLClient = client;
  };

  var defaultErrors = [{ message: 'an unknown error has occurred.' }];

  function defaultResolver(path) {
    var keys = path.split('.');

    return function (_ref) {
      var model = _ref.model,
          errors = _ref.errors;

      return new Promise(function (resolve, reject) {
        try {
          var result = keys.reduce(function (ref, key) {
            return ref[key];
          }, model);

          resolve(result);
        } catch (_) {
          if (errors) {
            reject(errors);
          } else {
            reject(defaultErrors);
          }
        }
      });
    };
  }

  function fetchResourcesForProducts(productOrProduct, client) {
    var products = [].concat(productOrProduct);

    return Promise.all(products.reduce(function (promiseAcc, product) {

      // If the graphql query doesn't find a match, skip fetching variants and images.
      if (product === null) {
        return promiseAcc;
      }

      // Fetch the rest of the images and variants for this product
      promiseAcc.push(client.fetchAllPages(product.images, { pageSize: 250 }).then(function (images) {
        product.attrs.images = images;
      }));

      promiseAcc.push(client.fetchAllPages(product.variants, { pageSize: 250 }).then(function (variants) {
        product.attrs.variants = variants;
      }));

      return promiseAcc;
    }, []));
  }

  function paginateProductConnectionsAndResolve(client) {
    return function (products) {
      return fetchResourcesForProducts(products, client).then(function () {
        return products;
      });
    };
  }

  function paginateCollectionsProductConnectionsAndResolve(client) {
    return function (collectionOrCollections) {
      var collections = [].concat(collectionOrCollections);

      return Promise.all(collections.reduce(function (promiseAcc, collection) {
        return promiseAcc.concat(fetchResourcesForProducts(collection.products, client));
      }, [])).then(function () {
        return collectionOrCollections;
      });
    };
  }

  /**
   * @namespace ProductHelpers
   */
  var productHelpers = {

    /**
     * Returns the variant of a product corresponding to the options given.
     *
     * @example
     * const selectedVariant = client.product.helpers.variantForOptions(product, {
     *   size: "Small",
     *   color: "Red"
     * });
     *
     * @memberof ProductHelpers
     * @method variantForOptions
     * @param {GraphModel} product The product to find the variant on. Must include `variants`.
     * @param {Object} options An object containing the options for the variant.
     * @return {GraphModel} The variant corresponding to the options given.
     */
    variantForOptions: function variantForOptions(product, options) {
      return product.variants.find(function (variant) {
        return variant.selectedOptions.every(function (selectedOption) {
          return options[selectedOption.name] === selectedOption.value.valueOf();
        });
      });
    }
  };

  function query(client) {
    var document = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.id = client.variable("id", "ID!");
    spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
      root.add("id");
      root.add("title");
      root.add("price", function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function (image) {
        image.add("id");
        image.add("url", {
          alias: "src"
        });
        image.add("altText");
        image.add("width");
        image.add("height");
      });
      root.add("selectedOptions", function (selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function (unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
      root.add("id");
      root.add("availableForSale");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("descriptionHtml");
      root.add("description");
      root.add("handle");
      root.add("productType");
      root.add("title");
      root.add("vendor");
      root.add("publishedAt");
      root.add("onlineStoreUrl");
      root.add("options", function (options) {
        options.add("name");
        options.add("values");
      });
      root.add("images", {
        args: {
          first: 250
        }
      }, function (images) {
        images.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        images.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.add("id");
            node.add("url", {
              alias: "src"
            });
            node.add("altText");
            node.add("width");
            node.add("height");
          });
        });
      });
      root.add("variants", {
        args: {
          first: 250
        }
      }, function (variants) {
        variants.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        variants.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.addFragment(spreads.VariantFragment);
          });
        });
      });
    });
    document.addQuery([variables.__defaultOperation__.id], function (root) {
      root.add("node", {
        args: {
          id: variables.__defaultOperation__.id
        }
      }, function (node) {
        node.addFragment(spreads.ProductFragment);
      });
    });
    return document;
  }

  function query$1(client) {
    var document = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.ids = client.variable("ids", "[ID!]!");
    spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
      root.add("id");
      root.add("title");
      root.add("price", function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function (image) {
        image.add("id");
        image.add("url", {
          alias: "src"
        });
        image.add("altText");
        image.add("width");
        image.add("height");
      });
      root.add("selectedOptions", function (selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function (unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
      root.add("id");
      root.add("availableForSale");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("descriptionHtml");
      root.add("description");
      root.add("handle");
      root.add("productType");
      root.add("title");
      root.add("vendor");
      root.add("publishedAt");
      root.add("onlineStoreUrl");
      root.add("options", function (options) {
        options.add("name");
        options.add("values");
      });
      root.add("images", {
        args: {
          first: 250
        }
      }, function (images) {
        images.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        images.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.add("id");
            node.add("url", {
              alias: "src"
            });
            node.add("altText");
            node.add("width");
            node.add("height");
          });
        });
      });
      root.add("variants", {
        args: {
          first: 250
        }
      }, function (variants) {
        variants.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        variants.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.addFragment(spreads.VariantFragment);
          });
        });
      });
    });
    document.addQuery([variables.__defaultOperation__.ids], function (root) {
      root.add("nodes", {
        args: {
          ids: variables.__defaultOperation__.ids
        }
      }, function (nodes) {
        nodes.addFragment(spreads.ProductFragment);
      });
    });
    return document;
  }

  function query$2(client) {
    var document = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.first = client.variable("first", "Int!");
    variables.__defaultOperation__.query = client.variable("query", "String");
    variables.__defaultOperation__.sortKey = client.variable("sortKey", "ProductSortKeys");
    variables.__defaultOperation__.reverse = client.variable("reverse", "Boolean");
    spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
      root.add("id");
      root.add("title");
      root.add("price", function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function (image) {
        image.add("id");
        image.add("url", {
          alias: "src"
        });
        image.add("altText");
        image.add("width");
        image.add("height");
      });
      root.add("selectedOptions", function (selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function (unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
      root.add("id");
      root.add("availableForSale");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("descriptionHtml");
      root.add("description");
      root.add("handle");
      root.add("productType");
      root.add("title");
      root.add("vendor");
      root.add("publishedAt");
      root.add("onlineStoreUrl");
      root.add("options", function (options) {
        options.add("name");
        options.add("values");
      });
      root.add("images", {
        args: {
          first: 250
        }
      }, function (images) {
        images.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        images.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.add("id");
            node.add("url", {
              alias: "src"
            });
            node.add("altText");
            node.add("width");
            node.add("height");
          });
        });
      });
      root.add("variants", {
        args: {
          first: 250
        }
      }, function (variants) {
        variants.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        variants.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.addFragment(spreads.VariantFragment);
          });
        });
      });
    });
    document.addQuery([variables.__defaultOperation__.first, variables.__defaultOperation__.query, variables.__defaultOperation__.sortKey, variables.__defaultOperation__.reverse], function (root) {
      root.add("products", {
        args: {
          first: variables.__defaultOperation__.first,
          query: variables.__defaultOperation__.query,
          sortKey: variables.__defaultOperation__.sortKey,
          reverse: variables.__defaultOperation__.reverse
        }
      }, function (products) {
        products.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        products.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.addFragment(spreads.ProductFragment);
          });
        });
      });
    });
    return document;
  }

  function query$3(client) {
    var document = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.handle = client.variable("handle", "String!");
    spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
      root.add("id");
      root.add("title");
      root.add("price", function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function (image) {
        image.add("id");
        image.add("url", {
          alias: "src"
        });
        image.add("altText");
        image.add("width");
        image.add("height");
      });
      root.add("selectedOptions", function (selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function (unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
      root.add("id");
      root.add("availableForSale");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("descriptionHtml");
      root.add("description");
      root.add("handle");
      root.add("productType");
      root.add("title");
      root.add("vendor");
      root.add("publishedAt");
      root.add("onlineStoreUrl");
      root.add("options", function (options) {
        options.add("name");
        options.add("values");
      });
      root.add("images", {
        args: {
          first: 250
        }
      }, function (images) {
        images.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        images.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.add("id");
            node.add("url", {
              alias: "src"
            });
            node.add("altText");
            node.add("width");
            node.add("height");
          });
        });
      });
      root.add("variants", {
        args: {
          first: 250
        }
      }, function (variants) {
        variants.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        variants.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.addFragment(spreads.VariantFragment);
          });
        });
      });
    });
    document.addQuery([variables.__defaultOperation__.handle], function (root) {
      root.add("productByHandle", {
        args: {
          handle: variables.__defaultOperation__.handle
        }
      }, function (productByHandle) {
        productByHandle.addFragment(spreads.ProductFragment);
      });
    });
    return document;
  }

  function query$4(client) {
    var document = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.productId = client.variable("productId", "ID!");
    spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
      root.add("id");
      root.add("title");
      root.add("price", function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function (image) {
        image.add("id");
        image.add("url", {
          alias: "src"
        });
        image.add("altText");
        image.add("width");
        image.add("height");
      });
      root.add("selectedOptions", function (selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function (unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
      root.add("id");
      root.add("availableForSale");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("descriptionHtml");
      root.add("description");
      root.add("handle");
      root.add("productType");
      root.add("title");
      root.add("vendor");
      root.add("publishedAt");
      root.add("onlineStoreUrl");
      root.add("options", function (options) {
        options.add("name");
        options.add("values");
      });
      root.add("images", {
        args: {
          first: 250
        }
      }, function (images) {
        images.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        images.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.add("id");
            node.add("url", {
              alias: "src"
            });
            node.add("altText");
            node.add("width");
            node.add("height");
          });
        });
      });
      root.add("variants", {
        args: {
          first: 250
        }
      }, function (variants) {
        variants.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        variants.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.addFragment(spreads.VariantFragment);
          });
        });
      });
    });
    document.addQuery([variables.__defaultOperation__.productId], function (root) {
      root.add("productRecommendations", {
        args: {
          productId: variables.__defaultOperation__.productId
        }
      }, function (productRecommendations) {
        productRecommendations.addFragment(spreads.ProductFragment);
      });
    });
    return document;
  }

  // GraphQL
  /**
   * The JS Buy SDK product resource
   * @class
   */

  var ProductResource = function (_Resource) {
    inherits$1(ProductResource, _Resource);

    function ProductResource() {
      classCallCheck$1(this, ProductResource);
      return possibleConstructorReturn$1(this, (ProductResource.__proto__ || Object.getPrototypeOf(ProductResource)).apply(this, arguments));
    }

    createClass$1(ProductResource, [{
      key: 'fetchAll',


      /**
       * Fetches all products on the shop.
       *
       * @example
       * client.product.fetchAll().then((products) => {
       *   // Do something with the products
       * });
       *
       * @param {Int} [pageSize] The number of products to fetch per page
       * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the products.
       */
      value: function fetchAll() {
        var first = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;

        return this.graphQLClient.send(query$2, { first: first }).then(defaultResolver('products')).then(paginateProductConnectionsAndResolve(this.graphQLClient));
      }

      /**
       * Fetches a single product by ID on the shop.
       *
       * @example
       * client.product.fetch('Xk9lM2JkNzFmNzIQ4NTIY4ZDFi9DaGVja291dC9lM2JkN==').then((product) => {
       *   // Do something with the product
       * });
       *
       * @param {String} id The id of the product to fetch.
       * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the product.
       */

    }, {
      key: 'fetch',
      value: function fetch(id) {
        return this.graphQLClient.send(query, { id: id }).then(defaultResolver('node')).then(paginateProductConnectionsAndResolve(this.graphQLClient));
      }

      /**
       * Fetches multiple products by ID on the shop.
       *
       * @example
       * const ids = ['Xk9lM2JkNzFmNzIQ4NTIY4ZDFi9DaGVja291dC9lM2JkN==', 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0Lzc4NTc5ODkzODQ='];
       * client.product.fetchMultiple(ids).then((products) => {
       *   // Do something with the products
       * });
       *
       * @param {String[]} ids The ids of the products to fetch
       * @return {Promise|GraphModel[]} A promise resolving with a `GraphModel` of the product.
       */

    }, {
      key: 'fetchMultiple',
      value: function fetchMultiple(ids) {
        return this.graphQLClient.send(query$1, { ids: ids }).then(defaultResolver('nodes')).then(paginateProductConnectionsAndResolve(this.graphQLClient));
      }

      /**
       * Fetches a single product by handle on the shop.
       *
       * @example
       * client.product.fetchByHandle('my-product').then((product) => {
       *   // Do something with the product
       * });
       *
       * @param {String} handle The handle of the product to fetch.
       * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the product.
       */

    }, {
      key: 'fetchByHandle',
      value: function fetchByHandle(handle) {
        return this.graphQLClient.send(query$3, { handle: handle }).then(defaultResolver('productByHandle')).then(paginateProductConnectionsAndResolve(this.graphQLClient));
      }

      /**
       * Fetches all products on the shop that match the query.
       *
       * @example
       * client.product.fetchQuery({first: 20, sortKey: 'CREATED_AT', reverse: true}).then((products) => {
       *   // Do something with the first 10 products sorted by title in ascending order
       * });
       *
       * @param {Object} [args] An object specifying the query data containing zero or more of:
       *   @param {Int} [args.first=20] The relay `first` param. This specifies page size.
       *   @param {String} [args.sortKey=ID] The key to sort results by. Available values are
       *   documented as {@link https://help.shopify.com/api/storefront-api/reference/enum/productsortkeys|Product Sort Keys}.
       *   @param {String} [args.query] A query string. See full documentation {@link https://help.shopify.com/api/storefront-api/reference/object/shop#products|here}
       *   @param {Boolean} [args.reverse] Whether or not to reverse the sort order of the results
       * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the products.
       */

    }, {
      key: 'fetchQuery',
      value: function fetchQuery() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$first = _ref.first,
            first = _ref$first === undefined ? 20 : _ref$first,
            _ref$sortKey = _ref.sortKey,
            sortKey = _ref$sortKey === undefined ? 'ID' : _ref$sortKey,
            query$$1 = _ref.query,
            reverse = _ref.reverse;

        return this.graphQLClient.send(query$2, {
          first: first,
          sortKey: sortKey,
          query: query$$1,
          reverse: reverse
        }).then(defaultResolver('products')).then(paginateProductConnectionsAndResolve(this.graphQLClient));
      }

      /**
       * Find recommended products related to a given productId.
       * To learn more about how recommendations are generated, see https://shopify.dev/themes/product-merchandising/recommendations.
       *
       * @example
       * const productId 'Xk9lM2JkNzFmNzIQ4NTIY4ZDFi9DaGVja291dC9lM2JkN==';
       * client.product.fetchProductRecommendations(productId).then((products) => {
       *   // Do something with the products
       * });
       *
       * @param {String} productId The id of the product to fetch.
       * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the products.
       */

    }, {
      key: 'fetchRecommendations',
      value: function fetchRecommendations(productId) {
        return this.graphQLClient.send(query$4, { productId: productId }).then(defaultResolver('productRecommendations')).then(paginateProductConnectionsAndResolve(this.graphQLClient));
      }
    }, {
      key: 'helpers',
      get: function get$$1() {
        return productHelpers;
      }
    }]);
    return ProductResource;
  }(Resource);

  function query$5(client) {
    var document = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.id = client.variable("id", "ID!");
    spreads.CollectionFragment = document.defineFragment("CollectionFragment", "Collection", function (root) {
      root.add("id");
      root.add("handle");
      root.add("description");
      root.add("descriptionHtml");
      root.add("updatedAt");
      root.add("title");
      root.add("image", function (image) {
        image.add("id");
        image.add("url", {
          alias: "src"
        });
        image.add("altText");
      });
    });
    document.addQuery([variables.__defaultOperation__.id], function (root) {
      root.add("node", {
        args: {
          id: variables.__defaultOperation__.id
        }
      }, function (node) {
        node.addFragment(spreads.CollectionFragment);
      });
    });
    return document;
  }

  function query$6(client) {
    var document = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.id = client.variable("id", "ID!");
    variables.__defaultOperation__.productsFirst = client.variable("productsFirst", "Int!");
    spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
      root.add("id");
      root.add("title");
      root.add("price", function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function (image) {
        image.add("id");
        image.add("url", {
          alias: "src"
        });
        image.add("altText");
        image.add("width");
        image.add("height");
      });
      root.add("selectedOptions", function (selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function (unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.CollectionFragment = document.defineFragment("CollectionFragment", "Collection", function (root) {
      root.add("id");
      root.add("handle");
      root.add("description");
      root.add("descriptionHtml");
      root.add("updatedAt");
      root.add("title");
      root.add("image", function (image) {
        image.add("id");
        image.add("url", {
          alias: "src"
        });
        image.add("altText");
      });
    });
    spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
      root.add("id");
      root.add("availableForSale");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("descriptionHtml");
      root.add("description");
      root.add("handle");
      root.add("productType");
      root.add("title");
      root.add("vendor");
      root.add("publishedAt");
      root.add("onlineStoreUrl");
      root.add("options", function (options) {
        options.add("name");
        options.add("values");
      });
      root.add("images", {
        args: {
          first: 250
        }
      }, function (images) {
        images.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        images.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.add("id");
            node.add("url", {
              alias: "src"
            });
            node.add("altText");
            node.add("width");
            node.add("height");
          });
        });
      });
      root.add("variants", {
        args: {
          first: 250
        }
      }, function (variants) {
        variants.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        variants.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.addFragment(spreads.VariantFragment);
          });
        });
      });
    });
    document.addQuery([variables.__defaultOperation__.id, variables.__defaultOperation__.productsFirst], function (root) {
      root.add("node", {
        args: {
          id: variables.__defaultOperation__.id
        }
      }, function (node) {
        node.addFragment(spreads.CollectionFragment);
        node.addInlineFragmentOn("Collection", function (Collection) {
          Collection.add("products", {
            args: {
              first: variables.__defaultOperation__.productsFirst
            }
          }, function (products) {
            products.add("pageInfo", function (pageInfo) {
              pageInfo.add("hasNextPage");
              pageInfo.add("hasPreviousPage");
            });
            products.add("edges", function (edges) {
              edges.add("cursor");
              edges.add("node", function (node) {
                node.addFragment(spreads.ProductFragment);
              });
            });
          });
        });
      });
    });
    return document;
  }

  function query$7(client) {
    var document = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.first = client.variable("first", "Int!");
    variables.__defaultOperation__.query = client.variable("query", "String");
    variables.__defaultOperation__.sortKey = client.variable("sortKey", "CollectionSortKeys");
    variables.__defaultOperation__.reverse = client.variable("reverse", "Boolean");
    spreads.CollectionFragment = document.defineFragment("CollectionFragment", "Collection", function (root) {
      root.add("id");
      root.add("handle");
      root.add("description");
      root.add("descriptionHtml");
      root.add("updatedAt");
      root.add("title");
      root.add("image", function (image) {
        image.add("id");
        image.add("url", {
          alias: "src"
        });
        image.add("altText");
      });
    });
    document.addQuery([variables.__defaultOperation__.first, variables.__defaultOperation__.query, variables.__defaultOperation__.sortKey, variables.__defaultOperation__.reverse], function (root) {
      root.add("collections", {
        args: {
          first: variables.__defaultOperation__.first,
          query: variables.__defaultOperation__.query,
          sortKey: variables.__defaultOperation__.sortKey,
          reverse: variables.__defaultOperation__.reverse
        }
      }, function (collections) {
        collections.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        collections.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.addFragment(spreads.CollectionFragment);
          });
        });
      });
    });
    return document;
  }

  function query$8(client) {
    var document = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.first = client.variable("first", "Int!");
    variables.__defaultOperation__.query = client.variable("query", "String");
    variables.__defaultOperation__.sortKey = client.variable("sortKey", "CollectionSortKeys");
    variables.__defaultOperation__.reverse = client.variable("reverse", "Boolean");
    variables.__defaultOperation__.productsFirst = client.variable("productsFirst", "Int!");
    spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
      root.add("id");
      root.add("title");
      root.add("price", function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function (image) {
        image.add("id");
        image.add("url", {
          alias: "src"
        });
        image.add("altText");
        image.add("width");
        image.add("height");
      });
      root.add("selectedOptions", function (selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function (unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.CollectionFragment = document.defineFragment("CollectionFragment", "Collection", function (root) {
      root.add("id");
      root.add("handle");
      root.add("description");
      root.add("descriptionHtml");
      root.add("updatedAt");
      root.add("title");
      root.add("image", function (image) {
        image.add("id");
        image.add("url", {
          alias: "src"
        });
        image.add("altText");
      });
    });
    spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
      root.add("id");
      root.add("availableForSale");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("descriptionHtml");
      root.add("description");
      root.add("handle");
      root.add("productType");
      root.add("title");
      root.add("vendor");
      root.add("publishedAt");
      root.add("onlineStoreUrl");
      root.add("options", function (options) {
        options.add("name");
        options.add("values");
      });
      root.add("images", {
        args: {
          first: 250
        }
      }, function (images) {
        images.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        images.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.add("id");
            node.add("url", {
              alias: "src"
            });
            node.add("altText");
            node.add("width");
            node.add("height");
          });
        });
      });
      root.add("variants", {
        args: {
          first: 250
        }
      }, function (variants) {
        variants.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        variants.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.addFragment(spreads.VariantFragment);
          });
        });
      });
    });
    document.addQuery([variables.__defaultOperation__.first, variables.__defaultOperation__.query, variables.__defaultOperation__.sortKey, variables.__defaultOperation__.reverse, variables.__defaultOperation__.productsFirst], function (root) {
      root.add("collections", {
        args: {
          first: variables.__defaultOperation__.first,
          query: variables.__defaultOperation__.query,
          sortKey: variables.__defaultOperation__.sortKey,
          reverse: variables.__defaultOperation__.reverse
        }
      }, function (collections) {
        collections.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        collections.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.addFragment(spreads.CollectionFragment);
            node.add("products", {
              args: {
                first: variables.__defaultOperation__.productsFirst
              }
            }, function (products) {
              products.add("pageInfo", function (pageInfo) {
                pageInfo.add("hasNextPage");
                pageInfo.add("hasPreviousPage");
              });
              products.add("edges", function (edges) {
                edges.add("cursor");
                edges.add("node", function (node) {
                  node.addFragment(spreads.ProductFragment);
                });
              });
            });
          });
        });
      });
    });
    return document;
  }

  function query$9(client) {
    var document = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.handle = client.variable("handle", "String!");
    spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
      root.add("id");
      root.add("title");
      root.add("price", function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function (image) {
        image.add("id");
        image.add("url", {
          alias: "src"
        });
        image.add("altText");
        image.add("width");
        image.add("height");
      });
      root.add("selectedOptions", function (selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function (unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
      root.add("id");
      root.add("availableForSale");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("descriptionHtml");
      root.add("description");
      root.add("handle");
      root.add("productType");
      root.add("title");
      root.add("vendor");
      root.add("publishedAt");
      root.add("onlineStoreUrl");
      root.add("options", function (options) {
        options.add("name");
        options.add("values");
      });
      root.add("images", {
        args: {
          first: 250
        }
      }, function (images) {
        images.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        images.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.add("id");
            node.add("url", {
              alias: "src"
            });
            node.add("altText");
            node.add("width");
            node.add("height");
          });
        });
      });
      root.add("variants", {
        args: {
          first: 250
        }
      }, function (variants) {
        variants.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        variants.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.addFragment(spreads.VariantFragment);
          });
        });
      });
    });
    spreads.CollectionFragment = document.defineFragment("CollectionFragment", "Collection", function (root) {
      root.add("id");
      root.add("handle");
      root.add("description");
      root.add("descriptionHtml");
      root.add("updatedAt");
      root.add("title");
      root.add("image", function (image) {
        image.add("id");
        image.add("url", {
          alias: "src"
        });
        image.add("altText");
      });
    });
    spreads.CollectionsProductsFragment = document.defineFragment("CollectionsProductsFragment", "Collection", function (root) {
      root.add("products", {
        args: {
          first: 20
        }
      }, function (products) {
        products.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        products.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.addFragment(spreads.ProductFragment);
          });
        });
      });
    });
    document.addQuery([variables.__defaultOperation__.handle], function (root) {
      root.add("collectionByHandle", {
        args: {
          handle: variables.__defaultOperation__.handle
        }
      }, function (collectionByHandle) {
        collectionByHandle.addFragment(spreads.CollectionFragment);
        collectionByHandle.addFragment(spreads.CollectionsProductsFragment);
      });
    });
    return document;
  }

  // GraphQL
  /**
   * The JS Buy SDK collection resource
   * @class
   */

  var CollectionResource = function (_Resource) {
    inherits$1(CollectionResource, _Resource);

    function CollectionResource() {
      classCallCheck$1(this, CollectionResource);
      return possibleConstructorReturn$1(this, (CollectionResource.__proto__ || Object.getPrototypeOf(CollectionResource)).apply(this, arguments));
    }

    createClass$1(CollectionResource, [{
      key: 'fetchAll',


      /**
       * Fetches all collections on the shop, not including products.
       * To fetch collections with products use [fetchAllsWithProducts]{@link Client#fetchAllsWithProducts}.
       *
       * @example
       * client.collection.fetchAll().then((collections) => {
       *   // Do something with the collections
       * });
       *
       * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the collections.
       */
      value: function fetchAll() {
        var first = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;

        return this.graphQLClient.send(query$7, { first: first }).then(defaultResolver('collections'));
      }

      /**
       * Fetches all collections on the shop, including products.
       *
       * @example
       * client.collection.fetchAllWithProducts().then((collections) => {
       *   // Do something with the collections
       * });
       *
       * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the collections.
       */

    }, {
      key: 'fetchAllWithProducts',
      value: function fetchAllWithProducts() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$first = _ref.first,
            first = _ref$first === undefined ? 20 : _ref$first,
            _ref$productsFirst = _ref.productsFirst,
            productsFirst = _ref$productsFirst === undefined ? 20 : _ref$productsFirst;

        return this.graphQLClient.send(query$8, { first: first, productsFirst: productsFirst }).then(defaultResolver('collections')).then(paginateCollectionsProductConnectionsAndResolve(this.graphQLClient));
      }

      /**
       * Fetches a single collection by ID on the shop, not including products.
       * To fetch the collection with products use [fetchWithProducts]{@link Client#fetchWithProducts}.
       *
       * @example
       * client.collection.fetch('Xk9lM2JkNzFmNzIQ4NTIY4ZDFiZTUyZTUwNTE2MDNhZjg==').then((collection) => {
       *   // Do something with the collection
       * });
       *
       * @param {String} id The id of the collection to fetch.
       * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the collection.
       */

    }, {
      key: 'fetch',
      value: function fetch(id) {
        return this.graphQLClient.send(query$5, { id: id }).then(defaultResolver('node'));
      }

      /**
       * Fetches a single collection by ID on the shop, including products.
       *
       * @example
       * client.collection.fetchWithProducts('Xk9lM2JkNzFmNzIQ4NTIY4ZDFiZTUyZTUwNTE2MDNhZjg==').then((collection) => {
       *   // Do something with the collection
       * });
       *
       * @param {String} id The id of the collection to fetch.
       * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the collection.
       */

    }, {
      key: 'fetchWithProducts',
      value: function fetchWithProducts(id) {
        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref2$productsFirst = _ref2.productsFirst,
            productsFirst = _ref2$productsFirst === undefined ? 20 : _ref2$productsFirst;

        return this.graphQLClient.send(query$6, { id: id, productsFirst: productsFirst }).then(defaultResolver('node')).then(paginateCollectionsProductConnectionsAndResolve(this.graphQLClient));
      }

      /**
       * Fetches a collection by handle on the shop.
       *
       * @example
       * client.collection.fetchByHandle('my-collection').then((collection) => {
       *   // Do something with the collection
       * });
       *
       * @param {String} handle The handle of the collection to fetch.
       * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the collection.
       */

    }, {
      key: 'fetchByHandle',
      value: function fetchByHandle(handle) {
        return this.graphQLClient.send(query$9, { handle: handle }).then(defaultResolver('collectionByHandle'));
      }

      /**
       * Fetches all collections on the shop that match the query.
       *
       * @example
       * client.collection.fetchQuery({first: 20, sortKey: 'CREATED_AT', reverse: true}).then((collections) => {
       *   // Do something with the first 10 collections sorted by title in ascending order
       * });
       *
       * @param {Object} [args] An object specifying the query data containing zero or more of:
       *   @param {Int} [args.first=20] The relay `first` param. This specifies page size.
       *   @param {String} [args.sortKey=ID] The key to sort results by. Available values are
       *   documented as {@link https://help.shopify.com/api/storefront-api/reference/enum/collectionsortkeys|Collection Sort Keys}.
       *   @param {String} [args.query] A query string. See full documentation {@link https://help.shopify.com/api/storefront-api/reference/object/shop#collections|here}
       *   @param {Boolean} [args.reverse] Whether or not to reverse the sort order of the results
       * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the collections.
       */

    }, {
      key: 'fetchQuery',
      value: function fetchQuery() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref3$first = _ref3.first,
            first = _ref3$first === undefined ? 20 : _ref3$first,
            _ref3$sortKey = _ref3.sortKey,
            sortKey = _ref3$sortKey === undefined ? 'ID' : _ref3$sortKey,
            query = _ref3.query,
            reverse = _ref3.reverse;

        return this.graphQLClient.send(query$7, {
          first: first,
          sortKey: sortKey,
          query: query,
          reverse: reverse
        }).then(defaultResolver('collections'));
      }
    }]);
    return CollectionResource;
  }(Resource);

  function query$10(client) {
    var document = client.document();
    document.addQuery(function (root) {
      root.add("shop", function (shop) {
        shop.add("paymentSettings", function (paymentSettings) {
          paymentSettings.add("enabledPresentmentCurrencies");
        });
        shop.add("description");
        shop.add("moneyFormat");
        shop.add("name");
        shop.add("primaryDomain", function (primaryDomain) {
          primaryDomain.add("host");
          primaryDomain.add("sslEnabled");
          primaryDomain.add("url");
        });
      });
    });
    return document;
  }

  function query$11(client) {
    var document = client.document();
    var spreads = {};
    spreads.PolicyFragment = document.defineFragment("PolicyFragment", "ShopPolicy", function (root) {
      root.add("id");
      root.add("title");
      root.add("url");
      root.add("body");
    });
    document.addQuery(function (root) {
      root.add("shop", function (shop) {
        shop.add("privacyPolicy", function (privacyPolicy) {
          privacyPolicy.addFragment(spreads.PolicyFragment);
        });
        shop.add("termsOfService", function (termsOfService) {
          termsOfService.addFragment(spreads.PolicyFragment);
        });
        shop.add("refundPolicy", function (refundPolicy) {
          refundPolicy.addFragment(spreads.PolicyFragment);
        });
      });
    });
    return document;
  }

  // GraphQL
  /**
   * The JS Buy SDK shop resource
   * @class
   */

  var ShopResource = function (_Resource) {
    inherits$1(ShopResource, _Resource);

    function ShopResource() {
      classCallCheck$1(this, ShopResource);
      return possibleConstructorReturn$1(this, (ShopResource.__proto__ || Object.getPrototypeOf(ShopResource)).apply(this, arguments));
    }

    createClass$1(ShopResource, [{
      key: 'fetchInfo',


      /**
       * Fetches shop information (`currencyCode`, `description`, `moneyFormat`, `name`, and `primaryDomain`).
       * See the {@link https://help.shopify.com/api/storefront-api/reference/object/shop|Storefront API reference} for more information.
       *
       * @example
       * client.shop.fetchInfo().then((shop) => {
       *   // Do something with the shop
       * });
       *
       * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the shop.
       */
      value: function fetchInfo() {
        return this.graphQLClient.send(query$10).then(defaultResolver('shop'));
      }

      /**
       * Fetches shop policies (privacy policy, terms of service and refund policy).
       *
       * @example
       * client.shop.fetchPolicies().then((shop) => {
       *   // Do something with the shop
       * });
       *
       * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the shop.
       */

    }, {
      key: 'fetchPolicies',
      value: function fetchPolicies() {
        return this.graphQLClient.send(query$11).then(defaultResolver('shop'));
      }
    }]);
    return ShopResource;
  }(Resource);

  function handleCheckoutMutation(mutationRootKey, client) {
    return function (_ref) {
      var _ref$data = _ref.data,
          data = _ref$data === undefined ? {} : _ref$data,
          errors = _ref.errors,
          _ref$model = _ref.model,
          model = _ref$model === undefined ? {} : _ref$model;

      var rootData = data[mutationRootKey];
      var rootModel = model[mutationRootKey];

      if (rootData && rootData.checkout) {
        return client.fetchAllPages(rootModel.checkout.lineItems, { pageSize: 250 }).then(function (lineItems) {
          rootModel.checkout.attrs.lineItems = lineItems;
          rootModel.checkout.errors = errors;
          rootModel.checkout.userErrors = rootModel.userErrors;

          return rootModel.checkout;
        });
      }

      if (errors && errors.length) {
        return Promise.reject(new Error(JSON.stringify(errors)));
      }

      if (rootData && rootData.checkoutUserErrors && rootData.checkoutUserErrors.length) {
        return Promise.reject(new Error(JSON.stringify(rootData.checkoutUserErrors)));
      }

      if (rootData && rootData.userErrors && rootData.userErrors.length) {
        return Promise.reject(new Error(JSON.stringify(rootData.userErrors)));
      }

      return Promise.reject(new Error("The " + mutationRootKey + " mutation failed due to an unknown error."));
    };
  }

  function query$12(client) {
    var document = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.id = client.variable("id", "ID!");
    spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
      root.add("id");
      root.add("title");
      root.add("price", function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function (image) {
        image.add("id");
        image.add("url", {
          alias: "src"
        });
        image.add("altText");
        image.add("width");
        image.add("height");
      });
      root.add("selectedOptions", function (selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function (unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
      root.add("targetSelection");
      root.add("allocationMethod");
      root.add("targetType");
      root.add("value", function (value) {
        value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
          MoneyV2.add("amount");
          MoneyV2.add("currencyCode");
        });
        value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
          PricingPercentageValue.add("percentage");
        });
      });
      root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
        ManualDiscountApplication.add("title");
        ManualDiscountApplication.add("description");
      });
      root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
        DiscountCodeApplication.add("code");
        DiscountCodeApplication.add("applicable");
      });
      root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
        ScriptDiscountApplication.add("title");
      });
      root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
        AutomaticDiscountApplication.add("title");
      });
    });
    spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
      root.add("amountUsed", function (amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("amountUsed", {
        alias: "amountUsedV2"
      }, function (amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("balance", function (balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("balance", {
        alias: "balanceV2"
      }, function (balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
        presentmentAmountUsed.add("amount");
        presentmentAmountUsed.add("currencyCode");
      });
      root.add("id");
      root.add("lastCharacters");
    });
    spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
      root.addFragment(spreads.VariantFragment);
      root.add("product", function (product) {
        product.add("id");
        product.add("handle");
      });
    });
    spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
      root.add("id");
      root.add("address1");
      root.add("address2");
      root.add("city");
      root.add("company");
      root.add("country");
      root.add("firstName");
      root.add("formatted");
      root.add("lastName");
      root.add("latitude");
      root.add("longitude");
      root.add("phone");
      root.add("province");
      root.add("zip");
      root.add("name");
      root.add("countryCodeV2", {
        alias: "countryCode"
      });
      root.add("provinceCode");
    });
    spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
      root.add("id");
      root.add("ready");
      root.add("requiresShipping");
      root.add("note");
      root.add("paymentDue", function (paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("paymentDue", {
        alias: "paymentDueV2"
      }, function (paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("webUrl");
      root.add("orderStatusUrl");
      root.add("taxExempt");
      root.add("taxesIncluded");
      root.add("currencyCode");
      root.add("totalTax", function (totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("totalTax", {
        alias: "totalTaxV2"
      }, function (totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
        lineItemsSubtotalPrice.add("amount");
        lineItemsSubtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", function (subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", {
        alias: "subtotalPriceV2"
      }, function (subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("totalPrice", function (totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("totalPrice", {
        alias: "totalPriceV2"
      }, function (totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("completedAt");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("email");
      root.add("discountApplications", {
        args: {
          first: 10
        }
      }, function (discountApplications) {
        discountApplications.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        discountApplications.add("edges", function (edges) {
          edges.add("node", function (node) {
            node.addFragment(spreads.DiscountApplicationFragment);
          });
        });
      });
      root.add("appliedGiftCards", function (appliedGiftCards) {
        appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
      });
      root.add("shippingAddress", function (shippingAddress) {
        shippingAddress.addFragment(spreads.MailingAddressFragment);
      });
      root.add("shippingLine", function (shippingLine) {
        shippingLine.add("handle");
        shippingLine.add("price", function (price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("price", {
          alias: "priceV2"
        }, function (price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("title");
      });
      root.add("customAttributes", function (customAttributes) {
        customAttributes.add("key");
        customAttributes.add("value");
      });
      root.add("order", function (order) {
        order.add("id");
        order.add("processedAt");
        order.add("orderNumber");
        order.add("subtotalPrice", function (subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order.add("subtotalPrice", {
          alias: "subtotalPriceV2"
        }, function (subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order.add("totalShippingPrice", function (totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order.add("totalShippingPrice", {
          alias: "totalShippingPriceV2"
        }, function (totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order.add("totalTax", function (totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order.add("totalTax", {
          alias: "totalTaxV2"
        }, function (totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order.add("totalPrice", function (totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order.add("totalPrice", {
          alias: "totalPriceV2"
        }, function (totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order.add("currencyCode");
        order.add("totalRefunded", function (totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order.add("totalRefunded", {
          alias: "totalRefundedV2"
        }, function (totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order.add("customerUrl");
        order.add("shippingAddress", function (shippingAddress) {
          shippingAddress.addFragment(spreads.MailingAddressFragment);
        });
        order.add("lineItems", {
          args: {
            first: 250
          }
        }, function (lineItems) {
          lineItems.add("pageInfo", function (pageInfo) {
            pageInfo.add("hasNextPage");
            pageInfo.add("hasPreviousPage");
          });
          lineItems.add("edges", function (edges) {
            edges.add("cursor");
            edges.add("node", function (node) {
              node.add("title");
              node.add("variant", function (variant) {
                variant.addFragment(spreads.VariantWithProductFragment);
              });
              node.add("quantity");
              node.add("customAttributes", function (customAttributes) {
                customAttributes.add("key");
                customAttributes.add("value");
              });
            });
          });
        });
      });
      root.add("lineItems", {
        args: {
          first: 250
        }
      }, function (lineItems) {
        lineItems.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        lineItems.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.add("id");
            node.add("title");
            node.add("variant", function (variant) {
              variant.addFragment(spreads.VariantWithProductFragment);
            });
            node.add("quantity");
            node.add("customAttributes", function (customAttributes) {
              customAttributes.add("key");
              customAttributes.add("value");
            });
            node.add("discountAllocations", function (discountAllocations) {
              discountAllocations.add("allocatedAmount", function (allocatedAmount) {
                allocatedAmount.add("amount");
                allocatedAmount.add("currencyCode");
              });
              discountAllocations.add("discountApplication", function (discountApplication) {
                discountApplication.addFragment(spreads.DiscountApplicationFragment);
              });
            });
          });
        });
      });
    });
    document.addQuery([variables.__defaultOperation__.id], function (root) {
      root.add("node", {
        args: {
          id: variables.__defaultOperation__.id
        }
      }, function (node) {
        node.addFragment(spreads.CheckoutFragment);
      });
    });
    return document;
  }

  function query$13(client) {
    var document = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.input = client.variable("input", "CheckoutCreateInput!");
    spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
      root.add("id");
      root.add("title");
      root.add("price", function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function (image) {
        image.add("id");
        image.add("url", {
          alias: "src"
        });
        image.add("altText");
        image.add("width");
        image.add("height");
      });
      root.add("selectedOptions", function (selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function (unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
      root.add("targetSelection");
      root.add("allocationMethod");
      root.add("targetType");
      root.add("value", function (value) {
        value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
          MoneyV2.add("amount");
          MoneyV2.add("currencyCode");
        });
        value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
          PricingPercentageValue.add("percentage");
        });
      });
      root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
        ManualDiscountApplication.add("title");
        ManualDiscountApplication.add("description");
      });
      root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
        DiscountCodeApplication.add("code");
        DiscountCodeApplication.add("applicable");
      });
      root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
        ScriptDiscountApplication.add("title");
      });
      root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
        AutomaticDiscountApplication.add("title");
      });
    });
    spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
      root.add("amountUsed", function (amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("amountUsed", {
        alias: "amountUsedV2"
      }, function (amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("balance", function (balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("balance", {
        alias: "balanceV2"
      }, function (balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
        presentmentAmountUsed.add("amount");
        presentmentAmountUsed.add("currencyCode");
      });
      root.add("id");
      root.add("lastCharacters");
    });
    spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
      root.addFragment(spreads.VariantFragment);
      root.add("product", function (product) {
        product.add("id");
        product.add("handle");
      });
    });
    spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
      root.add("field");
      root.add("message");
    });
    spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
      root.add("field");
      root.add("message");
      root.add("code");
    });
    spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
      root.add("id");
      root.add("address1");
      root.add("address2");
      root.add("city");
      root.add("company");
      root.add("country");
      root.add("firstName");
      root.add("formatted");
      root.add("lastName");
      root.add("latitude");
      root.add("longitude");
      root.add("phone");
      root.add("province");
      root.add("zip");
      root.add("name");
      root.add("countryCodeV2", {
        alias: "countryCode"
      });
      root.add("provinceCode");
    });
    spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
      root.add("id");
      root.add("ready");
      root.add("requiresShipping");
      root.add("note");
      root.add("paymentDue", function (paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("paymentDue", {
        alias: "paymentDueV2"
      }, function (paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("webUrl");
      root.add("orderStatusUrl");
      root.add("taxExempt");
      root.add("taxesIncluded");
      root.add("currencyCode");
      root.add("totalTax", function (totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("totalTax", {
        alias: "totalTaxV2"
      }, function (totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
        lineItemsSubtotalPrice.add("amount");
        lineItemsSubtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", function (subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", {
        alias: "subtotalPriceV2"
      }, function (subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("totalPrice", function (totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("totalPrice", {
        alias: "totalPriceV2"
      }, function (totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("completedAt");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("email");
      root.add("discountApplications", {
        args: {
          first: 10
        }
      }, function (discountApplications) {
        discountApplications.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        discountApplications.add("edges", function (edges) {
          edges.add("node", function (node) {
            node.addFragment(spreads.DiscountApplicationFragment);
          });
        });
      });
      root.add("appliedGiftCards", function (appliedGiftCards) {
        appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
      });
      root.add("shippingAddress", function (shippingAddress) {
        shippingAddress.addFragment(spreads.MailingAddressFragment);
      });
      root.add("shippingLine", function (shippingLine) {
        shippingLine.add("handle");
        shippingLine.add("price", function (price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("price", {
          alias: "priceV2"
        }, function (price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("title");
      });
      root.add("customAttributes", function (customAttributes) {
        customAttributes.add("key");
        customAttributes.add("value");
      });
      root.add("order", function (order) {
        order.add("id");
        order.add("processedAt");
        order.add("orderNumber");
        order.add("subtotalPrice", function (subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order.add("subtotalPrice", {
          alias: "subtotalPriceV2"
        }, function (subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order.add("totalShippingPrice", function (totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order.add("totalShippingPrice", {
          alias: "totalShippingPriceV2"
        }, function (totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order.add("totalTax", function (totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order.add("totalTax", {
          alias: "totalTaxV2"
        }, function (totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order.add("totalPrice", function (totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order.add("totalPrice", {
          alias: "totalPriceV2"
        }, function (totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order.add("currencyCode");
        order.add("totalRefunded", function (totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order.add("totalRefunded", {
          alias: "totalRefundedV2"
        }, function (totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order.add("customerUrl");
        order.add("shippingAddress", function (shippingAddress) {
          shippingAddress.addFragment(spreads.MailingAddressFragment);
        });
        order.add("lineItems", {
          args: {
            first: 250
          }
        }, function (lineItems) {
          lineItems.add("pageInfo", function (pageInfo) {
            pageInfo.add("hasNextPage");
            pageInfo.add("hasPreviousPage");
          });
          lineItems.add("edges", function (edges) {
            edges.add("cursor");
            edges.add("node", function (node) {
              node.add("title");
              node.add("variant", function (variant) {
                variant.addFragment(spreads.VariantWithProductFragment);
              });
              node.add("quantity");
              node.add("customAttributes", function (customAttributes) {
                customAttributes.add("key");
                customAttributes.add("value");
              });
            });
          });
        });
      });
      root.add("lineItems", {
        args: {
          first: 250
        }
      }, function (lineItems) {
        lineItems.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        lineItems.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.add("id");
            node.add("title");
            node.add("variant", function (variant) {
              variant.addFragment(spreads.VariantWithProductFragment);
            });
            node.add("quantity");
            node.add("customAttributes", function (customAttributes) {
              customAttributes.add("key");
              customAttributes.add("value");
            });
            node.add("discountAllocations", function (discountAllocations) {
              discountAllocations.add("allocatedAmount", function (allocatedAmount) {
                allocatedAmount.add("amount");
                allocatedAmount.add("currencyCode");
              });
              discountAllocations.add("discountApplication", function (discountApplication) {
                discountApplication.addFragment(spreads.DiscountApplicationFragment);
              });
            });
          });
        });
      });
    });
    document.addMutation([variables.__defaultOperation__.input], function (root) {
      root.add("checkoutCreate", {
        args: {
          input: variables.__defaultOperation__.input
        }
      }, function (checkoutCreate) {
        checkoutCreate.add("userErrors", function (userErrors) {
          userErrors.addFragment(spreads.UserErrorFragment);
        });
        checkoutCreate.add("checkoutUserErrors", function (checkoutUserErrors) {
          checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
        });
        checkoutCreate.add("checkout", function (checkout) {
          checkout.addFragment(spreads.CheckoutFragment);
        });
      });
    });
    return document;
  }

  function query$14(client) {
    var document = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.checkoutId = client.variable("checkoutId", "ID!");
    variables.__defaultOperation__.lineItems = client.variable("lineItems", "[CheckoutLineItemInput!]!");
    spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
      root.add("id");
      root.add("title");
      root.add("price", function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function (image) {
        image.add("id");
        image.add("url", {
          alias: "src"
        });
        image.add("altText");
        image.add("width");
        image.add("height");
      });
      root.add("selectedOptions", function (selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function (unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
      root.add("targetSelection");
      root.add("allocationMethod");
      root.add("targetType");
      root.add("value", function (value) {
        value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
          MoneyV2.add("amount");
          MoneyV2.add("currencyCode");
        });
        value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
          PricingPercentageValue.add("percentage");
        });
      });
      root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
        ManualDiscountApplication.add("title");
        ManualDiscountApplication.add("description");
      });
      root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
        DiscountCodeApplication.add("code");
        DiscountCodeApplication.add("applicable");
      });
      root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
        ScriptDiscountApplication.add("title");
      });
      root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
        AutomaticDiscountApplication.add("title");
      });
    });
    spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
      root.add("amountUsed", function (amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("amountUsed", {
        alias: "amountUsedV2"
      }, function (amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("balance", function (balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("balance", {
        alias: "balanceV2"
      }, function (balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
        presentmentAmountUsed.add("amount");
        presentmentAmountUsed.add("currencyCode");
      });
      root.add("id");
      root.add("lastCharacters");
    });
    spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
      root.addFragment(spreads.VariantFragment);
      root.add("product", function (product) {
        product.add("id");
        product.add("handle");
      });
    });
    spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
      root.add("field");
      root.add("message");
    });
    spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
      root.add("field");
      root.add("message");
      root.add("code");
    });
    spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
      root.add("id");
      root.add("address1");
      root.add("address2");
      root.add("city");
      root.add("company");
      root.add("country");
      root.add("firstName");
      root.add("formatted");
      root.add("lastName");
      root.add("latitude");
      root.add("longitude");
      root.add("phone");
      root.add("province");
      root.add("zip");
      root.add("name");
      root.add("countryCodeV2", {
        alias: "countryCode"
      });
      root.add("provinceCode");
    });
    spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
      root.add("id");
      root.add("ready");
      root.add("requiresShipping");
      root.add("note");
      root.add("paymentDue", function (paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("paymentDue", {
        alias: "paymentDueV2"
      }, function (paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("webUrl");
      root.add("orderStatusUrl");
      root.add("taxExempt");
      root.add("taxesIncluded");
      root.add("currencyCode");
      root.add("totalTax", function (totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("totalTax", {
        alias: "totalTaxV2"
      }, function (totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
        lineItemsSubtotalPrice.add("amount");
        lineItemsSubtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", function (subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", {
        alias: "subtotalPriceV2"
      }, function (subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("totalPrice", function (totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("totalPrice", {
        alias: "totalPriceV2"
      }, function (totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("completedAt");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("email");
      root.add("discountApplications", {
        args: {
          first: 10
        }
      }, function (discountApplications) {
        discountApplications.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        discountApplications.add("edges", function (edges) {
          edges.add("node", function (node) {
            node.addFragment(spreads.DiscountApplicationFragment);
          });
        });
      });
      root.add("appliedGiftCards", function (appliedGiftCards) {
        appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
      });
      root.add("shippingAddress", function (shippingAddress) {
        shippingAddress.addFragment(spreads.MailingAddressFragment);
      });
      root.add("shippingLine", function (shippingLine) {
        shippingLine.add("handle");
        shippingLine.add("price", function (price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("price", {
          alias: "priceV2"
        }, function (price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("title");
      });
      root.add("customAttributes", function (customAttributes) {
        customAttributes.add("key");
        customAttributes.add("value");
      });
      root.add("order", function (order) {
        order.add("id");
        order.add("processedAt");
        order.add("orderNumber");
        order.add("subtotalPrice", function (subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order.add("subtotalPrice", {
          alias: "subtotalPriceV2"
        }, function (subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order.add("totalShippingPrice", function (totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order.add("totalShippingPrice", {
          alias: "totalShippingPriceV2"
        }, function (totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order.add("totalTax", function (totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order.add("totalTax", {
          alias: "totalTaxV2"
        }, function (totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order.add("totalPrice", function (totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order.add("totalPrice", {
          alias: "totalPriceV2"
        }, function (totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order.add("currencyCode");
        order.add("totalRefunded", function (totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order.add("totalRefunded", {
          alias: "totalRefundedV2"
        }, function (totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order.add("customerUrl");
        order.add("shippingAddress", function (shippingAddress) {
          shippingAddress.addFragment(spreads.MailingAddressFragment);
        });
        order.add("lineItems", {
          args: {
            first: 250
          }
        }, function (lineItems) {
          lineItems.add("pageInfo", function (pageInfo) {
            pageInfo.add("hasNextPage");
            pageInfo.add("hasPreviousPage");
          });
          lineItems.add("edges", function (edges) {
            edges.add("cursor");
            edges.add("node", function (node) {
              node.add("title");
              node.add("variant", function (variant) {
                variant.addFragment(spreads.VariantWithProductFragment);
              });
              node.add("quantity");
              node.add("customAttributes", function (customAttributes) {
                customAttributes.add("key");
                customAttributes.add("value");
              });
            });
          });
        });
      });
      root.add("lineItems", {
        args: {
          first: 250
        }
      }, function (lineItems) {
        lineItems.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        lineItems.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.add("id");
            node.add("title");
            node.add("variant", function (variant) {
              variant.addFragment(spreads.VariantWithProductFragment);
            });
            node.add("quantity");
            node.add("customAttributes", function (customAttributes) {
              customAttributes.add("key");
              customAttributes.add("value");
            });
            node.add("discountAllocations", function (discountAllocations) {
              discountAllocations.add("allocatedAmount", function (allocatedAmount) {
                allocatedAmount.add("amount");
                allocatedAmount.add("currencyCode");
              });
              discountAllocations.add("discountApplication", function (discountApplication) {
                discountApplication.addFragment(spreads.DiscountApplicationFragment);
              });
            });
          });
        });
      });
    });
    document.addMutation([variables.__defaultOperation__.checkoutId, variables.__defaultOperation__.lineItems], function (root) {
      root.add("checkoutLineItemsAdd", {
        args: {
          checkoutId: variables.__defaultOperation__.checkoutId,
          lineItems: variables.__defaultOperation__.lineItems
        }
      }, function (checkoutLineItemsAdd) {
        checkoutLineItemsAdd.add("userErrors", function (userErrors) {
          userErrors.addFragment(spreads.UserErrorFragment);
        });
        checkoutLineItemsAdd.add("checkoutUserErrors", function (checkoutUserErrors) {
          checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
        });
        checkoutLineItemsAdd.add("checkout", function (checkout) {
          checkout.addFragment(spreads.CheckoutFragment);
        });
      });
    });
    return document;
  }

  function query$15(client) {
    var document = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.checkoutId = client.variable("checkoutId", "ID!");
    variables.__defaultOperation__.lineItemIds = client.variable("lineItemIds", "[ID!]!");
    spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
      root.add("id");
      root.add("title");
      root.add("price", function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function (image) {
        image.add("id");
        image.add("url", {
          alias: "src"
        });
        image.add("altText");
        image.add("width");
        image.add("height");
      });
      root.add("selectedOptions", function (selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function (unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
      root.add("targetSelection");
      root.add("allocationMethod");
      root.add("targetType");
      root.add("value", function (value) {
        value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
          MoneyV2.add("amount");
          MoneyV2.add("currencyCode");
        });
        value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
          PricingPercentageValue.add("percentage");
        });
      });
      root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
        ManualDiscountApplication.add("title");
        ManualDiscountApplication.add("description");
      });
      root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
        DiscountCodeApplication.add("code");
        DiscountCodeApplication.add("applicable");
      });
      root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
        ScriptDiscountApplication.add("title");
      });
      root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
        AutomaticDiscountApplication.add("title");
      });
    });
    spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
      root.add("amountUsed", function (amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("amountUsed", {
        alias: "amountUsedV2"
      }, function (amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("balance", function (balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("balance", {
        alias: "balanceV2"
      }, function (balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
        presentmentAmountUsed.add("amount");
        presentmentAmountUsed.add("currencyCode");
      });
      root.add("id");
      root.add("lastCharacters");
    });
    spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
      root.addFragment(spreads.VariantFragment);
      root.add("product", function (product) {
        product.add("id");
        product.add("handle");
      });
    });
    spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
      root.add("field");
      root.add("message");
    });
    spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
      root.add("field");
      root.add("message");
      root.add("code");
    });
    spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
      root.add("id");
      root.add("address1");
      root.add("address2");
      root.add("city");
      root.add("company");
      root.add("country");
      root.add("firstName");
      root.add("formatted");
      root.add("lastName");
      root.add("latitude");
      root.add("longitude");
      root.add("phone");
      root.add("province");
      root.add("zip");
      root.add("name");
      root.add("countryCodeV2", {
        alias: "countryCode"
      });
      root.add("provinceCode");
    });
    spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
      root.add("id");
      root.add("ready");
      root.add("requiresShipping");
      root.add("note");
      root.add("paymentDue", function (paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("paymentDue", {
        alias: "paymentDueV2"
      }, function (paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("webUrl");
      root.add("orderStatusUrl");
      root.add("taxExempt");
      root.add("taxesIncluded");
      root.add("currencyCode");
      root.add("totalTax", function (totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("totalTax", {
        alias: "totalTaxV2"
      }, function (totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
        lineItemsSubtotalPrice.add("amount");
        lineItemsSubtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", function (subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", {
        alias: "subtotalPriceV2"
      }, function (subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("totalPrice", function (totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("totalPrice", {
        alias: "totalPriceV2"
      }, function (totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("completedAt");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("email");
      root.add("discountApplications", {
        args: {
          first: 10
        }
      }, function (discountApplications) {
        discountApplications.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        discountApplications.add("edges", function (edges) {
          edges.add("node", function (node) {
            node.addFragment(spreads.DiscountApplicationFragment);
          });
        });
      });
      root.add("appliedGiftCards", function (appliedGiftCards) {
        appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
      });
      root.add("shippingAddress", function (shippingAddress) {
        shippingAddress.addFragment(spreads.MailingAddressFragment);
      });
      root.add("shippingLine", function (shippingLine) {
        shippingLine.add("handle");
        shippingLine.add("price", function (price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("price", {
          alias: "priceV2"
        }, function (price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("title");
      });
      root.add("customAttributes", function (customAttributes) {
        customAttributes.add("key");
        customAttributes.add("value");
      });
      root.add("order", function (order) {
        order.add("id");
        order.add("processedAt");
        order.add("orderNumber");
        order.add("subtotalPrice", function (subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order.add("subtotalPrice", {
          alias: "subtotalPriceV2"
        }, function (subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order.add("totalShippingPrice", function (totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order.add("totalShippingPrice", {
          alias: "totalShippingPriceV2"
        }, function (totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order.add("totalTax", function (totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order.add("totalTax", {
          alias: "totalTaxV2"
        }, function (totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order.add("totalPrice", function (totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order.add("totalPrice", {
          alias: "totalPriceV2"
        }, function (totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order.add("currencyCode");
        order.add("totalRefunded", function (totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order.add("totalRefunded", {
          alias: "totalRefundedV2"
        }, function (totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order.add("customerUrl");
        order.add("shippingAddress", function (shippingAddress) {
          shippingAddress.addFragment(spreads.MailingAddressFragment);
        });
        order.add("lineItems", {
          args: {
            first: 250
          }
        }, function (lineItems) {
          lineItems.add("pageInfo", function (pageInfo) {
            pageInfo.add("hasNextPage");
            pageInfo.add("hasPreviousPage");
          });
          lineItems.add("edges", function (edges) {
            edges.add("cursor");
            edges.add("node", function (node) {
              node.add("title");
              node.add("variant", function (variant) {
                variant.addFragment(spreads.VariantWithProductFragment);
              });
              node.add("quantity");
              node.add("customAttributes", function (customAttributes) {
                customAttributes.add("key");
                customAttributes.add("value");
              });
            });
          });
        });
      });
      root.add("lineItems", {
        args: {
          first: 250
        }
      }, function (lineItems) {
        lineItems.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        lineItems.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.add("id");
            node.add("title");
            node.add("variant", function (variant) {
              variant.addFragment(spreads.VariantWithProductFragment);
            });
            node.add("quantity");
            node.add("customAttributes", function (customAttributes) {
              customAttributes.add("key");
              customAttributes.add("value");
            });
            node.add("discountAllocations", function (discountAllocations) {
              discountAllocations.add("allocatedAmount", function (allocatedAmount) {
                allocatedAmount.add("amount");
                allocatedAmount.add("currencyCode");
              });
              discountAllocations.add("discountApplication", function (discountApplication) {
                discountApplication.addFragment(spreads.DiscountApplicationFragment);
              });
            });
          });
        });
      });
    });
    document.addMutation([variables.__defaultOperation__.checkoutId, variables.__defaultOperation__.lineItemIds], function (root) {
      root.add("checkoutLineItemsRemove", {
        args: {
          checkoutId: variables.__defaultOperation__.checkoutId,
          lineItemIds: variables.__defaultOperation__.lineItemIds
        }
      }, function (checkoutLineItemsRemove) {
        checkoutLineItemsRemove.add("userErrors", function (userErrors) {
          userErrors.addFragment(spreads.UserErrorFragment);
        });
        checkoutLineItemsRemove.add("checkoutUserErrors", function (checkoutUserErrors) {
          checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
        });
        checkoutLineItemsRemove.add("checkout", function (checkout) {
          checkout.addFragment(spreads.CheckoutFragment);
        });
      });
    });
    return document;
  }

  function query$16(client) {
    var document = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.checkoutId = client.variable("checkoutId", "ID!");
    variables.__defaultOperation__.lineItems = client.variable("lineItems", "[CheckoutLineItemInput!]!");
    spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
      root.add("id");
      root.add("title");
      root.add("price", function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function (image) {
        image.add("id");
        image.add("url", {
          alias: "src"
        });
        image.add("altText");
        image.add("width");
        image.add("height");
      });
      root.add("selectedOptions", function (selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function (unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
      root.add("targetSelection");
      root.add("allocationMethod");
      root.add("targetType");
      root.add("value", function (value) {
        value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
          MoneyV2.add("amount");
          MoneyV2.add("currencyCode");
        });
        value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
          PricingPercentageValue.add("percentage");
        });
      });
      root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
        ManualDiscountApplication.add("title");
        ManualDiscountApplication.add("description");
      });
      root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
        DiscountCodeApplication.add("code");
        DiscountCodeApplication.add("applicable");
      });
      root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
        ScriptDiscountApplication.add("title");
      });
      root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
        AutomaticDiscountApplication.add("title");
      });
    });
    spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
      root.add("amountUsed", function (amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("amountUsed", {
        alias: "amountUsedV2"
      }, function (amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("balance", function (balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("balance", {
        alias: "balanceV2"
      }, function (balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
        presentmentAmountUsed.add("amount");
        presentmentAmountUsed.add("currencyCode");
      });
      root.add("id");
      root.add("lastCharacters");
    });
    spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
      root.addFragment(spreads.VariantFragment);
      root.add("product", function (product) {
        product.add("id");
        product.add("handle");
      });
    });
    spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
      root.add("field");
      root.add("message");
      root.add("code");
    });
    spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
      root.add("id");
      root.add("address1");
      root.add("address2");
      root.add("city");
      root.add("company");
      root.add("country");
      root.add("firstName");
      root.add("formatted");
      root.add("lastName");
      root.add("latitude");
      root.add("longitude");
      root.add("phone");
      root.add("province");
      root.add("zip");
      root.add("name");
      root.add("countryCodeV2", {
        alias: "countryCode"
      });
      root.add("provinceCode");
    });
    spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
      root.add("id");
      root.add("ready");
      root.add("requiresShipping");
      root.add("note");
      root.add("paymentDue", function (paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("paymentDue", {
        alias: "paymentDueV2"
      }, function (paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("webUrl");
      root.add("orderStatusUrl");
      root.add("taxExempt");
      root.add("taxesIncluded");
      root.add("currencyCode");
      root.add("totalTax", function (totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("totalTax", {
        alias: "totalTaxV2"
      }, function (totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
        lineItemsSubtotalPrice.add("amount");
        lineItemsSubtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", function (subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", {
        alias: "subtotalPriceV2"
      }, function (subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("totalPrice", function (totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("totalPrice", {
        alias: "totalPriceV2"
      }, function (totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("completedAt");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("email");
      root.add("discountApplications", {
        args: {
          first: 10
        }
      }, function (discountApplications) {
        discountApplications.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        discountApplications.add("edges", function (edges) {
          edges.add("node", function (node) {
            node.addFragment(spreads.DiscountApplicationFragment);
          });
        });
      });
      root.add("appliedGiftCards", function (appliedGiftCards) {
        appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
      });
      root.add("shippingAddress", function (shippingAddress) {
        shippingAddress.addFragment(spreads.MailingAddressFragment);
      });
      root.add("shippingLine", function (shippingLine) {
        shippingLine.add("handle");
        shippingLine.add("price", function (price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("price", {
          alias: "priceV2"
        }, function (price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("title");
      });
      root.add("customAttributes", function (customAttributes) {
        customAttributes.add("key");
        customAttributes.add("value");
      });
      root.add("order", function (order) {
        order.add("id");
        order.add("processedAt");
        order.add("orderNumber");
        order.add("subtotalPrice", function (subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order.add("subtotalPrice", {
          alias: "subtotalPriceV2"
        }, function (subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order.add("totalShippingPrice", function (totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order.add("totalShippingPrice", {
          alias: "totalShippingPriceV2"
        }, function (totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order.add("totalTax", function (totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order.add("totalTax", {
          alias: "totalTaxV2"
        }, function (totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order.add("totalPrice", function (totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order.add("totalPrice", {
          alias: "totalPriceV2"
        }, function (totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order.add("currencyCode");
        order.add("totalRefunded", function (totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order.add("totalRefunded", {
          alias: "totalRefundedV2"
        }, function (totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order.add("customerUrl");
        order.add("shippingAddress", function (shippingAddress) {
          shippingAddress.addFragment(spreads.MailingAddressFragment);
        });
        order.add("lineItems", {
          args: {
            first: 250
          }
        }, function (lineItems) {
          lineItems.add("pageInfo", function (pageInfo) {
            pageInfo.add("hasNextPage");
            pageInfo.add("hasPreviousPage");
          });
          lineItems.add("edges", function (edges) {
            edges.add("cursor");
            edges.add("node", function (node) {
              node.add("title");
              node.add("variant", function (variant) {
                variant.addFragment(spreads.VariantWithProductFragment);
              });
              node.add("quantity");
              node.add("customAttributes", function (customAttributes) {
                customAttributes.add("key");
                customAttributes.add("value");
              });
            });
          });
        });
      });
      root.add("lineItems", {
        args: {
          first: 250
        }
      }, function (lineItems) {
        lineItems.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        lineItems.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.add("id");
            node.add("title");
            node.add("variant", function (variant) {
              variant.addFragment(spreads.VariantWithProductFragment);
            });
            node.add("quantity");
            node.add("customAttributes", function (customAttributes) {
              customAttributes.add("key");
              customAttributes.add("value");
            });
            node.add("discountAllocations", function (discountAllocations) {
              discountAllocations.add("allocatedAmount", function (allocatedAmount) {
                allocatedAmount.add("amount");
                allocatedAmount.add("currencyCode");
              });
              discountAllocations.add("discountApplication", function (discountApplication) {
                discountApplication.addFragment(spreads.DiscountApplicationFragment);
              });
            });
          });
        });
      });
    });
    document.addMutation([variables.__defaultOperation__.checkoutId, variables.__defaultOperation__.lineItems], function (root) {
      root.add("checkoutLineItemsReplace", {
        args: {
          checkoutId: variables.__defaultOperation__.checkoutId,
          lineItems: variables.__defaultOperation__.lineItems
        }
      }, function (checkoutLineItemsReplace) {
        checkoutLineItemsReplace.add("userErrors", function (userErrors) {
          userErrors.addFragment(spreads.CheckoutUserErrorFragment);
        });
        checkoutLineItemsReplace.add("checkout", function (checkout) {
          checkout.addFragment(spreads.CheckoutFragment);
        });
      });
    });
    return document;
  }

  function query$17(client) {
    var document = client.document();
    var spreads = {};
    var variables = {};
    variables.__defaultOperation__ = {};
    variables.__defaultOperation__.checkoutId = client.variable("checkoutId", "ID!");
    variables.__defaultOperation__.lineItems = client.variable("lineItems", "[CheckoutLineItemUpdateInput!]!");
    spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
      root.add("id");
      root.add("title");
      root.add("price", function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function (image) {
        image.add("id");
        image.add("url", {
          alias: "src"
        });
        image.add("altText");
        image.add("width");
        image.add("height");
      });
      root.add("selectedOptions", function (selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function (unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
      root.add("targetSelection");
      root.add("allocationMethod");
      root.add("targetType");
      root.add("value", function (value) {
        value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
          MoneyV2.add("amount");
          MoneyV2.add("currencyCode");
        });
        value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
          PricingPercentageValue.add("percentage");
        });
      });
      root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
        ManualDiscountApplication.add("title");
        ManualDiscountApplication.add("description");
      });
      root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
        DiscountCodeApplication.add("code");
        DiscountCodeApplication.add("applicable");
      });
      root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
        ScriptDiscountApplication.add("title");
      });
      root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
        AutomaticDiscountApplication.add("title");
      });
    });
    spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
      root.add("amountUsed", function (amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("amountUsed", {
        alias: "amountUsedV2"
      }, function (amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("balance", function (balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("balance", {
        alias: "balanceV2"
      }, function (balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
        presentmentAmountUsed.add("amount");
        presentmentAmountUsed.add("currencyCode");
      });
      root.add("id");
      root.add("lastCharacters");
    });
    spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
      root.addFragment(spreads.VariantFragment);
      root.add("product", function (product) {
        product.add("id");
        product.add("handle");
      });
    });
    spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
      root.add("field");
      root.add("message");
    });
    spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
      root.add("field");
      root.add("message");
      root.add("code");
    });
    spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
      root.add("id");
      root.add("address1");
      root.add("address2");
      root.add("city");
      root.add("company");
      root.add("country");
      root.add("firstName");
      root.add("formatted");
      root.add("lastName");
      root.add("latitude");
      root.add("longitude");
      root.add("phone");
      root.add("province");
      root.add("zip");
      root.add("name");
      root.add("countryCodeV2", {
        alias: "countryCode"
      });
      root.add("provinceCode");
    });
    spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
      root.add("id");
      root.add("ready");
      root.add("requiresShipping");
      root.add("note");
      root.add("paymentDue", function (paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("paymentDue", {
        alias: "paymentDueV2"
      }, function (paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("webUrl");
      root.add("orderStatusUrl");
      root.add("taxExempt");
      root.add("taxesIncluded");
      root.add("currencyCode");
      root.add("totalTax", function (totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("totalTax", {
        alias: "totalTaxV2"
      }, function (totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
        lineItemsSubtotalPrice.add("amount");
        lineItemsSubtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", function (subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", {
        alias: "subtotalPriceV2"
      }, function (subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("totalPrice", function (totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("totalPrice", {
        alias: "totalPriceV2"
      }, function (totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("completedAt");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("email");
      root.add("discountApplications", {
        args: {
          first: 10
        }
      }, function (discountApplications) {
        discountApplications.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        discountApplications.add("edges", function (edges) {
          edges.add("node", function (node) {
            node.addFragment(spreads.DiscountApplicationFragment);
          });
        });
      });
      root.add("appliedGiftCards", function (appliedGiftCards) {
        appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
      });
      root.add("shippingAddress", function (shippingAddress) {
        shippingAddress.addFragment(spreads.MailingAddressFragment);
      });
      root.add("shippingLine", function (shippingLine) {
        shippingLine.add("handle");
        shippingLine.add("price", function (price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("price", {
          alias: "priceV2"
        }, function (price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("title");
      });
      root.add("customAttributes", function (customAttributes) {
        customAttributes.add("key");
        customAttributes.add("value");
      });
      root.add("order", function (order) {
        order.add("id");
        order.add("processedAt");
        order.add("orderNumber");
        order.add("subtotalPrice", function (subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order.add("subtotalPrice", {
          alias: "subtotalPriceV2"
        }, function (subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order.add("totalShippingPrice", function (totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order.add("totalShippingPrice", {
          alias: "totalShippingPriceV2"
        }, function (totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order.add("totalTax", function (totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order.add("totalTax", {
          alias: "totalTaxV2"
        }, function (totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order.add("totalPrice", function (totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order.add("totalPrice", {
          alias: "totalPriceV2"
        }, function (totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order.add("currencyCode");
        order.add("totalRefunded", function (totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order.add("totalRefunded", {
          alias: "totalRefundedV2"
        }, function (totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order.add("customerUrl");
        order.add("shippingAddress", function (shippingAddress) {
          shippingAddress.addFragment(spreads.MailingAddressFragment);
        });
        order.add("lineItems", {
          args: {
            first: 250
          }
        }, function (lineItems) {
          lineItems.add("pageInfo", function (pageInfo) {
            pageInfo.add("hasNextPage");
            pageInfo.add("hasPreviousPage");
          });
          lineItems.add("edges", function (edges) {
            edges.add("cursor");
            edges.add("node", function (node) {
              node.add("title");
              node.add("variant", function (variant) {
                variant.addFragment(spreads.VariantWithProductFragment);
              });
              node.add("quantity");
              node.add("customAttributes", function (customAttributes) {
                customAttributes.add("key");
                customAttributes.add("value");
              });
            });
          });
        });
      });
      root.add("lineItems", {
        args: {
          first: 250
        }
      }, function (lineItems) {
        lineItems.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        lineItems.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.add("id");
            node.add("title");
            node.add("variant", function (variant) {
              variant.addFragment(spreads.VariantWithProductFragment);
            });
            node.add("quantity");
            node.add("customAttributes", function (customAttributes) {
              customAttributes.add("key");
              customAttributes.add("value");
            });
            node.add("discountAllocations", function (discountAllocations) {
              discountAllocations.add("allocatedAmount", function (allocatedAmount) {
                allocatedAmount.add("amount");
                allocatedAmount.add("currencyCode");
              });
              discountAllocations.add("discountApplication", function (discountApplication) {
                discountApplication.addFragment(spreads.DiscountApplicationFragment);
              });
            });
          });
        });
      });
    });
    document.addMutation([variables.__defaultOperation__.checkoutId, variables.__defaultOperation__.lineItems], function (root) {
      root.add("checkoutLineItemsUpdate", {
        args: {
          checkoutId: variables.__defaultOperation__.checkoutId,
          lineItems: variables.__defaultOperation__.lineItems
        }
      }, function (checkoutLineItemsUpdate) {
        checkoutLineItemsUpdate.add("userErrors", function (userErrors) {
          userErrors.addFragment(spreads.UserErrorFragment);
        });
        checkoutLineItemsUpdate.add("checkoutUserErrors", function (checkoutUserErrors) {
          checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
        });
        checkoutLineItemsUpdate.add("checkout", function (checkout) {
          checkout.addFragment(spreads.CheckoutFragment);
        });
      });
    });
    return document;
  }

  function query$18(client) {
    var document = client.document();
    var spreads = {};
    var variables = {};
    variables.checkoutAttributesUpdateV2 = {};
    variables.checkoutAttributesUpdateV2.checkoutId = client.variable("checkoutId", "ID!");
    variables.checkoutAttributesUpdateV2.input = client.variable("input", "CheckoutAttributesUpdateV2Input!");
    spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
      root.add("id");
      root.add("title");
      root.add("price", function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function (image) {
        image.add("id");
        image.add("url", {
          alias: "src"
        });
        image.add("altText");
        image.add("width");
        image.add("height");
      });
      root.add("selectedOptions", function (selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function (unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
      root.add("targetSelection");
      root.add("allocationMethod");
      root.add("targetType");
      root.add("value", function (value) {
        value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
          MoneyV2.add("amount");
          MoneyV2.add("currencyCode");
        });
        value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
          PricingPercentageValue.add("percentage");
        });
      });
      root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
        ManualDiscountApplication.add("title");
        ManualDiscountApplication.add("description");
      });
      root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
        DiscountCodeApplication.add("code");
        DiscountCodeApplication.add("applicable");
      });
      root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
        ScriptDiscountApplication.add("title");
      });
      root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
        AutomaticDiscountApplication.add("title");
      });
    });
    spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
      root.add("amountUsed", function (amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("amountUsed", {
        alias: "amountUsedV2"
      }, function (amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("balance", function (balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("balance", {
        alias: "balanceV2"
      }, function (balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
        presentmentAmountUsed.add("amount");
        presentmentAmountUsed.add("currencyCode");
      });
      root.add("id");
      root.add("lastCharacters");
    });
    spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
      root.addFragment(spreads.VariantFragment);
      root.add("product", function (product) {
        product.add("id");
        product.add("handle");
      });
    });
    spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
      root.add("field");
      root.add("message");
    });
    spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
      root.add("field");
      root.add("message");
      root.add("code");
    });
    spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
      root.add("id");
      root.add("address1");
      root.add("address2");
      root.add("city");
      root.add("company");
      root.add("country");
      root.add("firstName");
      root.add("formatted");
      root.add("lastName");
      root.add("latitude");
      root.add("longitude");
      root.add("phone");
      root.add("province");
      root.add("zip");
      root.add("name");
      root.add("countryCodeV2", {
        alias: "countryCode"
      });
      root.add("provinceCode");
    });
    spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
      root.add("id");
      root.add("ready");
      root.add("requiresShipping");
      root.add("note");
      root.add("paymentDue", function (paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("paymentDue", {
        alias: "paymentDueV2"
      }, function (paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("webUrl");
      root.add("orderStatusUrl");
      root.add("taxExempt");
      root.add("taxesIncluded");
      root.add("currencyCode");
      root.add("totalTax", function (totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("totalTax", {
        alias: "totalTaxV2"
      }, function (totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
        lineItemsSubtotalPrice.add("amount");
        lineItemsSubtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", function (subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", {
        alias: "subtotalPriceV2"
      }, function (subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("totalPrice", function (totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("totalPrice", {
        alias: "totalPriceV2"
      }, function (totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("completedAt");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("email");
      root.add("discountApplications", {
        args: {
          first: 10
        }
      }, function (discountApplications) {
        discountApplications.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        discountApplications.add("edges", function (edges) {
          edges.add("node", function (node) {
            node.addFragment(spreads.DiscountApplicationFragment);
          });
        });
      });
      root.add("appliedGiftCards", function (appliedGiftCards) {
        appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
      });
      root.add("shippingAddress", function (shippingAddress) {
        shippingAddress.addFragment(spreads.MailingAddressFragment);
      });
      root.add("shippingLine", function (shippingLine) {
        shippingLine.add("handle");
        shippingLine.add("price", function (price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("price", {
          alias: "priceV2"
        }, function (price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("title");
      });
      root.add("customAttributes", function (customAttributes) {
        customAttributes.add("key");
        customAttributes.add("value");
      });
      root.add("order", function (order) {
        order.add("id");
        order.add("processedAt");
        order.add("orderNumber");
        order.add("subtotalPrice", function (subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order.add("subtotalPrice", {
          alias: "subtotalPriceV2"
        }, function (subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order.add("totalShippingPrice", function (totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order.add("totalShippingPrice", {
          alias: "totalShippingPriceV2"
        }, function (totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order.add("totalTax", function (totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order.add("totalTax", {
          alias: "totalTaxV2"
        }, function (totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order.add("totalPrice", function (totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order.add("totalPrice", {
          alias: "totalPriceV2"
        }, function (totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order.add("currencyCode");
        order.add("totalRefunded", function (totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order.add("totalRefunded", {
          alias: "totalRefundedV2"
        }, function (totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order.add("customerUrl");
        order.add("shippingAddress", function (shippingAddress) {
          shippingAddress.addFragment(spreads.MailingAddressFragment);
        });
        order.add("lineItems", {
          args: {
            first: 250
          }
        }, function (lineItems) {
          lineItems.add("pageInfo", function (pageInfo) {
            pageInfo.add("hasNextPage");
            pageInfo.add("hasPreviousPage");
          });
          lineItems.add("edges", function (edges) {
            edges.add("cursor");
            edges.add("node", function (node) {
              node.add("title");
              node.add("variant", function (variant) {
                variant.addFragment(spreads.VariantWithProductFragment);
              });
              node.add("quantity");
              node.add("customAttributes", function (customAttributes) {
                customAttributes.add("key");
                customAttributes.add("value");
              });
            });
          });
        });
      });
      root.add("lineItems", {
        args: {
          first: 250
        }
      }, function (lineItems) {
        lineItems.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        lineItems.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.add("id");
            node.add("title");
            node.add("variant", function (variant) {
              variant.addFragment(spreads.VariantWithProductFragment);
            });
            node.add("quantity");
            node.add("customAttributes", function (customAttributes) {
              customAttributes.add("key");
              customAttributes.add("value");
            });
            node.add("discountAllocations", function (discountAllocations) {
              discountAllocations.add("allocatedAmount", function (allocatedAmount) {
                allocatedAmount.add("amount");
                allocatedAmount.add("currencyCode");
              });
              discountAllocations.add("discountApplication", function (discountApplication) {
                discountApplication.addFragment(spreads.DiscountApplicationFragment);
              });
            });
          });
        });
      });
    });
    document.addMutation("checkoutAttributesUpdateV2", [variables.checkoutAttributesUpdateV2.checkoutId, variables.checkoutAttributesUpdateV2.input], function (root) {
      root.add("checkoutAttributesUpdateV2", {
        args: {
          checkoutId: variables.checkoutAttributesUpdateV2.checkoutId,
          input: variables.checkoutAttributesUpdateV2.input
        }
      }, function (checkoutAttributesUpdateV2) {
        checkoutAttributesUpdateV2.add("userErrors", function (userErrors) {
          userErrors.addFragment(spreads.UserErrorFragment);
        });
        checkoutAttributesUpdateV2.add("checkoutUserErrors", function (checkoutUserErrors) {
          checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
        });
        checkoutAttributesUpdateV2.add("checkout", function (checkout) {
          checkout.addFragment(spreads.CheckoutFragment);
        });
      });
    });
    return document;
  }

  function query$19(client) {
    var document = client.document();
    var spreads = {};
    var variables = {};
    variables.checkoutDiscountCodeApplyV2 = {};
    variables.checkoutDiscountCodeApplyV2.discountCode = client.variable("discountCode", "String!");
    variables.checkoutDiscountCodeApplyV2.checkoutId = client.variable("checkoutId", "ID!");
    spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
      root.add("id");
      root.add("title");
      root.add("price", function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function (image) {
        image.add("id");
        image.add("url", {
          alias: "src"
        });
        image.add("altText");
        image.add("width");
        image.add("height");
      });
      root.add("selectedOptions", function (selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function (unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
      root.add("targetSelection");
      root.add("allocationMethod");
      root.add("targetType");
      root.add("value", function (value) {
        value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
          MoneyV2.add("amount");
          MoneyV2.add("currencyCode");
        });
        value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
          PricingPercentageValue.add("percentage");
        });
      });
      root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
        ManualDiscountApplication.add("title");
        ManualDiscountApplication.add("description");
      });
      root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
        DiscountCodeApplication.add("code");
        DiscountCodeApplication.add("applicable");
      });
      root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
        ScriptDiscountApplication.add("title");
      });
      root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
        AutomaticDiscountApplication.add("title");
      });
    });
    spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
      root.add("amountUsed", function (amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("amountUsed", {
        alias: "amountUsedV2"
      }, function (amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("balance", function (balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("balance", {
        alias: "balanceV2"
      }, function (balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
        presentmentAmountUsed.add("amount");
        presentmentAmountUsed.add("currencyCode");
      });
      root.add("id");
      root.add("lastCharacters");
    });
    spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
      root.addFragment(spreads.VariantFragment);
      root.add("product", function (product) {
        product.add("id");
        product.add("handle");
      });
    });
    spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
      root.add("field");
      root.add("message");
    });
    spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
      root.add("field");
      root.add("message");
      root.add("code");
    });
    spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
      root.add("id");
      root.add("address1");
      root.add("address2");
      root.add("city");
      root.add("company");
      root.add("country");
      root.add("firstName");
      root.add("formatted");
      root.add("lastName");
      root.add("latitude");
      root.add("longitude");
      root.add("phone");
      root.add("province");
      root.add("zip");
      root.add("name");
      root.add("countryCodeV2", {
        alias: "countryCode"
      });
      root.add("provinceCode");
    });
    spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
      root.add("id");
      root.add("ready");
      root.add("requiresShipping");
      root.add("note");
      root.add("paymentDue", function (paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("paymentDue", {
        alias: "paymentDueV2"
      }, function (paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("webUrl");
      root.add("orderStatusUrl");
      root.add("taxExempt");
      root.add("taxesIncluded");
      root.add("currencyCode");
      root.add("totalTax", function (totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("totalTax", {
        alias: "totalTaxV2"
      }, function (totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
        lineItemsSubtotalPrice.add("amount");
        lineItemsSubtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", function (subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", {
        alias: "subtotalPriceV2"
      }, function (subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("totalPrice", function (totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("totalPrice", {
        alias: "totalPriceV2"
      }, function (totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("completedAt");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("email");
      root.add("discountApplications", {
        args: {
          first: 10
        }
      }, function (discountApplications) {
        discountApplications.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        discountApplications.add("edges", function (edges) {
          edges.add("node", function (node) {
            node.addFragment(spreads.DiscountApplicationFragment);
          });
        });
      });
      root.add("appliedGiftCards", function (appliedGiftCards) {
        appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
      });
      root.add("shippingAddress", function (shippingAddress) {
        shippingAddress.addFragment(spreads.MailingAddressFragment);
      });
      root.add("shippingLine", function (shippingLine) {
        shippingLine.add("handle");
        shippingLine.add("price", function (price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("price", {
          alias: "priceV2"
        }, function (price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("title");
      });
      root.add("customAttributes", function (customAttributes) {
        customAttributes.add("key");
        customAttributes.add("value");
      });
      root.add("order", function (order) {
        order.add("id");
        order.add("processedAt");
        order.add("orderNumber");
        order.add("subtotalPrice", function (subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order.add("subtotalPrice", {
          alias: "subtotalPriceV2"
        }, function (subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order.add("totalShippingPrice", function (totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order.add("totalShippingPrice", {
          alias: "totalShippingPriceV2"
        }, function (totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order.add("totalTax", function (totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order.add("totalTax", {
          alias: "totalTaxV2"
        }, function (totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order.add("totalPrice", function (totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order.add("totalPrice", {
          alias: "totalPriceV2"
        }, function (totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order.add("currencyCode");
        order.add("totalRefunded", function (totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order.add("totalRefunded", {
          alias: "totalRefundedV2"
        }, function (totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order.add("customerUrl");
        order.add("shippingAddress", function (shippingAddress) {
          shippingAddress.addFragment(spreads.MailingAddressFragment);
        });
        order.add("lineItems", {
          args: {
            first: 250
          }
        }, function (lineItems) {
          lineItems.add("pageInfo", function (pageInfo) {
            pageInfo.add("hasNextPage");
            pageInfo.add("hasPreviousPage");
          });
          lineItems.add("edges", function (edges) {
            edges.add("cursor");
            edges.add("node", function (node) {
              node.add("title");
              node.add("variant", function (variant) {
                variant.addFragment(spreads.VariantWithProductFragment);
              });
              node.add("quantity");
              node.add("customAttributes", function (customAttributes) {
                customAttributes.add("key");
                customAttributes.add("value");
              });
            });
          });
        });
      });
      root.add("lineItems", {
        args: {
          first: 250
        }
      }, function (lineItems) {
        lineItems.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        lineItems.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.add("id");
            node.add("title");
            node.add("variant", function (variant) {
              variant.addFragment(spreads.VariantWithProductFragment);
            });
            node.add("quantity");
            node.add("customAttributes", function (customAttributes) {
              customAttributes.add("key");
              customAttributes.add("value");
            });
            node.add("discountAllocations", function (discountAllocations) {
              discountAllocations.add("allocatedAmount", function (allocatedAmount) {
                allocatedAmount.add("amount");
                allocatedAmount.add("currencyCode");
              });
              discountAllocations.add("discountApplication", function (discountApplication) {
                discountApplication.addFragment(spreads.DiscountApplicationFragment);
              });
            });
          });
        });
      });
    });
    document.addMutation("checkoutDiscountCodeApplyV2", [variables.checkoutDiscountCodeApplyV2.discountCode, variables.checkoutDiscountCodeApplyV2.checkoutId], function (root) {
      root.add("checkoutDiscountCodeApplyV2", {
        args: {
          discountCode: variables.checkoutDiscountCodeApplyV2.discountCode,
          checkoutId: variables.checkoutDiscountCodeApplyV2.checkoutId
        }
      }, function (checkoutDiscountCodeApplyV2) {
        checkoutDiscountCodeApplyV2.add("userErrors", function (userErrors) {
          userErrors.addFragment(spreads.UserErrorFragment);
        });
        checkoutDiscountCodeApplyV2.add("checkoutUserErrors", function (checkoutUserErrors) {
          checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
        });
        checkoutDiscountCodeApplyV2.add("checkout", function (checkout) {
          checkout.addFragment(spreads.CheckoutFragment);
        });
      });
    });
    return document;
  }

  function query$20(client) {
    var document = client.document();
    var spreads = {};
    var variables = {};
    variables.checkoutDiscountCodeRemove = {};
    variables.checkoutDiscountCodeRemove.checkoutId = client.variable("checkoutId", "ID!");
    spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
      root.add("id");
      root.add("title");
      root.add("price", function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function (image) {
        image.add("id");
        image.add("url", {
          alias: "src"
        });
        image.add("altText");
        image.add("width");
        image.add("height");
      });
      root.add("selectedOptions", function (selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function (unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
      root.add("targetSelection");
      root.add("allocationMethod");
      root.add("targetType");
      root.add("value", function (value) {
        value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
          MoneyV2.add("amount");
          MoneyV2.add("currencyCode");
        });
        value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
          PricingPercentageValue.add("percentage");
        });
      });
      root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
        ManualDiscountApplication.add("title");
        ManualDiscountApplication.add("description");
      });
      root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
        DiscountCodeApplication.add("code");
        DiscountCodeApplication.add("applicable");
      });
      root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
        ScriptDiscountApplication.add("title");
      });
      root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
        AutomaticDiscountApplication.add("title");
      });
    });
    spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
      root.add("amountUsed", function (amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("amountUsed", {
        alias: "amountUsedV2"
      }, function (amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("balance", function (balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("balance", {
        alias: "balanceV2"
      }, function (balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
        presentmentAmountUsed.add("amount");
        presentmentAmountUsed.add("currencyCode");
      });
      root.add("id");
      root.add("lastCharacters");
    });
    spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
      root.addFragment(spreads.VariantFragment);
      root.add("product", function (product) {
        product.add("id");
        product.add("handle");
      });
    });
    spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
      root.add("field");
      root.add("message");
    });
    spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
      root.add("field");
      root.add("message");
      root.add("code");
    });
    spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
      root.add("id");
      root.add("address1");
      root.add("address2");
      root.add("city");
      root.add("company");
      root.add("country");
      root.add("firstName");
      root.add("formatted");
      root.add("lastName");
      root.add("latitude");
      root.add("longitude");
      root.add("phone");
      root.add("province");
      root.add("zip");
      root.add("name");
      root.add("countryCodeV2", {
        alias: "countryCode"
      });
      root.add("provinceCode");
    });
    spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
      root.add("id");
      root.add("ready");
      root.add("requiresShipping");
      root.add("note");
      root.add("paymentDue", function (paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("paymentDue", {
        alias: "paymentDueV2"
      }, function (paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("webUrl");
      root.add("orderStatusUrl");
      root.add("taxExempt");
      root.add("taxesIncluded");
      root.add("currencyCode");
      root.add("totalTax", function (totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("totalTax", {
        alias: "totalTaxV2"
      }, function (totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
        lineItemsSubtotalPrice.add("amount");
        lineItemsSubtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", function (subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", {
        alias: "subtotalPriceV2"
      }, function (subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("totalPrice", function (totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("totalPrice", {
        alias: "totalPriceV2"
      }, function (totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("completedAt");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("email");
      root.add("discountApplications", {
        args: {
          first: 10
        }
      }, function (discountApplications) {
        discountApplications.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        discountApplications.add("edges", function (edges) {
          edges.add("node", function (node) {
            node.addFragment(spreads.DiscountApplicationFragment);
          });
        });
      });
      root.add("appliedGiftCards", function (appliedGiftCards) {
        appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
      });
      root.add("shippingAddress", function (shippingAddress) {
        shippingAddress.addFragment(spreads.MailingAddressFragment);
      });
      root.add("shippingLine", function (shippingLine) {
        shippingLine.add("handle");
        shippingLine.add("price", function (price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("price", {
          alias: "priceV2"
        }, function (price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("title");
      });
      root.add("customAttributes", function (customAttributes) {
        customAttributes.add("key");
        customAttributes.add("value");
      });
      root.add("order", function (order) {
        order.add("id");
        order.add("processedAt");
        order.add("orderNumber");
        order.add("subtotalPrice", function (subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order.add("subtotalPrice", {
          alias: "subtotalPriceV2"
        }, function (subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order.add("totalShippingPrice", function (totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order.add("totalShippingPrice", {
          alias: "totalShippingPriceV2"
        }, function (totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order.add("totalTax", function (totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order.add("totalTax", {
          alias: "totalTaxV2"
        }, function (totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order.add("totalPrice", function (totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order.add("totalPrice", {
          alias: "totalPriceV2"
        }, function (totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order.add("currencyCode");
        order.add("totalRefunded", function (totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order.add("totalRefunded", {
          alias: "totalRefundedV2"
        }, function (totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order.add("customerUrl");
        order.add("shippingAddress", function (shippingAddress) {
          shippingAddress.addFragment(spreads.MailingAddressFragment);
        });
        order.add("lineItems", {
          args: {
            first: 250
          }
        }, function (lineItems) {
          lineItems.add("pageInfo", function (pageInfo) {
            pageInfo.add("hasNextPage");
            pageInfo.add("hasPreviousPage");
          });
          lineItems.add("edges", function (edges) {
            edges.add("cursor");
            edges.add("node", function (node) {
              node.add("title");
              node.add("variant", function (variant) {
                variant.addFragment(spreads.VariantWithProductFragment);
              });
              node.add("quantity");
              node.add("customAttributes", function (customAttributes) {
                customAttributes.add("key");
                customAttributes.add("value");
              });
            });
          });
        });
      });
      root.add("lineItems", {
        args: {
          first: 250
        }
      }, function (lineItems) {
        lineItems.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        lineItems.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.add("id");
            node.add("title");
            node.add("variant", function (variant) {
              variant.addFragment(spreads.VariantWithProductFragment);
            });
            node.add("quantity");
            node.add("customAttributes", function (customAttributes) {
              customAttributes.add("key");
              customAttributes.add("value");
            });
            node.add("discountAllocations", function (discountAllocations) {
              discountAllocations.add("allocatedAmount", function (allocatedAmount) {
                allocatedAmount.add("amount");
                allocatedAmount.add("currencyCode");
              });
              discountAllocations.add("discountApplication", function (discountApplication) {
                discountApplication.addFragment(spreads.DiscountApplicationFragment);
              });
            });
          });
        });
      });
    });
    document.addMutation("checkoutDiscountCodeRemove", [variables.checkoutDiscountCodeRemove.checkoutId], function (root) {
      root.add("checkoutDiscountCodeRemove", {
        args: {
          checkoutId: variables.checkoutDiscountCodeRemove.checkoutId
        }
      }, function (checkoutDiscountCodeRemove) {
        checkoutDiscountCodeRemove.add("userErrors", function (userErrors) {
          userErrors.addFragment(spreads.UserErrorFragment);
        });
        checkoutDiscountCodeRemove.add("checkoutUserErrors", function (checkoutUserErrors) {
          checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
        });
        checkoutDiscountCodeRemove.add("checkout", function (checkout) {
          checkout.addFragment(spreads.CheckoutFragment);
        });
      });
    });
    return document;
  }

  function query$21(client) {
    var document = client.document();
    var spreads = {};
    var variables = {};
    variables.checkoutGiftCardsAppend = {};
    variables.checkoutGiftCardsAppend.giftCardCodes = client.variable("giftCardCodes", "[String!]!");
    variables.checkoutGiftCardsAppend.checkoutId = client.variable("checkoutId", "ID!");
    spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
      root.add("id");
      root.add("title");
      root.add("price", function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function (image) {
        image.add("id");
        image.add("url", {
          alias: "src"
        });
        image.add("altText");
        image.add("width");
        image.add("height");
      });
      root.add("selectedOptions", function (selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function (unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
      root.add("targetSelection");
      root.add("allocationMethod");
      root.add("targetType");
      root.add("value", function (value) {
        value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
          MoneyV2.add("amount");
          MoneyV2.add("currencyCode");
        });
        value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
          PricingPercentageValue.add("percentage");
        });
      });
      root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
        ManualDiscountApplication.add("title");
        ManualDiscountApplication.add("description");
      });
      root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
        DiscountCodeApplication.add("code");
        DiscountCodeApplication.add("applicable");
      });
      root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
        ScriptDiscountApplication.add("title");
      });
      root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
        AutomaticDiscountApplication.add("title");
      });
    });
    spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
      root.add("amountUsed", function (amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("amountUsed", {
        alias: "amountUsedV2"
      }, function (amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("balance", function (balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("balance", {
        alias: "balanceV2"
      }, function (balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
        presentmentAmountUsed.add("amount");
        presentmentAmountUsed.add("currencyCode");
      });
      root.add("id");
      root.add("lastCharacters");
    });
    spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
      root.addFragment(spreads.VariantFragment);
      root.add("product", function (product) {
        product.add("id");
        product.add("handle");
      });
    });
    spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
      root.add("field");
      root.add("message");
    });
    spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
      root.add("field");
      root.add("message");
      root.add("code");
    });
    spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
      root.add("id");
      root.add("address1");
      root.add("address2");
      root.add("city");
      root.add("company");
      root.add("country");
      root.add("firstName");
      root.add("formatted");
      root.add("lastName");
      root.add("latitude");
      root.add("longitude");
      root.add("phone");
      root.add("province");
      root.add("zip");
      root.add("name");
      root.add("countryCodeV2", {
        alias: "countryCode"
      });
      root.add("provinceCode");
    });
    spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
      root.add("id");
      root.add("ready");
      root.add("requiresShipping");
      root.add("note");
      root.add("paymentDue", function (paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("paymentDue", {
        alias: "paymentDueV2"
      }, function (paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("webUrl");
      root.add("orderStatusUrl");
      root.add("taxExempt");
      root.add("taxesIncluded");
      root.add("currencyCode");
      root.add("totalTax", function (totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("totalTax", {
        alias: "totalTaxV2"
      }, function (totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
        lineItemsSubtotalPrice.add("amount");
        lineItemsSubtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", function (subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", {
        alias: "subtotalPriceV2"
      }, function (subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("totalPrice", function (totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("totalPrice", {
        alias: "totalPriceV2"
      }, function (totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("completedAt");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("email");
      root.add("discountApplications", {
        args: {
          first: 10
        }
      }, function (discountApplications) {
        discountApplications.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        discountApplications.add("edges", function (edges) {
          edges.add("node", function (node) {
            node.addFragment(spreads.DiscountApplicationFragment);
          });
        });
      });
      root.add("appliedGiftCards", function (appliedGiftCards) {
        appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
      });
      root.add("shippingAddress", function (shippingAddress) {
        shippingAddress.addFragment(spreads.MailingAddressFragment);
      });
      root.add("shippingLine", function (shippingLine) {
        shippingLine.add("handle");
        shippingLine.add("price", function (price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("price", {
          alias: "priceV2"
        }, function (price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("title");
      });
      root.add("customAttributes", function (customAttributes) {
        customAttributes.add("key");
        customAttributes.add("value");
      });
      root.add("order", function (order) {
        order.add("id");
        order.add("processedAt");
        order.add("orderNumber");
        order.add("subtotalPrice", function (subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order.add("subtotalPrice", {
          alias: "subtotalPriceV2"
        }, function (subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order.add("totalShippingPrice", function (totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order.add("totalShippingPrice", {
          alias: "totalShippingPriceV2"
        }, function (totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order.add("totalTax", function (totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order.add("totalTax", {
          alias: "totalTaxV2"
        }, function (totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order.add("totalPrice", function (totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order.add("totalPrice", {
          alias: "totalPriceV2"
        }, function (totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order.add("currencyCode");
        order.add("totalRefunded", function (totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order.add("totalRefunded", {
          alias: "totalRefundedV2"
        }, function (totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order.add("customerUrl");
        order.add("shippingAddress", function (shippingAddress) {
          shippingAddress.addFragment(spreads.MailingAddressFragment);
        });
        order.add("lineItems", {
          args: {
            first: 250
          }
        }, function (lineItems) {
          lineItems.add("pageInfo", function (pageInfo) {
            pageInfo.add("hasNextPage");
            pageInfo.add("hasPreviousPage");
          });
          lineItems.add("edges", function (edges) {
            edges.add("cursor");
            edges.add("node", function (node) {
              node.add("title");
              node.add("variant", function (variant) {
                variant.addFragment(spreads.VariantWithProductFragment);
              });
              node.add("quantity");
              node.add("customAttributes", function (customAttributes) {
                customAttributes.add("key");
                customAttributes.add("value");
              });
            });
          });
        });
      });
      root.add("lineItems", {
        args: {
          first: 250
        }
      }, function (lineItems) {
        lineItems.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        lineItems.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.add("id");
            node.add("title");
            node.add("variant", function (variant) {
              variant.addFragment(spreads.VariantWithProductFragment);
            });
            node.add("quantity");
            node.add("customAttributes", function (customAttributes) {
              customAttributes.add("key");
              customAttributes.add("value");
            });
            node.add("discountAllocations", function (discountAllocations) {
              discountAllocations.add("allocatedAmount", function (allocatedAmount) {
                allocatedAmount.add("amount");
                allocatedAmount.add("currencyCode");
              });
              discountAllocations.add("discountApplication", function (discountApplication) {
                discountApplication.addFragment(spreads.DiscountApplicationFragment);
              });
            });
          });
        });
      });
    });
    document.addMutation("checkoutGiftCardsAppend", [variables.checkoutGiftCardsAppend.giftCardCodes, variables.checkoutGiftCardsAppend.checkoutId], function (root) {
      root.add("checkoutGiftCardsAppend", {
        args: {
          giftCardCodes: variables.checkoutGiftCardsAppend.giftCardCodes,
          checkoutId: variables.checkoutGiftCardsAppend.checkoutId
        }
      }, function (checkoutGiftCardsAppend) {
        checkoutGiftCardsAppend.add("userErrors", function (userErrors) {
          userErrors.addFragment(spreads.UserErrorFragment);
        });
        checkoutGiftCardsAppend.add("checkoutUserErrors", function (checkoutUserErrors) {
          checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
        });
        checkoutGiftCardsAppend.add("checkout", function (checkout) {
          checkout.addFragment(spreads.CheckoutFragment);
        });
      });
    });
    return document;
  }

  function query$22(client) {
    var document = client.document();
    var spreads = {};
    var variables = {};
    variables.checkoutGiftCardRemoveV2 = {};
    variables.checkoutGiftCardRemoveV2.appliedGiftCardId = client.variable("appliedGiftCardId", "ID!");
    variables.checkoutGiftCardRemoveV2.checkoutId = client.variable("checkoutId", "ID!");
    spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
      root.add("id");
      root.add("title");
      root.add("price", function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function (image) {
        image.add("id");
        image.add("url", {
          alias: "src"
        });
        image.add("altText");
        image.add("width");
        image.add("height");
      });
      root.add("selectedOptions", function (selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function (unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
      root.add("targetSelection");
      root.add("allocationMethod");
      root.add("targetType");
      root.add("value", function (value) {
        value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
          MoneyV2.add("amount");
          MoneyV2.add("currencyCode");
        });
        value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
          PricingPercentageValue.add("percentage");
        });
      });
      root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
        ManualDiscountApplication.add("title");
        ManualDiscountApplication.add("description");
      });
      root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
        DiscountCodeApplication.add("code");
        DiscountCodeApplication.add("applicable");
      });
      root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
        ScriptDiscountApplication.add("title");
      });
      root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
        AutomaticDiscountApplication.add("title");
      });
    });
    spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
      root.add("amountUsed", function (amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("amountUsed", {
        alias: "amountUsedV2"
      }, function (amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("balance", function (balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("balance", {
        alias: "balanceV2"
      }, function (balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
        presentmentAmountUsed.add("amount");
        presentmentAmountUsed.add("currencyCode");
      });
      root.add("id");
      root.add("lastCharacters");
    });
    spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
      root.addFragment(spreads.VariantFragment);
      root.add("product", function (product) {
        product.add("id");
        product.add("handle");
      });
    });
    spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
      root.add("field");
      root.add("message");
    });
    spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
      root.add("field");
      root.add("message");
      root.add("code");
    });
    spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
      root.add("id");
      root.add("address1");
      root.add("address2");
      root.add("city");
      root.add("company");
      root.add("country");
      root.add("firstName");
      root.add("formatted");
      root.add("lastName");
      root.add("latitude");
      root.add("longitude");
      root.add("phone");
      root.add("province");
      root.add("zip");
      root.add("name");
      root.add("countryCodeV2", {
        alias: "countryCode"
      });
      root.add("provinceCode");
    });
    spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
      root.add("id");
      root.add("ready");
      root.add("requiresShipping");
      root.add("note");
      root.add("paymentDue", function (paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("paymentDue", {
        alias: "paymentDueV2"
      }, function (paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("webUrl");
      root.add("orderStatusUrl");
      root.add("taxExempt");
      root.add("taxesIncluded");
      root.add("currencyCode");
      root.add("totalTax", function (totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("totalTax", {
        alias: "totalTaxV2"
      }, function (totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
        lineItemsSubtotalPrice.add("amount");
        lineItemsSubtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", function (subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", {
        alias: "subtotalPriceV2"
      }, function (subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("totalPrice", function (totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("totalPrice", {
        alias: "totalPriceV2"
      }, function (totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("completedAt");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("email");
      root.add("discountApplications", {
        args: {
          first: 10
        }
      }, function (discountApplications) {
        discountApplications.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        discountApplications.add("edges", function (edges) {
          edges.add("node", function (node) {
            node.addFragment(spreads.DiscountApplicationFragment);
          });
        });
      });
      root.add("appliedGiftCards", function (appliedGiftCards) {
        appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
      });
      root.add("shippingAddress", function (shippingAddress) {
        shippingAddress.addFragment(spreads.MailingAddressFragment);
      });
      root.add("shippingLine", function (shippingLine) {
        shippingLine.add("handle");
        shippingLine.add("price", function (price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("price", {
          alias: "priceV2"
        }, function (price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("title");
      });
      root.add("customAttributes", function (customAttributes) {
        customAttributes.add("key");
        customAttributes.add("value");
      });
      root.add("order", function (order) {
        order.add("id");
        order.add("processedAt");
        order.add("orderNumber");
        order.add("subtotalPrice", function (subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order.add("subtotalPrice", {
          alias: "subtotalPriceV2"
        }, function (subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order.add("totalShippingPrice", function (totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order.add("totalShippingPrice", {
          alias: "totalShippingPriceV2"
        }, function (totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order.add("totalTax", function (totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order.add("totalTax", {
          alias: "totalTaxV2"
        }, function (totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order.add("totalPrice", function (totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order.add("totalPrice", {
          alias: "totalPriceV2"
        }, function (totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order.add("currencyCode");
        order.add("totalRefunded", function (totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order.add("totalRefunded", {
          alias: "totalRefundedV2"
        }, function (totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order.add("customerUrl");
        order.add("shippingAddress", function (shippingAddress) {
          shippingAddress.addFragment(spreads.MailingAddressFragment);
        });
        order.add("lineItems", {
          args: {
            first: 250
          }
        }, function (lineItems) {
          lineItems.add("pageInfo", function (pageInfo) {
            pageInfo.add("hasNextPage");
            pageInfo.add("hasPreviousPage");
          });
          lineItems.add("edges", function (edges) {
            edges.add("cursor");
            edges.add("node", function (node) {
              node.add("title");
              node.add("variant", function (variant) {
                variant.addFragment(spreads.VariantWithProductFragment);
              });
              node.add("quantity");
              node.add("customAttributes", function (customAttributes) {
                customAttributes.add("key");
                customAttributes.add("value");
              });
            });
          });
        });
      });
      root.add("lineItems", {
        args: {
          first: 250
        }
      }, function (lineItems) {
        lineItems.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        lineItems.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.add("id");
            node.add("title");
            node.add("variant", function (variant) {
              variant.addFragment(spreads.VariantWithProductFragment);
            });
            node.add("quantity");
            node.add("customAttributes", function (customAttributes) {
              customAttributes.add("key");
              customAttributes.add("value");
            });
            node.add("discountAllocations", function (discountAllocations) {
              discountAllocations.add("allocatedAmount", function (allocatedAmount) {
                allocatedAmount.add("amount");
                allocatedAmount.add("currencyCode");
              });
              discountAllocations.add("discountApplication", function (discountApplication) {
                discountApplication.addFragment(spreads.DiscountApplicationFragment);
              });
            });
          });
        });
      });
    });
    document.addMutation("checkoutGiftCardRemoveV2", [variables.checkoutGiftCardRemoveV2.appliedGiftCardId, variables.checkoutGiftCardRemoveV2.checkoutId], function (root) {
      root.add("checkoutGiftCardRemoveV2", {
        args: {
          appliedGiftCardId: variables.checkoutGiftCardRemoveV2.appliedGiftCardId,
          checkoutId: variables.checkoutGiftCardRemoveV2.checkoutId
        }
      }, function (checkoutGiftCardRemoveV2) {
        checkoutGiftCardRemoveV2.add("userErrors", function (userErrors) {
          userErrors.addFragment(spreads.UserErrorFragment);
        });
        checkoutGiftCardRemoveV2.add("checkoutUserErrors", function (checkoutUserErrors) {
          checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
        });
        checkoutGiftCardRemoveV2.add("checkout", function (checkout) {
          checkout.addFragment(spreads.CheckoutFragment);
        });
      });
    });
    return document;
  }

  function query$23(client) {
    var document = client.document();
    var spreads = {};
    var variables = {};
    variables.checkoutEmailUpdateV2 = {};
    variables.checkoutEmailUpdateV2.checkoutId = client.variable("checkoutId", "ID!");
    variables.checkoutEmailUpdateV2.email = client.variable("email", "String!");
    spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
      root.add("id");
      root.add("title");
      root.add("price", function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function (image) {
        image.add("id");
        image.add("url", {
          alias: "src"
        });
        image.add("altText");
        image.add("width");
        image.add("height");
      });
      root.add("selectedOptions", function (selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function (unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
      root.add("targetSelection");
      root.add("allocationMethod");
      root.add("targetType");
      root.add("value", function (value) {
        value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
          MoneyV2.add("amount");
          MoneyV2.add("currencyCode");
        });
        value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
          PricingPercentageValue.add("percentage");
        });
      });
      root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
        ManualDiscountApplication.add("title");
        ManualDiscountApplication.add("description");
      });
      root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
        DiscountCodeApplication.add("code");
        DiscountCodeApplication.add("applicable");
      });
      root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
        ScriptDiscountApplication.add("title");
      });
      root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
        AutomaticDiscountApplication.add("title");
      });
    });
    spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
      root.add("amountUsed", function (amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("amountUsed", {
        alias: "amountUsedV2"
      }, function (amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("balance", function (balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("balance", {
        alias: "balanceV2"
      }, function (balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
        presentmentAmountUsed.add("amount");
        presentmentAmountUsed.add("currencyCode");
      });
      root.add("id");
      root.add("lastCharacters");
    });
    spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
      root.addFragment(spreads.VariantFragment);
      root.add("product", function (product) {
        product.add("id");
        product.add("handle");
      });
    });
    spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
      root.add("field");
      root.add("message");
    });
    spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
      root.add("field");
      root.add("message");
      root.add("code");
    });
    spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
      root.add("id");
      root.add("address1");
      root.add("address2");
      root.add("city");
      root.add("company");
      root.add("country");
      root.add("firstName");
      root.add("formatted");
      root.add("lastName");
      root.add("latitude");
      root.add("longitude");
      root.add("phone");
      root.add("province");
      root.add("zip");
      root.add("name");
      root.add("countryCodeV2", {
        alias: "countryCode"
      });
      root.add("provinceCode");
    });
    spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
      root.add("id");
      root.add("ready");
      root.add("requiresShipping");
      root.add("note");
      root.add("paymentDue", function (paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("paymentDue", {
        alias: "paymentDueV2"
      }, function (paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("webUrl");
      root.add("orderStatusUrl");
      root.add("taxExempt");
      root.add("taxesIncluded");
      root.add("currencyCode");
      root.add("totalTax", function (totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("totalTax", {
        alias: "totalTaxV2"
      }, function (totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
        lineItemsSubtotalPrice.add("amount");
        lineItemsSubtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", function (subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", {
        alias: "subtotalPriceV2"
      }, function (subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("totalPrice", function (totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("totalPrice", {
        alias: "totalPriceV2"
      }, function (totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("completedAt");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("email");
      root.add("discountApplications", {
        args: {
          first: 10
        }
      }, function (discountApplications) {
        discountApplications.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        discountApplications.add("edges", function (edges) {
          edges.add("node", function (node) {
            node.addFragment(spreads.DiscountApplicationFragment);
          });
        });
      });
      root.add("appliedGiftCards", function (appliedGiftCards) {
        appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
      });
      root.add("shippingAddress", function (shippingAddress) {
        shippingAddress.addFragment(spreads.MailingAddressFragment);
      });
      root.add("shippingLine", function (shippingLine) {
        shippingLine.add("handle");
        shippingLine.add("price", function (price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("price", {
          alias: "priceV2"
        }, function (price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("title");
      });
      root.add("customAttributes", function (customAttributes) {
        customAttributes.add("key");
        customAttributes.add("value");
      });
      root.add("order", function (order) {
        order.add("id");
        order.add("processedAt");
        order.add("orderNumber");
        order.add("subtotalPrice", function (subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order.add("subtotalPrice", {
          alias: "subtotalPriceV2"
        }, function (subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order.add("totalShippingPrice", function (totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order.add("totalShippingPrice", {
          alias: "totalShippingPriceV2"
        }, function (totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order.add("totalTax", function (totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order.add("totalTax", {
          alias: "totalTaxV2"
        }, function (totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order.add("totalPrice", function (totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order.add("totalPrice", {
          alias: "totalPriceV2"
        }, function (totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order.add("currencyCode");
        order.add("totalRefunded", function (totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order.add("totalRefunded", {
          alias: "totalRefundedV2"
        }, function (totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order.add("customerUrl");
        order.add("shippingAddress", function (shippingAddress) {
          shippingAddress.addFragment(spreads.MailingAddressFragment);
        });
        order.add("lineItems", {
          args: {
            first: 250
          }
        }, function (lineItems) {
          lineItems.add("pageInfo", function (pageInfo) {
            pageInfo.add("hasNextPage");
            pageInfo.add("hasPreviousPage");
          });
          lineItems.add("edges", function (edges) {
            edges.add("cursor");
            edges.add("node", function (node) {
              node.add("title");
              node.add("variant", function (variant) {
                variant.addFragment(spreads.VariantWithProductFragment);
              });
              node.add("quantity");
              node.add("customAttributes", function (customAttributes) {
                customAttributes.add("key");
                customAttributes.add("value");
              });
            });
          });
        });
      });
      root.add("lineItems", {
        args: {
          first: 250
        }
      }, function (lineItems) {
        lineItems.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        lineItems.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.add("id");
            node.add("title");
            node.add("variant", function (variant) {
              variant.addFragment(spreads.VariantWithProductFragment);
            });
            node.add("quantity");
            node.add("customAttributes", function (customAttributes) {
              customAttributes.add("key");
              customAttributes.add("value");
            });
            node.add("discountAllocations", function (discountAllocations) {
              discountAllocations.add("allocatedAmount", function (allocatedAmount) {
                allocatedAmount.add("amount");
                allocatedAmount.add("currencyCode");
              });
              discountAllocations.add("discountApplication", function (discountApplication) {
                discountApplication.addFragment(spreads.DiscountApplicationFragment);
              });
            });
          });
        });
      });
    });
    document.addMutation("checkoutEmailUpdateV2", [variables.checkoutEmailUpdateV2.checkoutId, variables.checkoutEmailUpdateV2.email], function (root) {
      root.add("checkoutEmailUpdateV2", {
        args: {
          checkoutId: variables.checkoutEmailUpdateV2.checkoutId,
          email: variables.checkoutEmailUpdateV2.email
        }
      }, function (checkoutEmailUpdateV2) {
        checkoutEmailUpdateV2.add("userErrors", function (userErrors) {
          userErrors.addFragment(spreads.UserErrorFragment);
        });
        checkoutEmailUpdateV2.add("checkoutUserErrors", function (checkoutUserErrors) {
          checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
        });
        checkoutEmailUpdateV2.add("checkout", function (checkout) {
          checkout.addFragment(spreads.CheckoutFragment);
        });
      });
    });
    return document;
  }

  function query$24(client) {
    var document = client.document();
    var spreads = {};
    var variables = {};
    variables.checkoutShippingAddressUpdateV2 = {};
    variables.checkoutShippingAddressUpdateV2.shippingAddress = client.variable("shippingAddress", "MailingAddressInput!");
    variables.checkoutShippingAddressUpdateV2.checkoutId = client.variable("checkoutId", "ID!");
    spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
      root.add("id");
      root.add("title");
      root.add("price", function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("price", {
        alias: "priceV2"
      }, function (price) {
        price.add("amount");
        price.add("currencyCode");
      });
      root.add("weight");
      root.add("availableForSale", {
        alias: "available"
      });
      root.add("sku");
      root.add("compareAtPrice", function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("compareAtPrice", {
        alias: "compareAtPriceV2"
      }, function (compareAtPrice) {
        compareAtPrice.add("amount");
        compareAtPrice.add("currencyCode");
      });
      root.add("image", function (image) {
        image.add("id");
        image.add("url", {
          alias: "src"
        });
        image.add("altText");
        image.add("width");
        image.add("height");
      });
      root.add("selectedOptions", function (selectedOptions) {
        selectedOptions.add("name");
        selectedOptions.add("value");
      });
      root.add("unitPrice", function (unitPrice) {
        unitPrice.add("amount");
        unitPrice.add("currencyCode");
      });
      root.add("unitPriceMeasurement", function (unitPriceMeasurement) {
        unitPriceMeasurement.add("measuredType");
        unitPriceMeasurement.add("quantityUnit");
        unitPriceMeasurement.add("quantityValue");
        unitPriceMeasurement.add("referenceUnit");
        unitPriceMeasurement.add("referenceValue");
      });
    });
    spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
      root.add("targetSelection");
      root.add("allocationMethod");
      root.add("targetType");
      root.add("value", function (value) {
        value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
          MoneyV2.add("amount");
          MoneyV2.add("currencyCode");
        });
        value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
          PricingPercentageValue.add("percentage");
        });
      });
      root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
        ManualDiscountApplication.add("title");
        ManualDiscountApplication.add("description");
      });
      root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
        DiscountCodeApplication.add("code");
        DiscountCodeApplication.add("applicable");
      });
      root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
        ScriptDiscountApplication.add("title");
      });
      root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
        AutomaticDiscountApplication.add("title");
      });
    });
    spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
      root.add("amountUsed", function (amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("amountUsed", {
        alias: "amountUsedV2"
      }, function (amountUsed) {
        amountUsed.add("amount");
        amountUsed.add("currencyCode");
      });
      root.add("balance", function (balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("balance", {
        alias: "balanceV2"
      }, function (balance) {
        balance.add("amount");
        balance.add("currencyCode");
      });
      root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
        presentmentAmountUsed.add("amount");
        presentmentAmountUsed.add("currencyCode");
      });
      root.add("id");
      root.add("lastCharacters");
    });
    spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
      root.addFragment(spreads.VariantFragment);
      root.add("product", function (product) {
        product.add("id");
        product.add("handle");
      });
    });
    spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
      root.add("field");
      root.add("message");
    });
    spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
      root.add("field");
      root.add("message");
      root.add("code");
    });
    spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
      root.add("id");
      root.add("address1");
      root.add("address2");
      root.add("city");
      root.add("company");
      root.add("country");
      root.add("firstName");
      root.add("formatted");
      root.add("lastName");
      root.add("latitude");
      root.add("longitude");
      root.add("phone");
      root.add("province");
      root.add("zip");
      root.add("name");
      root.add("countryCodeV2", {
        alias: "countryCode"
      });
      root.add("provinceCode");
    });
    spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
      root.add("id");
      root.add("ready");
      root.add("requiresShipping");
      root.add("note");
      root.add("paymentDue", function (paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("paymentDue", {
        alias: "paymentDueV2"
      }, function (paymentDue) {
        paymentDue.add("amount");
        paymentDue.add("currencyCode");
      });
      root.add("webUrl");
      root.add("orderStatusUrl");
      root.add("taxExempt");
      root.add("taxesIncluded");
      root.add("currencyCode");
      root.add("totalTax", function (totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("totalTax", {
        alias: "totalTaxV2"
      }, function (totalTax) {
        totalTax.add("amount");
        totalTax.add("currencyCode");
      });
      root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
        lineItemsSubtotalPrice.add("amount");
        lineItemsSubtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", function (subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("subtotalPrice", {
        alias: "subtotalPriceV2"
      }, function (subtotalPrice) {
        subtotalPrice.add("amount");
        subtotalPrice.add("currencyCode");
      });
      root.add("totalPrice", function (totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("totalPrice", {
        alias: "totalPriceV2"
      }, function (totalPrice) {
        totalPrice.add("amount");
        totalPrice.add("currencyCode");
      });
      root.add("completedAt");
      root.add("createdAt");
      root.add("updatedAt");
      root.add("email");
      root.add("discountApplications", {
        args: {
          first: 10
        }
      }, function (discountApplications) {
        discountApplications.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        discountApplications.add("edges", function (edges) {
          edges.add("node", function (node) {
            node.addFragment(spreads.DiscountApplicationFragment);
          });
        });
      });
      root.add("appliedGiftCards", function (appliedGiftCards) {
        appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
      });
      root.add("shippingAddress", function (shippingAddress) {
        shippingAddress.addFragment(spreads.MailingAddressFragment);
      });
      root.add("shippingLine", function (shippingLine) {
        shippingLine.add("handle");
        shippingLine.add("price", function (price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("price", {
          alias: "priceV2"
        }, function (price) {
          price.add("amount");
          price.add("currencyCode");
        });
        shippingLine.add("title");
      });
      root.add("customAttributes", function (customAttributes) {
        customAttributes.add("key");
        customAttributes.add("value");
      });
      root.add("order", function (order) {
        order.add("id");
        order.add("processedAt");
        order.add("orderNumber");
        order.add("subtotalPrice", function (subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order.add("subtotalPrice", {
          alias: "subtotalPriceV2"
        }, function (subtotalPrice) {
          subtotalPrice.add("amount");
          subtotalPrice.add("currencyCode");
        });
        order.add("totalShippingPrice", function (totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order.add("totalShippingPrice", {
          alias: "totalShippingPriceV2"
        }, function (totalShippingPrice) {
          totalShippingPrice.add("amount");
          totalShippingPrice.add("currencyCode");
        });
        order.add("totalTax", function (totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order.add("totalTax", {
          alias: "totalTaxV2"
        }, function (totalTax) {
          totalTax.add("amount");
          totalTax.add("currencyCode");
        });
        order.add("totalPrice", function (totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order.add("totalPrice", {
          alias: "totalPriceV2"
        }, function (totalPrice) {
          totalPrice.add("amount");
          totalPrice.add("currencyCode");
        });
        order.add("currencyCode");
        order.add("totalRefunded", function (totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order.add("totalRefunded", {
          alias: "totalRefundedV2"
        }, function (totalRefunded) {
          totalRefunded.add("amount");
          totalRefunded.add("currencyCode");
        });
        order.add("customerUrl");
        order.add("shippingAddress", function (shippingAddress) {
          shippingAddress.addFragment(spreads.MailingAddressFragment);
        });
        order.add("lineItems", {
          args: {
            first: 250
          }
        }, function (lineItems) {
          lineItems.add("pageInfo", function (pageInfo) {
            pageInfo.add("hasNextPage");
            pageInfo.add("hasPreviousPage");
          });
          lineItems.add("edges", function (edges) {
            edges.add("cursor");
            edges.add("node", function (node) {
              node.add("title");
              node.add("variant", function (variant) {
                variant.addFragment(spreads.VariantWithProductFragment);
              });
              node.add("quantity");
              node.add("customAttributes", function (customAttributes) {
                customAttributes.add("key");
                customAttributes.add("value");
              });
            });
          });
        });
      });
      root.add("lineItems", {
        args: {
          first: 250
        }
      }, function (lineItems) {
        lineItems.add("pageInfo", function (pageInfo) {
          pageInfo.add("hasNextPage");
          pageInfo.add("hasPreviousPage");
        });
        lineItems.add("edges", function (edges) {
          edges.add("cursor");
          edges.add("node", function (node) {
            node.add("id");
            node.add("title");
            node.add("variant", function (variant) {
              variant.addFragment(spreads.VariantWithProductFragment);
            });
            node.add("quantity");
            node.add("customAttributes", function (customAttributes) {
              customAttributes.add("key");
              customAttributes.add("value");
            });
            node.add("discountAllocations", function (discountAllocations) {
              discountAllocations.add("allocatedAmount", function (allocatedAmount) {
                allocatedAmount.add("amount");
                allocatedAmount.add("currencyCode");
              });
              discountAllocations.add("discountApplication", function (discountApplication) {
                discountApplication.addFragment(spreads.DiscountApplicationFragment);
              });
            });
          });
        });
      });
    });
    document.addMutation("checkoutShippingAddressUpdateV2", [variables.checkoutShippingAddressUpdateV2.shippingAddress, variables.checkoutShippingAddressUpdateV2.checkoutId], function (root) {
      root.add("checkoutShippingAddressUpdateV2", {
        args: {
          shippingAddress: variables.checkoutShippingAddressUpdateV2.shippingAddress,
          checkoutId: variables.checkoutShippingAddressUpdateV2.checkoutId
        }
      }, function (checkoutShippingAddressUpdateV2) {
        checkoutShippingAddressUpdateV2.add("userErrors", function (userErrors) {
          userErrors.addFragment(spreads.UserErrorFragment);
        });
        checkoutShippingAddressUpdateV2.add("checkoutUserErrors", function (checkoutUserErrors) {
          checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
        });
        checkoutShippingAddressUpdateV2.add("checkout", function (checkout) {
          checkout.addFragment(spreads.CheckoutFragment);
        });
      });
    });
    return document;
  }

  // GraphQL
  /**
   * The JS Buy SDK checkout resource
   * @class
   */

  var CheckoutResource = function (_Resource) {
    inherits$1(CheckoutResource, _Resource);

    function CheckoutResource() {
      classCallCheck$1(this, CheckoutResource);
      return possibleConstructorReturn$1(this, (CheckoutResource.__proto__ || Object.getPrototypeOf(CheckoutResource)).apply(this, arguments));
    }

    createClass$1(CheckoutResource, [{
      key: 'fetch',


      /**
       * Fetches a checkout by ID.
       *
       * @example
       * client.checkout.fetch('FlZj9rZXlN5MDY4ZDFiZTUyZTUwNTE2MDNhZjg=').then((checkout) => {
       *   // Do something with the checkout
       * });
       *
       * @param {String} id The id of the checkout to fetch.
       * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the checkout.
       */
      value: function fetch(id) {
        var _this2 = this;

        return this.graphQLClient.send(query$12, { id: id }).then(defaultResolver('node')).then(function (checkout) {
          if (!checkout) {
            return null;
          }

          return _this2.graphQLClient.fetchAllPages(checkout.lineItems, { pageSize: 250 }).then(function (lineItems) {
            checkout.attrs.lineItems = lineItems;

            return checkout;
          });
        });
      }

      /**
       * Creates a checkout.
       *
       * @example
       * const input = {
       *   lineItems: [
       *     {variantId: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8yOTEwNjAyMjc5Mg==', quantity: 5}
       *   ]
       * };
       *
       * client.checkout.create(input).then((checkout) => {
       *   // Do something with the newly created checkout
       * });
       *
       * @param {Object} [input] An input object containing zero or more of:
       *   @param {String} [input.email] An email connected to the checkout.
       *   @param {Object[]} [input.lineItems] A list of line items in the checkout. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/checkoutlineiteminput|Storefront API reference} for valid input fields for each line item.
       *   @param {Object} [input.shippingAddress] A shipping address. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/mailingaddressinput|Storefront API reference} for valid input fields.
       *   @param {String} [input.note] A note for the checkout.
       *   @param {Object[]} [input.customAttributes] A list of custom attributes for the checkout. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/attributeinput|Storefront API reference} for valid input fields.
       *   @param {String} [input.presentmentCurrencyCode ] A presentment currency code. See the {@link https://help.shopify.com/en/api/storefront-api/reference/enum/currencycode|Storefront API reference} for valid currency code values.
       * @return {Promise|GraphModel} A promise resolving with the created checkout.
       */

    }, {
      key: 'create',
      value: function create() {
        var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return this.graphQLClient.send(query$13, { input: input }).then(handleCheckoutMutation('checkoutCreate', this.graphQLClient));
      }

      /**
       * Replaces the value of checkout's custom attributes and/or note with values defined in the input
       *
       * @example
       * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
       * const input = {customAttributes: [{key: "MyKey", value: "MyValue"}]};
       *
       * client.checkout.updateAttributes(checkoutId, input).then((checkout) => {
       *   // Do something with the updated checkout
       * });
       *
       * @param {String} checkoutId The ID of the checkout to update.
       * @param {Object} [input] An input object containing zero or more of:
       *   @param {Boolean} [input.allowPartialAddresses] An email connected to the checkout.
       *   @param {Object[]} [input.customAttributes] A list of custom attributes for the checkout. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/attributeinput|Storefront API reference} for valid input fields.
       *   @param {String} [input.note] A note for the checkout.
       * @return {Promise|GraphModel} A promise resolving with the updated checkout.
       */

    }, {
      key: 'updateAttributes',
      value: function updateAttributes(checkoutId) {
        var input = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        return this.graphQLClient.send(query$18, { checkoutId: checkoutId, input: input }).then(handleCheckoutMutation('checkoutAttributesUpdateV2', this.graphQLClient));
      }

      /**
       * Replaces the value of checkout's email address
       *
       * @example
       * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
       * const email = 'user@example.com';
       *
       * client.checkout.updateEmail(checkoutId, email).then((checkout) => {
       *   // Do something with the updated checkout
       * });
       *
       * @param {String} checkoutId The ID of the checkout to update.
       * @param {String} email The email address to apply to the checkout.
       * @return {Promise|GraphModel} A promise resolving with the updated checkout.
       */

    }, {
      key: 'updateEmail',
      value: function updateEmail(checkoutId, email) {
        return this.graphQLClient.send(query$23, { checkoutId: checkoutId, email: email }).then(handleCheckoutMutation('checkoutEmailUpdateV2', this.graphQLClient));
      }

      /**
       * Adds line items to an existing checkout.
       *
       * @example
       * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
       * const lineItems = [{variantId: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8yOTEwNjAyMjc5Mg==', quantity: 5}];
       *
       * client.checkout.addLineItems(checkoutId, lineItems).then((checkout) => {
       *   // Do something with the updated checkout
       * });
       *
       * @param {String} checkoutId The ID of the checkout to add line items to.
       * @param {Object[]} lineItems A list of line items to add to the checkout. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/checkoutlineiteminput|Storefront API reference} for valid input fields for each line item.
       * @return {Promise|GraphModel} A promise resolving with the updated checkout.
       */

    }, {
      key: 'addLineItems',
      value: function addLineItems(checkoutId, lineItems) {
        return this.graphQLClient.send(query$14, { checkoutId: checkoutId, lineItems: lineItems }).then(handleCheckoutMutation('checkoutLineItemsAdd', this.graphQLClient));
      }

      /**
       * Applies a discount to an existing checkout using a discount code.
       *
       * @example
       * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
       * const discountCode = 'best-discount-ever';
       *
       * client.checkout.addDiscount(checkoutId, discountCode).then((checkout) => {
       *   // Do something with the updated checkout
       * });
       *
       * @param {String} checkoutId The ID of the checkout to add discount to.
       * @param {String} discountCode The discount code to apply to the checkout.
       * @return {Promise|GraphModel} A promise resolving with the updated checkout.
       */

    }, {
      key: 'addDiscount',
      value: function addDiscount(checkoutId, discountCode) {
        return this.graphQLClient.send(query$19, { checkoutId: checkoutId, discountCode: discountCode }).then(handleCheckoutMutation('checkoutDiscountCodeApplyV2', this.graphQLClient));
      }

      /**
       * Removes the applied discount from an existing checkout.
       *
       * @example
       * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
       *
       * client.checkout.removeDiscount(checkoutId).then((checkout) => {
       *   // Do something with the updated checkout
       * });
       *
       * @param {String} checkoutId The ID of the checkout to remove the discount from.
       * @return {Promise|GraphModel} A promise resolving with the updated checkout.
       */

    }, {
      key: 'removeDiscount',
      value: function removeDiscount(checkoutId) {
        return this.graphQLClient.send(query$20, { checkoutId: checkoutId }).then(handleCheckoutMutation('checkoutDiscountCodeRemove', this.graphQLClient));
      }

      /**
       * Applies gift cards to an existing checkout using a list of gift card codes
       *
       * @example
       * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
       * const giftCardCodes = ['6FD8853DAGAA949F'];
       *
       * client.checkout.addGiftCards(checkoutId, giftCardCodes).then((checkout) => {
       *   // Do something with the updated checkout
       * });
       *
       * @param {String} checkoutId The ID of the checkout to add gift cards to.
       * @param {String[]} giftCardCodes The gift card codes to apply to the checkout.
       * @return {Promise|GraphModel} A promise resolving with the updated checkout.
       */

    }, {
      key: 'addGiftCards',
      value: function addGiftCards(checkoutId, giftCardCodes) {
        return this.graphQLClient.send(query$21, { checkoutId: checkoutId, giftCardCodes: giftCardCodes }).then(handleCheckoutMutation('checkoutGiftCardsAppend', this.graphQLClient));
      }

      /**
       * Remove a gift card from an existing checkout
       *
       * @example
       * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
       * const appliedGiftCardId = 'Z2lkOi8vc2hvcGlmeS9BcHBsaWVkR2lmdENhcmQvNDI4NTQ1ODAzMTI=';
       *
       * client.checkout.removeGiftCard(checkoutId, appliedGiftCardId).then((checkout) => {
       *   // Do something with the updated checkout
       * });
       *
       * @param {String} checkoutId The ID of the checkout to add gift cards to.
       * @param {String} appliedGiftCardId The gift card id to remove from the checkout.
       * @return {Promise|GraphModel} A promise resolving with the updated checkout.
       */

    }, {
      key: 'removeGiftCard',
      value: function removeGiftCard(checkoutId, appliedGiftCardId) {
        return this.graphQLClient.send(query$22, { checkoutId: checkoutId, appliedGiftCardId: appliedGiftCardId }).then(handleCheckoutMutation('checkoutGiftCardRemoveV2', this.graphQLClient));
      }

      /**
       * Removes line items from an existing checkout.
       *
       * @example
       * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
       * const lineItemIds = ['TViZGE5Y2U1ZDFhY2FiMmM2YT9rZXk9NTc2YjBhODcwNWIxYzg0YjE5ZjRmZGQ5NjczNGVkZGU='];
       *
       * client.checkout.removeLineItems(checkoutId, lineItemIds).then((checkout) => {
       *   // Do something with the updated checkout
       * });
       *
       * @param {String} checkoutId The ID of the checkout to remove line items from.
       * @param {String[]} lineItemIds A list of the ids of line items to remove from the checkout.
       * @return {Promise|GraphModel} A promise resolving with the updated checkout.
       */

    }, {
      key: 'removeLineItems',
      value: function removeLineItems(checkoutId, lineItemIds) {
        return this.graphQLClient.send(query$15, { checkoutId: checkoutId, lineItemIds: lineItemIds }).then(handleCheckoutMutation('checkoutLineItemsRemove', this.graphQLClient));
      }

      /**
       * Replace line items on an existing checkout.
       *
       * @example
       * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
       * const lineItems = [{variantId: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8yOTEwNjAyMjc5Mg==', quantity: 5}];
       *
       * client.checkout.replaceLineItems(checkoutId, lineItems).then((checkout) => {
       *   // Do something with the updated checkout
       * });
       *
       * @param {String} checkoutId The ID of the checkout to add line items to.
       * @param {Object[]} lineItems A list of line items to set on the checkout. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/checkoutlineiteminput|Storefront API reference} for valid input fields for each line item.
       * @return {Promise|GraphModel} A promise resolving with the updated checkout.
       */

    }, {
      key: 'replaceLineItems',
      value: function replaceLineItems(checkoutId, lineItems) {
        return this.graphQLClient.send(query$16, { checkoutId: checkoutId, lineItems: lineItems }).then(handleCheckoutMutation('checkoutLineItemsReplace', this.graphQLClient));
      }

      /**
       * Updates line items on an existing checkout.
       *
       * @example
       * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
       * const lineItems = [
       *   {
       *     id: 'TViZGE5Y2U1ZDFhY2FiMmM2YT9rZXk9NTc2YjBhODcwNWIxYzg0YjE5ZjRmZGQ5NjczNGVkZGU=',
       *     quantity: 5,
       *     variantId: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8yOTEwNjAyMjc5Mg=='
       *   }
       * ];
       *
       * client.checkout.updateLineItems(checkoutId, lineItems).then(checkout => {
       *   // Do something with the updated checkout
       * });
       *
       * @param {String} checkoutId The ID of the checkout to update a line item on.
       * @param {Object[]} lineItems A list of line item information to update. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/checkoutlineitemupdateinput|Storefront API reference} for valid input fields for each line item.
       * @return {Promise|GraphModel} A promise resolving with the updated checkout.
       */

    }, {
      key: 'updateLineItems',
      value: function updateLineItems(checkoutId, lineItems) {
        return this.graphQLClient.send(query$17, { checkoutId: checkoutId, lineItems: lineItems }).then(handleCheckoutMutation('checkoutLineItemsUpdate', this.graphQLClient));
      }

      /**
       * Updates shipping address on an existing checkout.
       *
       * @example
       * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
       * const shippingAddress = {
       *    address1: 'Chestnut Street 92',
       *    address2: 'Apartment 2',
       *    city: 'Louisville',
       *    company: null,
       *    country: 'United States',
       *    firstName: 'Bob',
       *    lastName: 'Norman',
       *    phone: '555-625-1199',
       *    province: 'Kentucky',
       *    zip: '40202'
       *  };
       *
       * client.checkout.updateShippingAddress(checkoutId, shippingAddress).then(checkout => {
       *   // Do something with the updated checkout
       * });
       *
       * @param  {String} checkoutId The ID of the checkout to update shipping address.
       * @param  {Object} shippingAddress A shipping address.
       * @return {Promise|GraphModel} A promise resolving with the updated checkout.
       */

    }, {
      key: 'updateShippingAddress',
      value: function updateShippingAddress(checkoutId, shippingAddress) {
        return this.graphQLClient.send(query$24, { checkoutId: checkoutId, shippingAddress: shippingAddress }).then(handleCheckoutMutation('checkoutShippingAddressUpdateV2', this.graphQLClient));
      }
    }]);
    return CheckoutResource;
  }(Resource);

  /**
   * @namespace ImageHelpers
   */
  var imageHelpers = {

    /**
     * Generates the image src for a resized image with maximum dimensions `maxWidth` and `maxHeight`.
     * Images do not scale up.
     *
     * @example
     * const url = client.image.helpers.imageForSize(product.variants[0].image, {maxWidth: 50, maxHeight: 50});
     *
     * @memberof ImageHelpers
     * @method imageForSize
     * @param {Object} image The original image model to generate the image src for.
     * @param {Object} options An options object containing:
     *  @param {Integer} options.maxWidth The maximum width for the image.
     *  @param {Integer} options.maxHeight The maximum height for the image.
     * @return {String} The image src for the resized image.
     */
    imageForSize: function imageForSize(image, _ref) {
      var maxWidth = _ref.maxWidth,
          maxHeight = _ref.maxHeight;

      var splitUrl = image.src.split('?');
      var notQuery = splitUrl[0];
      var query = splitUrl[1] ? '?' + splitUrl[1] : '';

      // Use the section before the query
      var imageTokens = notQuery.split('.');

      // Take the token before the file extension and append the dimensions
      var imagePathIndex = imageTokens.length - 2;

      imageTokens[imagePathIndex] = imageTokens[imagePathIndex] + '_' + maxWidth + 'x' + maxHeight;

      return '' + imageTokens.join('.') + query;
    }
  };

  /**
   * The JS Buy SDK image resource
   * @class
   */

  var ImageResource = function (_Resource) {
    inherits$1(ImageResource, _Resource);

    function ImageResource() {
      classCallCheck$1(this, ImageResource);
      return possibleConstructorReturn$1(this, (ImageResource.__proto__ || Object.getPrototypeOf(ImageResource)).apply(this, arguments));
    }

    createClass$1(ImageResource, [{
      key: 'helpers',
      get: function get$$1() {
        return imageHelpers;
      }
    }]);
    return ImageResource;
  }(Resource);

  var version = "2.19.0";

  var ApiVersion = {
    "name": "ApiVersion",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "displayName": "String",
      "handle": "String",
      "supported": "Boolean"
    },
    "implementsNode": false
  };

  var ApplePayWalletContentInput = {
    "name": "ApplePayWalletContentInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "billingAddress": "MailingAddressInput",
      "data": "String",
      "header": "ApplePayWalletHeaderInput",
      "lastDigits": "String",
      "signature": "String",
      "version": "String"
    }
  };

  var ApplePayWalletHeaderInput = {
    "name": "ApplePayWalletHeaderInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "applicationData": "String",
      "ephemeralPublicKey": "String",
      "publicKeyHash": "String",
      "transactionId": "String"
    }
  };

  var AppliedGiftCard = {
    "name": "AppliedGiftCard",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "amountUsed": "MoneyV2",
      "amountUsedV2": "MoneyV2",
      "balance": "MoneyV2",
      "balanceV2": "MoneyV2",
      "id": "ID",
      "lastCharacters": "String",
      "presentmentAmountUsed": "MoneyV2"
    },
    "implementsNode": true
  };

  var Article = {
    "name": "Article",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "author": "ArticleAuthor",
      "authorV2": "ArticleAuthor",
      "blog": "Blog",
      "comments": "CommentConnection",
      "content": "String",
      "contentHtml": "HTML",
      "excerpt": "String",
      "excerptHtml": "HTML",
      "handle": "String",
      "id": "ID",
      "image": "Image",
      "metafield": "Metafield",
      "metafields": "Metafield",
      "onlineStoreUrl": "URL",
      "publishedAt": "DateTime",
      "seo": "SEO",
      "tags": "String",
      "title": "String"
    },
    "implementsNode": true
  };

  var ArticleAuthor = {
    "name": "ArticleAuthor",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "bio": "String",
      "email": "String",
      "firstName": "String",
      "lastName": "String",
      "name": "String"
    },
    "implementsNode": false
  };

  var ArticleConnection = {
    "name": "ArticleConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "ArticleEdge",
      "nodes": "Article",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };

  var ArticleEdge = {
    "name": "ArticleEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "Article"
    },
    "implementsNode": false
  };

  var ArticleSortKeys = {
    "name": "ArticleSortKeys",
    "kind": "ENUM"
  };

  var Attribute = {
    "name": "Attribute",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "key": "String",
      "value": "String"
    },
    "implementsNode": false
  };

  var AttributeInput = {
    "name": "AttributeInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "key": "String",
      "value": "String"
    }
  };

  var AutomaticDiscountApplication = {
    "name": "AutomaticDiscountApplication",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "allocationMethod": "DiscountApplicationAllocationMethod",
      "targetSelection": "DiscountApplicationTargetSelection",
      "targetType": "DiscountApplicationTargetType",
      "title": "String",
      "value": "PricingValue"
    },
    "implementsNode": false
  };

  var AvailableShippingRates = {
    "name": "AvailableShippingRates",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "ready": "Boolean",
      "shippingRates": "ShippingRate"
    },
    "implementsNode": false
  };

  var BaseCartLine = {
    "name": "BaseCartLine",
    "kind": "INTERFACE",
    "fieldBaseTypes": {
      "attribute": "Attribute",
      "attributes": "Attribute",
      "cost": "CartLineCost",
      "discountAllocations": "CartDiscountAllocation",
      "estimatedCost": "CartLineEstimatedCost",
      "id": "ID",
      "merchandise": "Merchandise",
      "quantity": "Int",
      "sellingPlanAllocation": "SellingPlanAllocation"
    },
    "possibleTypes": ["CartLine"]
  };

  var BaseCartLineConnection = {
    "name": "BaseCartLineConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "BaseCartLineEdge",
      "nodes": "BaseCartLine",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };

  var BaseCartLineEdge = {
    "name": "BaseCartLineEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "BaseCartLine"
    },
    "implementsNode": false
  };

  var Blog = {
    "name": "Blog",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "articleByHandle": "Article",
      "articles": "ArticleConnection",
      "authors": "ArticleAuthor",
      "handle": "String",
      "id": "ID",
      "metafield": "Metafield",
      "metafields": "Metafield",
      "onlineStoreUrl": "URL",
      "seo": "SEO",
      "title": "String"
    },
    "implementsNode": true
  };

  var BlogConnection = {
    "name": "BlogConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "BlogEdge",
      "nodes": "Blog",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };

  var BlogEdge = {
    "name": "BlogEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "Blog"
    },
    "implementsNode": false
  };

  var BlogSortKeys = {
    "name": "BlogSortKeys",
    "kind": "ENUM"
  };

  var Boolean$1 = {
    "name": "Boolean",
    "kind": "SCALAR"
  };

  var Brand = {
    "name": "Brand",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "colors": "BrandColors",
      "coverImage": "MediaImage",
      "logo": "MediaImage",
      "shortDescription": "String",
      "slogan": "String",
      "squareLogo": "MediaImage"
    },
    "implementsNode": false
  };

  var BrandColorGroup = {
    "name": "BrandColorGroup",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "background": "Color",
      "foreground": "Color"
    },
    "implementsNode": false
  };

  var BrandColors = {
    "name": "BrandColors",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "primary": "BrandColorGroup",
      "secondary": "BrandColorGroup"
    },
    "implementsNode": false
  };

  var CardBrand = {
    "name": "CardBrand",
    "kind": "ENUM"
  };

  var Cart = {
    "name": "Cart",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "attribute": "Attribute",
      "attributes": "Attribute",
      "buyerIdentity": "CartBuyerIdentity",
      "checkoutUrl": "URL",
      "cost": "CartCost",
      "createdAt": "DateTime",
      "deliveryGroups": "CartDeliveryGroupConnection",
      "discountAllocations": "CartDiscountAllocation",
      "discountCodes": "CartDiscountCode",
      "estimatedCost": "CartEstimatedCost",
      "id": "ID",
      "lines": "BaseCartLineConnection",
      "metafield": "Metafield",
      "metafields": "Metafield",
      "note": "String",
      "totalQuantity": "Int",
      "updatedAt": "DateTime"
    },
    "implementsNode": true
  };

  var CartAttributesUpdatePayload = {
    "name": "CartAttributesUpdatePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cart": "Cart",
      "userErrors": "CartUserError"
    },
    "implementsNode": false
  };

  var CartAutomaticDiscountAllocation = {
    "name": "CartAutomaticDiscountAllocation",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "discountedAmount": "MoneyV2",
      "title": "String"
    },
    "implementsNode": false
  };

  var CartBuyerIdentity = {
    "name": "CartBuyerIdentity",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "countryCode": "CountryCode",
      "customer": "Customer",
      "deliveryAddressPreferences": "DeliveryAddress",
      "email": "String",
      "phone": "String",
      "walletPreferences": "String"
    },
    "implementsNode": false
  };

  var CartBuyerIdentityInput = {
    "name": "CartBuyerIdentityInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "email": "String",
      "phone": "String",
      "countryCode": "CountryCode",
      "customerAccessToken": "String",
      "deliveryAddressPreferences": "DeliveryAddressInput",
      "walletPreferences": "String"
    }
  };

  var CartBuyerIdentityUpdatePayload = {
    "name": "CartBuyerIdentityUpdatePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cart": "Cart",
      "userErrors": "CartUserError"
    },
    "implementsNode": false
  };

  var CartCodeDiscountAllocation = {
    "name": "CartCodeDiscountAllocation",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "code": "String",
      "discountedAmount": "MoneyV2"
    },
    "implementsNode": false
  };

  var CartCompletionAction = {
    "name": "CartCompletionAction",
    "kind": "UNION"
  };

  var CartCompletionActionRequired = {
    "name": "CartCompletionActionRequired",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "action": "CartCompletionAction",
      "id": "String"
    },
    "implementsNode": false
  };

  var CartCompletionAttemptResult = {
    "name": "CartCompletionAttemptResult",
    "kind": "UNION"
  };

  var CartCompletionFailed = {
    "name": "CartCompletionFailed",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "errors": "CompletionError",
      "id": "String"
    },
    "implementsNode": false
  };

  var CartCompletionProcessing = {
    "name": "CartCompletionProcessing",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "id": "String",
      "pollDelay": "Int"
    },
    "implementsNode": false
  };

  var CartCompletionSuccess = {
    "name": "CartCompletionSuccess",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "completedAt": "DateTime",
      "id": "String",
      "orderId": "ID",
      "orderUrl": "URL"
    },
    "implementsNode": false
  };

  var CartCost = {
    "name": "CartCost",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkoutChargeAmount": "MoneyV2",
      "subtotalAmount": "MoneyV2",
      "subtotalAmountEstimated": "Boolean",
      "totalAmount": "MoneyV2",
      "totalAmountEstimated": "Boolean",
      "totalDutyAmount": "MoneyV2",
      "totalDutyAmountEstimated": "Boolean",
      "totalTaxAmount": "MoneyV2",
      "totalTaxAmountEstimated": "Boolean"
    },
    "implementsNode": false
  };

  var CartCreatePayload = {
    "name": "CartCreatePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cart": "Cart",
      "userErrors": "CartUserError"
    },
    "implementsNode": false
  };

  var CartCustomDiscountAllocation = {
    "name": "CartCustomDiscountAllocation",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "discountedAmount": "MoneyV2",
      "title": "String"
    },
    "implementsNode": false
  };

  var CartDeliveryGroup = {
    "name": "CartDeliveryGroup",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cartLines": "BaseCartLineConnection",
      "deliveryAddress": "MailingAddress",
      "deliveryOptions": "CartDeliveryOption",
      "id": "ID",
      "selectedDeliveryOption": "CartDeliveryOption"
    },
    "implementsNode": false
  };

  var CartDeliveryGroupConnection = {
    "name": "CartDeliveryGroupConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "CartDeliveryGroupEdge",
      "nodes": "CartDeliveryGroup",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };

  var CartDeliveryGroupEdge = {
    "name": "CartDeliveryGroupEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "CartDeliveryGroup"
    },
    "implementsNode": false
  };

  var CartDeliveryOption = {
    "name": "CartDeliveryOption",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "code": "String",
      "deliveryMethodType": "DeliveryMethodType",
      "description": "String",
      "estimatedCost": "MoneyV2",
      "handle": "String",
      "title": "String"
    },
    "implementsNode": false
  };

  var CartDirectPaymentMethodInput = {
    "name": "CartDirectPaymentMethodInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "billingAddress": "MailingAddressInput",
      "sessionId": "String"
    }
  };

  var CartDiscountAllocation = {
    "name": "CartDiscountAllocation",
    "kind": "INTERFACE",
    "fieldBaseTypes": {
      "discountedAmount": "MoneyV2"
    },
    "possibleTypes": ["CartAutomaticDiscountAllocation", "CartCodeDiscountAllocation", "CartCustomDiscountAllocation"]
  };

  var CartDiscountCode = {
    "name": "CartDiscountCode",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "applicable": "Boolean",
      "code": "String"
    },
    "implementsNode": false
  };

  var CartDiscountCodesUpdatePayload = {
    "name": "CartDiscountCodesUpdatePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cart": "Cart",
      "userErrors": "CartUserError"
    },
    "implementsNode": false
  };

  var CartErrorCode = {
    "name": "CartErrorCode",
    "kind": "ENUM"
  };

  var CartEstimatedCost = {
    "name": "CartEstimatedCost",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkoutChargeAmount": "MoneyV2",
      "subtotalAmount": "MoneyV2",
      "totalAmount": "MoneyV2",
      "totalDutyAmount": "MoneyV2",
      "totalTaxAmount": "MoneyV2"
    },
    "implementsNode": false
  };

  var CartFreePaymentMethodInput = {
    "name": "CartFreePaymentMethodInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "billingAddress": "MailingAddressInput"
    }
  };

  var CartInput = {
    "name": "CartInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "attributes": "AttributeInput",
      "lines": "CartLineInput",
      "discountCodes": "String",
      "note": "String",
      "buyerIdentity": "CartBuyerIdentityInput",
      "metafields": "CartInputMetafieldInput"
    }
  };

  var CartInputMetafieldInput = {
    "name": "CartInputMetafieldInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "key": "String",
      "value": "String",
      "type": "String"
    }
  };

  var CartLine = {
    "name": "CartLine",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "attribute": "Attribute",
      "attributes": "Attribute",
      "cost": "CartLineCost",
      "discountAllocations": "CartDiscountAllocation",
      "estimatedCost": "CartLineEstimatedCost",
      "id": "ID",
      "merchandise": "Merchandise",
      "quantity": "Int",
      "sellingPlanAllocation": "SellingPlanAllocation"
    },
    "implementsNode": true
  };

  var CartLineCost = {
    "name": "CartLineCost",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "amountPerQuantity": "MoneyV2",
      "compareAtAmountPerQuantity": "MoneyV2",
      "subtotalAmount": "MoneyV2",
      "totalAmount": "MoneyV2"
    },
    "implementsNode": false
  };

  var CartLineEstimatedCost = {
    "name": "CartLineEstimatedCost",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "amount": "MoneyV2",
      "compareAtAmount": "MoneyV2",
      "subtotalAmount": "MoneyV2",
      "totalAmount": "MoneyV2"
    },
    "implementsNode": false
  };

  var CartLineInput = {
    "name": "CartLineInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "attributes": "AttributeInput",
      "quantity": "Int",
      "merchandiseId": "ID",
      "sellingPlanId": "ID"
    }
  };

  var CartLineUpdateInput = {
    "name": "CartLineUpdateInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "id": "ID",
      "quantity": "Int",
      "merchandiseId": "ID",
      "attributes": "AttributeInput",
      "sellingPlanId": "ID"
    }
  };

  var CartLinesAddPayload = {
    "name": "CartLinesAddPayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cart": "Cart",
      "userErrors": "CartUserError"
    },
    "implementsNode": false
  };

  var CartLinesRemovePayload = {
    "name": "CartLinesRemovePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cart": "Cart",
      "userErrors": "CartUserError"
    },
    "implementsNode": false
  };

  var CartLinesUpdatePayload = {
    "name": "CartLinesUpdatePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cart": "Cart",
      "userErrors": "CartUserError"
    },
    "implementsNode": false
  };

  var CartMetafieldDeleteInput = {
    "name": "CartMetafieldDeleteInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "ownerId": "ID",
      "key": "String"
    }
  };

  var CartMetafieldDeletePayload = {
    "name": "CartMetafieldDeletePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "deletedId": "ID",
      "userErrors": "MetafieldDeleteUserError"
    },
    "implementsNode": false
  };

  var CartMetafieldsSetInput = {
    "name": "CartMetafieldsSetInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "ownerId": "ID",
      "key": "String",
      "value": "String",
      "type": "String"
    }
  };

  var CartMetafieldsSetPayload = {
    "name": "CartMetafieldsSetPayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "metafields": "Metafield",
      "userErrors": "MetafieldsSetUserError"
    },
    "implementsNode": false
  };

  var CartNoteUpdatePayload = {
    "name": "CartNoteUpdatePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cart": "Cart",
      "userErrors": "CartUserError"
    },
    "implementsNode": false
  };

  var CartPaymentInput = {
    "name": "CartPaymentInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "amount": "MoneyInput",
      "sourceIdentifier": "String",
      "freePaymentMethod": "CartFreePaymentMethodInput",
      "directPaymentMethod": "CartDirectPaymentMethodInput",
      "walletPaymentMethod": "CartWalletPaymentMethodInput"
    }
  };

  var CartPaymentUpdatePayload = {
    "name": "CartPaymentUpdatePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cart": "Cart",
      "userErrors": "CartUserError"
    },
    "implementsNode": false
  };

  var CartSelectedDeliveryOptionInput = {
    "name": "CartSelectedDeliveryOptionInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "deliveryGroupId": "ID",
      "deliveryOptionHandle": "String"
    }
  };

  var CartSelectedDeliveryOptionsUpdatePayload = {
    "name": "CartSelectedDeliveryOptionsUpdatePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cart": "Cart",
      "userErrors": "CartUserError"
    },
    "implementsNode": false
  };

  var CartSubmitForCompletionPayload = {
    "name": "CartSubmitForCompletionPayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "result": "CartSubmitForCompletionResult",
      "userErrors": "CartUserError"
    },
    "implementsNode": false
  };

  var CartSubmitForCompletionResult = {
    "name": "CartSubmitForCompletionResult",
    "kind": "UNION"
  };

  var CartUserError = {
    "name": "CartUserError",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "code": "CartErrorCode",
      "field": "String",
      "message": "String"
    },
    "implementsNode": false
  };

  var CartWalletPaymentMethodInput = {
    "name": "CartWalletPaymentMethodInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "applePayWalletContent": "ApplePayWalletContentInput",
      "shopPayWalletContent": "ShopPayWalletContentInput"
    }
  };

  var Checkout = {
    "name": "Checkout",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "appliedGiftCards": "AppliedGiftCard",
      "availableShippingRates": "AvailableShippingRates",
      "buyerIdentity": "CheckoutBuyerIdentity",
      "completedAt": "DateTime",
      "createdAt": "DateTime",
      "currencyCode": "CurrencyCode",
      "customAttributes": "Attribute",
      "discountApplications": "DiscountApplicationConnection",
      "email": "String",
      "id": "ID",
      "lineItems": "CheckoutLineItemConnection",
      "lineItemsSubtotalPrice": "MoneyV2",
      "note": "String",
      "order": "Order",
      "orderStatusUrl": "URL",
      "paymentDue": "MoneyV2",
      "paymentDueV2": "MoneyV2",
      "ready": "Boolean",
      "requiresShipping": "Boolean",
      "shippingAddress": "MailingAddress",
      "shippingDiscountAllocations": "DiscountAllocation",
      "shippingLine": "ShippingRate",
      "subtotalPrice": "MoneyV2",
      "subtotalPriceV2": "MoneyV2",
      "taxExempt": "Boolean",
      "taxesIncluded": "Boolean",
      "totalDuties": "MoneyV2",
      "totalPrice": "MoneyV2",
      "totalPriceV2": "MoneyV2",
      "totalTax": "MoneyV2",
      "totalTaxV2": "MoneyV2",
      "updatedAt": "DateTime",
      "webUrl": "URL"
    },
    "implementsNode": true
  };

  var CheckoutAttributesUpdateV2Input = {
    "name": "CheckoutAttributesUpdateV2Input",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "note": "String",
      "customAttributes": "AttributeInput",
      "allowPartialAddresses": "Boolean"
    }
  };

  var CheckoutAttributesUpdateV2Payload = {
    "name": "CheckoutAttributesUpdateV2Payload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CheckoutBuyerIdentity = {
    "name": "CheckoutBuyerIdentity",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "countryCode": "CountryCode"
    },
    "implementsNode": false
  };

  var CheckoutBuyerIdentityInput = {
    "name": "CheckoutBuyerIdentityInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "countryCode": "CountryCode"
    }
  };

  var CheckoutCompleteFreePayload = {
    "name": "CheckoutCompleteFreePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CheckoutCompleteWithCreditCardV2Payload = {
    "name": "CheckoutCompleteWithCreditCardV2Payload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "payment": "Payment",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CheckoutCompleteWithTokenizedPaymentV3Payload = {
    "name": "CheckoutCompleteWithTokenizedPaymentV3Payload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "payment": "Payment",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CheckoutCreateInput = {
    "name": "CheckoutCreateInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "email": "String",
      "lineItems": "CheckoutLineItemInput",
      "shippingAddress": "MailingAddressInput",
      "note": "String",
      "customAttributes": "AttributeInput",
      "allowPartialAddresses": "Boolean",
      "buyerIdentity": "CheckoutBuyerIdentityInput"
    }
  };

  var CheckoutCreatePayload = {
    "name": "CheckoutCreatePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "queueToken": "String",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CheckoutCustomerAssociateV2Payload = {
    "name": "CheckoutCustomerAssociateV2Payload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "customer": "Customer",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CheckoutCustomerDisassociateV2Payload = {
    "name": "CheckoutCustomerDisassociateV2Payload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CheckoutDiscountCodeApplyV2Payload = {
    "name": "CheckoutDiscountCodeApplyV2Payload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CheckoutDiscountCodeRemovePayload = {
    "name": "CheckoutDiscountCodeRemovePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CheckoutEmailUpdateV2Payload = {
    "name": "CheckoutEmailUpdateV2Payload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CheckoutErrorCode = {
    "name": "CheckoutErrorCode",
    "kind": "ENUM"
  };

  var CheckoutGiftCardRemoveV2Payload = {
    "name": "CheckoutGiftCardRemoveV2Payload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CheckoutGiftCardsAppendPayload = {
    "name": "CheckoutGiftCardsAppendPayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CheckoutLineItem = {
    "name": "CheckoutLineItem",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "customAttributes": "Attribute",
      "discountAllocations": "DiscountAllocation",
      "id": "ID",
      "quantity": "Int",
      "title": "String",
      "unitPrice": "MoneyV2",
      "variant": "ProductVariant"
    },
    "implementsNode": true
  };

  var CheckoutLineItemConnection = {
    "name": "CheckoutLineItemConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "CheckoutLineItemEdge",
      "nodes": "CheckoutLineItem",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };

  var CheckoutLineItemEdge = {
    "name": "CheckoutLineItemEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "CheckoutLineItem"
    },
    "implementsNode": false
  };

  var CheckoutLineItemInput = {
    "name": "CheckoutLineItemInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "customAttributes": "AttributeInput",
      "quantity": "Int",
      "variantId": "ID"
    }
  };

  var CheckoutLineItemUpdateInput = {
    "name": "CheckoutLineItemUpdateInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "id": "ID",
      "variantId": "ID",
      "quantity": "Int",
      "customAttributes": "AttributeInput"
    }
  };

  var CheckoutLineItemsAddPayload = {
    "name": "CheckoutLineItemsAddPayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CheckoutLineItemsRemovePayload = {
    "name": "CheckoutLineItemsRemovePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CheckoutLineItemsReplacePayload = {
    "name": "CheckoutLineItemsReplacePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "userErrors": "CheckoutUserError"
    },
    "implementsNode": false
  };

  var CheckoutLineItemsUpdatePayload = {
    "name": "CheckoutLineItemsUpdatePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CheckoutShippingAddressUpdateV2Payload = {
    "name": "CheckoutShippingAddressUpdateV2Payload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CheckoutShippingLineUpdatePayload = {
    "name": "CheckoutShippingLineUpdatePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkout": "Checkout",
      "checkoutUserErrors": "CheckoutUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CheckoutUserError = {
    "name": "CheckoutUserError",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "code": "CheckoutErrorCode",
      "field": "String",
      "message": "String"
    },
    "implementsNode": false
  };

  var Collection = {
    "name": "Collection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "description": "String",
      "descriptionHtml": "HTML",
      "handle": "String",
      "id": "ID",
      "image": "Image",
      "metafield": "Metafield",
      "metafields": "Metafield",
      "onlineStoreUrl": "URL",
      "products": "ProductConnection",
      "seo": "SEO",
      "title": "String",
      "updatedAt": "DateTime"
    },
    "implementsNode": true
  };

  var CollectionConnection = {
    "name": "CollectionConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "CollectionEdge",
      "nodes": "Collection",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };

  var CollectionEdge = {
    "name": "CollectionEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "Collection"
    },
    "implementsNode": false
  };

  var CollectionSortKeys = {
    "name": "CollectionSortKeys",
    "kind": "ENUM"
  };

  var Color = {
    "name": "Color",
    "kind": "SCALAR"
  };

  var Comment = {
    "name": "Comment",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "author": "CommentAuthor",
      "content": "String",
      "contentHtml": "HTML",
      "id": "ID"
    },
    "implementsNode": true
  };

  var CommentAuthor = {
    "name": "CommentAuthor",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "email": "String",
      "name": "String"
    },
    "implementsNode": false
  };

  var CommentConnection = {
    "name": "CommentConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "CommentEdge",
      "nodes": "Comment",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };

  var CommentEdge = {
    "name": "CommentEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "Comment"
    },
    "implementsNode": false
  };

  var CompletePaymentChallenge = {
    "name": "CompletePaymentChallenge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "redirectUrl": "URL"
    },
    "implementsNode": false
  };

  var CompletionError = {
    "name": "CompletionError",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "code": "CompletionErrorCode",
      "message": "String"
    },
    "implementsNode": false
  };

  var CompletionErrorCode = {
    "name": "CompletionErrorCode",
    "kind": "ENUM"
  };

  var Country = {
    "name": "Country",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "availableLanguages": "Language",
      "currency": "Currency",
      "isoCode": "CountryCode",
      "market": "Market",
      "name": "String",
      "unitSystem": "UnitSystem"
    },
    "implementsNode": false
  };

  var CountryCode = {
    "name": "CountryCode",
    "kind": "ENUM"
  };

  var CreditCard = {
    "name": "CreditCard",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "brand": "String",
      "expiryMonth": "Int",
      "expiryYear": "Int",
      "firstDigits": "String",
      "firstName": "String",
      "lastDigits": "String",
      "lastName": "String",
      "maskedNumber": "String"
    },
    "implementsNode": false
  };

  var CreditCardPaymentInputV2 = {
    "name": "CreditCardPaymentInputV2",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "paymentAmount": "MoneyInput",
      "idempotencyKey": "String",
      "billingAddress": "MailingAddressInput",
      "vaultId": "String",
      "test": "Boolean"
    }
  };

  var CropRegion = {
    "name": "CropRegion",
    "kind": "ENUM"
  };

  var Currency = {
    "name": "Currency",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "isoCode": "CurrencyCode",
      "name": "String",
      "symbol": "String"
    },
    "implementsNode": false
  };

  var CurrencyCode = {
    "name": "CurrencyCode",
    "kind": "ENUM"
  };

  var Customer = {
    "name": "Customer",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "acceptsMarketing": "Boolean",
      "addresses": "MailingAddressConnection",
      "createdAt": "DateTime",
      "defaultAddress": "MailingAddress",
      "displayName": "String",
      "email": "String",
      "firstName": "String",
      "id": "ID",
      "lastIncompleteCheckout": "Checkout",
      "lastName": "String",
      "metafield": "Metafield",
      "metafields": "Metafield",
      "numberOfOrders": "UnsignedInt64",
      "orders": "OrderConnection",
      "phone": "String",
      "tags": "String",
      "updatedAt": "DateTime"
    },
    "implementsNode": false
  };

  var CustomerAccessToken = {
    "name": "CustomerAccessToken",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "accessToken": "String",
      "expiresAt": "DateTime"
    },
    "implementsNode": false
  };

  var CustomerAccessTokenCreateInput = {
    "name": "CustomerAccessTokenCreateInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "email": "String",
      "password": "String"
    }
  };

  var CustomerAccessTokenCreatePayload = {
    "name": "CustomerAccessTokenCreatePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "customerAccessToken": "CustomerAccessToken",
      "customerUserErrors": "CustomerUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CustomerAccessTokenCreateWithMultipassPayload = {
    "name": "CustomerAccessTokenCreateWithMultipassPayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "customerAccessToken": "CustomerAccessToken",
      "customerUserErrors": "CustomerUserError"
    },
    "implementsNode": false
  };

  var CustomerAccessTokenDeletePayload = {
    "name": "CustomerAccessTokenDeletePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "deletedAccessToken": "String",
      "deletedCustomerAccessTokenId": "String",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CustomerAccessTokenRenewPayload = {
    "name": "CustomerAccessTokenRenewPayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "customerAccessToken": "CustomerAccessToken",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CustomerActivateByUrlPayload = {
    "name": "CustomerActivateByUrlPayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "customer": "Customer",
      "customerAccessToken": "CustomerAccessToken",
      "customerUserErrors": "CustomerUserError"
    },
    "implementsNode": false
  };

  var CustomerActivateInput = {
    "name": "CustomerActivateInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "activationToken": "String",
      "password": "String"
    }
  };

  var CustomerActivatePayload = {
    "name": "CustomerActivatePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "customer": "Customer",
      "customerAccessToken": "CustomerAccessToken",
      "customerUserErrors": "CustomerUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CustomerAddressCreatePayload = {
    "name": "CustomerAddressCreatePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "customerAddress": "MailingAddress",
      "customerUserErrors": "CustomerUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CustomerAddressDeletePayload = {
    "name": "CustomerAddressDeletePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "customerUserErrors": "CustomerUserError",
      "deletedCustomerAddressId": "String",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CustomerAddressUpdatePayload = {
    "name": "CustomerAddressUpdatePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "customerAddress": "MailingAddress",
      "customerUserErrors": "CustomerUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CustomerCreateInput = {
    "name": "CustomerCreateInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "firstName": "String",
      "lastName": "String",
      "email": "String",
      "phone": "String",
      "password": "String",
      "acceptsMarketing": "Boolean"
    }
  };

  var CustomerCreatePayload = {
    "name": "CustomerCreatePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "customer": "Customer",
      "customerUserErrors": "CustomerUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CustomerDefaultAddressUpdatePayload = {
    "name": "CustomerDefaultAddressUpdatePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "customer": "Customer",
      "customerUserErrors": "CustomerUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CustomerErrorCode = {
    "name": "CustomerErrorCode",
    "kind": "ENUM"
  };

  var CustomerRecoverPayload = {
    "name": "CustomerRecoverPayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "customerUserErrors": "CustomerUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CustomerResetByUrlPayload = {
    "name": "CustomerResetByUrlPayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "customer": "Customer",
      "customerAccessToken": "CustomerAccessToken",
      "customerUserErrors": "CustomerUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CustomerResetInput = {
    "name": "CustomerResetInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "resetToken": "String",
      "password": "String"
    }
  };

  var CustomerResetPayload = {
    "name": "CustomerResetPayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "customer": "Customer",
      "customerAccessToken": "CustomerAccessToken",
      "customerUserErrors": "CustomerUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CustomerUpdateInput = {
    "name": "CustomerUpdateInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "firstName": "String",
      "lastName": "String",
      "email": "String",
      "phone": "String",
      "password": "String",
      "acceptsMarketing": "Boolean"
    }
  };

  var CustomerUpdatePayload = {
    "name": "CustomerUpdatePayload",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "customer": "Customer",
      "customerAccessToken": "CustomerAccessToken",
      "customerUserErrors": "CustomerUserError",
      "userErrors": "UserError"
    },
    "implementsNode": false
  };

  var CustomerUserError = {
    "name": "CustomerUserError",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "code": "CustomerErrorCode",
      "field": "String",
      "message": "String"
    },
    "implementsNode": false
  };

  var DateTime = {
    "name": "DateTime",
    "kind": "SCALAR"
  };

  var Decimal = {
    "name": "Decimal",
    "kind": "SCALAR"
  };

  var DeliveryAddress = {
    "name": "DeliveryAddress",
    "kind": "UNION"
  };

  var DeliveryAddressInput = {
    "name": "DeliveryAddressInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "deliveryAddress": "MailingAddressInput",
      "customerAddressId": "ID"
    }
  };

  var DeliveryMethodType = {
    "name": "DeliveryMethodType",
    "kind": "ENUM"
  };

  var DigitalWallet = {
    "name": "DigitalWallet",
    "kind": "ENUM"
  };

  var DiscountAllocation = {
    "name": "DiscountAllocation",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "allocatedAmount": "MoneyV2",
      "discountApplication": "DiscountApplication"
    },
    "implementsNode": false
  };

  var DiscountApplication = {
    "name": "DiscountApplication",
    "kind": "INTERFACE",
    "fieldBaseTypes": {
      "allocationMethod": "DiscountApplicationAllocationMethod",
      "targetSelection": "DiscountApplicationTargetSelection",
      "targetType": "DiscountApplicationTargetType",
      "value": "PricingValue"
    },
    "possibleTypes": ["AutomaticDiscountApplication", "DiscountCodeApplication", "ManualDiscountApplication", "ScriptDiscountApplication"]
  };

  var DiscountApplicationAllocationMethod = {
    "name": "DiscountApplicationAllocationMethod",
    "kind": "ENUM"
  };

  var DiscountApplicationConnection = {
    "name": "DiscountApplicationConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "DiscountApplicationEdge",
      "nodes": "DiscountApplication",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };

  var DiscountApplicationEdge = {
    "name": "DiscountApplicationEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "DiscountApplication"
    },
    "implementsNode": false
  };

  var DiscountApplicationTargetSelection = {
    "name": "DiscountApplicationTargetSelection",
    "kind": "ENUM"
  };

  var DiscountApplicationTargetType = {
    "name": "DiscountApplicationTargetType",
    "kind": "ENUM"
  };

  var DiscountCodeApplication = {
    "name": "DiscountCodeApplication",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "allocationMethod": "DiscountApplicationAllocationMethod",
      "applicable": "Boolean",
      "code": "String",
      "targetSelection": "DiscountApplicationTargetSelection",
      "targetType": "DiscountApplicationTargetType",
      "value": "PricingValue"
    },
    "implementsNode": false
  };

  var DisplayableError = {
    "name": "DisplayableError",
    "kind": "INTERFACE",
    "fieldBaseTypes": {
      "field": "String",
      "message": "String"
    },
    "possibleTypes": ["CartUserError", "CheckoutUserError", "CustomerUserError", "MetafieldDeleteUserError", "MetafieldsSetUserError", "UserError"]
  };

  var Domain = {
    "name": "Domain",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "host": "String",
      "sslEnabled": "Boolean",
      "url": "URL"
    },
    "implementsNode": false
  };

  var ExternalVideo = {
    "name": "ExternalVideo",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "alt": "String",
      "embedUrl": "URL",
      "embeddedUrl": "URL",
      "host": "MediaHost",
      "id": "ID",
      "mediaContentType": "MediaContentType",
      "originUrl": "URL",
      "presentation": "MediaPresentation",
      "previewImage": "Image"
    },
    "implementsNode": true
  };

  var Filter = {
    "name": "Filter",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "id": "String",
      "label": "String",
      "type": "FilterType",
      "values": "FilterValue"
    },
    "implementsNode": false
  };

  var FilterType = {
    "name": "FilterType",
    "kind": "ENUM"
  };

  var FilterValue = {
    "name": "FilterValue",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "count": "Int",
      "id": "String",
      "input": "JSON",
      "label": "String"
    },
    "implementsNode": false
  };

  var Float = {
    "name": "Float",
    "kind": "SCALAR"
  };

  var Fulfillment = {
    "name": "Fulfillment",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "fulfillmentLineItems": "FulfillmentLineItemConnection",
      "trackingCompany": "String",
      "trackingInfo": "FulfillmentTrackingInfo"
    },
    "implementsNode": false
  };

  var FulfillmentLineItem = {
    "name": "FulfillmentLineItem",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "lineItem": "OrderLineItem",
      "quantity": "Int"
    },
    "implementsNode": false
  };

  var FulfillmentLineItemConnection = {
    "name": "FulfillmentLineItemConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "FulfillmentLineItemEdge",
      "nodes": "FulfillmentLineItem",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };

  var FulfillmentLineItemEdge = {
    "name": "FulfillmentLineItemEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "FulfillmentLineItem"
    },
    "implementsNode": false
  };

  var FulfillmentTrackingInfo = {
    "name": "FulfillmentTrackingInfo",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "number": "String",
      "url": "URL"
    },
    "implementsNode": false
  };

  var GenericFile = {
    "name": "GenericFile",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "alt": "String",
      "id": "ID",
      "mimeType": "String",
      "originalFileSize": "Int",
      "previewImage": "Image",
      "url": "URL"
    },
    "implementsNode": true
  };

  var GeoCoordinateInput = {
    "name": "GeoCoordinateInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "latitude": "Float",
      "longitude": "Float"
    }
  };

  var HTML = {
    "name": "HTML",
    "kind": "SCALAR"
  };

  var HasMetafields = {
    "name": "HasMetafields",
    "kind": "INTERFACE",
    "fieldBaseTypes": {
      "metafield": "Metafield",
      "metafields": "Metafield"
    },
    "possibleTypes": ["Article", "Blog", "Cart", "Collection", "Customer", "Location", "Market", "Order", "Page", "Product", "ProductVariant", "Shop"]
  };

  var HasMetafieldsIdentifier = {
    "name": "HasMetafieldsIdentifier",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "namespace": "String",
      "key": "String"
    }
  };

  var ID = {
    "name": "ID",
    "kind": "SCALAR"
  };

  var Image = {
    "name": "Image",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "altText": "String",
      "height": "Int",
      "id": "ID",
      "originalSrc": "URL",
      "src": "URL",
      "transformedSrc": "URL",
      "url": "URL",
      "width": "Int"
    },
    "implementsNode": false
  };

  var ImageConnection = {
    "name": "ImageConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "ImageEdge",
      "nodes": "Image",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };

  var ImageContentType = {
    "name": "ImageContentType",
    "kind": "ENUM"
  };

  var ImageEdge = {
    "name": "ImageEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "Image"
    },
    "implementsNode": false
  };

  var ImageTransformInput = {
    "name": "ImageTransformInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "crop": "CropRegion",
      "maxWidth": "Int",
      "maxHeight": "Int",
      "scale": "Int",
      "preferredContentType": "ImageContentType"
    }
  };

  var Int = {
    "name": "Int",
    "kind": "SCALAR"
  };

  var JSON$1 = {
    "name": "JSON",
    "kind": "SCALAR"
  };

  var Language = {
    "name": "Language",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "endonymName": "String",
      "isoCode": "LanguageCode",
      "name": "String"
    },
    "implementsNode": false
  };

  var LanguageCode = {
    "name": "LanguageCode",
    "kind": "ENUM"
  };

  var Localization = {
    "name": "Localization",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "availableCountries": "Country",
      "availableLanguages": "Language",
      "country": "Country",
      "language": "Language",
      "market": "Market"
    },
    "implementsNode": false
  };

  var Location = {
    "name": "Location",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "address": "LocationAddress",
      "id": "ID",
      "metafield": "Metafield",
      "metafields": "Metafield",
      "name": "String"
    },
    "implementsNode": true
  };

  var LocationAddress = {
    "name": "LocationAddress",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "address1": "String",
      "address2": "String",
      "city": "String",
      "country": "String",
      "countryCode": "String",
      "formatted": "String",
      "latitude": "Float",
      "longitude": "Float",
      "phone": "String",
      "province": "String",
      "provinceCode": "String",
      "zip": "String"
    },
    "implementsNode": false
  };

  var LocationConnection = {
    "name": "LocationConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "LocationEdge",
      "nodes": "Location",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };

  var LocationEdge = {
    "name": "LocationEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "Location"
    },
    "implementsNode": false
  };

  var LocationSortKeys = {
    "name": "LocationSortKeys",
    "kind": "ENUM"
  };

  var MailingAddress = {
    "name": "MailingAddress",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "address1": "String",
      "address2": "String",
      "city": "String",
      "company": "String",
      "country": "String",
      "countryCode": "String",
      "countryCodeV2": "CountryCode",
      "firstName": "String",
      "formatted": "String",
      "formattedArea": "String",
      "id": "ID",
      "lastName": "String",
      "latitude": "Float",
      "longitude": "Float",
      "name": "String",
      "phone": "String",
      "province": "String",
      "provinceCode": "String",
      "zip": "String"
    },
    "implementsNode": true
  };

  var MailingAddressConnection = {
    "name": "MailingAddressConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "MailingAddressEdge",
      "nodes": "MailingAddress",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };

  var MailingAddressEdge = {
    "name": "MailingAddressEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "MailingAddress"
    },
    "implementsNode": false
  };

  var MailingAddressInput = {
    "name": "MailingAddressInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "address1": "String",
      "address2": "String",
      "city": "String",
      "company": "String",
      "country": "String",
      "firstName": "String",
      "lastName": "String",
      "phone": "String",
      "province": "String",
      "zip": "String"
    }
  };

  var ManualDiscountApplication = {
    "name": "ManualDiscountApplication",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "allocationMethod": "DiscountApplicationAllocationMethod",
      "description": "String",
      "targetSelection": "DiscountApplicationTargetSelection",
      "targetType": "DiscountApplicationTargetType",
      "title": "String",
      "value": "PricingValue"
    },
    "implementsNode": false
  };

  var Market = {
    "name": "Market",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "handle": "String",
      "id": "ID",
      "metafield": "Metafield",
      "metafields": "Metafield"
    },
    "implementsNode": true
  };

  var Media = {
    "name": "Media",
    "kind": "INTERFACE",
    "fieldBaseTypes": {
      "alt": "String",
      "mediaContentType": "MediaContentType",
      "presentation": "MediaPresentation",
      "previewImage": "Image"
    },
    "possibleTypes": ["ExternalVideo", "MediaImage", "Model3d", "Video"]
  };

  var MediaConnection = {
    "name": "MediaConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "MediaEdge",
      "nodes": "Media",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };

  var MediaContentType = {
    "name": "MediaContentType",
    "kind": "ENUM"
  };

  var MediaEdge = {
    "name": "MediaEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "Media"
    },
    "implementsNode": false
  };

  var MediaHost = {
    "name": "MediaHost",
    "kind": "ENUM"
  };

  var MediaImage = {
    "name": "MediaImage",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "alt": "String",
      "id": "ID",
      "image": "Image",
      "mediaContentType": "MediaContentType",
      "presentation": "MediaPresentation",
      "previewImage": "Image"
    },
    "implementsNode": true
  };

  var MediaPresentation = {
    "name": "MediaPresentation",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "asJson": "JSON",
      "id": "ID"
    },
    "implementsNode": true
  };

  var MediaPresentationFormat = {
    "name": "MediaPresentationFormat",
    "kind": "ENUM"
  };

  var Menu = {
    "name": "Menu",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "handle": "String",
      "id": "ID",
      "items": "MenuItem",
      "itemsCount": "Int",
      "title": "String"
    },
    "implementsNode": true
  };

  var MenuItem = {
    "name": "MenuItem",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "id": "ID",
      "items": "MenuItem",
      "resourceId": "ID",
      "tags": "String",
      "title": "String",
      "type": "MenuItemType",
      "url": "URL"
    },
    "implementsNode": true
  };

  var MenuItemType = {
    "name": "MenuItemType",
    "kind": "ENUM"
  };

  var Merchandise = {
    "name": "Merchandise",
    "kind": "UNION"
  };

  var Metafield = {
    "name": "Metafield",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "createdAt": "DateTime",
      "description": "String",
      "id": "ID",
      "key": "String",
      "namespace": "String",
      "parentResource": "MetafieldParentResource",
      "reference": "MetafieldReference",
      "references": "MetafieldReferenceConnection",
      "type": "String",
      "updatedAt": "DateTime",
      "value": "String"
    },
    "implementsNode": true
  };

  var MetafieldDeleteErrorCode = {
    "name": "MetafieldDeleteErrorCode",
    "kind": "ENUM"
  };

  var MetafieldDeleteUserError = {
    "name": "MetafieldDeleteUserError",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "code": "MetafieldDeleteErrorCode",
      "field": "String",
      "message": "String"
    },
    "implementsNode": false
  };

  var MetafieldFilter = {
    "name": "MetafieldFilter",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "namespace": "String",
      "key": "String",
      "value": "String"
    }
  };

  var MetafieldParentResource = {
    "name": "MetafieldParentResource",
    "kind": "UNION"
  };

  var MetafieldReference = {
    "name": "MetafieldReference",
    "kind": "UNION"
  };

  var MetafieldReferenceConnection = {
    "name": "MetafieldReferenceConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "MetafieldReferenceEdge",
      "nodes": "MetafieldReference",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };

  var MetafieldReferenceEdge = {
    "name": "MetafieldReferenceEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "MetafieldReference"
    },
    "implementsNode": false
  };

  var MetafieldsSetUserError = {
    "name": "MetafieldsSetUserError",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "code": "MetafieldsSetUserErrorCode",
      "elementIndex": "Int",
      "field": "String",
      "message": "String"
    },
    "implementsNode": false
  };

  var MetafieldsSetUserErrorCode = {
    "name": "MetafieldsSetUserErrorCode",
    "kind": "ENUM"
  };

  var Metaobject = {
    "name": "Metaobject",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "field": "MetaobjectField",
      "fields": "MetaobjectField",
      "handle": "String",
      "id": "ID",
      "type": "String",
      "updatedAt": "DateTime"
    },
    "implementsNode": true
  };

  var MetaobjectConnection = {
    "name": "MetaobjectConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "MetaobjectEdge",
      "nodes": "Metaobject",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };

  var MetaobjectEdge = {
    "name": "MetaobjectEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "Metaobject"
    },
    "implementsNode": false
  };

  var MetaobjectField = {
    "name": "MetaobjectField",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "key": "String",
      "reference": "MetafieldReference",
      "references": "MetafieldReferenceConnection",
      "type": "String",
      "value": "String"
    },
    "implementsNode": false
  };

  var MetaobjectHandleInput = {
    "name": "MetaobjectHandleInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "handle": "String",
      "type": "String"
    }
  };

  var Model3d = {
    "name": "Model3d",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "alt": "String",
      "id": "ID",
      "mediaContentType": "MediaContentType",
      "presentation": "MediaPresentation",
      "previewImage": "Image",
      "sources": "Model3dSource"
    },
    "implementsNode": true
  };

  var Model3dSource = {
    "name": "Model3dSource",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "filesize": "Int",
      "format": "String",
      "mimeType": "String",
      "url": "String"
    },
    "implementsNode": false
  };

  var MoneyInput = {
    "name": "MoneyInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "amount": "Decimal",
      "currencyCode": "CurrencyCode"
    }
  };

  var MoneyV2 = {
    "name": "MoneyV2",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "amount": "Decimal",
      "currencyCode": "CurrencyCode"
    },
    "implementsNode": false
  };

  var Mutation$1 = {
    "name": "Mutation",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cartAttributesUpdate": "CartAttributesUpdatePayload",
      "cartBuyerIdentityUpdate": "CartBuyerIdentityUpdatePayload",
      "cartCreate": "CartCreatePayload",
      "cartDiscountCodesUpdate": "CartDiscountCodesUpdatePayload",
      "cartLinesAdd": "CartLinesAddPayload",
      "cartLinesRemove": "CartLinesRemovePayload",
      "cartLinesUpdate": "CartLinesUpdatePayload",
      "cartMetafieldDelete": "CartMetafieldDeletePayload",
      "cartMetafieldsSet": "CartMetafieldsSetPayload",
      "cartNoteUpdate": "CartNoteUpdatePayload",
      "cartPaymentUpdate": "CartPaymentUpdatePayload",
      "cartSelectedDeliveryOptionsUpdate": "CartSelectedDeliveryOptionsUpdatePayload",
      "cartSubmitForCompletion": "CartSubmitForCompletionPayload",
      "checkoutAttributesUpdateV2": "CheckoutAttributesUpdateV2Payload",
      "checkoutCompleteFree": "CheckoutCompleteFreePayload",
      "checkoutCompleteWithCreditCardV2": "CheckoutCompleteWithCreditCardV2Payload",
      "checkoutCompleteWithTokenizedPaymentV3": "CheckoutCompleteWithTokenizedPaymentV3Payload",
      "checkoutCreate": "CheckoutCreatePayload",
      "checkoutCustomerAssociateV2": "CheckoutCustomerAssociateV2Payload",
      "checkoutCustomerDisassociateV2": "CheckoutCustomerDisassociateV2Payload",
      "checkoutDiscountCodeApplyV2": "CheckoutDiscountCodeApplyV2Payload",
      "checkoutDiscountCodeRemove": "CheckoutDiscountCodeRemovePayload",
      "checkoutEmailUpdateV2": "CheckoutEmailUpdateV2Payload",
      "checkoutGiftCardRemoveV2": "CheckoutGiftCardRemoveV2Payload",
      "checkoutGiftCardsAppend": "CheckoutGiftCardsAppendPayload",
      "checkoutLineItemsAdd": "CheckoutLineItemsAddPayload",
      "checkoutLineItemsRemove": "CheckoutLineItemsRemovePayload",
      "checkoutLineItemsReplace": "CheckoutLineItemsReplacePayload",
      "checkoutLineItemsUpdate": "CheckoutLineItemsUpdatePayload",
      "checkoutShippingAddressUpdateV2": "CheckoutShippingAddressUpdateV2Payload",
      "checkoutShippingLineUpdate": "CheckoutShippingLineUpdatePayload",
      "customerAccessTokenCreate": "CustomerAccessTokenCreatePayload",
      "customerAccessTokenCreateWithMultipass": "CustomerAccessTokenCreateWithMultipassPayload",
      "customerAccessTokenDelete": "CustomerAccessTokenDeletePayload",
      "customerAccessTokenRenew": "CustomerAccessTokenRenewPayload",
      "customerActivate": "CustomerActivatePayload",
      "customerActivateByUrl": "CustomerActivateByUrlPayload",
      "customerAddressCreate": "CustomerAddressCreatePayload",
      "customerAddressDelete": "CustomerAddressDeletePayload",
      "customerAddressUpdate": "CustomerAddressUpdatePayload",
      "customerCreate": "CustomerCreatePayload",
      "customerDefaultAddressUpdate": "CustomerDefaultAddressUpdatePayload",
      "customerRecover": "CustomerRecoverPayload",
      "customerReset": "CustomerResetPayload",
      "customerResetByUrl": "CustomerResetByUrlPayload",
      "customerUpdate": "CustomerUpdatePayload"
    },
    "implementsNode": false,
    "relayInputObjectBaseTypes": {
      "cartCreate": "CartInput",
      "cartMetafieldDelete": "CartMetafieldDeleteInput",
      "checkoutAttributesUpdateV2": "CheckoutAttributesUpdateV2Input",
      "checkoutCreate": "CheckoutCreateInput",
      "customerAccessTokenCreate": "CustomerAccessTokenCreateInput",
      "customerActivate": "CustomerActivateInput",
      "customerCreate": "CustomerCreateInput",
      "customerReset": "CustomerResetInput"
    }
  };

  var Node = {
    "name": "Node",
    "kind": "INTERFACE",
    "fieldBaseTypes": {
      "id": "ID"
    },
    "possibleTypes": ["AppliedGiftCard", "Article", "Blog", "Cart", "CartLine", "Checkout", "CheckoutLineItem", "Collection", "Comment", "ExternalVideo", "GenericFile", "Location", "MailingAddress", "Market", "MediaImage", "MediaPresentation", "Menu", "MenuItem", "Metafield", "Metaobject", "Model3d", "Order", "Page", "Payment", "Product", "ProductOption", "ProductVariant", "Shop", "ShopPolicy", "UrlRedirect", "Video"]
  };

  var OnlineStorePublishable = {
    "name": "OnlineStorePublishable",
    "kind": "INTERFACE",
    "fieldBaseTypes": {
      "onlineStoreUrl": "URL"
    },
    "possibleTypes": ["Article", "Blog", "Collection", "Page", "Product"]
  };

  var Order = {
    "name": "Order",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "billingAddress": "MailingAddress",
      "cancelReason": "OrderCancelReason",
      "canceledAt": "DateTime",
      "currencyCode": "CurrencyCode",
      "currentSubtotalPrice": "MoneyV2",
      "currentTotalDuties": "MoneyV2",
      "currentTotalPrice": "MoneyV2",
      "currentTotalTax": "MoneyV2",
      "customAttributes": "Attribute",
      "customerLocale": "String",
      "customerUrl": "URL",
      "discountApplications": "DiscountApplicationConnection",
      "edited": "Boolean",
      "email": "String",
      "financialStatus": "OrderFinancialStatus",
      "fulfillmentStatus": "OrderFulfillmentStatus",
      "id": "ID",
      "lineItems": "OrderLineItemConnection",
      "metafield": "Metafield",
      "metafields": "Metafield",
      "name": "String",
      "orderNumber": "Int",
      "originalTotalDuties": "MoneyV2",
      "originalTotalPrice": "MoneyV2",
      "phone": "String",
      "processedAt": "DateTime",
      "shippingAddress": "MailingAddress",
      "shippingDiscountAllocations": "DiscountAllocation",
      "statusUrl": "URL",
      "subtotalPrice": "MoneyV2",
      "subtotalPriceV2": "MoneyV2",
      "successfulFulfillments": "Fulfillment",
      "totalPrice": "MoneyV2",
      "totalPriceV2": "MoneyV2",
      "totalRefunded": "MoneyV2",
      "totalRefundedV2": "MoneyV2",
      "totalShippingPrice": "MoneyV2",
      "totalShippingPriceV2": "MoneyV2",
      "totalTax": "MoneyV2",
      "totalTaxV2": "MoneyV2"
    },
    "implementsNode": true
  };

  var OrderCancelReason = {
    "name": "OrderCancelReason",
    "kind": "ENUM"
  };

  var OrderConnection = {
    "name": "OrderConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "OrderEdge",
      "nodes": "Order",
      "pageInfo": "PageInfo",
      "totalCount": "UnsignedInt64"
    },
    "implementsNode": false
  };

  var OrderEdge = {
    "name": "OrderEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "Order"
    },
    "implementsNode": false
  };

  var OrderFinancialStatus = {
    "name": "OrderFinancialStatus",
    "kind": "ENUM"
  };

  var OrderFulfillmentStatus = {
    "name": "OrderFulfillmentStatus",
    "kind": "ENUM"
  };

  var OrderLineItem = {
    "name": "OrderLineItem",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "currentQuantity": "Int",
      "customAttributes": "Attribute",
      "discountAllocations": "DiscountAllocation",
      "discountedTotalPrice": "MoneyV2",
      "originalTotalPrice": "MoneyV2",
      "quantity": "Int",
      "title": "String",
      "variant": "ProductVariant"
    },
    "implementsNode": false
  };

  var OrderLineItemConnection = {
    "name": "OrderLineItemConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "OrderLineItemEdge",
      "nodes": "OrderLineItem",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };

  var OrderLineItemEdge = {
    "name": "OrderLineItemEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "OrderLineItem"
    },
    "implementsNode": false
  };

  var OrderSortKeys = {
    "name": "OrderSortKeys",
    "kind": "ENUM"
  };

  var Page = {
    "name": "Page",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "body": "HTML",
      "bodySummary": "String",
      "createdAt": "DateTime",
      "handle": "String",
      "id": "ID",
      "metafield": "Metafield",
      "metafields": "Metafield",
      "onlineStoreUrl": "URL",
      "seo": "SEO",
      "title": "String",
      "updatedAt": "DateTime"
    },
    "implementsNode": true
  };

  var PageConnection = {
    "name": "PageConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "PageEdge",
      "nodes": "Page",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };

  var PageEdge = {
    "name": "PageEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "Page"
    },
    "implementsNode": false
  };

  var PageInfo = {
    "name": "PageInfo",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "endCursor": "String",
      "hasNextPage": "Boolean",
      "hasPreviousPage": "Boolean",
      "startCursor": "String"
    },
    "implementsNode": false
  };

  var PageSortKeys = {
    "name": "PageSortKeys",
    "kind": "ENUM"
  };

  var Payment = {
    "name": "Payment",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "amount": "MoneyV2",
      "amountV2": "MoneyV2",
      "billingAddress": "MailingAddress",
      "checkout": "Checkout",
      "creditCard": "CreditCard",
      "errorMessage": "String",
      "id": "ID",
      "idempotencyKey": "String",
      "nextActionUrl": "URL",
      "ready": "Boolean",
      "test": "Boolean",
      "transaction": "Transaction"
    },
    "implementsNode": true
  };

  var PaymentSettings = {
    "name": "PaymentSettings",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "acceptedCardBrands": "CardBrand",
      "cardVaultUrl": "URL",
      "countryCode": "CountryCode",
      "currencyCode": "CurrencyCode",
      "enabledPresentmentCurrencies": "CurrencyCode",
      "shopifyPaymentsAccountId": "String",
      "supportedDigitalWallets": "DigitalWallet"
    },
    "implementsNode": false
  };

  var PaymentTokenType = {
    "name": "PaymentTokenType",
    "kind": "ENUM"
  };

  var PriceRangeFilter = {
    "name": "PriceRangeFilter",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "min": "Float",
      "max": "Float"
    }
  };

  var PricingPercentageValue = {
    "name": "PricingPercentageValue",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "percentage": "Float"
    },
    "implementsNode": false
  };

  var PricingValue = {
    "name": "PricingValue",
    "kind": "UNION"
  };

  var Product = {
    "name": "Product",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "availableForSale": "Boolean",
      "collections": "CollectionConnection",
      "compareAtPriceRange": "ProductPriceRange",
      "createdAt": "DateTime",
      "description": "String",
      "descriptionHtml": "HTML",
      "featuredImage": "Image",
      "handle": "String",
      "id": "ID",
      "images": "ImageConnection",
      "isGiftCard": "Boolean",
      "media": "MediaConnection",
      "metafield": "Metafield",
      "metafields": "Metafield",
      "onlineStoreUrl": "URL",
      "options": "ProductOption",
      "priceRange": "ProductPriceRange",
      "productType": "String",
      "publishedAt": "DateTime",
      "requiresSellingPlan": "Boolean",
      "sellingPlanGroups": "SellingPlanGroupConnection",
      "seo": "SEO",
      "tags": "String",
      "title": "String",
      "totalInventory": "Int",
      "updatedAt": "DateTime",
      "variantBySelectedOptions": "ProductVariant",
      "variants": "ProductVariantConnection",
      "vendor": "String"
    },
    "implementsNode": true
  };

  var ProductCollectionSortKeys = {
    "name": "ProductCollectionSortKeys",
    "kind": "ENUM"
  };

  var ProductConnection = {
    "name": "ProductConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "ProductEdge",
      "filters": "Filter",
      "nodes": "Product",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };

  var ProductEdge = {
    "name": "ProductEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "Product"
    },
    "implementsNode": false
  };

  var ProductFilter = {
    "name": "ProductFilter",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "available": "Boolean",
      "variantOption": "VariantOptionFilter",
      "productType": "String",
      "productVendor": "String",
      "price": "PriceRangeFilter",
      "productMetafield": "MetafieldFilter",
      "variantMetafield": "MetafieldFilter",
      "tag": "String"
    }
  };

  var ProductImageSortKeys = {
    "name": "ProductImageSortKeys",
    "kind": "ENUM"
  };

  var ProductMediaSortKeys = {
    "name": "ProductMediaSortKeys",
    "kind": "ENUM"
  };

  var ProductOption = {
    "name": "ProductOption",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "id": "ID",
      "name": "String",
      "values": "String"
    },
    "implementsNode": true
  };

  var ProductPriceRange = {
    "name": "ProductPriceRange",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "maxVariantPrice": "MoneyV2",
      "minVariantPrice": "MoneyV2"
    },
    "implementsNode": false
  };

  var ProductRecommendationIntent = {
    "name": "ProductRecommendationIntent",
    "kind": "ENUM"
  };

  var ProductSortKeys = {
    "name": "ProductSortKeys",
    "kind": "ENUM"
  };

  var ProductVariant = {
    "name": "ProductVariant",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "availableForSale": "Boolean",
      "barcode": "String",
      "compareAtPrice": "MoneyV2",
      "compareAtPriceV2": "MoneyV2",
      "currentlyNotInStock": "Boolean",
      "id": "ID",
      "image": "Image",
      "metafield": "Metafield",
      "metafields": "Metafield",
      "price": "MoneyV2",
      "priceV2": "MoneyV2",
      "product": "Product",
      "quantityAvailable": "Int",
      "requiresShipping": "Boolean",
      "selectedOptions": "SelectedOption",
      "sellingPlanAllocations": "SellingPlanAllocationConnection",
      "sku": "String",
      "storeAvailability": "StoreAvailabilityConnection",
      "title": "String",
      "unitPrice": "MoneyV2",
      "unitPriceMeasurement": "UnitPriceMeasurement",
      "weight": "Float",
      "weightUnit": "WeightUnit"
    },
    "implementsNode": true
  };

  var ProductVariantConnection = {
    "name": "ProductVariantConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "ProductVariantEdge",
      "nodes": "ProductVariant",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };

  var ProductVariantEdge = {
    "name": "ProductVariantEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "ProductVariant"
    },
    "implementsNode": false
  };

  var ProductVariantSortKeys = {
    "name": "ProductVariantSortKeys",
    "kind": "ENUM"
  };

  var QueryRoot = {
    "name": "QueryRoot",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "article": "Article",
      "articles": "ArticleConnection",
      "blog": "Blog",
      "blogByHandle": "Blog",
      "blogs": "BlogConnection",
      "cart": "Cart",
      "cartCompletionAttempt": "CartCompletionAttemptResult",
      "collection": "Collection",
      "collectionByHandle": "Collection",
      "collections": "CollectionConnection",
      "customer": "Customer",
      "localization": "Localization",
      "locations": "LocationConnection",
      "menu": "Menu",
      "metaobject": "Metaobject",
      "metaobjects": "MetaobjectConnection",
      "node": "Node",
      "nodes": "Node",
      "page": "Page",
      "pageByHandle": "Page",
      "pages": "PageConnection",
      "product": "Product",
      "productByHandle": "Product",
      "productRecommendations": "Product",
      "productTags": "StringConnection",
      "productTypes": "StringConnection",
      "products": "ProductConnection",
      "publicApiVersions": "ApiVersion",
      "shop": "Shop",
      "urlRedirects": "UrlRedirectConnection"
    },
    "implementsNode": false
  };

  var SEO = {
    "name": "SEO",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "description": "String",
      "title": "String"
    },
    "implementsNode": false
  };

  var ScriptDiscountApplication = {
    "name": "ScriptDiscountApplication",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "allocationMethod": "DiscountApplicationAllocationMethod",
      "targetSelection": "DiscountApplicationTargetSelection",
      "targetType": "DiscountApplicationTargetType",
      "title": "String",
      "value": "PricingValue"
    },
    "implementsNode": false
  };

  var SelectedOption = {
    "name": "SelectedOption",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "name": "String",
      "value": "String"
    },
    "implementsNode": false
  };

  var SelectedOptionInput = {
    "name": "SelectedOptionInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "name": "String",
      "value": "String"
    }
  };

  var SellingPlan = {
    "name": "SellingPlan",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkoutCharge": "SellingPlanCheckoutCharge",
      "description": "String",
      "id": "ID",
      "name": "String",
      "options": "SellingPlanOption",
      "priceAdjustments": "SellingPlanPriceAdjustment",
      "recurringDeliveries": "Boolean"
    },
    "implementsNode": false
  };

  var SellingPlanAllocation = {
    "name": "SellingPlanAllocation",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkoutChargeAmount": "MoneyV2",
      "priceAdjustments": "SellingPlanAllocationPriceAdjustment",
      "remainingBalanceChargeAmount": "MoneyV2",
      "sellingPlan": "SellingPlan"
    },
    "implementsNode": false
  };

  var SellingPlanAllocationConnection = {
    "name": "SellingPlanAllocationConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "SellingPlanAllocationEdge",
      "nodes": "SellingPlanAllocation",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };

  var SellingPlanAllocationEdge = {
    "name": "SellingPlanAllocationEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "SellingPlanAllocation"
    },
    "implementsNode": false
  };

  var SellingPlanAllocationPriceAdjustment = {
    "name": "SellingPlanAllocationPriceAdjustment",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "compareAtPrice": "MoneyV2",
      "perDeliveryPrice": "MoneyV2",
      "price": "MoneyV2",
      "unitPrice": "MoneyV2"
    },
    "implementsNode": false
  };

  var SellingPlanCheckoutCharge = {
    "name": "SellingPlanCheckoutCharge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "type": "SellingPlanCheckoutChargeType",
      "value": "SellingPlanCheckoutChargeValue"
    },
    "implementsNode": false
  };

  var SellingPlanCheckoutChargePercentageValue = {
    "name": "SellingPlanCheckoutChargePercentageValue",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "percentage": "Float"
    },
    "implementsNode": false
  };

  var SellingPlanCheckoutChargeType = {
    "name": "SellingPlanCheckoutChargeType",
    "kind": "ENUM"
  };

  var SellingPlanCheckoutChargeValue = {
    "name": "SellingPlanCheckoutChargeValue",
    "kind": "UNION"
  };

  var SellingPlanConnection = {
    "name": "SellingPlanConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "SellingPlanEdge",
      "nodes": "SellingPlan",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };

  var SellingPlanEdge = {
    "name": "SellingPlanEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "SellingPlan"
    },
    "implementsNode": false
  };

  var SellingPlanFixedAmountPriceAdjustment = {
    "name": "SellingPlanFixedAmountPriceAdjustment",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "adjustmentAmount": "MoneyV2"
    },
    "implementsNode": false
  };

  var SellingPlanFixedPriceAdjustment = {
    "name": "SellingPlanFixedPriceAdjustment",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "price": "MoneyV2"
    },
    "implementsNode": false
  };

  var SellingPlanGroup = {
    "name": "SellingPlanGroup",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "appName": "String",
      "name": "String",
      "options": "SellingPlanGroupOption",
      "sellingPlans": "SellingPlanConnection"
    },
    "implementsNode": false
  };

  var SellingPlanGroupConnection = {
    "name": "SellingPlanGroupConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "SellingPlanGroupEdge",
      "nodes": "SellingPlanGroup",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };

  var SellingPlanGroupEdge = {
    "name": "SellingPlanGroupEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "SellingPlanGroup"
    },
    "implementsNode": false
  };

  var SellingPlanGroupOption = {
    "name": "SellingPlanGroupOption",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "name": "String",
      "values": "String"
    },
    "implementsNode": false
  };

  var SellingPlanOption = {
    "name": "SellingPlanOption",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "name": "String",
      "value": "String"
    },
    "implementsNode": false
  };

  var SellingPlanPercentagePriceAdjustment = {
    "name": "SellingPlanPercentagePriceAdjustment",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "adjustmentPercentage": "Int"
    },
    "implementsNode": false
  };

  var SellingPlanPriceAdjustment = {
    "name": "SellingPlanPriceAdjustment",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "adjustmentValue": "SellingPlanPriceAdjustmentValue",
      "orderCount": "Int"
    },
    "implementsNode": false
  };

  var SellingPlanPriceAdjustmentValue = {
    "name": "SellingPlanPriceAdjustmentValue",
    "kind": "UNION"
  };

  var ShippingRate = {
    "name": "ShippingRate",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "handle": "String",
      "price": "MoneyV2",
      "priceV2": "MoneyV2",
      "title": "String"
    },
    "implementsNode": false
  };

  var Shop = {
    "name": "Shop",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "brand": "Brand",
      "description": "String",
      "id": "ID",
      "metafield": "Metafield",
      "metafields": "Metafield",
      "moneyFormat": "String",
      "name": "String",
      "paymentSettings": "PaymentSettings",
      "primaryDomain": "Domain",
      "privacyPolicy": "ShopPolicy",
      "refundPolicy": "ShopPolicy",
      "shippingPolicy": "ShopPolicy",
      "shipsToCountries": "CountryCode",
      "subscriptionPolicy": "ShopPolicyWithDefault",
      "termsOfService": "ShopPolicy"
    },
    "implementsNode": true
  };

  var ShopPayWalletContentInput = {
    "name": "ShopPayWalletContentInput",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "billingAddress": "MailingAddressInput",
      "sessionToken": "String"
    }
  };

  var ShopPolicy = {
    "name": "ShopPolicy",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "body": "String",
      "handle": "String",
      "id": "ID",
      "title": "String",
      "url": "URL"
    },
    "implementsNode": true
  };

  var ShopPolicyWithDefault = {
    "name": "ShopPolicyWithDefault",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "body": "String",
      "handle": "String",
      "id": "ID",
      "title": "String",
      "url": "URL"
    },
    "implementsNode": false
  };

  var StoreAvailability = {
    "name": "StoreAvailability",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "available": "Boolean",
      "location": "Location",
      "pickUpTime": "String"
    },
    "implementsNode": false
  };

  var StoreAvailabilityConnection = {
    "name": "StoreAvailabilityConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "StoreAvailabilityEdge",
      "nodes": "StoreAvailability",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };

  var StoreAvailabilityEdge = {
    "name": "StoreAvailabilityEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "StoreAvailability"
    },
    "implementsNode": false
  };

  var String$1 = {
    "name": "String",
    "kind": "SCALAR"
  };

  var StringConnection = {
    "name": "StringConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "StringEdge",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };

  var StringEdge = {
    "name": "StringEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "String"
    },
    "implementsNode": false
  };

  var SubmissionError = {
    "name": "SubmissionError",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "code": "SubmissionErrorCode",
      "message": "String"
    },
    "implementsNode": false
  };

  var SubmissionErrorCode = {
    "name": "SubmissionErrorCode",
    "kind": "ENUM"
  };

  var SubmitAlreadyAccepted = {
    "name": "SubmitAlreadyAccepted",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "attemptId": "String"
    },
    "implementsNode": false
  };

  var SubmitFailed = {
    "name": "SubmitFailed",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "checkoutUrl": "URL",
      "errors": "SubmissionError"
    },
    "implementsNode": false
  };

  var SubmitSuccess = {
    "name": "SubmitSuccess",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "attemptId": "String"
    },
    "implementsNode": false
  };

  var SubmitThrottled = {
    "name": "SubmitThrottled",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "pollAfter": "DateTime"
    },
    "implementsNode": false
  };

  var TokenizedPaymentInputV3 = {
    "name": "TokenizedPaymentInputV3",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "paymentAmount": "MoneyInput",
      "idempotencyKey": "String",
      "billingAddress": "MailingAddressInput",
      "paymentData": "String",
      "test": "Boolean",
      "identifier": "String",
      "type": "PaymentTokenType"
    }
  };

  var Transaction = {
    "name": "Transaction",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "amount": "MoneyV2",
      "amountV2": "MoneyV2",
      "kind": "TransactionKind",
      "status": "TransactionStatus",
      "statusV2": "TransactionStatus",
      "test": "Boolean"
    },
    "implementsNode": false
  };

  var TransactionKind = {
    "name": "TransactionKind",
    "kind": "ENUM"
  };

  var TransactionStatus = {
    "name": "TransactionStatus",
    "kind": "ENUM"
  };

  var URL = {
    "name": "URL",
    "kind": "SCALAR"
  };

  var UnitPriceMeasurement = {
    "name": "UnitPriceMeasurement",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "measuredType": "UnitPriceMeasurementMeasuredType",
      "quantityUnit": "UnitPriceMeasurementMeasuredUnit",
      "quantityValue": "Float",
      "referenceUnit": "UnitPriceMeasurementMeasuredUnit",
      "referenceValue": "Int"
    },
    "implementsNode": false
  };

  var UnitPriceMeasurementMeasuredType = {
    "name": "UnitPriceMeasurementMeasuredType",
    "kind": "ENUM"
  };

  var UnitPriceMeasurementMeasuredUnit = {
    "name": "UnitPriceMeasurementMeasuredUnit",
    "kind": "ENUM"
  };

  var UnitSystem = {
    "name": "UnitSystem",
    "kind": "ENUM"
  };

  var UnsignedInt64 = {
    "name": "UnsignedInt64",
    "kind": "SCALAR"
  };

  var UrlRedirect = {
    "name": "UrlRedirect",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "id": "ID",
      "path": "String",
      "target": "String"
    },
    "implementsNode": true
  };

  var UrlRedirectConnection = {
    "name": "UrlRedirectConnection",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "edges": "UrlRedirectEdge",
      "nodes": "UrlRedirect",
      "pageInfo": "PageInfo"
    },
    "implementsNode": false
  };

  var UrlRedirectEdge = {
    "name": "UrlRedirectEdge",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "cursor": "String",
      "node": "UrlRedirect"
    },
    "implementsNode": false
  };

  var UserError = {
    "name": "UserError",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "field": "String",
      "message": "String"
    },
    "implementsNode": false
  };

  var VariantOptionFilter = {
    "name": "VariantOptionFilter",
    "kind": "INPUT_OBJECT",
    "inputFieldBaseTypes": {
      "name": "String",
      "value": "String"
    }
  };

  var Video = {
    "name": "Video",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "alt": "String",
      "id": "ID",
      "mediaContentType": "MediaContentType",
      "presentation": "MediaPresentation",
      "previewImage": "Image",
      "sources": "VideoSource"
    },
    "implementsNode": true
  };

  var VideoSource = {
    "name": "VideoSource",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "format": "String",
      "height": "Int",
      "mimeType": "String",
      "url": "String",
      "width": "Int"
    },
    "implementsNode": false
  };

  var WeightUnit = {
    "name": "WeightUnit",
    "kind": "ENUM"
  };

  var __Directive = {
    "name": "__Directive",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "args": "__InputValue",
      "description": "String",
      "isRepeatable": "Boolean",
      "locations": "__DirectiveLocation",
      "name": "String",
      "onField": "Boolean",
      "onFragment": "Boolean",
      "onOperation": "Boolean"
    },
    "implementsNode": false
  };

  var __DirectiveLocation = {
    "name": "__DirectiveLocation",
    "kind": "ENUM"
  };

  var __EnumValue = {
    "name": "__EnumValue",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "deprecationReason": "String",
      "description": "String",
      "isDeprecated": "Boolean",
      "isPrivatelyDocumented": "Boolean",
      "name": "String"
    },
    "implementsNode": false
  };

  var __Field = {
    "name": "__Field",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "accessRestricted": "Boolean",
      "accessRestrictedReason": "String",
      "args": "__InputValue",
      "deprecationReason": "String",
      "description": "String",
      "isDeprecated": "Boolean",
      "isPrivatelyDocumented": "Boolean",
      "isProtected": "Boolean",
      "name": "String",
      "protectedContent": "String",
      "protectedSubject": "String",
      "requiredAccess": "String",
      "type": "__Type"
    },
    "implementsNode": false
  };

  var __InputValue = {
    "name": "__InputValue",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "defaultValue": "String",
      "deprecationReason": "String",
      "description": "String",
      "gidTypes": "String",
      "isDeprecated": "Boolean",
      "name": "String",
      "type": "__Type"
    },
    "implementsNode": false
  };

  var __Schema = {
    "name": "__Schema",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "description": "String",
      "directives": "__Directive",
      "mutationType": "__Type",
      "queryType": "__Type",
      "subscriptionType": "__Type",
      "types": "__Type"
    },
    "implementsNode": false
  };

  var __Type = {
    "name": "__Type",
    "kind": "OBJECT",
    "fieldBaseTypes": {
      "accessRestricted": "Boolean",
      "accessRestrictedReason": "String",
      "componentName": "String",
      "description": "String",
      "enumValues": "__EnumValue",
      "fields": "__Field",
      "inputFields": "__InputValue",
      "interfaces": "__Type",
      "isOneOf": "Boolean",
      "isPrivatelyDocumented": "Boolean",
      "isProtected": "Boolean",
      "kind": "__TypeKind",
      "name": "String",
      "ofType": "__Type",
      "possibleTypes": "__Type",
      "protectedSubject": "String",
      "requiredAccess": "String",
      "specifiedByURL": "String"
    },
    "implementsNode": false
  };

  var __TypeKind = {
    "name": "__TypeKind",
    "kind": "ENUM"
  };

  var Types = {
    types: {}
  };
  Types.types["ApiVersion"] = ApiVersion;
  Types.types["ApplePayWalletContentInput"] = ApplePayWalletContentInput;
  Types.types["ApplePayWalletHeaderInput"] = ApplePayWalletHeaderInput;
  Types.types["AppliedGiftCard"] = AppliedGiftCard;
  Types.types["Article"] = Article;
  Types.types["ArticleAuthor"] = ArticleAuthor;
  Types.types["ArticleConnection"] = ArticleConnection;
  Types.types["ArticleEdge"] = ArticleEdge;
  Types.types["ArticleSortKeys"] = ArticleSortKeys;
  Types.types["Attribute"] = Attribute;
  Types.types["AttributeInput"] = AttributeInput;
  Types.types["AutomaticDiscountApplication"] = AutomaticDiscountApplication;
  Types.types["AvailableShippingRates"] = AvailableShippingRates;
  Types.types["BaseCartLine"] = BaseCartLine;
  Types.types["BaseCartLineConnection"] = BaseCartLineConnection;
  Types.types["BaseCartLineEdge"] = BaseCartLineEdge;
  Types.types["Blog"] = Blog;
  Types.types["BlogConnection"] = BlogConnection;
  Types.types["BlogEdge"] = BlogEdge;
  Types.types["BlogSortKeys"] = BlogSortKeys;
  Types.types["Boolean"] = Boolean$1;
  Types.types["Brand"] = Brand;
  Types.types["BrandColorGroup"] = BrandColorGroup;
  Types.types["BrandColors"] = BrandColors;
  Types.types["CardBrand"] = CardBrand;
  Types.types["Cart"] = Cart;
  Types.types["CartAttributesUpdatePayload"] = CartAttributesUpdatePayload;
  Types.types["CartAutomaticDiscountAllocation"] = CartAutomaticDiscountAllocation;
  Types.types["CartBuyerIdentity"] = CartBuyerIdentity;
  Types.types["CartBuyerIdentityInput"] = CartBuyerIdentityInput;
  Types.types["CartBuyerIdentityUpdatePayload"] = CartBuyerIdentityUpdatePayload;
  Types.types["CartCodeDiscountAllocation"] = CartCodeDiscountAllocation;
  Types.types["CartCompletionAction"] = CartCompletionAction;
  Types.types["CartCompletionActionRequired"] = CartCompletionActionRequired;
  Types.types["CartCompletionAttemptResult"] = CartCompletionAttemptResult;
  Types.types["CartCompletionFailed"] = CartCompletionFailed;
  Types.types["CartCompletionProcessing"] = CartCompletionProcessing;
  Types.types["CartCompletionSuccess"] = CartCompletionSuccess;
  Types.types["CartCost"] = CartCost;
  Types.types["CartCreatePayload"] = CartCreatePayload;
  Types.types["CartCustomDiscountAllocation"] = CartCustomDiscountAllocation;
  Types.types["CartDeliveryGroup"] = CartDeliveryGroup;
  Types.types["CartDeliveryGroupConnection"] = CartDeliveryGroupConnection;
  Types.types["CartDeliveryGroupEdge"] = CartDeliveryGroupEdge;
  Types.types["CartDeliveryOption"] = CartDeliveryOption;
  Types.types["CartDirectPaymentMethodInput"] = CartDirectPaymentMethodInput;
  Types.types["CartDiscountAllocation"] = CartDiscountAllocation;
  Types.types["CartDiscountCode"] = CartDiscountCode;
  Types.types["CartDiscountCodesUpdatePayload"] = CartDiscountCodesUpdatePayload;
  Types.types["CartErrorCode"] = CartErrorCode;
  Types.types["CartEstimatedCost"] = CartEstimatedCost;
  Types.types["CartFreePaymentMethodInput"] = CartFreePaymentMethodInput;
  Types.types["CartInput"] = CartInput;
  Types.types["CartInputMetafieldInput"] = CartInputMetafieldInput;
  Types.types["CartLine"] = CartLine;
  Types.types["CartLineCost"] = CartLineCost;
  Types.types["CartLineEstimatedCost"] = CartLineEstimatedCost;
  Types.types["CartLineInput"] = CartLineInput;
  Types.types["CartLineUpdateInput"] = CartLineUpdateInput;
  Types.types["CartLinesAddPayload"] = CartLinesAddPayload;
  Types.types["CartLinesRemovePayload"] = CartLinesRemovePayload;
  Types.types["CartLinesUpdatePayload"] = CartLinesUpdatePayload;
  Types.types["CartMetafieldDeleteInput"] = CartMetafieldDeleteInput;
  Types.types["CartMetafieldDeletePayload"] = CartMetafieldDeletePayload;
  Types.types["CartMetafieldsSetInput"] = CartMetafieldsSetInput;
  Types.types["CartMetafieldsSetPayload"] = CartMetafieldsSetPayload;
  Types.types["CartNoteUpdatePayload"] = CartNoteUpdatePayload;
  Types.types["CartPaymentInput"] = CartPaymentInput;
  Types.types["CartPaymentUpdatePayload"] = CartPaymentUpdatePayload;
  Types.types["CartSelectedDeliveryOptionInput"] = CartSelectedDeliveryOptionInput;
  Types.types["CartSelectedDeliveryOptionsUpdatePayload"] = CartSelectedDeliveryOptionsUpdatePayload;
  Types.types["CartSubmitForCompletionPayload"] = CartSubmitForCompletionPayload;
  Types.types["CartSubmitForCompletionResult"] = CartSubmitForCompletionResult;
  Types.types["CartUserError"] = CartUserError;
  Types.types["CartWalletPaymentMethodInput"] = CartWalletPaymentMethodInput;
  Types.types["Checkout"] = Checkout;
  Types.types["CheckoutAttributesUpdateV2Input"] = CheckoutAttributesUpdateV2Input;
  Types.types["CheckoutAttributesUpdateV2Payload"] = CheckoutAttributesUpdateV2Payload;
  Types.types["CheckoutBuyerIdentity"] = CheckoutBuyerIdentity;
  Types.types["CheckoutBuyerIdentityInput"] = CheckoutBuyerIdentityInput;
  Types.types["CheckoutCompleteFreePayload"] = CheckoutCompleteFreePayload;
  Types.types["CheckoutCompleteWithCreditCardV2Payload"] = CheckoutCompleteWithCreditCardV2Payload;
  Types.types["CheckoutCompleteWithTokenizedPaymentV3Payload"] = CheckoutCompleteWithTokenizedPaymentV3Payload;
  Types.types["CheckoutCreateInput"] = CheckoutCreateInput;
  Types.types["CheckoutCreatePayload"] = CheckoutCreatePayload;
  Types.types["CheckoutCustomerAssociateV2Payload"] = CheckoutCustomerAssociateV2Payload;
  Types.types["CheckoutCustomerDisassociateV2Payload"] = CheckoutCustomerDisassociateV2Payload;
  Types.types["CheckoutDiscountCodeApplyV2Payload"] = CheckoutDiscountCodeApplyV2Payload;
  Types.types["CheckoutDiscountCodeRemovePayload"] = CheckoutDiscountCodeRemovePayload;
  Types.types["CheckoutEmailUpdateV2Payload"] = CheckoutEmailUpdateV2Payload;
  Types.types["CheckoutErrorCode"] = CheckoutErrorCode;
  Types.types["CheckoutGiftCardRemoveV2Payload"] = CheckoutGiftCardRemoveV2Payload;
  Types.types["CheckoutGiftCardsAppendPayload"] = CheckoutGiftCardsAppendPayload;
  Types.types["CheckoutLineItem"] = CheckoutLineItem;
  Types.types["CheckoutLineItemConnection"] = CheckoutLineItemConnection;
  Types.types["CheckoutLineItemEdge"] = CheckoutLineItemEdge;
  Types.types["CheckoutLineItemInput"] = CheckoutLineItemInput;
  Types.types["CheckoutLineItemUpdateInput"] = CheckoutLineItemUpdateInput;
  Types.types["CheckoutLineItemsAddPayload"] = CheckoutLineItemsAddPayload;
  Types.types["CheckoutLineItemsRemovePayload"] = CheckoutLineItemsRemovePayload;
  Types.types["CheckoutLineItemsReplacePayload"] = CheckoutLineItemsReplacePayload;
  Types.types["CheckoutLineItemsUpdatePayload"] = CheckoutLineItemsUpdatePayload;
  Types.types["CheckoutShippingAddressUpdateV2Payload"] = CheckoutShippingAddressUpdateV2Payload;
  Types.types["CheckoutShippingLineUpdatePayload"] = CheckoutShippingLineUpdatePayload;
  Types.types["CheckoutUserError"] = CheckoutUserError;
  Types.types["Collection"] = Collection;
  Types.types["CollectionConnection"] = CollectionConnection;
  Types.types["CollectionEdge"] = CollectionEdge;
  Types.types["CollectionSortKeys"] = CollectionSortKeys;
  Types.types["Color"] = Color;
  Types.types["Comment"] = Comment;
  Types.types["CommentAuthor"] = CommentAuthor;
  Types.types["CommentConnection"] = CommentConnection;
  Types.types["CommentEdge"] = CommentEdge;
  Types.types["CompletePaymentChallenge"] = CompletePaymentChallenge;
  Types.types["CompletionError"] = CompletionError;
  Types.types["CompletionErrorCode"] = CompletionErrorCode;
  Types.types["Country"] = Country;
  Types.types["CountryCode"] = CountryCode;
  Types.types["CreditCard"] = CreditCard;
  Types.types["CreditCardPaymentInputV2"] = CreditCardPaymentInputV2;
  Types.types["CropRegion"] = CropRegion;
  Types.types["Currency"] = Currency;
  Types.types["CurrencyCode"] = CurrencyCode;
  Types.types["Customer"] = Customer;
  Types.types["CustomerAccessToken"] = CustomerAccessToken;
  Types.types["CustomerAccessTokenCreateInput"] = CustomerAccessTokenCreateInput;
  Types.types["CustomerAccessTokenCreatePayload"] = CustomerAccessTokenCreatePayload;
  Types.types["CustomerAccessTokenCreateWithMultipassPayload"] = CustomerAccessTokenCreateWithMultipassPayload;
  Types.types["CustomerAccessTokenDeletePayload"] = CustomerAccessTokenDeletePayload;
  Types.types["CustomerAccessTokenRenewPayload"] = CustomerAccessTokenRenewPayload;
  Types.types["CustomerActivateByUrlPayload"] = CustomerActivateByUrlPayload;
  Types.types["CustomerActivateInput"] = CustomerActivateInput;
  Types.types["CustomerActivatePayload"] = CustomerActivatePayload;
  Types.types["CustomerAddressCreatePayload"] = CustomerAddressCreatePayload;
  Types.types["CustomerAddressDeletePayload"] = CustomerAddressDeletePayload;
  Types.types["CustomerAddressUpdatePayload"] = CustomerAddressUpdatePayload;
  Types.types["CustomerCreateInput"] = CustomerCreateInput;
  Types.types["CustomerCreatePayload"] = CustomerCreatePayload;
  Types.types["CustomerDefaultAddressUpdatePayload"] = CustomerDefaultAddressUpdatePayload;
  Types.types["CustomerErrorCode"] = CustomerErrorCode;
  Types.types["CustomerRecoverPayload"] = CustomerRecoverPayload;
  Types.types["CustomerResetByUrlPayload"] = CustomerResetByUrlPayload;
  Types.types["CustomerResetInput"] = CustomerResetInput;
  Types.types["CustomerResetPayload"] = CustomerResetPayload;
  Types.types["CustomerUpdateInput"] = CustomerUpdateInput;
  Types.types["CustomerUpdatePayload"] = CustomerUpdatePayload;
  Types.types["CustomerUserError"] = CustomerUserError;
  Types.types["DateTime"] = DateTime;
  Types.types["Decimal"] = Decimal;
  Types.types["DeliveryAddress"] = DeliveryAddress;
  Types.types["DeliveryAddressInput"] = DeliveryAddressInput;
  Types.types["DeliveryMethodType"] = DeliveryMethodType;
  Types.types["DigitalWallet"] = DigitalWallet;
  Types.types["DiscountAllocation"] = DiscountAllocation;
  Types.types["DiscountApplication"] = DiscountApplication;
  Types.types["DiscountApplicationAllocationMethod"] = DiscountApplicationAllocationMethod;
  Types.types["DiscountApplicationConnection"] = DiscountApplicationConnection;
  Types.types["DiscountApplicationEdge"] = DiscountApplicationEdge;
  Types.types["DiscountApplicationTargetSelection"] = DiscountApplicationTargetSelection;
  Types.types["DiscountApplicationTargetType"] = DiscountApplicationTargetType;
  Types.types["DiscountCodeApplication"] = DiscountCodeApplication;
  Types.types["DisplayableError"] = DisplayableError;
  Types.types["Domain"] = Domain;
  Types.types["ExternalVideo"] = ExternalVideo;
  Types.types["Filter"] = Filter;
  Types.types["FilterType"] = FilterType;
  Types.types["FilterValue"] = FilterValue;
  Types.types["Float"] = Float;
  Types.types["Fulfillment"] = Fulfillment;
  Types.types["FulfillmentLineItem"] = FulfillmentLineItem;
  Types.types["FulfillmentLineItemConnection"] = FulfillmentLineItemConnection;
  Types.types["FulfillmentLineItemEdge"] = FulfillmentLineItemEdge;
  Types.types["FulfillmentTrackingInfo"] = FulfillmentTrackingInfo;
  Types.types["GenericFile"] = GenericFile;
  Types.types["GeoCoordinateInput"] = GeoCoordinateInput;
  Types.types["HTML"] = HTML;
  Types.types["HasMetafields"] = HasMetafields;
  Types.types["HasMetafieldsIdentifier"] = HasMetafieldsIdentifier;
  Types.types["ID"] = ID;
  Types.types["Image"] = Image;
  Types.types["ImageConnection"] = ImageConnection;
  Types.types["ImageContentType"] = ImageContentType;
  Types.types["ImageEdge"] = ImageEdge;
  Types.types["ImageTransformInput"] = ImageTransformInput;
  Types.types["Int"] = Int;
  Types.types["JSON"] = JSON$1;
  Types.types["Language"] = Language;
  Types.types["LanguageCode"] = LanguageCode;
  Types.types["Localization"] = Localization;
  Types.types["Location"] = Location;
  Types.types["LocationAddress"] = LocationAddress;
  Types.types["LocationConnection"] = LocationConnection;
  Types.types["LocationEdge"] = LocationEdge;
  Types.types["LocationSortKeys"] = LocationSortKeys;
  Types.types["MailingAddress"] = MailingAddress;
  Types.types["MailingAddressConnection"] = MailingAddressConnection;
  Types.types["MailingAddressEdge"] = MailingAddressEdge;
  Types.types["MailingAddressInput"] = MailingAddressInput;
  Types.types["ManualDiscountApplication"] = ManualDiscountApplication;
  Types.types["Market"] = Market;
  Types.types["Media"] = Media;
  Types.types["MediaConnection"] = MediaConnection;
  Types.types["MediaContentType"] = MediaContentType;
  Types.types["MediaEdge"] = MediaEdge;
  Types.types["MediaHost"] = MediaHost;
  Types.types["MediaImage"] = MediaImage;
  Types.types["MediaPresentation"] = MediaPresentation;
  Types.types["MediaPresentationFormat"] = MediaPresentationFormat;
  Types.types["Menu"] = Menu;
  Types.types["MenuItem"] = MenuItem;
  Types.types["MenuItemType"] = MenuItemType;
  Types.types["Merchandise"] = Merchandise;
  Types.types["Metafield"] = Metafield;
  Types.types["MetafieldDeleteErrorCode"] = MetafieldDeleteErrorCode;
  Types.types["MetafieldDeleteUserError"] = MetafieldDeleteUserError;
  Types.types["MetafieldFilter"] = MetafieldFilter;
  Types.types["MetafieldParentResource"] = MetafieldParentResource;
  Types.types["MetafieldReference"] = MetafieldReference;
  Types.types["MetafieldReferenceConnection"] = MetafieldReferenceConnection;
  Types.types["MetafieldReferenceEdge"] = MetafieldReferenceEdge;
  Types.types["MetafieldsSetUserError"] = MetafieldsSetUserError;
  Types.types["MetafieldsSetUserErrorCode"] = MetafieldsSetUserErrorCode;
  Types.types["Metaobject"] = Metaobject;
  Types.types["MetaobjectConnection"] = MetaobjectConnection;
  Types.types["MetaobjectEdge"] = MetaobjectEdge;
  Types.types["MetaobjectField"] = MetaobjectField;
  Types.types["MetaobjectHandleInput"] = MetaobjectHandleInput;
  Types.types["Model3d"] = Model3d;
  Types.types["Model3dSource"] = Model3dSource;
  Types.types["MoneyInput"] = MoneyInput;
  Types.types["MoneyV2"] = MoneyV2;
  Types.types["Mutation"] = Mutation$1;
  Types.types["Node"] = Node;
  Types.types["OnlineStorePublishable"] = OnlineStorePublishable;
  Types.types["Order"] = Order;
  Types.types["OrderCancelReason"] = OrderCancelReason;
  Types.types["OrderConnection"] = OrderConnection;
  Types.types["OrderEdge"] = OrderEdge;
  Types.types["OrderFinancialStatus"] = OrderFinancialStatus;
  Types.types["OrderFulfillmentStatus"] = OrderFulfillmentStatus;
  Types.types["OrderLineItem"] = OrderLineItem;
  Types.types["OrderLineItemConnection"] = OrderLineItemConnection;
  Types.types["OrderLineItemEdge"] = OrderLineItemEdge;
  Types.types["OrderSortKeys"] = OrderSortKeys;
  Types.types["Page"] = Page;
  Types.types["PageConnection"] = PageConnection;
  Types.types["PageEdge"] = PageEdge;
  Types.types["PageInfo"] = PageInfo;
  Types.types["PageSortKeys"] = PageSortKeys;
  Types.types["Payment"] = Payment;
  Types.types["PaymentSettings"] = PaymentSettings;
  Types.types["PaymentTokenType"] = PaymentTokenType;
  Types.types["PriceRangeFilter"] = PriceRangeFilter;
  Types.types["PricingPercentageValue"] = PricingPercentageValue;
  Types.types["PricingValue"] = PricingValue;
  Types.types["Product"] = Product;
  Types.types["ProductCollectionSortKeys"] = ProductCollectionSortKeys;
  Types.types["ProductConnection"] = ProductConnection;
  Types.types["ProductEdge"] = ProductEdge;
  Types.types["ProductFilter"] = ProductFilter;
  Types.types["ProductImageSortKeys"] = ProductImageSortKeys;
  Types.types["ProductMediaSortKeys"] = ProductMediaSortKeys;
  Types.types["ProductOption"] = ProductOption;
  Types.types["ProductPriceRange"] = ProductPriceRange;
  Types.types["ProductRecommendationIntent"] = ProductRecommendationIntent;
  Types.types["ProductSortKeys"] = ProductSortKeys;
  Types.types["ProductVariant"] = ProductVariant;
  Types.types["ProductVariantConnection"] = ProductVariantConnection;
  Types.types["ProductVariantEdge"] = ProductVariantEdge;
  Types.types["ProductVariantSortKeys"] = ProductVariantSortKeys;
  Types.types["QueryRoot"] = QueryRoot;
  Types.types["SEO"] = SEO;
  Types.types["ScriptDiscountApplication"] = ScriptDiscountApplication;
  Types.types["SelectedOption"] = SelectedOption;
  Types.types["SelectedOptionInput"] = SelectedOptionInput;
  Types.types["SellingPlan"] = SellingPlan;
  Types.types["SellingPlanAllocation"] = SellingPlanAllocation;
  Types.types["SellingPlanAllocationConnection"] = SellingPlanAllocationConnection;
  Types.types["SellingPlanAllocationEdge"] = SellingPlanAllocationEdge;
  Types.types["SellingPlanAllocationPriceAdjustment"] = SellingPlanAllocationPriceAdjustment;
  Types.types["SellingPlanCheckoutCharge"] = SellingPlanCheckoutCharge;
  Types.types["SellingPlanCheckoutChargePercentageValue"] = SellingPlanCheckoutChargePercentageValue;
  Types.types["SellingPlanCheckoutChargeType"] = SellingPlanCheckoutChargeType;
  Types.types["SellingPlanCheckoutChargeValue"] = SellingPlanCheckoutChargeValue;
  Types.types["SellingPlanConnection"] = SellingPlanConnection;
  Types.types["SellingPlanEdge"] = SellingPlanEdge;
  Types.types["SellingPlanFixedAmountPriceAdjustment"] = SellingPlanFixedAmountPriceAdjustment;
  Types.types["SellingPlanFixedPriceAdjustment"] = SellingPlanFixedPriceAdjustment;
  Types.types["SellingPlanGroup"] = SellingPlanGroup;
  Types.types["SellingPlanGroupConnection"] = SellingPlanGroupConnection;
  Types.types["SellingPlanGroupEdge"] = SellingPlanGroupEdge;
  Types.types["SellingPlanGroupOption"] = SellingPlanGroupOption;
  Types.types["SellingPlanOption"] = SellingPlanOption;
  Types.types["SellingPlanPercentagePriceAdjustment"] = SellingPlanPercentagePriceAdjustment;
  Types.types["SellingPlanPriceAdjustment"] = SellingPlanPriceAdjustment;
  Types.types["SellingPlanPriceAdjustmentValue"] = SellingPlanPriceAdjustmentValue;
  Types.types["ShippingRate"] = ShippingRate;
  Types.types["Shop"] = Shop;
  Types.types["ShopPayWalletContentInput"] = ShopPayWalletContentInput;
  Types.types["ShopPolicy"] = ShopPolicy;
  Types.types["ShopPolicyWithDefault"] = ShopPolicyWithDefault;
  Types.types["StoreAvailability"] = StoreAvailability;
  Types.types["StoreAvailabilityConnection"] = StoreAvailabilityConnection;
  Types.types["StoreAvailabilityEdge"] = StoreAvailabilityEdge;
  Types.types["String"] = String$1;
  Types.types["StringConnection"] = StringConnection;
  Types.types["StringEdge"] = StringEdge;
  Types.types["SubmissionError"] = SubmissionError;
  Types.types["SubmissionErrorCode"] = SubmissionErrorCode;
  Types.types["SubmitAlreadyAccepted"] = SubmitAlreadyAccepted;
  Types.types["SubmitFailed"] = SubmitFailed;
  Types.types["SubmitSuccess"] = SubmitSuccess;
  Types.types["SubmitThrottled"] = SubmitThrottled;
  Types.types["TokenizedPaymentInputV3"] = TokenizedPaymentInputV3;
  Types.types["Transaction"] = Transaction;
  Types.types["TransactionKind"] = TransactionKind;
  Types.types["TransactionStatus"] = TransactionStatus;
  Types.types["URL"] = URL;
  Types.types["UnitPriceMeasurement"] = UnitPriceMeasurement;
  Types.types["UnitPriceMeasurementMeasuredType"] = UnitPriceMeasurementMeasuredType;
  Types.types["UnitPriceMeasurementMeasuredUnit"] = UnitPriceMeasurementMeasuredUnit;
  Types.types["UnitSystem"] = UnitSystem;
  Types.types["UnsignedInt64"] = UnsignedInt64;
  Types.types["UrlRedirect"] = UrlRedirect;
  Types.types["UrlRedirectConnection"] = UrlRedirectConnection;
  Types.types["UrlRedirectEdge"] = UrlRedirectEdge;
  Types.types["UserError"] = UserError;
  Types.types["VariantOptionFilter"] = VariantOptionFilter;
  Types.types["Video"] = Video;
  Types.types["VideoSource"] = VideoSource;
  Types.types["WeightUnit"] = WeightUnit;
  Types.types["__Directive"] = __Directive;
  Types.types["__DirectiveLocation"] = __DirectiveLocation;
  Types.types["__EnumValue"] = __EnumValue;
  Types.types["__Field"] = __Field;
  Types.types["__InputValue"] = __InputValue;
  Types.types["__Schema"] = __Schema;
  Types.types["__Type"] = __Type;
  Types.types["__TypeKind"] = __TypeKind;
  Types.queryType = "QueryRoot";
  Types.mutationType = "Mutation";
  Types.subscriptionType = null;

  function recursivelyFreezeObject(structure) {
    Object.getOwnPropertyNames(structure).forEach(function (key) {
      var value = structure[key];
      if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object') {
        recursivelyFreezeObject(value);
      }
    });
    Object.freeze(structure);
    return structure;
  }

  var types = recursivelyFreezeObject(Types);

  // GraphQL
  /**
   * The JS Buy SDK Client.
   * @class
   *
   * @property {ProductResource} product The property under which product fetching methods live.
   * @property {CollectionResource} collection The property under which collection fetching methods live.
   * @property {ShopResource} shop The property under which shop fetching methods live.
   * @property {CheckoutResource} checkout The property under which shop fetching and mutating methods live.
   * @property {ImageResource} image The property under which image helper methods live.
   */

  var Client = function () {
    createClass$1(Client, null, [{
      key: 'buildClient',


      /**
       * Primary entry point for building a new Client.
       */
      value: function buildClient(config, fetchFunction) {
        var newConfig = new Config(config);
        var client = new Client(newConfig, Client$2, fetchFunction);

        client.config = newConfig;

        return client;
      }

      /**
       * @constructs Client
       * @param {Config} config An instance of {@link Config} used to configure the Client.
       */

    }]);

    function Client(config) {
      var GraphQLClientClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Client$2;
      var fetchFunction = arguments[2];
      classCallCheck$1(this, Client);

      var url = 'https://' + config.domain + '/api/' + config.apiVersion + '/graphql';

      var headers = {
        'X-SDK-Variant': 'javascript',
        'X-SDK-Version': version,
        'X-Shopify-Storefront-Access-Token': config.storefrontAccessToken
      };

      if (config.source) {
        headers['X-SDK-Variant-Source'] = config.source;
      }

      var languageHeader = config.language ? config.language : '*';

      headers['Accept-Language'] = languageHeader;

      if (fetchFunction) {
        headers['Content-Type'] = 'application/json';
        headers.Accept = 'application/json';

        this.graphQLClient = new GraphQLClientClass(types, {
          fetcher: function fetcher(graphQLParams) {
            return fetchFunction(url, {
              body: JSON.stringify(graphQLParams),
              method: 'POST',
              mode: 'cors',
              headers: headers
            }).then(function (response) {
              return response.json();
            });
          }
        });
      } else {
        this.graphQLClient = new GraphQLClientClass(types, {
          url: url,
          fetcherOptions: { headers: headers }
        });
      }

      this.product = new ProductResource(this.graphQLClient);
      this.collection = new CollectionResource(this.graphQLClient);
      this.shop = new ShopResource(this.graphQLClient);
      this.checkout = new CheckoutResource(this.graphQLClient);
      this.image = new ImageResource(this.graphQLClient);
    }

    /**
     * Fetches the next page of models
     *
     * @example
     * client.fetchNextPage(products).then((nextProducts) => {
     *   // Do something with the products
     * });
     *
     * @param {models} [Array] The paginated set to fetch the next page of
     * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the type provided.
     */


    createClass$1(Client, [{
      key: 'fetchNextPage',
      value: function fetchNextPage(models) {
        return this.graphQLClient.fetchNextPage(models);
      }
    }]);
    return Client;
  }();

  return Client;

  })));

  });

  const Tienda = index_unoptimized_umd.buildClient({
    domain: 'rodin.es',
    storefrontAccessToken: '8db7ae76ca6983a3d1ecd9332316ac00'
  });

  const llaveDeLocalStorage = "arte-rodin-carrito";
  const PRODUCCIÓN = window.location.origin === "https://rodin.es";
  async function agregarProductosAjax(lineItems) {
    // lineItems => {id:idDeVariante,quantity:cantidad}
    return await $.ajax({
      type: "POST",
      contentType: "application/json",
      url: "/cart/add.js",
      data: JSON.stringify({
        items: lineItems
      }),
      dataType: "json",
      success: data => {
        return data;
      }
    }).then(data => {
      return {
        error: false,
        data
      };
    }).catch(r => {
      return {
        error: true,
        data: undefined
      };
    });
  }
  async function vaciarProductosAjax() {
    return await $.ajax({
      type: "POST",
      url: "/cart/clear.js",
      dataType: "json",
      success: data => {
        return data;
      }
    }).then(data => {
      return {
        error: false,
        data
      };
    }).catch(r => {
      return {
        error: true,
        data: undefined
      };
    });
  }
  async function actualizarAjaxCarrito() {
    const checkout = await obtenerCheckout();
    return await vaciarProductosAjax().then(r => {
      const lineItems = checkout.lineItems.map(({
        variant: {
          id
        },
        quantity
      }) => {
        id = Number(id.replace("gid://shopify/ProductVariant/", ""));
        return {
          id,
          quantity
        };
      });
      return lineItems.length ? agregarProductosAjax(lineItems) : false;
    }).then(() => {
      return obtenerCarritoAjax();
    }).catch(r => {
      throw new Error("Error en carrito ajax");
    });
  }
  function errorEnLineItems(lineItems) {
    return [!Array.isArray(lineItems), lineItems.some(({
      variantId,
      quantity
    }) => {
      return typeof variantId !== "string" || isNaN(quantity);
    })].some(error => error);
  }
  async function obtenerCarritoAjax() {
    return fetch("/cart.js", {
      method: "GET"
    }).then(respuesta => {
      return respuesta.json();
    });
  }
  async function crearNuevoCheckout() {
    const checkout = await Tienda.checkout.create().then(checkout => checkout);
    window.localStorage.setItem(llaveDeLocalStorage, JSON.stringify(checkout.id));
    return checkout;
  }
  function obtenerTokenLocal() {
    return JSON.parse(window.localStorage.getItem(llaveDeLocalStorage));
  }
  async function obtenerCheckout() {
    return await Tienda.checkout.fetch(obtenerTokenLocal()).then(checkout => checkout).catch(() => {
      return iniciarCarrito();
    });
  }
  async function iniciarCarrito() {
    const local = obtenerTokenLocal();
    const error = await Promise.all([new Promise((resolve, rejcet) => {
      resolve(typeof local !== "string" || local == "");
    }), Tienda.checkout.fetch(local || "").then(checkout => !checkout).catch(() => {
      return true;
    })]);
    if (error.some(error => error)) {
      return await crearNuevoCheckout();
    }
    return await Tienda.checkout.fetch(obtenerTokenLocal()).then(async checkout => {
      if (PRODUCCIÓN) {
        await actualizarAjaxCarrito().then(r => console.log(r));
      }
      return checkout;
    }).catch(r => {
      console.log(r);
      return false;
    });
  }
  async function agergarProductos(lineItems, update = false) {
    const error = errorEnLineItems(lineItems);
    if (error) {
      throw new Error("Error en estructura de lineItems");
    }
    return await Tienda.checkout[update ? "updateLineItems" : "addLineItems"](obtenerTokenLocal(), lineItems).then(checkout => checkout).catch(r => {
      console.log(r);
      return false;
    });
  }
  async function reemplazarProductos(lineItems) {
    const error = errorEnLineItems(lineItems);
    if (error) {
      throw new Error("Error en estructura de lineItems");
    }
    return await Tienda.checkout.replaceLineItems(obtenerTokenLocal(), lineItems).then(checkout => checkout).catch(() => {
      return false;
    });
  }
  async function eliminarProductos(lineItems) {
    return await Tienda.checkout.removeLineItems(obtenerTokenLocal(), lineItems).then(checkout => checkout).catch(r => {
      return false;
    });
  }
  async function vaciarCarrito() {
    return await obtenerCheckout().then(async checkout => {
      if (checkout) {
        const {
          lineItems
        } = checkout;
        return eliminarProductos(lineItems.map(({
          id
        }) => {
          return id;
        }));
      } else {
        return false;
      }
    });
  }
  function formatoLineItems(selección) {
    const lineItems = [];
    for (let id in selección) {
      const {
        cantidad
      } = selección[id];
      lineItems.push({
        variantId: id,
        quantity: cantidad
      });
    }
    return lineItems;
  }
  const buscarDescuentoPorProducto = async product_id => {
    if (PRODUCCIÓN) {
      return await $.ajax({
        type: "GET",
        dataType: "json",
        url: "https://qd2.tengrowth.com/discount/",
        data: {
          pid: window.atob(product_id).replace("gid://shopify/Product/", ""),
          store_id: "rodinespana.myshopify.com",
          theme: Shopify.theme.name,
          price: 1,
          currency: Shopify.currency.active,
          currency_rate: Shopify.currency.rate,
          customer: ""
        },
        crossDomain: true
      }).then(function (data) {
        if (data != "") {
          var res = JSON.parse(data);
          return res.html;
        }
        return false;
      }).catch(() => {
        return false;
      });
    }
    return new Promise((resolve, reject) => {
      resolve(false);
    });
  };
  async function obtenerDescuentos(cart) {
    const carrito = await obtenerCarritoAjax();
    let data = {
      cart_data: JSON.stringify(carrito.items),
      store_id: "rodinespana.myshopify.com",
      theme: Shopify.theme.name,
      currency: Shopify.currency.active,
      currency_rate: Shopify.currency.rate,
      customer: meta ? meta.page.customerId : "",
      code: ""
    };
    return await $.ajax({
      type: "POST",
      url: "https://qd2.tengrowth.com/discount/get_cart_details",
      data: data,
      crossDomain: true,
      dataType: "json",
      success: data => {
        return data;
      }
    }).then(data => {
      data = JSON.parse(data);
      if (typeof data.discounts == "object" && typeof data.discounts.cart == "object" && typeof data.discounts.cart.items == "object") {
        data.discounts.cart.items = data.discounts.cart.items.reduce((mapa, item) => {
          mapa[item.key.split(":")[0]] = item;
          return mapa;
        }, {});
      }
      return data.discounts || false;
    }).catch(r => {
      return false;
    });
  }
  var Checkout = {
    buscarDescuentoPorProducto,
    iniciar: iniciarCarrito,
    formatoLineItems,
    agregar: async lineItems => {
      return obtenerCheckout().then(async checkout => {
        const actualizar = [];
        const nuevos = lineItems.reduce((agregar, lineItem) => {
          const existe = checkout.lineItems.find(({
            variant: {
              id
            }
          }) => {
            return id == lineItem.variantId;
          });
          if (existe) {
            lineItem.id = existe.id;
            actualizar.push(lineItem);
          } else {
            agregar.push(lineItem);
          }
          return agregar;
        }, []);
        return await Promise.all([agergarProductos(nuevos, false), agergarProductos(actualizar, true)]).then(async ([agregado, actualizado]) => {
          const errors = Boolean(!agregado && !actualizado);
          const checkout = await obtenerCheckout();
          return {
            errors,
            checkout
          };
        });
      });
    },
    reemplazar: reemplazarProductos,
    eliminar: eliminarProductos,
    obtener: obtenerCheckout,
    vaciarCarrito,
    obtenerResúmen: async () => {
      let subtotal, total;
      if (PRODUCCIÓN) {
        obtenerDescuentos().then(r => {
          console.log(r);
        });
        const carrito = await obtenerCarritoAjax();
        const descuentos = await obtenerDescuentos();
        subtotal = descuentos.discounted_price_total || carrito.items_subtotal_price;
        total = descuentos.discounted_price_total || carrito.total_price;
        total = (total / 100).toFixed(2);
        subtotal = (subtotal / 100).toFixed(2);
      }
      return {
        subtotal,
        total
      };
    },
    obtenerCarritoAjax,
    actualizarAjaxCarrito,
    descuentos: obtenerDescuentos
  };

  const tiposDeProductos = {
    "lápices de carboncillo": "punta",
    "lápices acuareables": "punta",
    "lápices base aceite": "punta",
    bloc: "tamaño",
    lapices: "punta",
    pincel: "tamaño",
    pintura: "ml",
    rotulador: "punta",
    "lápices base cera": "punta",
    medios: "ml",
    aerosol: "ml",
    soportes: "tamaño",
    "tableta y pantalla gráfica": "tamaño",
    "derwent expositor": "genérica",
    "derwent muestras": "genérica",
    accesorio: "genérica",
    derwent: "genérica",
    "arte y ocio": "genérica"
  };
  const errorEnDatosDeVariante = datos => {
    let errors = [() => {
      return Object.values(datos).some(v => {
        return v == undefined;
      });
    }, () => {
      return !chroma.valid(datos.color);
    }];
    return errors.some(error => {
      return error();
    });
  };
  const obtenerEfectos = (efecto = "") => {
    efecto = efecto.toLowerCase();
    const tipos = [["metálico", efecto.match(/met[á|a]lico[s]*/)], ["neon", efecto.match(/neon/)], ["fluorescente", efecto.match(/fl[u|o][o|u]r[e]*s[e]*cente[s]*/)], ["glitter", efecto.match(/gli[t]+er/)]];
    const tipo = tipos.find(([nombre, efecto]) => {
      return efecto;
    });
    return tipo ? tipo[0] : false;
  };
  const obtenerTipoDeVariante = producto => {
    const color = producto.options.find(({
      name
    }) => {
      return name.toLowerCase() == "color";
    });
    if (color) {
      return "color";
    }
    const tamaño = producto.options.find(({
      name
    }) => {
      return name.toLowerCase() == "tamaño";
    });
    if (tamaño) {
      return "tamaño";
    }
    return "default";
  };
  const extrearDatosDeVariante = (variant, {
    tipoDeVariante,
    options,
    handle
  }) => {
    let título = "",
      color = "",
      efecto = "",
      textura = "",
      acabado = "",
      tamaño = "";
    if (tipoDeVariante == "color") {
      const tamañoEsLaVariante = options.findIndex(o => {
        return o.name.toLowerCase().match("tamaño");
      }) == 0;
      let data = variant.title.split("/");
      if (data.length > 2) {
        data = [data.slice(0, data.length - 1).join("/"), data[data.length - 1]];
      }
      if (data.length == 2) {
        tamaño = data[tamañoEsLaVariante ? 0 : 1].trim().toLowerCase();
        [título, color, efecto, textura, acabado] = data[tamañoEsLaVariante ? 1 : 0].split("|").map(v => {
          return v.trim();
        });
      }
      if (errorEnDatosDeVariante({
        título,
        color,
        efecto,
        textura,
        acabado,
        tamaño
      })) {
        alert(`
          Mensaje de Error
          ----------------- 
          Tipo : Nomenclatura de variante incorrecta,
          Servridad: baja,
          Mensaje: variante no disponible hasta corregir nomenclatura, 
          Variante: ${variant.title},
          Handle: ${handle}
        `);
      }
    } else if (tipoDeVariante == "tamaño") {
      [título, efecto, textura, acabado] = variant.title.split("|").map(v => {
        return v.trim();
      });
      tamaño = título;
      color = false;
    } else {
      [título, efecto, textura, acabado] = variant.title.split("|").map(v => {
        return v.trim();
      });
      tamaño = false;
      color = false;
    }
    [título, color, efecto, textura, acabado, tamaño] = [título, color, obtenerEfectos(efecto), textura, acabado, tamaño].map(v => Boolean(v) ? v : false);
    return {
      título,
      color,
      efecto,
      textura,
      acabado,
      tamaño
    };
  };
  const obtenerColores = async producto => {
    if (producto.tipoDeVariante != "color") {
      return false;
    }
    const colores = producto.variantes.concat(producto.familia.flat()).reduce((colores, variante) => {
      const {
        color
      } = variante;
      if (!colores[color]) {
        colores[color] = [];
      }
      colores[color].push(variante);
      return colores;
    }, {});
    for (let color in colores) {
      colores[color] = ordenarPorTamaño(colores[color]);
    }
    return ordenarColores(colores);
  };
  const ordenarPorTamaño = variantes => {
    let número = !variantes.some(v => {
      if (v.tamaño === undefined) ;
      return !v.tamaño.match(/[0-9]+/);
    });
    let ordenarPorNúmero = ({
      tamaño: t1
    }, {
      tamaño: t2
    }) => {
      return Number(t1.match(/[0-9]+/)[0]) - Number(t2.match(/[0-9]+/)[0]);
    };
    let ordernarPorTexto = (a, b) => {
      a.tamaño.localeCompare(b.tamaño);
    };
    return variantes.sort(número ? ordenarPorNúmero : ordernarPorTexto);
  };
  const limpiarVariantes = producto => {
    const marca = producto.vendor;
    return producto.variants.edges.map(({
      node: variante
    }) => {
      const {
        price: precio,
        quantityAvailable: existencias,
        id,
        compareAtPriceV2: precioComparativo
      } = variante;
      const {
        título,
        color,
        efecto,
        textura,
        acabado,
        tamaño
      } = extrearDatosDeVariante(variante, producto);
      return {
        id,
        precioComparativo: precioComparativo && Number(precioComparativo) ? Number(precioComparativo.amount).toFixed(2) : "",
        marca,
        color,
        efecto,
        textura,
        acabado,
        tamaño,
        título,
        precio: precio.amount,
        existencias
      };
    });
  };
  const obtenerPrecio = ({
    variantes
  }) => {
    if (variantes.length > 1) {
      return variantes.reduce((p1, {
        precio: p2
      }) => {
        p1 = Number(p1);
        p2 = Number(p2);
        return Math.min(p1, p2);
      }, variantes[0].precio).toFixed(2);
    }
    return Number(variantes[0].precio).toFixed(2);
  };
  const extrearImágenes = ({
    edges
  }) => {
    return edges.map(({
      node
    }) => {
      return node.originalSrc;
    });
  };
  const limpiarColecciones = ({
    collections: {
      edges
    }
  }) => {
    return edges.map(({
      node: {
        handle,
        id,
        title: título
      }
    }) => {
      return {
        handle,
        id,
        título
      };
    });
  };
  const obtenerPrecioComparativo = prodcuto => {
    const {
      compareAtPriceRange: {
        maxVariantPrice: {
          amount: max
        },
        minVariantPrice: {
          amount: min
        }
      }
    } = prodcuto;
    return Number(min) ? Number(min).toFixed(2) : "";
  };
  const limpiarProducto = async (producto, buscarColores = false) => {
    producto.tipoDeVariante = obtenerTipoDeVariante(producto);
    producto.variantes = limpiarVariantes(producto);
    producto.images = extrearImágenes(producto.images);
    producto.collections = producto.collections ? limpiarColecciones(producto) : false;
    producto.colores = buscarColores ? await obtenerColores(producto) : false;
    const precio = obtenerPrecio(producto);
    const precioComparativo = obtenerPrecioComparativo(producto);
    const {
      id,
      colores,
      title: título,
      images: imágenes,
      handle,
      vendor: marca,
      descriptionHtml: descripción,
      tags: etiquetas,
      productType: tipo,
      collections: colecciones
    } = producto;
    return {
      id,
      colores,
      tipoDeVariante: producto.tipoDeVariante,
      variantes: producto.variantes,
      título,
      precioComparativo,
      precio,
      handle,
      imágenes,
      marca,
      descripción,
      etiquetas,
      unidadDeMedición: tiposDeProductos[tipo.toLowerCase()] || "cantidad",
      colecciones
    };
  };

  const Conexiones = {};
  Conexiones.metafield = ({
    namespace,
    campos,
    recurso
  }) => {
    return recurso.addConnection("metafields", {
      args: {
        namespace,
        first: 10
      }
    }, metafield => {
      campos.forEach(campo => metafield.add(campo));
    });
  };
  Conexiones.imágenes = ({
    args,
    recurso
  }) => {
    const campos = ["id", "originalSrc", "transformedSrc"];
    return recurso.addConnection("images", {
      args
    }, imágenes => {
      campos.forEach(campo => imágenes.add(campo));
    });
  };
  Conexiones.colecciones = ({
    args,
    recurso
  }) => {
    return recurso.addConnection("collections", {
      args
    }, producto => {
      const campos = "id,title,handle";
      campos.split(",").forEach(campo => producto.add(campo));
    });
  };
  Conexiones.variants = ({
    args,
    recurso
  }) => {
    return recurso.addConnection("variants", {
      args
    }, producto => {
      const campos = "id,title,weight,availableForSale,sku,quantityAvailable";
      campos.split(",").forEach(campo => producto.add(campo));
      producto.addField("price", price => {
        ["amount", "currencyCode"].forEach(campo => price.add(campo));
      });
      producto.addField("compareAtPrice", price => {
        ["amount", "currencyCode"].forEach(campo => price.add(campo));
      });
      producto.addField("metafield", {
        args: {
          namespace: "producto",
          key: ""
        }
      }, metafield => {
        ["key", "namespace", "value"].forEach(campo => metafield.add(campo));
      });
    });
  };
  Conexiones.productoBásico = ({
    args,
    recurso
  }) => {
    return recurso.addConnection("products", {
      args
    }, producto => {
      const campos = "id,availableForSale,createdAt,updatedAt,descriptionHtml,tags,description,handle,productType,title,vendor,publishedAt,onlineStoreUrl";
      campos.split(",").forEach(campo => producto.add(campo));
      producto.addField("options", {}, options => {
        ["id", "name", "values"].forEach(campo => options.add(campo));
      });
      producto.addField("compareAtPriceRange", {}, precio => {
        ["maxVariantPrice", "minVariantPrice"].forEach(campo => {
          precio.addField(campo, {}, campo => {
            campo.add("amount");
          });
        });
      });
      Conexiones.imágenes({
        args: {
          first: 10
        },
        recurso: producto
      });
      Conexiones.colecciones({
        args: {
          first: 10
        },
        recurso: producto
      });
      Conexiones.variants({
        args: {
          first: 10
        },
        recurso: producto
      });
    });
  };

  const Consultas$1 = {};
  Consultas$1.productoPorHandle = handle => {
    handle = decodeURI(handle);
    return Tienda.graphQLClient.query(raíz => {
      raíz.add("productByHandle", {
        args: {
          handle
        }
      }, producto => {
        const campos = "id,availableForSale,createdAt,updatedAt,tags,descriptionHtml,description,handle,productType,title,vendor,publishedAt,onlineStoreUrl";
        campos.split(",").forEach(campo => producto.add(campo));
        producto.addField("options", {}, options => {
          ["id", "name", "values"].forEach(campo => options.add(campo));
        });
        producto.addField("compareAtPriceRange", {}, precio => {
          ["maxVariantPrice", "minVariantPrice"].forEach(campo => {
            precio.addField(campo, {}, campo => {
              campo.add("amount");
            });
          });
        });
        Conexiones.imágenes({
          args: {
            first: 10
          },
          recurso: producto
        });
        Conexiones.variants({
          args: {
            first: 100
          },
          recurso: producto
        });
      });
    });
  };
  Consultas$1.consultaDeProductos = consulta => {
    const str = `tag:${consulta} OR title:${consulta}`;
    return Tienda.graphQLClient.query(raíz => {
      Conexiones.productoBásico({
        args: {
          first: 25,
          query: str
        },
        recurso: raíz
      });
    });
  };
  Consultas$1.productosRelacionados = tags => {
    tags = tags.reduce((str, tag, i, arreglo) => {
      if (i == 0) {
        str = `tag:${tag}`;
      } else {
        str = `${str} OR ${tag}`;
      }
      return str;
    }, "");
    return Tienda.graphQLClient.query(raíz => {
      let args = {
        first: 10,
        query: tags
      };
      Conexiones.productoBásico({
        args,
        recurso: raíz
      });
    });
  };
  const consultaDeProductos = async consulta => {
    return Tienda.graphQLClient.send(Consultas$1.consultaDeProductos(consulta)).then(async ({
      errors,
      data,
      model
    }) => {
      const resultado = {
        producto: undefined,
        errors,
        model: model ? model.products : undefined
      };
      if (data) {
        errors = [];
        const {
          products: {
            edges,
            pageInfo: {
              hasNextPage
            }
          }
        } = data;
        resultado.hasNextPage = hasNextPage;
        resultado.producto = await Promise.all(edges.map(async ({
          node: prodcuto
        }) => {
          return limpiarProducto(prodcuto);
        }));
      }
      return resultado;
    });
  };

  const EventosDeWishList = new Observer(["lista actualizada", "agrego producto", "elimino producto"]);
  const llaveDeStorage = "rodin-es-wishlist";
  let LISTA = [];
  function iniciar() {
    let existe = window.localStorage.getItem(llaveDeStorage);
    if (existe) {
      LISTA = JSON.parse(existe);
    } else {
      LISTA = [];
    }
  }
  function obtener() {
    return LISTA.map(producto => producto);
  }
  iniciar();

  const Consultas = {};
  const Peticiones = {};
  const LlaveDeUsuario = "acceso-arte-rodin-storefront";
  const actualizarTokenLocal = token => {
    window.localStorage.setItem(LlaveDeUsuario, JSON.stringify(token));
  };
  const obtenerTokeLocal = () => {
    const data = window.localStorage.getItem(LlaveDeUsuario);
    return data == "" || data == null ? {} : JSON.parse(data);
  };
  Consultas.actualizarDomicilio = ({
    id,
    address,
    customerAccessToken
  }) => {
    const args = {
      args: {
        address,
        id,
        customerAccessToken
      }
    };
    return Tienda.graphQLClient.mutation("customerAddressUpdate", mutation => {
      mutation.add("customerAddressUpdate", args, respuesta => {
        respuesta.add("customerAddress", domicilio => {
          ["address1", "address2", "city", "company", "country", "firstName", "formatted", "zip", "phone", "lastName", "province"].forEach(campo => {
            domicilio.add(campo);
          });
        });
        respuesta.addField("customerUserErrors", errors => {
          ["code", "field", "message"].forEach(campo => {
            errors.add(campo);
          });
        });
      });
    });
  };
  Consultas.eliminarDomicilio = ({
    id,
    customerAccessToken
  }) => {
    const args = {
      args: {
        id,
        customerAccessToken
      }
    };
    return Tienda.graphQLClient.mutation("customerAddressDelete", mutation => {
      mutation.add("customerAddressDelete", args, respuesta => {
        respuesta.add("deletedCustomerAddressId");
        respuesta.addField("customerUserErrors", errors => {
          ["code", "field", "message"].forEach(campo => {
            errors.add(campo);
          });
        });
      });
    });
  };
  Consultas.crearDomicilio = ({
    address,
    customerAccessToken
  }) => {
    delete address.defaultAddress;
    const args = {
      args: {
        address,
        customerAccessToken
      }
    };
    return Tienda.graphQLClient.mutation("customerAddressCreate", mutation => {
      mutation.add("customerAddressCreate", args, respuesta => {
        respuesta.add("customerAddress", domicilio => {
          ["address1", "address2", "city", "company", "country", "firstName", "formatted", "zip", "phone", "lastName", "province"].forEach(campo => {
            domicilio.add(campo);
          });
        });
        respuesta.addField("customerUserErrors", errors => {
          ["code", "field", "message"].forEach(campo => {
            errors.add(campo);
          });
        });
      });
    });
  };
  Consultas.iniciarSesión = credenciales => {
    const {
      contraseña: password,
      correo: email
    } = credenciales;
    const args = {
      input: {
        password,
        email
      }
    };
    return Tienda.graphQLClient.mutation("customerAccessTokenCreate", [], respuesta => {
      respuesta.add("customerAccessTokenCreate", {
        args
      }, acceso => {
        acceso.addField("customerAccessToken", {}, token => {
          ["accessToken", "expiresAt"].forEach(campo => {
            token.add(campo);
          });
        });
        acceso.addField("customerUserErrors", {}, errors => {
          ["code", "field", "message"].forEach(campo => {
            errors.add(campo);
          });
        });
      });
    });
  };
  Consultas.crearUsuario = usuario => {
    const {
      contraseña: password,
      correo: email,
      nombre: firstName,
      apellido: lastName,
      aceptaNotificaciones: acceptsMarketing
    } = usuario;
    const args = {
      input: {
        password,
        email,
        firstName,
        lastName,
        acceptsMarketing
      }
    };
    if (!args.input.acceptsMarketing) {
      args.input.acceptsMarketing = false;
    }
    return Tienda.graphQLClient.mutation("customerCreate", [], peticion => {
      peticion.add("customerCreate", {
        args
      }, respuesta => {
        respuesta.addField("customer", {}, usuario => {
          ["tags", "email", "firstName", "lastName", "phone", "acceptsMarketing"].forEach(campo => {
            usuario.add(campo);
          });
        });
        respuesta.addField("customerUserErrors", {}, errors => {
          ["code", "field", "message"].forEach(campo => {
            errors.add(campo);
          });
        });
      });
    });
  };
  Consultas.recuperarPass = correo => {
    return Tienda.graphQLClient.mutation("customerRecover", mutation => {
      mutation.add("customerRecover", {
        args: {
          email: correo
        }
      }, reseteo => {
        reseteo.addField("customerUserErrors", errors => {
          ["code", "field", "message"].forEach(campo => {
            errors.add(campo);
          });
        });
      });
    });
  };
  Consultas.reseteoPass = ({
    password,
    resetUrl
  }) => {
    return Tienda.graphQLClient.mutation("customerResetByUrl", mutation => {
      mutation.add("customerResetByUrl", {
        args: {
          password,
          resetUrl
        }
      }, reseteo => {
        reseteo.addField("customerAccessToken", {}, token => {
          ["accessToken", "expiresAt"].forEach(campo => {
            token.add(campo);
          });
        });
        reseteo.addField("customerUserErrors", errors => {
          ["code", "field", "message"].forEach(campo => {
            errors.add(campo);
          });
        });
      });
    });
  };
  Consultas.usuarioPorAccessToken = accessToken => {
    return Tienda.graphQLClient.query(raíz => {
      raíz.add("customer", {
        args: {
          customerAccessToken: accessToken
        }
      }, usuario => {
        ["tags", "email", "firstName", "lastName", "phone", "acceptsMarketing"].forEach(campo => {
          usuario.add(campo);
        });
        usuario.addField("defaultAddress", domicilio => {
          ["address1", "address2", "city", "company", "country", "firstName", "formatted", "zip", "phone", "lastName", "province"].forEach(campo => {
            domicilio.add(campo);
          });
        });
        usuario.addConnection("addresses", {
          args: {
            first: 10
          }
        }, domicilio => {
          ["address1", "address2", "city", "company", "country", "firstName", "formatted", "zip", "phone", "lastName", "province"].forEach(campo => {
            domicilio.add(campo);
          });
        });
        usuario.addConnection("orders", {
          args: {
            first: 10
          }
        }, orders => {
          ["id", "statusUrl", "name", "orderNumber", "processedAt", "edited", "financialStatus", "fulfillmentStatus"].forEach(campo => {
            orders.add(campo);
          });
          orders.addField("currentTotalTax", total => {
            total.add("amount");
            total.add("currencyCode");
          });
          orders.addField("currentTotalPrice", total => {
            total.add("amount");
            total.add("currencyCode");
          });
          orders.addConnection("lineItems", {
            args: {
              first: 50
            }
          }, items => {
            ["quantity", "title"].forEach(campo => {
              items.add(campo);
            });
            items.addField("variant", variant => {
              variant.add("title");
              variant.addField("product", product => {
                product.add("id");
                product.add("title");
                Conexiones.imágenes({
                  args: {
                    first: 3
                  },
                  recurso: product
                });
              });
            });
          });
        });
      });
    });
  };
  Consultas.activarUsuarioPorURL = credenciales => {
    const {
      activationUrl,
      password
    } = credenciales;
    const args = {
      activationUrl,
      password
    };
    return Tienda.graphQLClient.mutation("customerActivateByUrl", [], respuesta => {
      respuesta.add("customerActivateByUrl", {
        args
      }, acceso => {
        acceso.addField("customer", {}, customer => {
          ["id", "email"].forEach(campo => {
            customer.add(campo);
          });
        });
        acceso.addField("customerAccessToken", {}, token => {
          ["accessToken", "expiresAt"].forEach(campo => {
            token.add(campo);
          });
        });
        acceso.addField("customerUserErrors", {}, errors => {
          ["code", "field", "message"].forEach(campo => {
            errors.add(campo);
          });
        });
      });
    });
  };
  Consultas.usuarioCerrarSessión = accessToken => {
    return Tienda.graphQLClient.mutation("customerAccessTokenDelete", mutation => {
      mutation.add("customerAccessTokenDelete", {
        args: {
          customerAccessToken: accessToken
        }
      }, respuesta => {
        respuesta.add("deletedAccessToken");
        respuesta.addField("userErrors", errors => {
          errors.add("field");
          errors.add("message");
        });
      });
    });
  };
  Peticiones.iniciarSesión = async credenciales => {
    return Tienda.graphQLClient.send(Consultas.iniciarSesión(credenciales)).then(({
      errors,
      data,
      model
    }) => {
      if (data) {
        errors = data.customerAccessTokenCreate.customerUserErrors;
        data = data.customerAccessTokenCreate.customerAccessToken;
        errors.length == 0 ? actualizarTokenLocal(data) : "";
      }
      return {
        data,
        errores: errors
      };
    }).catch(r => console.log(r));
  };
  Peticiones.activarUsuarioPorURL = async ({
    activationUrl,
    password
  }) => {
    return Tienda.graphQLClient.send(Consultas.activarUsuarioPorURL({
      activationUrl,
      password
    })).then(({
      errors,
      data,
      model
    }) => {
      if (data) {
        errors = data.customerActivateByUrl.customerUserErrors;
        data = {
          customerAccessToken: data.customerActivateByUrl.customerAccessToken,
          customer: data.customerActivateByUrl.customer
        };
      }
      return {
        data,
        errors
      };
    }).catch(r => console.log(r));
  };
  Peticiones.obtenerUsuario = async () => {
    const {
      accessToken
    } = obtenerTokeLocal();
    return Tienda.graphQLClient.send(Consultas.usuarioPorAccessToken(accessToken)).then(({
      errors,
      data,
      model
    }) => {
      data = data && data.customer ? data.customer : false;
      if (data) {
        data.addresses = data ? data.addresses.edges.map(({
          node
        }) => {
          return node;
        }) || [] : fa;
        data.orders = data.orders.edges.map(({
          node
        }) => {
          node.lineItems = node.lineItems.edges.map(({
            node
          }) => {
            node.variant != null ? node.variant.product.images = node.variant.product.images.edges.map(({
              node
            }) => {
              return node.originalSrc;
            }) : "";
            return node;
          }) || [];
          return node;
        }) || [];
      }
      return {
        data,
        errores: errors
      };
    }).catch(r => console.log(r));
  };
  Peticiones.usuarioCerrarSessión = async () => {
    const {
      accessToken
    } = obtenerTokeLocal();
    return Tienda.graphQLClient.send(Consultas.usuarioCerrarSessión(accessToken)).then(({
      errors,
      data,
      model
    }) => {
      if (data) {
        errors = data.customerAccessTokenDelete.useErrors || [];
        data = data.customerAccessTokenDelete;
        actualizarTokenLocal("");
      }
      return {
        data,
        errors
      };
    }).catch(r => console.log(r));
  };
  Peticiones.crearCuenta = async usuario => {
    return Tienda.graphQLClient.send(Consultas.crearUsuario(usuario)).then(({
      errors,
      data,
      model
    }) => {
      if (errors == undefined) {
        let tieneDatos = data ? data.customerCreate : null;
        errors = tieneDatos ? tieneDatos.customerUserErrors : [];
        data = tieneDatos ? tieneDatos.customer : null;
      }
      return {
        errores: errors,
        data
      };
    }).catch(r => console.log(r));
  };
  Peticiones.recuperarPass = async email => {
    return Tienda.graphQLClient.send(Consultas.recuperarPass(email)).then(({
      errors,
      data,
      model
    }) => {
      data = data && data.customerRecover ? data.customerRecover : false;
      if (data) {
        errors = data.customerRecover.customerUserErrors;
        data = [];
      }
      return {
        errors,
        data
      };
    }).catch(r => r);
  };
  Peticiones.reseteoPass = async ({
    resetUrl,
    password
  }) => {
    return Tienda.graphQLClient.send(Consultas.reseteoPass({
      resetUrl,
      password
    })).then(({
      errors,
      data,
      model
    }) => {
      if (data) {
        errors = data.customerResetByUrl.customerUserErrors;
        data = data.customerResetByUrl.customerAccessToken;
        actualizarTokenLocal(data);
      }
      return {
        errors,
        data
      };
    }).catch(r => console.log(r));
  };
  Peticiones.crearDomicilio = async address => {
    const {
      accessToken: customerAccessToken
    } = obtenerTokeLocal();
    return Tienda.graphQLClient.send(Consultas.crearDomicilio({
      customerAccessToken,
      address
    })).then(({
      errors,
      data,
      model
    }) => {
      if (data) {
        errors = data.customerAddressCreate.customerUserErrors;
        data = data.customerAddressCreate.customerAddress;
      }
      return {
        data,
        errors
      };
    });
  };
  Peticiones.actualizarDomicilio = async ({
    id,
    address
  }) => {
    const {
      accessToken: customerAccessToken
    } = obtenerTokeLocal();
    return Tienda.graphQLClient.send(Consultas.actualizarDomicilio({
      id,
      customerAccessToken,
      address
    })).then(({
      errors,
      data,
      model
    }) => {
      if (data) {
        errors = data.customerAddressUpdate.customerUserErrors;
        data = data.customerAddressUpdate.customerAddress;
      }
      return {
        data,
        errors
      };
    });
  };
  Peticiones.eliminarDomicilio = async ({
    id
  }) => {
    const {
      accessToken: customerAccessToken
    } = obtenerTokeLocal();
    return Tienda.graphQLClient.send(Consultas.eliminarDomicilio({
      id,
      customerAccessToken
    })).then(({
      errors,
      data,
      model
    }) => {
      if (data) {
        errors = data.customerAddressDelete.customerUserErrors;
      }
      return {
        data,
        errors
      };
    });
  };

  const Producto = datos => {
    return y("a", {
      class: "producto-enlace",
      href: `/products/${datos.handle}`,
      title: `/products/${datos.handle}`
    }, y("div", {
      class: "producto"
    }, y("div", {
      class: "superior"
    }, y("img", {
      class: "producto-img",
      src: datos.imagen,
      alt: CortarTítulo(datos.nombre),
      title: CortarTítulo(datos.nombre)
    })), y("div", {
      class: "inferior"
    }, y("p", {
      class: "descripcion"
    }, CortarTítulo(datos.nombre)), y("div", {
      class: "precio-calificacion",
      style: "display: grid;justify-content: center;"
    }, y("p", {
      class: "precio"
    }, datos.precio.length ? formatoPrecio(datos.precio) : datos.precio, "\u20AC"), datos.comparativePrices && y("p", {
      style: "margin: 7.5px;visibility: visible;color: red;text-decoration: line-through;font-weight: 700;font-size: 6px;"
    }, formatoPrecio(datos.comparativePrices), "\u20AC")))));
  };
  class Nav extends k {
    constructor(props) {
      super();
      const self = this;
      this.iconos = {
        usuario: {
          desactivo: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/usuario-header.png?v=10938938484457976803",
          activo: "https://cdn.shopify.com/s/files/1/0533/1157/0100/files/usuario-activo.svg?v=1652839270"
        }
      };
      this.state = {
        productos: "",
        colecciones: "",
        usuarioLogueado: false,
        wishlist: obtener().length,
        iconoUsurio: this.iconos.usuario.desactivo,
        usuario: "Iniciar sesión o Registro"
      };
      Peticiones.obtenerUsuario().then(({
        errores,
        data
      }) => {
        if (data) {
          this.setState({
            iconoUsurio: this.iconos.usuario.activo,
            usuario: `Hola ${data.firstName} ${data.lastName}`
          });
        }
      });
      EventosDeWishList.register("lista actualizada", function (lista) {
        self.setState({
          wishlist: lista.length
        });
      });
      this.eventos = new Observer(["busqueda marca"]);
      Checkout.obtener().then(checkout => {
        const productos = checkout.lineItems.length ? y("div", {
          class: "c\xEDrculo"
        }) : "";
        this.setState({
          productos
        });
      });
    }
    móvil() {
      return y("div", {
        class: "m\xF3vil"
      }, y("div", {
        class: "botones-navegacion"
      }, y("button", {
        id: "btn-men\xFA"
      }, y("div", {
        class: "l\xEDnea"
      }), y("div", {
        class: "l\xEDnea"
      }), y("div", {
        class: "l\xEDnea"
      })), y("div", {
        class: "lupa"
      }, y("div", {
        class: "cont-img"
      }, y("img", {
        src: "https://cdn.shopify.com/s/files/1/1577/8469/files/lupa_c5303124-c3b7-493c-baf7-b2da1f085433.png?v=1614718687",
        alt: "buscar",
        title: "buscar"
      })))), y("div", {
        class: "logo"
      }, y("div", {
        class: "cont-img"
      }, y("a", {
        href: "/",
        title: "/"
      }, y("img", {
        src: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/logo-rodin-header.png?v=15619386453047641044",
        alt: "logo-rodin",
        title: "logo-rodin"
      })))), y("div", {
        class: "iconos"
      }, y("div", {
        class: "cart"
      }, y("a", {
        href: "/cart",
        title: "/cart"
      }, y("div", {
        class: "cont-img"
      }, y("img", {
        src: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/carrito-header.png?v=13558517324228180857",
        alt: "carrito",
        title: "carrito"
      })), this.state.productos)), y("div", {
        class: "coraz\xF3n"
      }, y("div", {
        class: "cont-img"
      }, y("a", {
        href: "/pages/wish-list",
        title: "/pages/wish-list"
      }, y("span", null, this.state.wishlist), y("img", {
        src: "https://cdn.shopify.com/s/files/1/0533/1157/0100/files/favorite_icon_c17a9786-ef42-4276-86e6-715cf8947a2e.png?v=1636662031",
        alt: "favoritos",
        title: "favoritos"
      })))), y("div", {
        class: "usuario"
      }, y("div", {
        class: "cont-img"
      }, y("a", {
        href: "/account",
        title: "/account"
      }, y("img", {
        src: this.state.iconoUsurio,
        alt: "usuario",
        title: "usuario"
      }))))));
    }
    escritorio() {
      return y("div", {
        class: "nav-bar"
      }, y("div", {
        class: "logo"
      }, y("a", {
        href: "/",
        title: "/"
      }, y("img", {
        src: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/logo-rodin-header.png?v=15619386453047641044",
        alt: "logo-rodin",
        title: "logo-rodin"
      }))), y("div", {
        class: "search"
      }, y("section", null, y("div", {
        class: "buscador"
      }, y("input", {
        name: "escritorio",
        id: "input-buscar",
        type: "text",
        placeholder: "Buscar en nuestra tienda"
      }), y("span", null, y("img", {
        name: "search",
        src: "https://cdn.shopify.com/s/files/1/1577/8469/files/lupa.png?v=1613591910",
        alt: "buscar",
        title: "buscar"
      }))), y("div", {
        class: "linea"
      }), y("div", {
        class: "mega-menu"
      }, y("div", {
        class: "lateral"
      }, this.state.colecciones), y("div", {
        class: "resultados"
      }, this.state.resultadoBusqueda)))), y("div", {
        class: "options"
      }, y("div", {
        class: "shopping-cart"
      }, y("a", {
        href: "/cart",
        title: "/cart"
      }, this.state.productos, y("div", {
        class: "cart"
      }, y("img", {
        class: "icono",
        src: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/carrito-header.png?v=13558517324228180857",
        alt: "carrito",
        title: "carrito"
      })))), y("div", null, y("a", {
        href: "/pages/wish-list",
        title: "/pages/wish-list"
      }, y("span", null, this.state.wishlist), y("img", {
        class: "icono",
        src: "https://cdn.shopify.com/s/files/1/0533/1157/0100/files/favorite_icon_c17a9786-ef42-4276-86e6-715cf8947a2e.png?v=1636662031",
        alt: "favoritos",
        title: "favoritos"
      }))), y("div", null, y("a", {
        href: "/account",
        title: "/account"
      }, y("img", {
        class: "icono usuario",
        src: this.state.iconoUsurio,
        alt: "usuario",
        title: "usuario"
      }))), y("div", {
        class: "registro"
      }, this.state.usuarioLogueado ? y("a", {
        href: "/account",
        title: "/account"
      }, "Mi cuenta") : y("a", {
        href: "/account",
        title: "/account"
      }, this.state.usuario))));
    }
    obtenerProductos(busqueda) {
      const self = this;
      consultaDeProductos(busqueda).then(({
        producto
      }) => {
        if (producto.length) {
          const colecciones = [];
          producto.reduce((arreglo, {
            colecciones: collections
          }) => {
            const {
              título: title,
              handle,
              id
            } = collections[0] || {};
            if (!arreglo.find(h => h == handle) && handle) {
              arreglo.push(handle);
              colecciones.push(y("a", {
                href: `/collections/${handle}`,
                title: `/collections/${handle}`
              }, " ", title.replace(/-/g, "").trim().toLowerCase(), " en", " ", y("b", null, busqueda)));
            }
            return arreglo;
          }, []);
          let productos = producto.map(({
            imágenes: images,
            título: title,
            handle,
            precio,
            precioComparativo
          }) => {
            return Producto({
              handle,
              imagen: images[0],
              nombre: title,
              precio,
              comparativePrices: precioComparativo
            });
          });
          self.setState({
            colecciones,
            resultadoBusqueda: productos
          });
        }
      });
    }
    componentDidMount() {
      const input = $("#input-buscar");
      const img = $('img[name="search"]');
      const megaMenu = $(".search").find("section");
      const onEnter = e => {
        let busqueda = input.val().trim();
        if (busqueda.length >= 3) {
          $(megaMenu).addClass("mostrar-mega-menu");
          this.obtenerProductos(busqueda);
        } else {
          $(megaMenu).removeClass("mostrar-mega-menu");
        }
        if (e.which == 13) {
          const value = input.val().trim();
          window.location = `/search?q=${value}`;
        }
      };
      const onClick = e => {
        const value = input.val().trim();
        window.location = `/search?q=${value}`;
      };
      input.on("keyup", onEnter);
      input.on("change", onEnter);
      img.on("click", onClick);
    }
    render() {
      return y("nav", null, this.móvil(), this.escritorio());
    }
  }

  class AvisoCookies extends k {
    constructor() {
      super();
      this.els = {};
      this.els.cont = d();
      this.els.btnsi = d();
      this.els.btnno = d();
    }
    componentDidMount() {
      this.els.cont = $(this.els.cont.current);
      this.els.btnno = $(this.els.btnno.current);
      this.els.btnsi = $(this.els.btnsi.current);
      if (localStorage.getItem("cookie") == null) ; else {
        this.els.cont.css("display", "none");
      }
      this.els.btnsi.on("click", () => {
        this.els.cont.css("display", "none");
        localStorage.setItem("cookie", true);
      });
      this.els.btnno.on("click", () => {
        this.els.cont.css("display", "none");
        localStorage.setItem("cookie", false);
      });
    }
    render() {
      return y("div", {
        id: "cookie-banner",
        ref: this.els.cont
      }, y("div", {
        class: "superior"
      }, y("h3", {
        class: "titulo"
      }, "Aviso de cookies"), y("p", {
        class: "informaci\xF3n"
      }, "Las cookies de este sitio web se usan para personalizar el contenido y los anuncios, ofrecer funciones de redes sociales y analizar el tr\xE1fico. Adem\xE1s, compartimos informaci\xF3n sobre el uso que haga del sitio web con nuestros partners de redes sociales, publicidad y an\xE1lisis web, quienes pueden combinarla con otra informaci\xF3n que les haya proporcionado o que hayan recopilado a partir del uso que haya hecho de sus servicios.")), y("div", {
        class: "inferior"
      }, y("button", {
        class: "acepto-cookies",
        ref: this.els.btnsi
      }, "Acepto"), y("button", {
        class: "no-acepto-cookies",
        ref: this.els.btnno
      }, "No acepto")));
    }
  }

  class ScrollToButton extends k {
    constructor() {
      super();
    }
    componentDidMount() {
      const handleScroll = () => {
        if (window.pageYOffset > 250) {
          $(".scroll-to-body").css("right", "0");
        } else {
          $(".scroll-to-body").css("right", "-100px");
        }
      };
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      $("#scroll-to-body").click(function () {
        $([document.documentElement, document.body]).animate({
          scrollTop: $("body,html").offset().top
        }, 2000);
      });
    }
    render() {
      return y("div", {
        class: "scroll-to-body"
      }, y("button", {
        id: "scroll-to-body"
      }, y("img", {
        src: botones["flecha-abajo"].sm,
        alt: "flecha-abajo",
        title: "flecha-abajo"
      })));
    }
  }

  class Header extends k {
    render() {
      return y("header", null, y(Info, null), y(Nav, null), y(InfoMovil, null), y(BuscadorMovil, null), y(Menu, null), y(MenuMovil, null), y(AvisoCookies, null), y(ScrollToButton, null));
    }
  }

  class Footer extends k {
    constructor() {
      super();
      this.informacion = [{
        href: "/pages/sobre-nosotros",
        texto: "Sobre nosotros"
      }, {
        href: "/pages/envios-y-devoluciones",
        texto: "Envíos y devoluciones"
      }, {
        href: "/pages/terminos-y-condiciones",
        texto: "Términos y condiciones"
      }, {
        href: "/pages/aviso-de-privacidad",
        texto: "Aviso de privacidad"
      }, {
        href: "/pages/politica-de-proteccion-de-datos",
        texto: "Política de Protección de Datos"
      }, {
        href: "/pages/cookies",
        texto: "Cookies"
      }];
      this.atencion = [{
        href: "/pages/contacto",
        texto: "¿Quieres ser distribuidor?"
      }, {
        href: "/pages/contacto",
        texto: "Contáctanos"
      }, {
        href: "/pages/facturacion",
        texto: "Facturación"
      }, {
        href: "https://rodin.filecamp.com/l",
        texto: "Banco de Imágenes"
      }, {
        href: "/",
        texto: "Formas de pago"
      }];
      this.redesSociales = [{
        href: "https://www.facebook.com/Arte-Rodin-106739044635580/",
        imagen: footer["redesSociales"]["facebook"],
        alt: "facebook"
      }, {
        href: "https://www.instagram.com/arte.rodin/",
        imagen: footer["redesSociales"]["instagram"],
        alt: "instagram"
      }, {
        href: "https://www.tiktok.com/@arte.rodin?is_copy_url=1&is_from_webapp=v1&lang=es",
        imagen: footer["redesSociales"]["tiktok"],
        alt: "tiktok"
      }, {
        href: "https://www.youtube.com/@arterodinesp",
        imagen: footer["redesSociales"]["youtube"],
        alt: "youtube"
      }, {
        href: "mailto:arterodinsl@gmail.com",
        imagen: footer["redesSociales"]["mail"],
        alt: "mail"
      }];
    }
    seccion(titulo) {
      let contenido = [P({
        class: "titulo"
      }, titulo), Hr({})];
      if (titulo == "Información") {
        let li = this.informacion.map(enlace => {
          return Li({}, A({
            href: enlace.href,
            title: enlace.href
          }, enlace.texto));
        });
        contenido.push(Ul({}, li));
        return Div({
          class: ""
        }, contenido);
      } else if (titulo == "Atención") {
        let li = this.atencion.map(enlace => {
          return Li({}, A({
            href: enlace.href,
            title: enlace.href
          }, enlace.texto));
        });
        contenido.push(Ul({}, li));
        return Div({
          class: ""
        }, contenido);
      } else if (titulo == "Siguenos") {
        let li = this.redesSociales.map(enlace => {
          return Li({}, A({
            href: enlace.href,
            title: enlace.href
          }, Img({
            src: enlace.imagen.sm,
            alt: enlace.alt,
            title: enlace.alt
          })));
        });
        li.push(Li({}, Img({
          src: footer["redesSociales"]["pagina"].sm,
          alt: "pagina",
          title: "pagina"
        })));
        li.push(Li({}, y("p", null, "P\xE1gina segura")));
        contenido.push(Ul({
          class: "redes"
        }, li));
        return Div({
          class: "siguenos"
        }, contenido);
      } else if (titulo == "Formas de pago") {
        let li = [];
        for (const imagen in footer["pagos"]) {
          li.push(Li({}, Img({
            src: footer["pagos"][imagen].sm,
            alt: imagen,
            title: imagen
          })));
        }
        contenido.push(Ul({
          class: "metodos"
        }, li));
        contenido.push(Hr({
          class: "separador"
        }));
        return Div({
          class: "formas-pago"
        }, contenido);
      }
    }
    render() {
      return y("footer", null, this.seccion("Información"), this.seccion("Atención"), y("div", {
        class: "siguenos-pagos"
      }, this.seccion("Siguenos"), this.seccion("Formas de pago")));
    }
  }

  class Encabezado extends k {
    render() {
      return y("div", {
        class: "encabezado-categoria"
      }, y("div", {
        class: "migas-de-pan"
      }, y("p", null, "Inicio > Pintar")), y("div", {
        class: "titulo-categoria"
      }, y("p", null, "Pintar")));
    }
  }

  class CarruselMarcas extends k {
    constructor() {
      super();
      this.imgs = {
        carrusel: [{
          busqueda: "/collections/marca-shin-shan",
          imagen: "https://cdn.shopify.com/s/files/1/0533/1157/0100/files/SHINHAN.png?v=1631548495"
        }, {
          busqueda: "/collections/marca-legion-paper",
          imagen: "https://cdn.shopify.com/s/files/1/0533/1157/0100/files/LEGIONPAPER.png?v=1631548495"
        }, {
          busqueda: "/collections/marca-xp-pen",
          imagen: "https://cdn.shopify.com/s/files/1/0533/1157/0100/files/xppen_ecommerce.jpg?v=1652585562"
        }, {
          busqueda: "/collections/marca-higgins",
          imagen: "https://cdn.shopify.com/s/files/1/0533/1157/0100/files/HIGGIS.png?v=1631548495"
        }, {
          busqueda: "/collections/marca-derwent",
          imagen: "https://cdn.shopify.com/s/files/1/1577/8469/files/Derwent_Mesa_de_trabajo_1.png?v=1625696902"
        }, {
          busqueda: "/collections/marca-liquitex",
          imagen: "https://cdn.shopify.com/s/files/1/1577/8469/files/logo-liquitex.png?v=1613503593"
        }, {
          busqueda: "/collections/marca-grumbacher",
          imagen: "https://cdn.shopify.com/s/files/1/0533/1157/0100/files/GRUMBACHER.png?v=1631548495"
        }, {
          busqueda: "/collections/marca-chartpak",
          imagen: "https://cdn.shopify.com/s/files/1/1577/8469/files/Chartpak_Mesa_de_trabajo_1.png?v=1625696902"
        }, {
          busqueda: "/collections/marca-royal-langnickel",
          imagen: "https://cdn.shopify.com/s/files/1/1577/8469/files/Royal_Langnickel_Mesa_de_trabajo_1.png?v=1625696902"
        }, {
          busqueda: "/collections/marca-molotow",
          imagen: "https://cdn.shopify.com/s/files/1/1577/8469/files/logo_molotow.png?v=1613503593"
        }, {
          busqueda: "/collections/marca-royal-talens",
          imagen: "https://cdn.shopify.com/s/files/1/1577/8469/files/Royal.png?v=1625696902"
        }, {
          busqueda: "/collections/marca-winsor-newton",
          imagen: "https://cdn.shopify.com/s/files/1/1577/8469/files/logo-winstor-amd..png?v=1613503593"
        }, {
          busqueda: "/collections/marca-sakura-koi",
          imagen: "https://cdn.shopify.com/s/files/1/1577/8469/files/Sakura.png?v=1625696902"
        }, {
          busqueda: "/collections/marca-angelus",
          imagen: "https://cdn.shopify.com/s/files/1/0533/1157/0100/files/logo_Angelus.jpg?v=1663868643"
        }, {
          busqueda: "/collections/marca-rodin",
          imagen: "https://cdn.shopify.com/s/files/1/0533/1157/0100/files/logo_Rodin.jpg?v=1663868649"
        }],
        btns: {
          izquierda: botones["flecha-izquierda-carrusel"].sm,
          derecha: botones["flecha-derecha-carrusel"].sm
        }
      };
      this.elements = {
        carrusel: d(),
        carruselMovil: d(),
        btns: {
          izquierda: d(),
          derecha: d()
        }
      };
    }
    button(ref, izquierda = false) {
      let img = this.imgs.btns[izquierda ? "izquierda" : "derecha"];
      return y("span", {
        ref: ref,
        class: izquierda ? "prev-marcas" : "pos-marcas"
      }, y("img", {
        src: img,
        alt: `flecha-${izquierda ? "izquierda" : "derecha"}`,
        title: `flecha-${izquierda ? "izquierda" : "derecha"}`
      }));
    }
    carrusel(ref) {
      let marca = (busqueda, imagen) => {
        return y("a", {
          href: busqueda,
          title: busqueda
        }, y("img", {
          src: imagen,
          alt: busqueda.split("/collections/")[1],
          title: busqueda.split("/collections/")[1]
        }));
      };
      return y("div", {
        ref: ref,
        class: "carrusel-item"
      }, this.imgs.carrusel.map(({
        busqueda,
        imagen
      }) => marca(busqueda, imagen)));
    }
    componentDidMount() {
      this.elements.carrusel = $(this.elements.carrusel.current);
      for (let el in this.elements.btns) {
        this.elements.btns[el] = $(this.elements.btns[el].current);
      }
      this.elements.carrusel.slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000,
        prevArrow: this.elements.btns.izquierda,
        nextArrow: this.elements.btns.derecha,
        variableWidth: true
      });
      this.elements.carruselMovil = $(this.elements.carruselMovil.current);
      this.elements.carruselMovil.slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000,
        arrows: false
      });
    }
    render() {
      return y("div", {
        class: "carrusel-marcas"
      }, y("div", {
        class: "contenedor-carrusel"
      }, y("div", {
        class: "carrusel"
      }, this.carrusel(this.elements.carruselMovil))), y("div", {
        class: "container-carrusel-l"
      }, this.button(this.elements.btns.izquierda, true), y("div", {
        class: "carrusel-brands"
      }, this.carrusel(this.elements.carrusel)), this.button(this.elements.btns.derecha)));
    }
  }

  class Filtro extends k {
    constructor() {
      super();
      this.els = {
        cerrarFiltro: d(),
        desplegarFiltro: d(),
        desplegarPrecio: d(),
        rangoPrecios: d()
      };
    }
    componentDidMount() {}
    filtros() {
      return y("div", {
        class: "contenido-filtros"
      }, y("div", {
        class: "migas-de-pan"
      }, y("p", null, "Inicio > Pintar")), y("div", {
        class: "opciones",
        ref: this.els.desplegarFiltro
      }, y("div", {
        class: "titulo"
      }, y("h2", null, "Filtros"), y("button", {
        class: "cerrar-filtro",
        ref: this.els.cerrarFiltro
      }, "X")), y("div", {
        class: "contenido"
      }, y("div", {
        class: "por-categoria"
      }, y("button", {
        class: "desplegar"
      }, y("p", {
        class: "titulo-filtro"
      }, "Categor\xEDas"), y("span", {
        class: "signo"
      }, "+")), y("ul", null, y("li", null, y("input", {
        type: "radio",
        id: "pintar",
        name: "categoria",
        value: "pintar"
      }), y("label", {
        for: "pintar"
      }, "Pintar")), y("li", null, y("input", {
        type: "radio",
        id: "dibujar",
        name: "categoria",
        value: "dibujar"
      }), y("label", {
        for: "dibujar"
      }, "Dibujar")), y("li", null, y("input", {
        type: "radio",
        id: "decoracion",
        name: "categoria",
        value: "decoraci\xF3n"
      }), y("label", {
        for: "decoracion"
      }, "Decoraci\xF3n")), y("li", null, y("input", {
        type: "radio",
        id: "papeleria",
        name: "categoria",
        value: "papeler\xEDa"
      }), y("label", {
        for: "papeleria"
      }, "Papeler\xEDa y escolar")), y("li", null, y("input", {
        type: "radio",
        id: "tabletas",
        name: "categoria",
        value: "tabletas"
      }), y("label", {
        for: "tabletas"
      }, "Tabletas y gr\xE1ficas")))), y("div", {
        class: "por-marca"
      }, y("button", {
        class: "desplegar"
      }, y("p", {
        class: "titulo-filtro"
      }, "Marcas"), y("span", {
        class: "signo"
      }, "+")), y("ul", null, y("li", null, y("input", {
        type: "checkbox",
        id: "amsterdam",
        name: "amsterdam"
      }), y("label", {
        for: "amsterdam"
      }, "\xC1msterdam")), y("li", null, y("input", {
        type: "checkbox",
        id: "derwnt",
        name: "derwnt"
      }), y("label", {
        for: "derwnt"
      }, "Derwent")), y("li", null, y("input", {
        type: "checkbox",
        id: "liquitex",
        name: "liquitex"
      }), y("label", {
        for: "liquitex"
      }, "Liquitex")), y("li", null, y("input", {
        type: "checkbox",
        id: "atl",
        name: "atl"
      }), y("label", {
        for: "atl"
      }, "ATL")), y("li", null, y("button", {
        class: "mas-filtros"
      }, "Ver m\xE1s...")))), y("div", {
        class: "por-base"
      }, y("button", {
        class: "desplegar"
      }, y("p", {
        class: "titulo-filtro"
      }, "Base"), y("span", {
        class: "signo"
      }, "+"))), y("div", {
        class: "por-base"
      }, y("button", {
        class: "desplegar"
      }, y("p", {
        class: "titulo-filtro"
      }, "Acabados"), y("span", {
        class: "signo"
      }, "+"))), y("div", {
        class: "por-base"
      }, y("button", {
        class: "desplegar"
      }, y("p", {
        class: "titulo-filtro"
      }, "Efectos"), y("span", {
        class: "signo"
      }, "+"))), y("div", {
        class: "por-base"
      }, y("button", {
        class: "desplegar"
      }, y("p", {
        class: "titulo-filtro"
      }, "Capacidad"), y("span", {
        class: "signo"
      }, "+"))), y("div", {
        class: "por-base"
      }, y("button", {
        class: "desplegar"
      }, y("p", {
        class: "titulo-filtro"
      }, "Textura"), y("span", {
        class: "signo"
      }, "+")))), y("div", {
        class: "precio"
      }, y("button", {
        class: "desplegar-precio",
        ref: this.els.desplegarPrecio
      }, y("p", {
        class: "titulo-filtro"
      }, "Precio"), y("span", {
        class: "signo"
      }, "-")))), y("div", {
        class: "rango",
        ref: this.els.rangoPrecios
      }, y("input", {
        type: "range",
        min: "200",
        max: "500",
        list: "tickmarks"
      }), y("datalist", {
        id: "tickmarks"
      }, y("option", {
        value: "200",
        label: "$200"
      }), y("option", {
        value: "350",
        label: "$350"
      }), y("option", {
        value: "500",
        label: "$500"
      }))), y("div", {
        class: "botones-filtro"
      }, y("button", null, "Reestablecer"), y("button", null, "Guardar")), y("div", {
        class: "envios"
      }, y("div", {
        class: "furgoneta"
      }, y("img", {
        class: "imagen",
        src: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/furgoneta.png?v=4400691296498506757",
        alt: "furgoneta",
        title: "furgoneta"
      }), y("p", {
        class: "aviso"
      }, "\xA1Env\xEDo Gratis!"), y("p", {
        class: "precio"
      }, "Con un importe neto superior a 50.00\u20AC")), y("a", {
        href: "/envios-y-devoluciones.html",
        title: "/envios-y-devoluciones.html"
      }, y("button", {
        class: "boton"
      }, "Click aqu\xED"))));
    }
    render() {
      return y("div", {
        class: "filtros"
      }, this.filtros());
    }
  }

  class Categoria extends k {
    constructor() {
      super();
      this.state = {
        productos: []
      };
      this.els = {
        carruselPromo: d(),
        btnFiltros: d()
      };
    }
    obtenerColeccion() {
      Tienda.collection.fetchByHandle("rodin").then(collection => {
        this.setState({
          productos: collection.products
        });
      });
    }
    mostrarproductos(productos) {
      return y("div", {
        class: "titulo-productos"
      }, y("p", {
        class: "titulo-categoria-producto"
      }, "Acr\xEDlico"), y("div", {
        class: "productos"
      }, productos.map(dato => {
        return y(TarjetaProducto, {
          imagen: dato.images[0].src,
          titulo: dato.title,
          variante: "compacto"
        });
      })));
    }
    componentDidMount() {
      this.els.carruselPromo = $(this.els.carruselPromo.current);
      this.els.carruselPromo.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        arrows: false
      });
      this.els.btnFiltros = $(this.els.btnFiltros.current);
      this.els.btnFiltros.click(function () {
        $(".filtros").css("display", "block");
        window.scrollTo(0, 0);
        $("body").css("overflow", "hidden");
      });
      this.obtenerColeccion();
    }
    render() {
      return y("div", {
        class: "categoria"
      }, y("div", {
        class: "boton-carrusel"
      }, y("button", {
        class: "boton-filtros",
        ref: this.els.btnFiltros
      }, y("p", null, "Filtros"), y("img", {
        src: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/flecha.png?v=10118075206433113737",
        alt: "flecha-derecha",
        title: "flecha-derecha"
      })), y("div", {
        class: "carrusel-promo",
        ref: this.els.carruselPromo
      }, y("div", {
        class: "carrusel-promo-item1"
      }, y("div", {
        class: "imagen-boton"
      }, y("div", {
        class: "furgoneta"
      }, y("img", {
        class: "imagen",
        src: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/furgoneta.png?v=4400691296498506757",
        alt: "furgoneta",
        title: "furgoneta"
      }), y("p", {
        class: "aviso"
      }, "\xA1Env\xEDo Gratis!"), y("p", {
        class: "precio"
      }, "Con un importe neto superior a \u20AC50.00")), y("button", {
        class: "boton"
      }, "Click aqu\xED"))), y("div", {
        class: "carrusel-promo-item2"
      }, y("div", {
        class: "imagen-boton"
      }, y("div", {
        class: "furgoneta"
      }, y("img", {
        class: "imagen",
        src: "//cdn.shopify.com/s/files/1/1577/8469/t/4/assets/furgoneta.png?v=4400691296498506757",
        alt: "furgoneta",
        title: "furgoneta"
      }), y("p", {
        class: "aviso"
      }, "Tus entregas"), y("p", {
        class: "precio"
      }, "\xA1EN S\xD3LO 24 HORAS!"), y("p", {
        class: "exclusivo"
      }, "\xFAnicamente para albacete, espa\xF1a*")), y("button", {
        class: "boton"
      }, "Click aqu\xED"))))), y("div", {
        class: "titulo-productos-filtros"
      }, y(Filtro, null), y("hr", {
        class: "separador"
      }), this.state ? this.mostrarproductos(this.state.productos) : ""));
    }
  }

  class App extends k {
    render() {
      return y("main", null, y(Header, null), y(Encabezado, null), y(CarruselMarcas, null), y(Categoria, null), y(Footer, null));
    }
  }
  $(document).ready(() => {
    B(y(App, null), document.body);
  });

}());
//# sourceMappingURL=categoria.js.map
